!function(t,e){"function"==typeof define&&define.amd?define(function(){return e(t)}):"object"==typeof module&&module.exports?module.exports=e(t):t.bodymovin=e(t)}(window||{},function(window){function ProjectInterface(){return{}}function roundValues(t){bm_rnd=t?Math.round:function(t){return t}}function roundTo2Decimals(t){return Math.round(1e4*t)/1e4}function roundTo3Decimals(t){return Math.round(100*t)/100}function styleDiv(t){t.style.position="absolute",t.style.top=0,t.style.left=0,t.style.display="block",t.style.transformOrigin=t.style.webkitTransformOrigin="0 0",t.style.backfaceVisibility=t.style.webkitBackfaceVisibility="visible",t.style.transformStyle=t.style.webkitTransformStyle=t.style.mozTransformStyle="preserve-3d"}function styleUnselectableDiv(t){t.style.userSelect="none",t.style.MozUserSelect="none",t.style.webkitUserSelect="none",t.style.oUserSelect="none"}function BMEnterFrameEvent(t,e,s,r){this.type=t,this.currentTime=e,this.totalTime=s,this.direction=0>r?-1:1}function BMCompleteEvent(t,e){this.type=t,this.direction=0>e?-1:1}function BMCompleteLoopEvent(t,e,s,r){this.type=t,this.currentLoop=e,this.totalLoops=s,this.direction=0>r?-1:1}function BMSegmentStartEvent(t,e,s){this.type=t,this.firstFrame=e,this.totalFrames=s}function BMDestroyEvent(t,e){this.type=t,this.target=e}function _addEventListener(t,e){return this._cbs[t]||(this._cbs[t]=[]),this._cbs[t].push(e),function(){this.removeEventListener(t,e)}.bind(this)}function _removeEventListener(t,e){if(e){if(this._cbs[t]){for(var s=0,r=this._cbs[t].length;r>s;)this._cbs[t][s]===e&&(this._cbs[t].splice(s,1),s-=1,r-=1),s+=1;this._cbs[t].length||(this._cbs[t]=null)}}else this._cbs[t]=null}function _triggerEvent(t,e){if(this._cbs[t])for(var s=this._cbs[t].length,r=0;s>r;r++)this._cbs[t][r](e)}function randomString(t,e){void 0===e&&(e="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");var s,r="";for(s=t;s>0;--s)r+=e[Math.round(Math.random()*(e.length-1))];return r}function HSVtoRGB(t,e,s){var r,i,a,n,o,h,l,p;switch(1===arguments.length&&(e=t.s,s=t.v,t=t.h),n=Math.floor(6*t),o=6*t-n,h=s*(1-e),l=s*(1-o*e),p=s*(1-(1-o)*e),n%6){case 0:r=s,i=p,a=h;break;case 1:r=l,i=s,a=h;break;case 2:r=h,i=s,a=p;break;case 3:r=h,i=l,a=s;break;case 4:r=p,i=h,a=s;break;case 5:r=s,i=h,a=l}return[r,i,a]}function RGBtoHSV(t,e,s){1===arguments.length&&(e=t.g,s=t.b,t=t.r);var r,i=Math.max(t,e,s),a=Math.min(t,e,s),n=i-a,o=0===i?0:n/i,h=i/255;switch(i){case a:r=0;break;case t:r=e-s+n*(s>e?6:0),r/=6*n;break;case e:r=s-t+2*n,r/=6*n;break;case s:r=t-e+4*n,r/=6*n}return[r,o,h]}function addSaturationToRGB(t,e){var s=RGBtoHSV(255*t[0],255*t[1],255*t[2]);return s[1]+=e,s[1]>1?s[1]=1:s[1]<=0&&(s[1]=0),HSVtoRGB(s[0],s[1],s[2])}function addBrightnessToRGB(t,e){var s=RGBtoHSV(255*t[0],255*t[1],255*t[2]);return s[2]+=e,s[2]>1?s[2]=1:s[2]<0&&(s[2]=0),HSVtoRGB(s[0],s[1],s[2])}function addHueToRGB(t,e){var s=RGBtoHSV(255*t[0],255*t[1],255*t[2]);return s[0]+=e/360,s[0]>1?s[0]-=1:s[0]<0&&(s[0]+=1),HSVtoRGB(s[0],s[1],s[2])}function componentToHex(t){var e=t.toString(16);return 1==e.length?"0"+e:e}function fillToRgba(t,e){if(!cachedColors[t]){var s=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);cachedColors[t]=parseInt(s[1],16)+","+parseInt(s[2],16)+","+parseInt(s[3],16)}return"rgba("+cachedColors[t]+","+e+")"}function RenderedFrame(t,e){this.tr=t,this.o=e}function iterateDynamicProperties(t){var e,s=this.dynamicProperties;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(t)}function reversePath(t){var e,s,r=[],i=[],a=[],n={},o=0;t.c&&(r[0]=t.o[0],i[0]=t.i[0],a[0]=t.v[0],o=1),s=t.i.length;var h=s-1;for(e=o;s>e;e+=1)r.push(t.o[h]),i.push(t.i[h]),a.push(t.v[h]),h-=1;return n.i=r,n.o=i,n.v=a,n}function Matrix(){}function createElement(t,e,s){if(!e){var r=Object.create(t.prototype,s),i={};return r&&"[object Function]"===i.toString.call(r.init)&&r.init(),r}e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.prototype._parent=t.prototype}function extendPrototype(t,e){for(var s in t.prototype)t.prototype.hasOwnProperty(s)&&(e.prototype[s]=t.prototype[s])}function bezFunction(){function t(t,e,s,r,i,a){var n=t*r+e*i+s*a-i*r-a*t-s*e;return n>-1e-4&&1e-4>n}function e(e,s,r,i,a,n,o,h,l){if(0===r&&0===n&&0===l)return t(e,s,i,a,o,h);var p,m=Math.sqrt(Math.pow(i-e,2)+Math.pow(a-s,2)+Math.pow(n-r,2)),f=Math.sqrt(Math.pow(o-e,2)+Math.pow(h-s,2)+Math.pow(l-r,2)),c=Math.sqrt(Math.pow(o-i,2)+Math.pow(h-a,2)+Math.pow(l-n,2));return p=m>f?m>c?m-f-c:c-f-m:c>f?c-f-m:f-m-c,p>-1e-4&&1e-4>p}function s(t){var e,s=t.c,r=t.v,i=t.o,a=t.i,n=t._length,o=[],h=0;for(e=0;n-1>e;e+=1)o[e]=l(r[e],r[e+1],i[e],a[e+1]),h+=o[e].addedLength;return s&&(o[e]=l(r[e],r[0],i[e],a[0]),h+=o[e].addedLength),{lengths:o,totalLength:h}}function r(t){this.segmentLength=0,this.points=new Array(t)}function i(t,e){this.partialLength=t,this.point=e}function a(t,e){var s=e.segments,r=s.length,i=bm_floor((r-1)*t),a=t*e.addedLength,n=0;if(a==s[i].l)return s[i].p;for(var o=s[i].l>a?-1:1,h=!0;h;)s[i].l<=a&&s[i+1].l>a?(n=(a-s[i].l)/(s[i+1].l-s[i].l),h=!1):i+=o,(0>i||i>=r-1)&&(h=!1);return s[i].p+(s[i+1].p-s[i].p)*n}function n(){this.pt1=new Array(2),this.pt2=new Array(2),this.pt3=new Array(2),this.pt4=new Array(2)}function o(t,e,s,r,i,n){var o=a(i,n),h=1-o,l=Math.round(1e3*(h*h*h*t[0]+(o*h*h+h*o*h+h*h*o)*s[0]+(o*o*h+h*o*o+o*h*o)*r[0]+o*o*o*e[0]))/1e3,p=Math.round(1e3*(h*h*h*t[1]+(o*h*h+h*o*h+h*h*o)*s[1]+(o*o*h+h*o*o+o*h*o)*r[1]+o*o*o*e[1]))/1e3;return[l,p]}function h(t,e,s,r,i,o,h){var l=new n;i=0>i?0:i>1?1:i;var p=a(i,h);o=o>1?1:o;var m,f=a(o,h),c=t.length,d=1-p,u=1-f;for(m=0;c>m;m+=1)l.pt1[m]=Math.round(1e3*(d*d*d*t[m]+(p*d*d+d*p*d+d*d*p)*s[m]+(p*p*d+d*p*p+p*d*p)*r[m]+p*p*p*e[m]))/1e3,l.pt3[m]=Math.round(1e3*(d*d*u*t[m]+(p*d*u+d*p*u+d*d*f)*s[m]+(p*p*u+d*p*f+p*d*f)*r[m]+p*p*f*e[m]))/1e3,l.pt4[m]=Math.round(1e3*(d*u*u*t[m]+(p*u*u+d*f*u+d*u*f)*s[m]+(p*f*u+d*f*f+p*u*f)*r[m]+p*f*f*e[m]))/1e3,l.pt2[m]=Math.round(1e3*(u*u*u*t[m]+(f*u*u+u*f*u+u*u*f)*s[m]+(f*f*u+u*f*f+f*u*f)*r[m]+f*f*f*e[m]))/1e3;return l}var l=(Math,function(){function t(t,e){this.l=t,this.p=e}return function(e,s,r,i){var a,n,o,h,l,p,m=defaultCurveSegments,f=0,c=[],d=[],u={addedLength:0,segments:[]};for(o=r.length,a=0;m>a;a+=1){for(l=a/(m-1),p=0,n=0;o>n;n+=1)h=bm_pow(1-l,3)*e[n]+3*bm_pow(1-l,2)*l*r[n]+3*(1-l)*bm_pow(l,2)*i[n]+bm_pow(l,3)*s[n],c[n]=h,null!==d[n]&&(p+=bm_pow(c[n]-d[n],2)),d[n]=c[n];p&&(p=bm_sqrt(p),f+=p),u.segments.push(new t(f,l))}return u.addedLength=f,u}}()),p=function(){var e={};return function(s){var a=s.s,n=s.e,o=s.to,h=s.ti,l=(a.join("_")+"_"+n.join("_")+"_"+o.join("_")+"_"+h.join("_")).replace(/\./g,"p");if(e[l])return void(s.bezierData=e[l]);var p,m,f,c,d,u,y,g=defaultCurveSegments,v=0,b=null;2===a.length&&(a[0]!=n[0]||a[1]!=n[1])&&t(a[0],a[1],n[0],n[1],a[0]+o[0],a[1]+o[1])&&t(a[0],a[1],n[0],n[1],n[0]+h[0],n[1]+h[1])&&(g=2);var E=new r(g);for(f=o.length,p=0;g>p;p+=1){for(y=new Array(f),d=p/(g-1),u=0,m=0;f>m;m+=1)c=bm_pow(1-d,3)*a[m]+3*bm_pow(1-d,2)*d*(a[m]+o[m])+3*(1-d)*bm_pow(d,2)*(n[m]+h[m])+bm_pow(d,3)*n[m],y[m]=c,null!==b&&(u+=bm_pow(y[m]-b[m],2));u=bm_sqrt(u),v+=u,E.points[p]=new i(u,y),b=y}E.segmentLength=v,s.bezierData=E,e[l]=E}}();return{getBezierLength:l,getSegmentsLength:s,getNewSegment:h,getPointInSegment:o,buildBezierData:p,pointOnLine2D:t,pointOnLine3D:e}}function dataFunctionManager(){function t(i,a,o){var h,l,p,m,f,c,d,u,y=i.length;for(m=0;y>m;m+=1)if(h=i[m],"ks"in h&&!h.completed){if(h.completed=!0,h.tt&&(i[m-1].td=h.tt),l=[],p=-1,h.hasMask){var g=h.masksProperties;for(c=g.length,f=0;c>f;f+=1)if(g[f].pt.k.i)r(g[f].pt.k);else for(u=g[f].pt.k.length,d=0;u>d;d+=1)g[f].pt.k[d].s&&r(g[f].pt.k[d].s[0]),g[f].pt.k[d].e&&r(g[f].pt.k[d].e[0])}0===h.ty?(h.layers=e(h.refId,a),t(h.layers,a,o)):4===h.ty?s(h.shapes):5==h.ty&&n(h,o)}}function e(t,e){for(var s=0,r=e.length;r>s;){if(e[s].id===t)return e[s].layers.__used?JSON.parse(JSON.stringify(e[s].layers)):(e[s].layers.__used=!0,e[s].layers);s+=1}}function s(t){var e,i,a,n=t.length,o=!1;for(e=n-1;e>=0;e-=1)if("sh"==t[e].ty){if(t[e].ks.k.i)r(t[e].ks.k);else for(a=t[e].ks.k.length,i=0;a>i;i+=1)t[e].ks.k[i].s&&r(t[e].ks.k[i].s[0]),t[e].ks.k[i].e&&r(t[e].ks.k[i].e[0]);o=!0}else"gr"==t[e].ty&&s(t[e].it)}function r(t){var e,s=t.i.length;for(e=0;s>e;e+=1)t.i[e][0]+=t.v[e][0],t.i[e][1]+=t.v[e][1],t.o[e][0]+=t.v[e][0],t.o[e][1]+=t.v[e][1]}function i(t,e){var s=e?e.split("."):[100,100,100];return t[0]>s[0]?!0:s[0]>t[0]?!1:t[1]>s[1]?!0:s[1]>t[1]?!1:t[2]>s[2]?!0:s[2]>t[2]?!1:void 0}function a(e,s){e.__complete||(l(e),o(e),h(e),p(e),t(e.layers,e.assets,s),e.__complete=!0)}function n(t,e){0!==t.t.a.length||"m"in t.t.p||(t.singleShape=!0)}var o=function(){function t(t){var e=t.t.d;t.t.d={k:[{s:e,t:0}]}}function e(e){var s,r=e.length;for(s=0;r>s;s+=1)5===e[s].ty&&t(e[s])}var s=[4,4,14];return function(t){if(i(s,t.v)&&(e(t.layers),t.assets)){var r,a=t.assets.length;for(r=0;a>r;r+=1)t.assets[r].layers&&e(t.assets[r].layers)}}}(),h=function(){var t=[4,7,99];return function(e){if(e.chars&&!i(t,e.v)){var s,a,n,o,h,l=e.chars.length;for(s=0;l>s;s+=1)if(e.chars[s].data&&e.chars[s].data.shapes)for(h=e.chars[s].data.shapes[0].it,n=h.length,a=0;n>a;a+=1)o=h[a].ks.k,o.__converted||(r(h[a].ks.k),o.__converted=!0)}}}(),l=function(){function t(e){var s,r,i,a=e.length;for(s=0;a>s;s+=1)if("gr"===e[s].ty)t(e[s].it);else if("fl"===e[s].ty||"st"===e[s].ty)if(e[s].c.k&&e[s].c.k[0].i)for(i=e[s].c.k.length,r=0;i>r;r+=1)e[s].c.k[r].s&&(e[s].c.k[r].s[0]/=255,e[s].c.k[r].s[1]/=255,e[s].c.k[r].s[2]/=255,e[s].c.k[r].s[3]/=255),e[s].c.k[r].e&&(e[s].c.k[r].e[0]/=255,e[s].c.k[r].e[1]/=255,e[s].c.k[r].e[2]/=255,e[s].c.k[r].e[3]/=255);else e[s].c.k[0]/=255,e[s].c.k[1]/=255,e[s].c.k[2]/=255,e[s].c.k[3]/=255}function e(e){var s,r=e.length;for(s=0;r>s;s+=1)4===e[s].ty&&t(e[s].shapes)}var s=[4,1,9];return function(t){if(i(s,t.v)&&(e(t.layers),t.assets)){var r,a=t.assets.length;for(r=0;a>r;r+=1)t.assets[r].layers&&e(t.assets[r].layers)}}}(),p=function(){function t(e){var s,r,i,a=e.length,n=!1;for(s=a-1;s>=0;s-=1)if("sh"==e[s].ty){if(e[s].ks.k.i)e[s].ks.k.c=e[s].closed;else for(i=e[s].ks.k.length,r=0;i>r;r+=1)e[s].ks.k[r].s&&(e[s].ks.k[r].s[0].c=e[s].closed),e[s].ks.k[r].e&&(e[s].ks.k[r].e[0].c=e[s].closed);n=!0}else"gr"==e[s].ty&&t(e[s].it)}function e(e){var s,r,i,a,n,o,h=e.length;for(r=0;h>r;r+=1){if(s=e[r],s.hasMask){var l=s.masksProperties;for(a=l.length,i=0;a>i;i+=1)if(l[i].pt.k.i)l[i].pt.k.c=l[i].cl;else for(o=l[i].pt.k.length,n=0;o>n;n+=1)l[i].pt.k[n].s&&(l[i].pt.k[n].s[0].c=l[i].cl),l[i].pt.k[n].e&&(l[i].pt.k[n].e[0].c=l[i].cl)}4===s.ty&&t(s.shapes)}}var s=[4,4,18];return function(t){if(i(s,t.v)&&(e(t.layers),t.assets)){var r,a=t.assets.length;for(r=0;a>r;r+=1)t.assets[r].layers&&e(t.assets[r].layers)}}}(),m={};return m.completeData=a,m}function ShapePath(){this.c=!1,this._length=0,this._maxLength=8,this.v=Array.apply(null,{length:this._maxLength}),this.o=Array.apply(null,{length:this._maxLength}),this.i=Array.apply(null,{length:this._maxLength})}function ShapeModifier(){}function TrimModifier(){}function RoundCornersModifier(){}function RepeaterModifier(){}function ShapeCollection(){this._length=0,this._maxLength=4,this.shapes=Array.apply(null,{length:this._maxLength})}function TextAnimatorProperty(t,e,s){this.mdf=!1,this._firstFrame=!0,this._hasMaskedPath=!1,this._frameId=-1,this._dynamicProperties=[],this._textData=t,this._renderType=e,this._elem=s,this._animatorsData=Array.apply(null,{length:this._textData.a.length}),this._pathData={},this._moreOptions={alignment:{}},this.renderedLetters=[],this.lettersChangedFlag=!1}function LetterProps(t,e,s,r,i,a){this.o=t,this.sw=e,this.sc=s,this.fc=r,this.m=i,this.p=a,this.mdf={o:!0,sw:!!e,sc:!!s,fc:!!r,m:!0,p:!0}}function TextProperty(t,e,s){this._frameId=-99999,this.pv="",this.v="",this.kf=!1,this.firstFrame=!0,this.mdf=!0,this.data=e,this.elem=t,this.keysIndex=-1,this.currentData={ascent:0,boxWidth:[0,0],f:"",fStyle:"",fWeight:"",fc:"",j:"",justifyOffset:"",l:[],lh:0,lineWidths:[],ls:"",of:"",s:"",sc:"",sw:0,t:0,tr:0,fillColorAnim:!1,strokeColorAnim:!1,strokeWidthAnim:!1,yOffset:0,__complete:!1},this.searchProperty()?s.push(this):this.getValue(!0)}function BaseRenderer(){}function SVGRenderer(t,e){this.animationItem=t,this.layers=null,this.renderedFrame=-1,this.globalData={frameNum:-1},this.renderConfig={preserveAspectRatio:e&&e.preserveAspectRatio||"xMidYMid meet",progressiveLoad:e&&e.progressiveLoad||!1,hideOnTransparent:e&&e.hideOnTransparent===!1?!1:!0,viewBoxOnly:e&&e.viewBoxOnly||!1,className:e&&e.className||""},this.globalData.renderConfig=this.renderConfig,this.elements=[],this.pendingElements=[],this.destroyed=!1}function MaskElement(t,e,s){this.dynamicProperties=[],this.data=t,this.element=e,this.globalData=s,this.storedData=[],this.masksProperties=this.data.masksProperties,this.viewData=Array.apply(null,{length:this.masksProperties.length}),this.maskElement=null,this.firstFrame=!0;var r,i,a,n,o,h,l,p,m=this.globalData.defs,f=this.masksProperties.length,c=this.masksProperties,d=0,u=[],y=randomString(10),g="clipPath",v="clip-path";for(r=0;f>r;r++)if(("a"!==c[r].mode&&"n"!==c[r].mode||c[r].inv||100!==c[r].o.k)&&(g="mask",v="mask"),"s"!=c[r].mode&&"i"!=c[r].mode||0!=d?o=null:(o=document.createElementNS(svgNS,"rect"),o.setAttribute("fill","#ffffff"),o.setAttribute("width",this.element.comp.data.w),o.setAttribute("height",this.element.comp.data.h),u.push(o)),i=document.createElementNS(svgNS,"path"),"n"!=c[r].mode){if(d+=1,"s"==c[r].mode?i.setAttribute("fill","#000000"):i.setAttribute("fill","#ffffff"),i.setAttribute("clip-rule","nonzero"),0!==c[r].x.k){g="mask",v="mask",p=PropertyFactory.getProp(this.element,c[r].x,0,null,this.dynamicProperties);var b="fi_"+randomString(10);h=document.createElementNS(svgNS,"filter"),h.setAttribute("id",b),l=document.createElementNS(svgNS,"feMorphology"),l.setAttribute("operator","dilate"),l.setAttribute("in","SourceGraphic"),l.setAttribute("radius","0"),h.appendChild(l),m.appendChild(h),"s"==c[r].mode?i.setAttribute("stroke","#000000"):i.setAttribute("stroke","#ffffff")}else l=null,p=null;if(this.storedData[r]={elem:i,x:p,expan:l,lastPath:"",lastOperator:"",filterId:b,lastRadius:0},"i"==c[r].mode){n=u.length;var E=document.createElementNS(svgNS,"g");for(a=0;n>a;a+=1)E.appendChild(u[a]);var P=document.createElementNS(svgNS,"mask");P.setAttribute("mask-type","alpha"),P.setAttribute("id",y+"_"+d),P.appendChild(i),m.appendChild(P),E.setAttribute("mask","url("+locationHref+"#"+y+"_"+d+")"),u.length=0,u.push(E)}else u.push(i);c[r].inv&&!this.solidPath&&(this.solidPath=this.createLayerSolidPath()),this.viewData[r]={elem:i,lastPath:"",op:PropertyFactory.getProp(this.element,c[r].o,0,.01,this.dynamicProperties),prop:ShapePropertyFactory.getShapeProp(this.element,c[r],3,this.dynamicProperties,null)},o&&(this.viewData[r].invRect=o),this.viewData[r].prop.k||this.drawPath(c[r],this.viewData[r].prop.v,this.viewData[r])}else this.viewData[r]={op:PropertyFactory.getProp(this.element,c[r].o,0,.01,this.dynamicProperties),prop:ShapePropertyFactory.getShapeProp(this.element,c[r],3,this.dynamicProperties,null),elem:i},m.appendChild(i);for(this.maskElement=document.createElementNS(svgNS,g),f=u.length,r=0;f>r;r+=1)this.maskElement.appendChild(u[r]);this.maskElement.setAttribute("id",y),d>0&&this.element.maskedElement.setAttribute(v,"url("+locationHref+"#"+y+")"),m.appendChild(this.maskElement)}function BaseElement(){}function SVGBaseElement(t,e,s,r,i){this.globalData=s,this.comp=r,this.data=t,this.matteElement=null,this.transformedElement=null,this.isTransparent=!1,this.parentContainer=e,this.layerId=i?i.layerId:"ly_"+randomString(10),this.placeholder=i,this._sizeChanged=!1,this.init()}function IShapeElement(t,e,s,r,i){this.shapes=[],this.shapesData=t.shapes,this.stylesList=[],this.itemsData=[],this.prevViewData=[],this.shapeModifiers=[],this.processedElements=[],this._parent.constructor.call(this,t,e,s,r,i)}function ITextElement(t,e,s,r){}function SVGTextElement(t,e,s,r,i){this.textSpans=[],this.renderType="svg",this._parent.constructor.call(this,t,e,s,r,i)}function SVGTintFilter(t,e){this.filterManager=e;var s=document.createElementNS(svgNS,"feColorMatrix");if(s.setAttribute("type","matrix"),s.setAttribute("color-interpolation-filters","linearRGB"),s.setAttribute("values","0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"),s.setAttribute("result","f1"),t.appendChild(s),s=document.createElementNS(svgNS,"feColorMatrix"),s.setAttribute("type","matrix"),s.setAttribute("color-interpolation-filters","sRGB"),s.setAttribute("values","1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),s.setAttribute("result","f2"),t.appendChild(s),this.matrixFilter=s,100!==e.effectElements[2].p.v||e.effectElements[2].p.k){var r=document.createElementNS(svgNS,"feMerge");t.appendChild(r);var i;i=document.createElementNS(svgNS,"feMergeNode"),i.setAttribute("in","SourceGraphic"),r.appendChild(i),i=document.createElementNS(svgNS,"feMergeNode"),i.setAttribute("in","f2"),r.appendChild(i)}}function SVGFillFilter(t,e){this.filterManager=e;var s=document.createElementNS(svgNS,"feColorMatrix");s.setAttribute("type","matrix"),s.setAttribute("color-interpolation-filters","sRGB"),s.setAttribute("values","1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),t.appendChild(s),this.matrixFilter=s}function SVGStrokeEffect(t,e){this.initialized=!1,this.filterManager=e,this.elem=t,this.paths=[]}function SVGTritoneFilter(t,e){this.filterManager=e;var s=document.createElementNS(svgNS,"feColorMatrix");s.setAttribute("type","matrix"),s.setAttribute("color-interpolation-filters","linearRGB"),s.setAttribute("values","0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"),s.setAttribute("result","f1"),t.appendChild(s);var r=document.createElementNS(svgNS,"feComponentTransfer");r.setAttribute("color-interpolation-filters","sRGB"),t.appendChild(r),this.matrixFilter=r;var i=document.createElementNS(svgNS,"feFuncR");i.setAttribute("type","table"),r.appendChild(i),this.feFuncR=i;var a=document.createElementNS(svgNS,"feFuncG");a.setAttribute("type","table"),r.appendChild(a),this.feFuncG=a;var n=document.createElementNS(svgNS,"feFuncB");n.setAttribute("type","table"),r.appendChild(n),this.feFuncB=n}function SVGProLevelsFilter(t,e){this.filterManager=e;var s=this.filterManager.effectElements,r=document.createElementNS(svgNS,"feComponentTransfer");(s[9].p.k||0!==s[9].p.v||s[10].p.k||1!==s[10].p.v||s[11].p.k||1!==s[11].p.v||s[12].p.k||0!==s[12].p.v||s[13].p.k||1!==s[13].p.v)&&(this.feFuncR=this.createFeFunc("feFuncR",r)),(s[16].p.k||0!==s[16].p.v||s[17].p.k||1!==s[17].p.v||s[18].p.k||1!==s[18].p.v||s[19].p.k||0!==s[19].p.v||s[20].p.k||1!==s[20].p.v)&&(this.feFuncG=this.createFeFunc("feFuncG",r)),(s[23].p.k||0!==s[23].p.v||s[24].p.k||1!==s[24].p.v||s[25].p.k||1!==s[25].p.v||s[26].p.k||0!==s[26].p.v||s[27].p.k||1!==s[27].p.v)&&(this.feFuncB=this.createFeFunc("feFuncB",r)),(s[30].p.k||0!==s[30].p.v||s[31].p.k||1!==s[31].p.v||s[32].p.k||1!==s[32].p.v||s[33].p.k||0!==s[33].p.v||s[34].p.k||1!==s[34].p.v)&&(this.feFuncA=this.createFeFunc("feFuncA",r)),(this.feFuncR||this.feFuncG||this.feFuncB||this.feFuncA)&&(r.setAttribute("color-interpolation-filters","sRGB"),t.appendChild(r),r=document.createElementNS(svgNS,"feComponentTransfer")),(s[2].p.k||0!==s[2].p.v||s[3].p.k||1!==s[3].p.v||s[4].p.k||1!==s[4].p.v||s[5].p.k||0!==s[5].p.v||s[6].p.k||1!==s[6].p.v)&&(r.setAttribute("color-interpolation-filters","sRGB"),t.appendChild(r),this.feFuncRComposed=this.createFeFunc("feFuncR",r),this.feFuncGComposed=this.createFeFunc("feFuncG",r),this.feFuncBComposed=this.createFeFunc("feFuncB",r))}function SVGDropShadowEffect(t,e){t.setAttribute("x","-100%"),t.setAttribute("y","-100%"),t.setAttribute("width","400%"),t.setAttribute("height","400%"),this.filterManager=e;var s=document.createElementNS(svgNS,"feGaussianBlur");s.setAttribute("in","SourceAlpha"),s.setAttribute("result","drop_shadow_1"),s.setAttribute("stdDeviation","0"),this.feGaussianBlur=s,t.appendChild(s);var r=document.createElementNS(svgNS,"feOffset");r.setAttribute("dx","25"),r.setAttribute("dy","0"),r.setAttribute("in","drop_shadow_1"),r.setAttribute("result","drop_shadow_2"),this.feOffset=r,t.appendChild(r);var i=document.createElementNS(svgNS,"feFlood");i.setAttribute("flood-color","#00ff00"),i.setAttribute("flood-opacity","1"),i.setAttribute("result","drop_shadow_3"),this.feFlood=i,t.appendChild(i);var a=document.createElementNS(svgNS,"feComposite");a.setAttribute("in","drop_shadow_3"),a.setAttribute("in2","drop_shadow_2"),a.setAttribute("operator","in"),a.setAttribute("result","drop_shadow_4"),t.appendChild(a);var n=document.createElementNS(svgNS,"feMerge");t.appendChild(n);var o;o=document.createElementNS(svgNS,"feMergeNode"),n.appendChild(o),o=document.createElementNS(svgNS,"feMergeNode"),o.setAttribute("in","SourceGraphic"),this.feMergeNode=o,this.feMerge=n,this.originalNodeAdded=!1,n.appendChild(o)}function SVGMatte3Effect(t,e,s){this.initialized=!1,this.filterManager=e,this.filterElem=t,this.elem=s,s.matteElement=document.createElementNS(svgNS,"g"),s.matteElement.appendChild(s.layerElement),s.matteElement.appendChild(s.transformedElement),s.baseElement=s.matteElement}function SVGEffects(t){var e,s=t.data.ef.length,r=randomString(10),i=filtersFactory.createFilter(r),a=0;this.filters=[];var n;for(e=0;s>e;e+=1)20===t.data.ef[e].ty?(a+=1,n=new SVGTintFilter(i,t.effects.effectElements[e]),this.filters.push(n)):21===t.data.ef[e].ty?(a+=1,n=new SVGFillFilter(i,t.effects.effectElements[e]),this.filters.push(n)):22===t.data.ef[e].ty?(n=new SVGStrokeEffect(t,t.effects.effectElements[e]),this.filters.push(n)):23===t.data.ef[e].ty?(a+=1,n=new SVGTritoneFilter(i,t.effects.effectElements[e]),this.filters.push(n)):24===t.data.ef[e].ty?(a+=1,n=new SVGProLevelsFilter(i,t.effects.effectElements[e]),this.filters.push(n)):25===t.data.ef[e].ty?(a+=1,n=new SVGDropShadowEffect(i,t.effects.effectElements[e]),this.filters.push(n)):28===t.data.ef[e].ty&&(n=new SVGMatte3Effect(i,t.effects.effectElements[e],t),this.filters.push(n));a&&(t.globalData.defs.appendChild(i),t.layerElement.setAttribute("filter","url("+locationHref+"#"+r+")"))}function ICompElement(t,e,s,r,i){this._parent.constructor.call(this,t,e,s,r,i),this.layers=t.layers,this.supports3d=!0,this.completeLayers=!1,this.pendingElements=[],this.elements=this.layers?Array.apply(null,{length:this.layers.length}):[],this.data.tm&&(this.tm=PropertyFactory.getProp(this,this.data.tm,0,s.frameRate,this.dynamicProperties)),this.data.xt?(this.layerElement=document.createElementNS(svgNS,"g"),this.buildAllItems()):s.progressiveLoad||this.buildAllItems()}function IImageElement(t,e,s,r,i){this.assetData=s.getAssetData(t.refId),this._parent.constructor.call(this,t,e,s,r,i)}function ISolidElement(t,e,s,r,i){this._parent.constructor.call(this,t,e,s,r,i)}function CanvasRenderer(t,e){this.animationItem=t,this.renderConfig={clearCanvas:e&&void 0!==e.clearCanvas?e.clearCanvas:!0,context:e&&e.context||null,progressiveLoad:e&&e.progressiveLoad||!1,preserveAspectRatio:e&&e.preserveAspectRatio||"xMidYMid meet",className:e&&e.className||""},this.renderConfig.dpr=e&&e.dpr||1,this.animationItem.wrapper&&(this.renderConfig.dpr=e&&e.dpr||window.devicePixelRatio||1),this.renderedFrame=-1,this.globalData={frameNum:-1},this.contextData={saved:Array.apply(null,{length:15}),savedOp:Array.apply(null,{length:15}),cArrPos:0,cTr:new Matrix,cO:1};var s,r=15;for(s=0;r>s;s+=1)this.contextData.saved[s]=Array.apply(null,{length:16});this.elements=[],this.pendingElements=[],this.transformMat=new Matrix,this.completeLayers=!1}function HybridRenderer(t,e){this.animationItem=t,this.layers=null,this.renderedFrame=-1,this.globalData={frameNum:-1},this.renderConfig={className:e&&e.className||""},this.pendingElements=[],this.elements=[],this.threeDElements=[],this.destroyed=!1,this.camera=null,this.supports3d=!0}function CVBaseElement(t,e,s){this.globalData=s,this.data=t,this.comp=e,this.canvasContext=s.canvasContext,this.init()}function CVCompElement(t,e,s){this._parent.constructor.call(this,t,e,s);var r={};for(var i in s)s.hasOwnProperty(i)&&(r[i]=s[i]);r.renderer=this,r.compHeight=this.data.h,r.compWidth=this.data.w,this.renderConfig={clearCanvas:!0},this.contextData={saved:Array.apply(null,{length:15}),savedOp:Array.apply(null,{length:15}),cArrPos:0,cTr:new Matrix,cO:1},this.completeLayers=!1;var a,n=15;for(a=0;n>a;a+=1)this.contextData.saved[a]=Array.apply(null,{length:16});this.transformMat=new Matrix,this.parentGlobalData=this.globalData;var o=document.createElement("canvas");r.canvasContext=o.getContext("2d"),this.canvasContext=r.canvasContext,o.width=this.data.w,o.height=this.data.h,this.canvas=o,this.globalData=r,this.layers=t.layers,this.pendingElements=[],this.elements=Array.apply(null,{length:this.layers.length}),this.data.tm&&(this.tm=PropertyFactory.getProp(this,this.data.tm,0,s.frameRate,this.dynamicProperties)),(this.data.xt||!s.progressiveLoad)&&this.buildAllItems()}function CVImageElement(t,e,s){this.assetData=s.getAssetData(t.refId),this._parent.constructor.call(this,t,e,s),this.globalData.addPendingElement()}function CVMaskElement(t,e){this.data=t,this.element=e,this.dynamicProperties=[],this.masksProperties=this.data.masksProperties,this.viewData=Array.apply(null,{length:this.masksProperties.length});var s,r=this.masksProperties.length;for(s=0;r>s;s++)this.viewData[s]=ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[s],3,this.dynamicProperties,null)}function CVShapeElement(t,e,s){this.shapes=[],this.shapesData=t.shapes,this.stylesList=[],this.itemsData=[],this.prevViewData=[],this.shapeModifiers=[],this.processedElements=[],this._parent.constructor.call(this,t,e,s)}function CVSolidElement(t,e,s){this._parent.constructor.call(this,t,e,s)}function CVTextElement(t,e,s){this.textSpans=[],this.yOffset=0,this.fillColorAnim=!1,this.strokeColorAnim=!1,this.strokeWidthAnim=!1,this.stroke=!1,this.fill=!1,this.justifyOffset=0,this.currentRender=null,this.renderType="canvas",this.values={fill:"rgba(0,0,0,0)",stroke:"rgba(0,0,0,0)",sWidth:0,fValue:""},this._parent.constructor.call(this,t,e,s)}function HBaseElement(t,e,s,r,i){this.globalData=s,this.comp=r,this.data=t,this.matteElement=null,this.parentContainer=e,this.layerId=i?i.layerId:"ly_"+randomString(10),this.placeholder=i,this.init()}function HSolidElement(t,e,s,r,i){this._parent.constructor.call(this,t,e,s,r,i)}function HCompElement(t,e,s,r,i){this._parent.constructor.call(this,t,e,s,r,i),this.layers=t.layers,this.supports3d=!0,this.completeLayers=!1,this.pendingElements=[],this.elements=Array.apply(null,{length:this.layers.length}),this.data.tm&&(this.tm=PropertyFactory.getProp(this,this.data.tm,0,s.frameRate,this.dynamicProperties)),this.data.hasMask&&(this.supports3d=!1),this.data.xt&&(this.layerElement=document.createElement("div")),this.buildAllItems()}function HShapeElement(t,e,s,r,i){this.shapes=[],this.shapesData=t.shapes,this.stylesList=[],this.itemsData=[],this.prevViewData=[],this.shapeModifiers=[],this.processedElements=[],this._parent.constructor.call(this,t,e,s,r,i),this.currentBBox={x:999999,y:-999999,h:0,w:0}}function HTextElement(t,e,s,r,i){this.textSpans=[],this.textPaths=[],this.currentBBox={x:999999,y:-999999,h:0,w:0},this.renderType="svg",this.isMasked=!1,this._parent.constructor.call(this,t,e,s,r,i)}function HImageElement(t,e,s,r,i){this.assetData=s.getAssetData(t.refId),this._parent.constructor.call(this,t,e,s,r,i)}function HCameraElement(t,e,s,r,i){this._parent.constructor.call(this,t,e,s,r,i);var a=PropertyFactory.getProp;if(this.pe=a(this,t.pe,0,0,this.dynamicProperties),t.ks.p.s?(this.px=a(this,t.ks.p.x,1,0,this.dynamicProperties),this.py=a(this,t.ks.p.y,1,0,this.dynamicProperties),this.pz=a(this,t.ks.p.z,1,0,this.dynamicProperties)):this.p=a(this,t.ks.p,1,0,this.dynamicProperties),t.ks.a&&(this.a=a(this,t.ks.a,1,0,this.dynamicProperties)),t.ks.or.k.length&&t.ks.or.k[0].to){var n,o=t.ks.or.k.length;for(n=0;o>n;n+=1)t.ks.or.k[n].to=null,t.ks.or.k[n].ti=null}this.or=a(this,t.ks.or,1,degToRads,this.dynamicProperties),this.or.sh=!0,this.rx=a(this,t.ks.rx,0,degToRads,this.dynamicProperties),this.ry=a(this,t.ks.ry,0,degToRads,this.dynamicProperties),this.rz=a(this,t.ks.rz,0,degToRads,this.dynamicProperties),this.mat=new Matrix}function SliderEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,0,0,s)}function AngleEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,0,0,s)}function ColorEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,1,0,s)}function PointEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,1,0,s)}function LayerIndexEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,0,0,s)}function MaskIndexEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,0,0,s)}function CheckboxEffect(t,e,s){this.p=PropertyFactory.getProp(e,t.v,0,0,s)}function NoValueEffect(){this.p={}}function EffectsManager(t,e,s){var r=t.ef;this.effectElements=[];var i,a,n=r.length;for(i=0;n>i;i++)a=new GroupEffect(r[i],e,s),this.effectElements.push(a)}function GroupEffect(t,e,s){this.dynamicProperties=[],this.init(t,e,this.dynamicProperties),this.dynamicProperties.length&&s.push(this)}function setLocationHref(t){locationHref=t}function play(t){animationManager.play(t)}function pause(t){animationManager.pause(t)}function togglePause(t){animationManager.togglePause(t)}function setSpeed(t,e){animationManager.setSpeed(t,e)}function setDirection(t,e){animationManager.setDirection(t,e)}function stop(t){animationManager.stop(t)}function moveFrame(t){animationManager.moveFrame(t)}function searchAnimations(){standalone===!0?animationManager.searchAnimations(animationData,standalone,renderer):animationManager.searchAnimations()}function registerAnimation(t){return animationManager.registerAnimation(t)}function resize(){animationManager.resize()}function start(){animationManager.start()}function goToAndStop(t,e,s){animationManager.goToAndStop(t,e,s)}function setSubframeRendering(t){subframeEnabled=t}function loadAnimation(t){return standalone===!0&&(t.animationData=JSON.parse(animationData)),animationManager.loadAnimation(t)}function destroy(t){return animationManager.destroy(t)}function setQuality(t){if("string"==typeof t)switch(t){case"high":defaultCurveSegments=200;break;case"medium":defaultCurveSegments=50;break;case"low":defaultCurveSegments=10}else!isNaN(t)&&t>1&&(defaultCurveSegments=t);roundValues(defaultCurveSegments>=50?!1:!0)}function inBrowser(){return"undefined"!=typeof navigator}function installPlugin(t,e){"expressions"===t&&(expressionsPlugin=e)}function getFactory(t){switch(t){case"propertyFactory":return PropertyFactory;case"shapePropertyFactory":return ShapePropertyFactory;case"matrix":return Matrix}}function checkReady(){"complete"===document.readyState&&(clearInterval(readyStateCheckInterval),searchAnimations())}function getQueryVariable(t){for(var e=queryString.split("&"),s=0;s<e.length;s++){var r=e[s].split("=");if(decodeURIComponent(r[0])==t)return decodeURIComponent(r[1])}}var svgNS="http://www.w3.org/2000/svg",locationHref="",subframeEnabled=!0,expressionsPlugin,isSafari=/^((?!chrome|android).)*safari/i.test(navigator.userAgent),cachedColors={},bm_rounder=Math.round,bm_rnd,bm_pow=Math.pow,bm_sqrt=Math.sqrt,bm_abs=Math.abs,bm_floor=Math.floor,bm_max=Math.max,bm_min=Math.min,blitter=10,BMMath={};!function(){var t,e=Object.getOwnPropertyNames(Math),s=e.length;for(t=0;s>t;t+=1)BMMath[e[t]]=Math[e[t]]}(),BMMath.random=Math.random,BMMath.abs=function(t){var e=typeof t;if("object"===e&&t.length){var s,r=Array.apply(null,{length:t.length}),i=t.length;for(s=0;i>s;s+=1)r[s]=Math.abs(t[s]);return r}return Math.abs(t)};var defaultCurveSegments=150,degToRads=Math.PI/180,roundCorner=.5519;roundValues(!1);var rgbToHex=function(){var t,e,s=[];for(t=0;256>t;t+=1)e=t.toString(16),s[t]=1==e.length?"0"+e:e;return function(t,e,r){return 0>t&&(t=0),0>e&&(e=0),0>r&&(r=0),"#"+s[t]+s[e]+s[r]}}(),fillColorToString=function(){var t=[];return function(e,s){return void 0!==s&&(e[3]=s),t[e[0]]||(t[e[0]]={}),t[e[0]][e[1]]||(t[e[0]][e[1]]={}),t[e[0]][e[1]][e[2]]||(t[e[0]][e[1]][e[2]]={}),
t[e[0]][e[1]][e[2]][e[3]]||(t[e[0]][e[1]][e[2]][e[3]]="rgba("+e.join(",")+")"),t[e[0]][e[1]][e[2]][e[3]]}}(),Matrix=function(){function t(){return this.props[0]=1,this.props[1]=0,this.props[2]=0,this.props[3]=0,this.props[4]=0,this.props[5]=1,this.props[6]=0,this.props[7]=0,this.props[8]=0,this.props[9]=0,this.props[10]=1,this.props[11]=0,this.props[12]=0,this.props[13]=0,this.props[14]=0,this.props[15]=1,this}function e(t){if(0===t)return this;var e=Math.cos(t),s=Math.sin(t);return this._t(e,-s,0,0,s,e,0,0,0,0,1,0,0,0,0,1)}function s(t){if(0===t)return this;var e=Math.cos(t),s=Math.sin(t);return this._t(1,0,0,0,0,e,-s,0,0,s,e,0,0,0,0,1)}function r(t){if(0===t)return this;var e=Math.cos(t),s=Math.sin(t);return this._t(e,0,s,0,0,1,0,0,-s,0,e,0,0,0,0,1)}function i(t){if(0===t)return this;var e=Math.cos(t),s=Math.sin(t);return this._t(e,-s,0,0,s,e,0,0,0,0,1,0,0,0,0,1)}function a(t,e){return this._t(1,e,t,1,0,0)}function n(t,e){return this.shear(Math.tan(t),Math.tan(e))}function o(t,e){var s=Math.cos(e),r=Math.sin(e);return this._t(s,r,0,0,-r,s,0,0,0,0,1,0,0,0,0,1)._t(1,0,0,0,Math.tan(t),1,0,0,0,0,1,0,0,0,0,1)._t(s,-r,0,0,r,s,0,0,0,0,1,0,0,0,0,1)}function h(t,e,s){return s=isNaN(s)?1:s,1==t&&1==e&&1==s?this:this._t(t,0,0,0,0,e,0,0,0,0,s,0,0,0,0,1)}function l(t,e,s,r,i,a,n,o,h,l,p,m,f,c,d,u){return this.props[0]=t,this.props[1]=e,this.props[2]=s,this.props[3]=r,this.props[4]=i,this.props[5]=a,this.props[6]=n,this.props[7]=o,this.props[8]=h,this.props[9]=l,this.props[10]=p,this.props[11]=m,this.props[12]=f,this.props[13]=c,this.props[14]=d,this.props[15]=u,this}function p(t,e,s){return s=s||0,0!==t||0!==e||0!==s?this._t(1,0,0,0,0,1,0,0,0,0,1,0,t,e,s,1):this}function m(t,e,s,r,i,a,n,o,h,l,p,m,f,c,d,u){if(1===t&&0===e&&0===s&&0===r&&0===i&&1===a&&0===n&&0===o&&0===h&&0===l&&1===p&&0===m)return(0!==f||0!==c||0!==d)&&(this.props[12]=this.props[12]*t+this.props[13]*i+this.props[14]*h+this.props[15]*f,this.props[13]=this.props[12]*e+this.props[13]*a+this.props[14]*l+this.props[15]*c,this.props[14]=this.props[12]*s+this.props[13]*n+this.props[14]*p+this.props[15]*d,this.props[15]=this.props[12]*r+this.props[13]*o+this.props[14]*m+this.props[15]*u),this._identityCalculated=!1,this;var y=this.props[0],g=this.props[1],v=this.props[2],b=this.props[3],E=this.props[4],P=this.props[5],x=this.props[6],S=this.props[7],C=this.props[8],k=this.props[9],A=this.props[10],M=this.props[11],D=this.props[12],T=this.props[13],w=this.props[14],_=this.props[15];return this.props[0]=y*t+g*i+v*h+b*f,this.props[1]=y*e+g*a+v*l+b*c,this.props[2]=y*s+g*n+v*p+b*d,this.props[3]=y*r+g*o+v*m+b*u,this.props[4]=E*t+P*i+x*h+S*f,this.props[5]=E*e+P*a+x*l+S*c,this.props[6]=E*s+P*n+x*p+S*d,this.props[7]=E*r+P*o+x*m+S*u,this.props[8]=C*t+k*i+A*h+M*f,this.props[9]=C*e+k*a+A*l+M*c,this.props[10]=C*s+k*n+A*p+M*d,this.props[11]=C*r+k*o+A*m+M*u,this.props[12]=D*t+T*i+w*h+_*f,this.props[13]=D*e+T*a+w*l+_*c,this.props[14]=D*s+T*n+w*p+_*d,this.props[15]=D*r+T*o+w*m+_*u,this._identityCalculated=!1,this}function f(){return this._identityCalculated||(this._identity=!(1!==this.props[0]||0!==this.props[1]||0!==this.props[2]||0!==this.props[3]||0!==this.props[4]||1!==this.props[5]||0!==this.props[6]||0!==this.props[7]||0!==this.props[8]||0!==this.props[9]||1!==this.props[10]||0!==this.props[11]||0!==this.props[12]||0!==this.props[13]||0!==this.props[14]||1!==this.props[15]),this._identityCalculated=!0),this._identity}function c(t){var e;for(e=0;16>e;e+=1)t.props[e]=this.props[e]}function d(t){var e;for(e=0;16>e;e+=1)this.props[e]=t[e]}function u(t,e,s){return{x:t*this.props[0]+e*this.props[4]+s*this.props[8]+this.props[12],y:t*this.props[1]+e*this.props[5]+s*this.props[9]+this.props[13],z:t*this.props[2]+e*this.props[6]+s*this.props[10]+this.props[14]}}function y(t,e,s){return t*this.props[0]+e*this.props[4]+s*this.props[8]+this.props[12]}function g(t,e,s){return t*this.props[1]+e*this.props[5]+s*this.props[9]+this.props[13]}function v(t,e,s){return t*this.props[2]+e*this.props[6]+s*this.props[10]+this.props[14]}function b(t){var e=this.props[0]*this.props[5]-this.props[1]*this.props[4],s=this.props[5]/e,r=-this.props[1]/e,i=-this.props[4]/e,a=this.props[0]/e,n=(this.props[4]*this.props[13]-this.props[5]*this.props[12])/e,o=-(this.props[0]*this.props[13]-this.props[1]*this.props[12])/e;return[t[0]*s+t[1]*i+n,t[0]*r+t[1]*a+o,0]}function E(t){var e,s=t.length,r=[];for(e=0;s>e;e+=1)r[e]=b(t[e]);return r}function P(t,e,s,r){if(r&&2===r){var i=point_pool.newPoint();return i[0]=t*this.props[0]+e*this.props[4]+s*this.props[8]+this.props[12],i[1]=t*this.props[1]+e*this.props[5]+s*this.props[9]+this.props[13],i}return[t*this.props[0]+e*this.props[4]+s*this.props[8]+this.props[12],t*this.props[1]+e*this.props[5]+s*this.props[9]+this.props[13],t*this.props[2]+e*this.props[6]+s*this.props[10]+this.props[14]]}function x(t,e){return this.isIdentity()?t+","+e:bm_rnd(t*this.props[0]+e*this.props[4]+this.props[12])+","+bm_rnd(t*this.props[1]+e*this.props[5]+this.props[13])}function S(){return[this.props[0],this.props[1],this.props[2],this.props[3],this.props[4],this.props[5],this.props[6],this.props[7],this.props[8],this.props[9],this.props[10],this.props[11],this.props[12],this.props[13],this.props[14],this.props[15]]}function C(){return isSafari?"matrix3d("+roundTo2Decimals(this.props[0])+","+roundTo2Decimals(this.props[1])+","+roundTo2Decimals(this.props[2])+","+roundTo2Decimals(this.props[3])+","+roundTo2Decimals(this.props[4])+","+roundTo2Decimals(this.props[5])+","+roundTo2Decimals(this.props[6])+","+roundTo2Decimals(this.props[7])+","+roundTo2Decimals(this.props[8])+","+roundTo2Decimals(this.props[9])+","+roundTo2Decimals(this.props[10])+","+roundTo2Decimals(this.props[11])+","+roundTo2Decimals(this.props[12])+","+roundTo2Decimals(this.props[13])+","+roundTo2Decimals(this.props[14])+","+roundTo2Decimals(this.props[15])+")":(this.cssParts[1]=this.props.join(","),this.cssParts.join(""))}function k(){return"matrix("+roundTo2Decimals(this.props[0])+","+roundTo2Decimals(this.props[1])+","+roundTo2Decimals(this.props[4])+","+roundTo2Decimals(this.props[5])+","+roundTo2Decimals(this.props[12])+","+roundTo2Decimals(this.props[13])+")"}function A(){return""+this.toArray()}return function(){this.reset=t,this.rotate=e,this.rotateX=s,this.rotateY=r,this.rotateZ=i,this.skew=n,this.skewFromAxis=o,this.shear=a,this.scale=h,this.setTransform=l,this.translate=p,this.transform=m,this.applyToPoint=u,this.applyToX=y,this.applyToY=g,this.applyToZ=v,this.applyToPointArray=P,this.applyToPointStringified=x,this.toArray=S,this.toCSS=C,this.to2dCSS=k,this.toString=A,this.clone=c,this.cloneFromProps=d,this.inversePoints=E,this.inversePoint=b,this._t=this.transform,this.isIdentity=f,this._identity=!0,this._identityCalculated=!1,this.props=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],this.cssParts=["matrix3d(","",")"]}}();!function(t,e){function s(s,l,p){var c=[];l=1==l?{entropy:!0}:l||{};var v=n(a(l.entropy?[s,h(t)]:null==s?o():s,3),c),b=new r(c),E=function(){for(var t=b.g(f),e=u,s=0;y>t;)t=(t+s)*m,e*=m,s=b.g(1);for(;t>=g;)t/=2,e/=2,s>>>=1;return(t+s)/e};return E.int32=function(){return 0|b.g(4)},E.quick=function(){return b.g(4)/4294967296},E["double"]=E,n(h(b.S),t),(l.pass||p||function(t,s,r,a){return a&&(a.S&&i(a,b),t.state=function(){return i(b,{})}),r?(e[d]=t,s):t})(E,v,"global"in l?l.global:this==e,l.state)}function r(t){var e,s=t.length,r=this,i=0,a=r.i=r.j=0,n=r.S=[];for(s||(t=[s++]);m>i;)n[i]=i++;for(i=0;m>i;i++)n[i]=n[a=v&a+t[i%s]+(e=n[i])],n[a]=e;(r.g=function(t){for(var e,s=0,i=r.i,a=r.j,n=r.S;t--;)e=n[i=v&i+1],s=s*m+n[v&(n[i]=n[a=v&a+e])+(n[a]=e)];return r.i=i,r.j=a,s})(m)}function i(t,e){return e.i=t.i,e.j=t.j,e.S=t.S.slice(),e}function a(t,e){var s,r=[],i=typeof t;if(e&&"object"==i)for(s in t)try{r.push(a(t[s],e-1))}catch(n){}return r.length?r:"string"==i?t:t+"\x00"}function n(t,e){for(var s,r=t+"",i=0;i<r.length;)e[v&i]=v&(s^=19*e[v&i])+r.charCodeAt(i++);return h(e)}function o(){try{if(l)return h(l.randomBytes(m));var e=new Uint8Array(m);return(p.crypto||p.msCrypto).getRandomValues(e),h(e)}catch(s){var r=p.navigator,i=r&&r.plugins;return[+new Date,p,i,p.screen,h(t)]}}function h(t){return String.fromCharCode.apply(0,t)}var l,p=this,m=256,f=6,c=52,d="random",u=e.pow(m,f),y=e.pow(2,c),g=2*y,v=m-1;e["seed"+d]=s,n(e.random(),t)}([],BMMath);var BezierFactory=function(){function t(t,e,s,r,i){var a=i||("bez_"+t+"_"+e+"_"+s+"_"+r).replace(/\./g,"p");if(p[a])return p[a];var n=new h([t,e,s,r]);return p[a]=n,n}function e(t,e){return 1-3*e+3*t}function s(t,e){return 3*e-6*t}function r(t){return 3*t}function i(t,i,a){return((e(i,a)*t+s(i,a))*t+r(i))*t}function a(t,i,a){return 3*e(i,a)*t*t+2*s(i,a)*t+r(i)}function n(t,e,s,r,a){var n,o,h=0;do o=e+(s-e)/2,n=i(o,r,a)-t,n>0?s=o:e=o;while(Math.abs(n)>c&&++h<d);return o}function o(t,e,s,r){for(var n=0;m>n;++n){var o=a(e,s,r);if(0===o)return e;var h=i(e,s,r)-t;e-=h/o}return e}function h(t){this._p=t,this._mSampleValues=g?new Float32Array(u):new Array(u),this._precomputed=!1,this.get=this.get.bind(this)}var l={};l.getBezierEasing=t;var p={},m=4,f=.001,c=1e-7,d=10,u=11,y=1/(u-1),g="function"==typeof Float32Array;return h.prototype={get:function(t){var e=this._p[0],s=this._p[1],r=this._p[2],a=this._p[3];return this._precomputed||this._precompute(),e===s&&r===a?t:0===t?0:1===t?1:i(this._getTForX(t),s,a)},_precompute:function(){var t=this._p[0],e=this._p[1],s=this._p[2],r=this._p[3];this._precomputed=!0,(t!==e||s!==r)&&this._calcSampleValues()},_calcSampleValues:function(){for(var t=this._p[0],e=this._p[2],s=0;u>s;++s)this._mSampleValues[s]=i(s*y,t,e)},_getTForX:function(t){for(var e=this._p[0],s=this._p[2],r=this._mSampleValues,i=0,h=1,l=u-1;h!==l&&r[h]<=t;++h)i+=y;--h;var p=(t-r[h])/(r[h+1]-r[h]),m=i+p*y,c=a(m,e,s);return c>=f?o(t,m,e,s):0===c?m:n(t,i,i+y,e,s)}},l}();!function(){for(var t=0,e=["ms","moz","webkit","o"],s=0;s<e.length&&!window.requestAnimationFrame;++s)window.requestAnimationFrame=window[e[s]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[e[s]+"CancelAnimationFrame"]||window[e[s]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(e,s){var r=(new Date).getTime(),i=Math.max(0,16-(r-t)),a=setTimeout(function(){e(r+i)},i);return t=r+i,a}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(t){clearTimeout(t)})}();var bez=bezFunction(),dataManager=dataFunctionManager(),FontManager=function(){function t(t,e){var s=document.createElement("span");s.style.fontFamily=e;var r=document.createElement("span");r.innerHTML="giItT1WQy@!-/#",s.style.position="absolute",s.style.left="-10000px",s.style.top="-10000px",s.style.fontSize="300px",s.style.fontVariant="normal",s.style.fontStyle="normal",s.style.fontWeight="normal",s.style.letterSpacing="0",s.appendChild(r),document.body.appendChild(s);var i=r.offsetWidth;return r.style.fontFamily=t+", "+e,{node:r,w:i,parent:s}}function e(){var t,s,r,i=this.fonts.length,a=i;for(t=0;i>t;t+=1)if(this.fonts[t].loaded)a-=1;else if("t"===this.fonts[t].fOrigin||2===this.fonts[t].origin){if(window.Typekit&&window.Typekit.load&&0===this.typekitLoaded){this.typekitLoaded=1;try{window.Typekit.load({async:!0,active:function(){this.typekitLoaded=2}.bind(this)})}catch(n){}}2===this.typekitLoaded&&(this.fonts[t].loaded=!0)}else"n"===this.fonts[t].fOrigin||0===this.fonts[t].origin?this.fonts[t].loaded=!0:(s=this.fonts[t].monoCase.node,r=this.fonts[t].monoCase.w,s.offsetWidth!==r?(a-=1,this.fonts[t].loaded=!0):(s=this.fonts[t].sansCase.node,r=this.fonts[t].sansCase.w,s.offsetWidth!==r&&(a-=1,this.fonts[t].loaded=!0)),this.fonts[t].loaded&&(this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent),this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));0!==a&&Date.now()-this.initTime<h?setTimeout(e.bind(this),20):setTimeout(function(){this.loaded=!0}.bind(this),0)}function s(t,e){var s=document.createElementNS(svgNS,"text");s.style.fontSize="100px",s.style.fontFamily=e.fFamily,s.textContent="1",e.fClass?(s.style.fontFamily="inherit",s.className=e.fClass):s.style.fontFamily=e.fFamily,t.appendChild(s);var r=document.createElement("canvas").getContext("2d");return r.font="100px "+e.fFamily,r}function r(r,i){if(!r)return void(this.loaded=!0);if(this.chars)return this.loaded=!0,void(this.fonts=r.list);var a,n=r.list,o=n.length;for(a=0;o>a;a+=1){if(n[a].loaded=!1,n[a].monoCase=t(n[a].fFamily,"monospace"),n[a].sansCase=t(n[a].fFamily,"sans-serif"),n[a].fPath){if("p"===n[a].fOrigin||3===n[a].origin){var h=document.createElement("style");h.type="text/css",h.innerHTML="@font-face {font-family: "+n[a].fFamily+"; font-style: normal; src: url('"+n[a].fPath+"');}",i.appendChild(h)}else if("g"===n[a].fOrigin||1===n[a].origin){var l=document.createElement("link");l.type="text/css",l.rel="stylesheet",l.href=n[a].fPath,i.appendChild(l)}else if("t"===n[a].fOrigin||2===n[a].origin){var p=document.createElement("script");p.setAttribute("src",n[a].fPath),i.appendChild(p)}}else n[a].loaded=!0;n[a].helper=s(i,n[a]),this.fonts.push(n[a])}e.bind(this)()}function i(t){if(t){this.chars||(this.chars=[]);var e,s,r,i=t.length,a=this.chars.length;for(e=0;i>e;e+=1){for(s=0,r=!1;a>s;)this.chars[s].style===t[e].style&&this.chars[s].fFamily===t[e].fFamily&&this.chars[s].ch===t[e].ch&&(r=!0),s+=1;r||(this.chars.push(t[e]),a+=1)}}}function a(t,e,s){for(var r=0,i=this.chars.length;i>r;){if(this.chars[r].ch===t&&this.chars[r].style===e&&this.chars[r].fFamily===s)return this.chars[r];r+=1}}function n(t,e,s){var r=this.getFontByName(e),i=r.helper;return i.measureText(t).width*s/100}function o(t){for(var e=0,s=this.fonts.length;s>e;){if(this.fonts[e].fName===t)return this.fonts[e];e+=1}return"sans-serif"}var h=5e3,l=function(){this.fonts=[],this.chars=null,this.typekitLoaded=0,this.loaded=!1,this.initTime=Date.now()};return l.prototype.addChars=i,l.prototype.addFonts=r,l.prototype.getCharData=a,l.prototype.getFontByName=o,l.prototype.measureText=n,l}(),PropertyFactory=function(){function t(t,e,s,r){var i,a=this.offsetTime;s.constructor===Array&&(i=Array.apply(null,{length:s.length}));for(var n,o,h=e,l=this.keyframes.length-1,p=!0;p;){if(n=this.keyframes[h],o=this.keyframes[h+1],h==l-1&&t>=o.t-a){n.h&&(n=o),e=0;break}if(o.t-a>t){e=h;break}l-1>h?h+=1:(e=0,p=!1)}var m,f,c,d,u,y;if(n.to){n.bezierData||bez.buildBezierData(n);var g=n.bezierData;if(t>=o.t-a||t<n.t-a){var v=t>=o.t-a?g.points.length-1:0;for(f=g.points[v].point.length,m=0;f>m;m+=1)i[m]=g.points[v].point[m];r._lastBezierData=null}else{n.__fnct?y=n.__fnct:(y=BezierFactory.getBezierEasing(n.o.x,n.o.y,n.i.x,n.i.y,n.n).get,n.__fnct=y),c=y((t-(n.t-a))/(o.t-a-(n.t-a)));var b,E=g.segmentLength*c,P=r.lastFrame<t&&r._lastBezierData===g?r._lastAddedLength:0;for(u=r.lastFrame<t&&r._lastBezierData===g?r._lastPoint:0,p=!0,d=g.points.length;p;){if(P+=g.points[u].partialLength,0===E||0===c||u==g.points.length-1){for(f=g.points[u].point.length,m=0;f>m;m+=1)i[m]=g.points[u].point[m];break}if(E>=P&&E<P+g.points[u+1].partialLength){for(b=(E-P)/g.points[u+1].partialLength,f=g.points[u].point.length,m=0;f>m;m+=1)i[m]=g.points[u].point[m]+(g.points[u+1].point[m]-g.points[u].point[m])*b;break}d-1>u?u+=1:p=!1}r._lastPoint=u,r._lastAddedLength=P-g.points[u].partialLength,r._lastBezierData=g}}else{var x,S,C,k,A;for(l=n.s.length,h=0;l>h;h+=1){if(1!==n.h&&(t>=o.t-a?c=1:t<n.t-a?c=0:(n.o.x.constructor===Array?(n.__fnct||(n.__fnct=[]),n.__fnct[h]?y=n.__fnct[h]:(x=n.o.x[h]||n.o.x[0],S=n.o.y[h]||n.o.y[0],C=n.i.x[h]||n.i.x[0],k=n.i.y[h]||n.i.y[0],y=BezierFactory.getBezierEasing(x,S,C,k).get,n.__fnct[h]=y)):n.__fnct?y=n.__fnct:(x=n.o.x,S=n.o.y,C=n.i.x,k=n.i.y,y=BezierFactory.getBezierEasing(x,S,C,k).get,n.__fnct=y),c=y((t-(n.t-a))/(o.t-a-(n.t-a))))),this.sh&&1!==n.h){var M=n.s[h],D=n.e[h];-180>M-D?M+=360:M-D>180&&(M-=360),A=M+(D-M)*c}else A=1===n.h?n.s[h]:n.s[h]+(n.e[h]-n.s[h])*c;1===l?i=A:i[h]=A}}return{value:i,iterationIndex:e}}function e(){if(this.elem.globalData.frameId!==this.frameId){this.mdf=!1;var t=this.comp.renderedFrame-this.offsetTime,e=this.keyframes[0].t-this.offsetTime,s=this.keyframes[this.keyframes.length-1].t-this.offsetTime;if(!(t===this._caching.lastFrame||this._caching.lastFrame!==p&&(this._caching.lastFrame>=s&&t>=s||this._caching.lastFrame<e&&e>t))){var r=this._caching.lastFrame<t?this._caching.lastIndex:0,i=this.interpolateValue(t,r,this.pv,this._caching);if(this._caching.lastIndex=i.iterationIndex,this.pv.constructor===Array)for(r=0;r<this.v.length;)this.pv[r]=i.value[r],this.v[r]=this.mult?this.pv[r]*this.mult:this.pv[r],this.lastPValue[r]!==this.pv[r]&&(this.mdf=!0,this.lastPValue[r]=this.pv[r]),r+=1;else this.pv=i.value,this.v=this.mult?this.pv*this.mult:this.pv,this.lastPValue!=this.pv&&(this.mdf=!0,this.lastPValue=this.pv)}this._caching.lastFrame=t,this.frameId=this.elem.globalData.frameId}}function s(){}function r(t,e,r){this.mult=r,this.v=r?e.k*r:e.k,this.pv=e.k,this.mdf=!1,this.comp=t.comp,this.k=!1,this.kf=!1,this.vel=0,this.getValue=s}function i(t,e,r){this.mult=r,this.data=e,this.mdf=!1,this.comp=t.comp,this.k=!1,this.kf=!1,this.frameId=-1,this.v=Array.apply(null,{length:e.k.length}),this.pv=Array.apply(null,{length:e.k.length}),this.lastValue=Array.apply(null,{length:e.k.length});var i=Array.apply(null,{length:e.k.length});this.vel=i.map(function(){return 0});var a,n=e.k.length;for(a=0;n>a;a+=1)this.v[a]=r?e.k[a]*r:e.k[a],this.pv[a]=e.k[a];this.getValue=s}function a(s,r,i){this.keyframes=r.k,this.offsetTime=s.data.st,this.lastValue=-99999,this.lastPValue=-99999,this.frameId=-1,this._caching={lastFrame:p,lastIndex:0},this.k=!0,this.kf=!0,this.data=r,this.mult=i,this.elem=s,this.comp=s.comp,this.v=i?r.k[0].s[0]*i:r.k[0].s[0],this.pv=r.k[0].s[0],this.getValue=e,this.interpolateValue=t}function n(s,r,i){var a,n,o,h,l,m=r.k.length;for(a=0;m-1>a;a+=1)r.k[a].to&&r.k[a].s&&r.k[a].e&&(n=r.k[a].s,o=r.k[a].e,h=r.k[a].to,l=r.k[a].ti,(2===n.length&&(n[0]!==o[0]||n[1]!==o[1])&&bez.pointOnLine2D(n[0],n[1],o[0],o[1],n[0]+h[0],n[1]+h[1])&&bez.pointOnLine2D(n[0],n[1],o[0],o[1],o[0]+l[0],o[1]+l[1])||3===n.length&&(n[0]!==o[0]||n[1]!==o[1]||n[2]!==o[2])&&bez.pointOnLine3D(n[0],n[1],n[2],o[0],o[1],o[2],n[0]+h[0],n[1]+h[1],n[2]+h[2])&&bez.pointOnLine3D(n[0],n[1],n[2],o[0],o[1],o[2],o[0]+l[0],o[1]+l[1],o[2]+l[2]))&&(r.k[a].to=null,r.k[a].ti=null));this.keyframes=r.k,this.offsetTime=s.data.st,this.k=!0,this.kf=!0,this.mult=i,this.elem=s,this.comp=s.comp,this._caching={lastFrame:p,lastIndex:0},this.getValue=e,this.interpolateValue=t,this.frameId=-1,this.v=Array.apply(null,{length:r.k[0].s.length}),this.pv=Array.apply(null,{length:r.k[0].s.length}),this.lastValue=Array.apply(null,{length:r.k[0].s.length}),this.lastPValue=Array.apply(null,{length:r.k[0].s.length})}function o(t,e,s,o,h){var l;if(2===s)l=new m(t,e,h);else if(0===e.a)l=0===s?new r(t,e,o):new i(t,e,o);else if(1===e.a)l=0===s?new a(t,e,o):new n(t,e,o);else if(e.k.length)if("number"==typeof e.k[0])l=new i(t,e,o);else switch(s){case 0:l=new a(t,e,o);break;case 1:l=new n(t,e,o)}else l=new r(t,e,o);return l.k&&h.push(l),l}function h(t,e,s,r){return new c(t,e,s,r)}function l(t,e,s){return new d(t,e,s)}var p=-999999,m=function(){function t(){return this.p?ExpressionValue(this.p):[this.px.v,this.py.v,this.pz?this.pz.v:0]}function e(){return ExpressionValue(this.px)}function s(){return ExpressionValue(this.py)}function r(){return ExpressionValue(this.a)}function i(){return ExpressionValue(this.or)}function a(){return this.r?ExpressionValue(this.r,1/degToRads):ExpressionValue(this.rz,1/degToRads)}function n(){return ExpressionValue(this.s,100)}function o(){return ExpressionValue(this.o,100)}function h(){return ExpressionValue(this.sk)}function l(){return ExpressionValue(this.sa)}function p(t){var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(),this.dynamicProperties[e].mdf&&(this.mdf=!0);this.a&&t.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]),this.s&&t.scale(this.s.v[0],this.s.v[1],this.s.v[2]),this.r?t.rotate(-this.r.v):t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),this.data.p.s?this.data.p.z?t.translate(this.px.v,this.py.v,-this.pz.v):t.translate(this.px.v,this.py.v,0):t.translate(this.p.v[0],this.p.v[1],-this.p.v[2])}function m(){if(this.elem.globalData.frameId!==this.frameId){this.mdf=!1;var t,e=this.dynamicProperties.length;for(t=0;e>t;t+=1)this.dynamicProperties[t].getValue(),this.dynamicProperties[t].mdf&&(this.mdf=!0);if(this.mdf){if(this.v.reset(),this.a&&this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]),this.s&&this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]),this.sk&&this.v.skewFromAxis(-this.sk.v,this.sa.v),this.r?this.v.rotate(-this.r.v):this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),this.autoOriented&&this.p.keyframes&&this.p.getValueAtTime){var s,r;this.p._caching.lastFrame+this.p.offsetTime<=this.p.keyframes[0].t?(s=this.p.getValueAtTime((this.p.keyframes[0].t+.01)/this.elem.globalData.frameRate,0),r=this.p.getValueAtTime(this.p.keyframes[0].t/this.elem.globalData.frameRate,0)):this.p._caching.lastFrame+this.p.offsetTime>=this.p.keyframes[this.p.keyframes.length-1].t?(s=this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length-1].t/this.elem.globalData.frameRate,0),r=this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length-1].t-.01)/this.elem.globalData.frameRate,0)):(s=this.p.pv,r=this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime-.01)/this.elem.globalData.frameRate,this.p.offsetTime)),this.v.rotate(-Math.atan2(s[1]-r[1],s[0]-r[0]))}this.data.p.s?this.data.p.z?this.v.translate(this.px.v,this.py.v,-this.pz.v):this.v.translate(this.px.v,this.py.v,0):this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2])}this.frameId=this.elem.globalData.frameId}}function f(){this.inverted=!0,this.iv=new Matrix,this.k||(this.data.p.s?this.iv.translate(this.px.v,this.py.v,-this.pz.v):this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]),this.r?this.iv.rotate(-this.r.v):this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),this.s&&this.iv.scale(this.s.v[0],this.s.v[1],1),this.a&&this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]))}function c(){}return function(d,u,y){this.elem=d,this.frameId=-1,this.type="transform",this.dynamicProperties=[],this.mdf=!1,this.data=u,this.getValue=m,this.applyToMatrix=p,this.setInverted=f,this.autoOrient=c,this.v=new Matrix,u.p.s?(this.px=PropertyFactory.getProp(d,u.p.x,0,0,this.dynamicProperties),this.py=PropertyFactory.getProp(d,u.p.y,0,0,this.dynamicProperties),u.p.z&&(this.pz=PropertyFactory.getProp(d,u.p.z,0,0,this.dynamicProperties))):this.p=PropertyFactory.getProp(d,u.p,1,0,this.dynamicProperties),u.r?this.r=PropertyFactory.getProp(d,u.r,0,degToRads,this.dynamicProperties):u.rx&&(this.rx=PropertyFactory.getProp(d,u.rx,0,degToRads,this.dynamicProperties),this.ry=PropertyFactory.getProp(d,u.ry,0,degToRads,this.dynamicProperties),this.rz=PropertyFactory.getProp(d,u.rz,0,degToRads,this.dynamicProperties),this.or=PropertyFactory.getProp(d,u.or,1,degToRads,this.dynamicProperties),this.or.sh=!0),u.sk&&(this.sk=PropertyFactory.getProp(d,u.sk,0,degToRads,this.dynamicProperties),this.sa=PropertyFactory.getProp(d,u.sa,0,degToRads,this.dynamicProperties)),u.a&&(this.a=PropertyFactory.getProp(d,u.a,1,0,this.dynamicProperties)),u.s&&(this.s=PropertyFactory.getProp(d,u.s,1,.01,this.dynamicProperties)),this.o=u.o?PropertyFactory.getProp(d,u.o,0,.01,this.dynamicProperties):{mdf:!1,v:1},this.dynamicProperties.length?y.push(this):(this.a&&this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]),this.s&&this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]),this.sk&&this.v.skewFromAxis(-this.sk.v,this.sa.v),this.r?this.v.rotate(-this.r.v):this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),this.data.p.s?u.p.z?this.v.translate(this.px.v,this.py.v,-this.pz.v):this.v.translate(this.px.v,this.py.v,0):this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2])),Object.defineProperty(this,"position",{get:t}),Object.defineProperty(this,"xPosition",{get:e}),Object.defineProperty(this,"yPosition",{get:s}),Object.defineProperty(this,"orientation",{get:i}),Object.defineProperty(this,"anchorPoint",{get:r}),Object.defineProperty(this,"rotation",{get:a}),Object.defineProperty(this,"scale",{get:n}),Object.defineProperty(this,"opacity",{get:o}),Object.defineProperty(this,"skew",{get:h}),Object.defineProperty(this,"skewAxis",{get:l})}}(),f=function(){function t(t){if(this.prop.getValue(),this.cmdf=!1,this.omdf=!1,this.prop.mdf||t){var e,s,r,i=4*this.data.p;for(e=0;i>e;e+=1)s=e%4===0?100:255,r=Math.round(this.prop.v[e]*s),this.c[e]!==r&&(this.c[e]=r,this.cmdf=!0);if(this.o.length)for(i=this.prop.v.length,e=4*this.data.p;i>e;e+=1)s=e%2===0?100:1,r=e%2===0?Math.round(100*this.prop.v[e]):this.prop.v[e],this.o[e-4*this.data.p]!==r&&(this.o[e-4*this.data.p]=r,this.omdf=!0)}}function e(e,s,r){this.prop=o(e,s.k,1,null,[]),this.data=s,this.k=this.prop.k,this.c=Array.apply(null,{length:4*s.p});var i=s.k.k[0].s?s.k.k[0].s.length-4*s.p:s.k.k.length-4*s.p;this.o=Array.apply(null,{length:i}),this.cmdf=!1,this.omdf=!1,this.getValue=t,this.prop.k&&r.push(this),this.getValue(!0)}return function(t,s,r){return new e(t,s,r)}}(),c=function(){function t(t){var e=0,s=this.dataProps.length;if(this.elem.globalData.frameId!==this.frameId||t){for(this.mdf=!1,this.frameId=this.elem.globalData.frameId;s>e;){if(this.dataProps[e].p.mdf){this.mdf=!0;break}e+=1}if(this.mdf||t)for("svg"===this.renderer&&(this.dasharray=""),e=0;s>e;e+=1)"o"!=this.dataProps[e].n?"svg"===this.renderer?this.dasharray+=" "+this.dataProps[e].p.v:this.dasharray[e]=this.dataProps[e].p.v:this.dashoffset=this.dataProps[e].p.v}}return function(e,s,r,i){this.elem=e,this.frameId=-1,this.dataProps=new Array(s.length),this.renderer=r,this.mdf=!1,this.k=!1,this.dasharray="svg"===this.renderer?"":new Array(s.length-1),this.dashoffset=0;var a,n,o=s.length;for(a=0;o>a;a+=1)n=PropertyFactory.getProp(e,s[a].v,0,0,i),this.k=n.k?!0:this.k,this.dataProps[a]={n:s[a].n,p:n};this.getValue=t,this.k?i.push(this):this.getValue(!0)}}(),d=function(){function t(t){if(this.mdf=t||!1,this.dynamicProperties.length){var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(),this.dynamicProperties[e].mdf&&(this.mdf=!0)}var r=this.elem.textProperty.currentData?this.elem.textProperty.currentData.l.length:0;t&&2===this.data.r&&(this.e.v=r);var i=2===this.data.r?1:100/r,a=this.o.v/i,n=this.s.v/i+a,o=this.e.v/i+a;if(n>o){var h=n;n=o,o=h}this.finalS=n,this.finalE=o}function e(t){var e=BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get,a=0,n=this.finalS,o=this.finalE,h=this.data.sh;if(2==h)a=o===n?t>=o?1:0:s(0,r(.5/(o-n)+(t-n)/(o-n),1)),a=e(a);else if(3==h)a=o===n?t>=o?0:1:1-s(0,r(.5/(o-n)+(t-n)/(o-n),1)),a=e(a);else if(4==h)o===n?a=0:(a=s(0,r(.5/(o-n)+(t-n)/(o-n),1)),.5>a?a*=2:a=1-2*(a-.5)),a=e(a);else if(5==h){if(o===n)a=0;else{var l=o-n;t=r(s(0,t+.5-n),o-n);var p=-l/2+t,m=l/2;a=Math.sqrt(1-p*p/(m*m))}a=e(a)}else 6==h?(o===n?a=0:(t=r(s(0,t+.5-n),o-n),a=(1+Math.cos(Math.PI+2*Math.PI*t/(o-n)))/2),a=e(a)):(t>=i(n)&&(a=0>t-n?1-(n-t):s(0,r(o-t,1))),a=e(a));return a*this.a.v}var s=Math.max,r=Math.min,i=Math.floor;return function(s,r,i){this.mdf=!1,this.k=!1,this.data=r,this.dynamicProperties=[],this.getValue=t,this.getMult=e,this.elem=s,this.comp=s.comp,this.finalS=0,this.finalE=0,this.s=PropertyFactory.getProp(s,r.s||{k:0},0,0,this.dynamicProperties),this.e="e"in r?PropertyFactory.getProp(s,r.e,0,0,this.dynamicProperties):{v:100},this.o=PropertyFactory.getProp(s,r.o||{k:0},0,0,this.dynamicProperties),this.xe=PropertyFactory.getProp(s,r.xe||{k:0},0,0,this.dynamicProperties),this.ne=PropertyFactory.getProp(s,r.ne||{k:0},0,0,this.dynamicProperties),this.a=PropertyFactory.getProp(s,r.a,0,.01,this.dynamicProperties),this.dynamicProperties.length?i.push(this):this.getValue()}}(),u={getProp:o,getDashProp:h,getTextSelectorProp:l,getGradientProp:f};return u}();ShapePath.prototype.setPathData=function(t,e){this.c=t,this.setLength(e);for(var s=0;e>s;)this.v[s]=point_pool.newPoint(),this.o[s]=point_pool.newPoint(),this.i[s]=point_pool.newPoint(),s+=1},ShapePath.prototype.setLength=function(t){for(;this._maxLength<t;)this.doubleArrayLength();this._length=t},ShapePath.prototype.doubleArrayLength=function(){this.v=this.v.concat(Array.apply(null,{length:this._maxLength})),this.i=this.i.concat(Array.apply(null,{length:this._maxLength})),this.o=this.o.concat(Array.apply(null,{length:this._maxLength})),this._maxLength*=2},ShapePath.prototype.setXYAt=function(t,e,s,r,i){var a;switch(this._length=Math.max(this._length,r+1),this._length>=this._maxLength&&this.doubleArrayLength(),s){case"v":a=this.v;break;case"i":a=this.i;break;case"o":a=this.o}(!a[r]||a[r]&&!i)&&(a[r]=point_pool.newPoint()),a[r][0]=t,a[r][1]=e},ShapePath.prototype.setTripleAt=function(t,e,s,r,i,a,n,o){this.setXYAt(t,e,"v",n,o),this.setXYAt(s,r,"o",n,o),this.setXYAt(i,a,"i",n,o)};var ShapePropertyFactory=function(){function t(t,e,s,r){var i,a,n;if(t<this.keyframes[0].t-this.offsetTime)i=this.keyframes[0].s[0],n=!0,e=0;else if(t>=this.keyframes[this.keyframes.length-1].t-this.offsetTime)i=1===this.keyframes[this.keyframes.length-2].h?this.keyframes[this.keyframes.length-1].s[0]:this.keyframes[this.keyframes.length-2].e[0],n=!0;else{for(var o,h,l,p,m,f,c=e,d=this.keyframes.length-1,u=!0;u&&(o=this.keyframes[c],h=this.keyframes[c+1],!(h.t-this.offsetTime>t));)d-1>c?c+=1:u=!1;n=1===o.h,e=c;var y;if(!n){if(t>=h.t-this.offsetTime)y=1;else if(t<o.t-this.offsetTime)y=0;else{var g;o.__fnct?g=o.__fnct:(g=BezierFactory.getBezierEasing(o.o.x,o.o.y,o.i.x,o.i.y).get,o.__fnct=g),y=g((t-(o.t-this.offsetTime))/(h.t-this.offsetTime-(o.t-this.offsetTime)))}a=o.e[0]}i=o.s[0]}p=s._length,f=i.i[0].length;var v,b=!1;for(l=0;p>l;l+=1)for(m=0;f>m;m+=1)n?(v=i.i[l][m],s.i[l][m]!==v&&(s.i[l][m]=v,r&&(this.pv.i[l][m]=v),b=!0),v=i.o[l][m],s.o[l][m]!==v&&(s.o[l][m]=v,r&&(this.pv.o[l][m]=v),b=!0),v=i.v[l][m],s.v[l][m]!==v&&(s.v[l][m]=v,r&&(this.pv.v[l][m]=v),b=!0)):(v=i.i[l][m]+(a.i[l][m]-i.i[l][m])*y,s.i[l][m]!==v&&(s.i[l][m]=v,r&&(this.pv.i[l][m]=v),b=!0),v=i.o[l][m]+(a.o[l][m]-i.o[l][m])*y,s.o[l][m]!==v&&(s.o[l][m]=v,r&&(this.pv.o[l][m]=v),b=!0),v=i.v[l][m]+(a.v[l][m]-i.v[l][m])*y,s.v[l][m]!==v&&(s.v[l][m]=v,r&&(this.pv.v[l][m]=v),b=!0));return b&&(s.c=i.c),{iterationIndex:e,hasModified:b}}function e(){if(this.elem.globalData.frameId!==this.frameId){this.mdf=!1;var t=this.comp.renderedFrame-this.offsetTime,e=this.keyframes[0].t-this.offsetTime,s=this.keyframes[this.keyframes.length-1].t-this.offsetTime;if(this.lastFrame===l||!(this.lastFrame<e&&e>t||this.lastFrame>s&&t>s)){var r=this.lastFrame<t?this._lastIndex:0,i=this.interpolateShape(t,r,this.v,!0);this._lastIndex=i.iterationIndex,this.mdf=i.hasModified,i.hasModified&&(this.paths=this.localShapeCollection)}this.lastFrame=t,this.frameId=this.elem.globalData.frameId}}function s(){return this.v}function r(){this.paths=this.localShapeCollection,this.k||(this.mdf=!1)}function i(t,e,s){this.__shapeObject=1,this.comp=t.comp,this.k=!1,this.mdf=!1;var i=3===s?e.pt.k:e.ks.k;this.v=shape_pool.clone(i),this.pv=shape_pool.clone(this.v),this.localShapeCollection=shapeCollection_pool.newShapeCollection(),this.paths=this.localShapeCollection,this.paths.addShape(this.v),this.reset=r}function a(t,e,s){this.__shapeObject=1,this.comp=t.comp,this.elem=t,this.offsetTime=t.data.st,this._lastIndex=0,this.keyframes=3===s?e.pt.k:e.ks.k,this.k=!0,this.kf=!0;{var i=this.keyframes[0].s[0].i.length;this.keyframes[0].s[0].i[0].length}this.v=shape_pool.newShape(),this.v.setPathData(this.keyframes[0].s[0].c,i),this.pv=shape_pool.clone(this.v),this.localShapeCollection=shapeCollection_pool.newShapeCollection(),this.paths=this.localShapeCollection,this.paths.addShape(this.v),this.lastFrame=l,this.reset=r}function n(t,e,s,r){var n;if(3===s||4===s){
var o=3===s?e.pt:e.ks,h=o.k;n=1===o.a||h.length?new a(t,e,s):new i(t,e,s)}else 5===s?n=new f(t,e):6===s?n=new p(t,e):7===s&&(n=new m(t,e));return n.k&&r.push(n),n}function o(){return i}function h(){return a}var l=-999999;i.prototype.interpolateShape=t,i.prototype.getValue=s,a.prototype.getValue=e,a.prototype.interpolateShape=t;var p=function(){function t(){var t=this.p.v[0],e=this.p.v[1],r=this.s.v[0]/2,i=this.s.v[1]/2;3!==this.d?(this.v.v[0][0]=t,this.v.v[0][1]=e-i,this.v.v[1][0]=t+r,this.v.v[1][1]=e,this.v.v[2][0]=t,this.v.v[2][1]=e+i,this.v.v[3][0]=t-r,this.v.v[3][1]=e,this.v.i[0][0]=t-r*s,this.v.i[0][1]=e-i,this.v.i[1][0]=t+r,this.v.i[1][1]=e-i*s,this.v.i[2][0]=t+r*s,this.v.i[2][1]=e+i,this.v.i[3][0]=t-r,this.v.i[3][1]=e+i*s,this.v.o[0][0]=t+r*s,this.v.o[0][1]=e-i,this.v.o[1][0]=t+r,this.v.o[1][1]=e+i*s,this.v.o[2][0]=t-r*s,this.v.o[2][1]=e+i,this.v.o[3][0]=t-r,this.v.o[3][1]=e-i*s):(this.v.v[0][0]=t,this.v.v[0][1]=e-i,this.v.v[1][0]=t-r,this.v.v[1][1]=e,this.v.v[2][0]=t,this.v.v[2][1]=e+i,this.v.v[3][0]=t+r,this.v.v[3][1]=e,this.v.i[0][0]=t+r*s,this.v.i[0][1]=e-i,this.v.i[1][0]=t-r,this.v.i[1][1]=e-i*s,this.v.i[2][0]=t-r*s,this.v.i[2][1]=e+i,this.v.i[3][0]=t+r,this.v.i[3][1]=e+i*s,this.v.o[0][0]=t-r*s,this.v.o[0][1]=e-i,this.v.o[1][0]=t-r,this.v.o[1][1]=e+i*s,this.v.o[2][0]=t+r*s,this.v.o[2][1]=e+i,this.v.o[3][0]=t+r,this.v.o[3][1]=e-i*s)}function e(t){var e,s=this.dynamicProperties.length;if(this.elem.globalData.frameId!==this.frameId){for(this.mdf=!1,this.frameId=this.elem.globalData.frameId,e=0;s>e;e+=1)this.dynamicProperties[e].getValue(t),this.dynamicProperties[e].mdf&&(this.mdf=!0);this.mdf&&this.convertEllToPath()}}var s=roundCorner;return function(s,i){this.v=shape_pool.newShape(),this.v.setPathData(!0,4),this.localShapeCollection=shapeCollection_pool.newShapeCollection(),this.paths=this.localShapeCollection,this.localShapeCollection.addShape(this.v),this.d=i.d,this.dynamicProperties=[],this.elem=s,this.comp=s.comp,this.frameId=-1,this.mdf=!1,this.getValue=e,this.convertEllToPath=t,this.reset=r,this.p=PropertyFactory.getProp(s,i.p,1,0,this.dynamicProperties),this.s=PropertyFactory.getProp(s,i.s,1,0,this.dynamicProperties),this.dynamicProperties.length?this.k=!0:this.convertEllToPath()}}(),m=function(){function t(){var t,e=Math.floor(this.pt.v),s=2*Math.PI/e,r=this.or.v,i=this.os.v,a=2*Math.PI*r/(4*e),n=-Math.PI/2,o=3===this.data.d?-1:1;for(n+=this.r.v,this.v._length=0,t=0;e>t;t+=1){var h=r*Math.cos(n),l=r*Math.sin(n),p=0===h&&0===l?0:l/Math.sqrt(h*h+l*l),m=0===h&&0===l?0:-h/Math.sqrt(h*h+l*l);h+=+this.p.v[0],l+=+this.p.v[1],this.v.setTripleAt(h,l,h-p*a*i*o,l-m*a*i*o,h+p*a*i*o,l+m*a*i*o,t,!0),n+=s*o}this.paths.length=0,this.paths[0]=this.v}function e(){var t,e,s,r,i=2*Math.floor(this.pt.v),a=2*Math.PI/i,n=!0,o=this.or.v,h=this.ir.v,l=this.os.v,p=this.is.v,m=2*Math.PI*o/(2*i),f=2*Math.PI*h/(2*i),c=-Math.PI/2;c+=this.r.v;var d=3===this.data.d?-1:1;for(this.v._length=0,t=0;i>t;t+=1){e=n?o:h,s=n?l:p,r=n?m:f;var u=e*Math.cos(c),y=e*Math.sin(c),g=0===u&&0===y?0:y/Math.sqrt(u*u+y*y),v=0===u&&0===y?0:-u/Math.sqrt(u*u+y*y);u+=+this.p.v[0],y+=+this.p.v[1],this.v.setTripleAt(u,y,u-g*r*s*d,y-v*r*s*d,u+g*r*s*d,y+v*r*s*d,t,!0),n=!n,c+=a*d}}function s(){if(this.elem.globalData.frameId!==this.frameId){this.mdf=!1,this.frameId=this.elem.globalData.frameId;var t,e=this.dynamicProperties.length;for(t=0;e>t;t+=1)this.dynamicProperties[t].getValue(),this.dynamicProperties[t].mdf&&(this.mdf=!0);this.mdf&&this.convertToPath()}}return function(i,a){this.v=shape_pool.newShape(),this.v.setPathData(!0,0),this.elem=i,this.comp=i.comp,this.data=a,this.frameId=-1,this.d=a.d,this.dynamicProperties=[],this.mdf=!1,this.getValue=s,this.reset=r,1===a.sy?(this.ir=PropertyFactory.getProp(i,a.ir,0,0,this.dynamicProperties),this.is=PropertyFactory.getProp(i,a.is,0,.01,this.dynamicProperties),this.convertToPath=e):this.convertToPath=t,this.pt=PropertyFactory.getProp(i,a.pt,0,0,this.dynamicProperties),this.p=PropertyFactory.getProp(i,a.p,1,0,this.dynamicProperties),this.r=PropertyFactory.getProp(i,a.r,0,degToRads,this.dynamicProperties),this.or=PropertyFactory.getProp(i,a.or,0,0,this.dynamicProperties),this.os=PropertyFactory.getProp(i,a.os,0,.01,this.dynamicProperties),this.localShapeCollection=shapeCollection_pool.newShapeCollection(),this.localShapeCollection.addShape(this.v),this.paths=this.localShapeCollection,this.dynamicProperties.length?this.k=!0:this.convertToPath()}}(),f=function(){function t(t){if(this.elem.globalData.frameId!==this.frameId){this.mdf=!1,this.frameId=this.elem.globalData.frameId;var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(t),this.dynamicProperties[e].mdf&&(this.mdf=!0);this.mdf&&this.convertRectToPath()}}function e(){var t=this.p.v[0],e=this.p.v[1],s=this.s.v[0]/2,r=this.s.v[1]/2,i=bm_min(s,r,this.r.v),a=i*(1-roundCorner);this.v._length=0,2===this.d||1===this.d?(this.v.setTripleAt(t+s,e-r+i,t+s,e-r+i,t+s,e-r+a,0,!0),this.v.setTripleAt(t+s,e+r-i,t+s,e+r-a,t+s,e+r-i,1,!0),0!==i?(this.v.setTripleAt(t+s-i,e+r,t+s-i,e+r,t+s-a,e+r,2,!0),this.v.setTripleAt(t-s+i,e+r,t-s+a,e+r,t-s+i,e+r,3,!0),this.v.setTripleAt(t-s,e+r-i,t-s,e+r-i,t-s,e+r-a,4,!0),this.v.setTripleAt(t-s,e-r+i,t-s,e-r+a,t-s,e-r+i,5,!0),this.v.setTripleAt(t-s+i,e-r,t-s+i,e-r,t-s+a,e-r,6,!0),this.v.setTripleAt(t+s-i,e-r,t+s-a,e-r,t+s-i,e-r,7,!0)):(this.v.setTripleAt(t-s,e+r,t-s+a,e+r,t-s,e+r,2),this.v.setTripleAt(t-s,e-r,t-s,e-r+a,t-s,e-r,3))):(this.v.setTripleAt(t+s,e-r+i,t+s,e-r+a,t+s,e-r+i,0,!0),0!==i?(this.v.setTripleAt(t+s-i,e-r,t+s-i,e-r,t+s-a,e-r,1,!0),this.v.setTripleAt(t-s+i,e-r,t-s+a,e-r,t-s+i,e-r,2,!0),this.v.setTripleAt(t-s,e-r+i,t-s,e-r+i,t-s,e-r+a,3,!0),this.v.setTripleAt(t-s,e+r-i,t-s,e+r-a,t-s,e+r-i,4,!0),this.v.setTripleAt(t-s+i,e+r,t-s+i,e+r,t-s+a,e+r,5,!0),this.v.setTripleAt(t+s-i,e+r,t+s-a,e+r,t+s-i,e+r,6,!0),this.v.setTripleAt(t+s,e+r-i,t+s,e+r-i,t+s,e+r-a,7,!0)):(this.v.setTripleAt(t-s,e-r,t-s+a,e-r,t-s,e-r,1,!0),this.v.setTripleAt(t-s,e+r,t-s,e+r-a,t-s,e+r,2,!0),this.v.setTripleAt(t+s,e+r,t+s-a,e+r,t+s,e+r,3,!0)))}return function(s,i){this.v=shape_pool.newShape(),this.v.c=!0,this.localShapeCollection=shapeCollection_pool.newShapeCollection(),this.localShapeCollection.addShape(this.v),this.paths=this.localShapeCollection,this.elem=s,this.comp=s.comp,this.frameId=-1,this.d=i.d,this.dynamicProperties=[],this.mdf=!1,this.getValue=t,this.convertRectToPath=e,this.reset=r,this.p=PropertyFactory.getProp(s,i.p,1,0,this.dynamicProperties),this.s=PropertyFactory.getProp(s,i.s,1,0,this.dynamicProperties),this.r=PropertyFactory.getProp(s,i.r,0,0,this.dynamicProperties),this.dynamicProperties.length?this.k=!0:this.convertRectToPath()}}(),c={};return c.getShapeProp=n,c.getConstructorFunction=o,c.getKeyframedConstructorFunction=h,c}(),ShapeModifiers=function(){function t(t,e){r[t]||(r[t]=e)}function e(t,e,s,i){return new r[t](e,s,i)}var s={},r={};return s.registerModifier=t,s.getModifier=e,s}();ShapeModifier.prototype.initModifierProperties=function(){},ShapeModifier.prototype.addShapeToModifier=function(){},ShapeModifier.prototype.addShape=function(t){this.closed||(this.shapes.push({shape:t.sh,data:t,localShapeCollection:shapeCollection_pool.newShapeCollection()}),this.addShapeToModifier(t.sh))},ShapeModifier.prototype.init=function(t,e,s){this.elem=t,this.frameId=-1,this.shapes=[],this.dynamicProperties=[],this.mdf=!1,this.closed=!1,this.k=!1,this.comp=t.comp,this.initModifierProperties(t,e),this.dynamicProperties.length?(this.k=!0,s.push(this)):this.getValue(!0)},extendPrototype(ShapeModifier,TrimModifier),TrimModifier.prototype.processKeys=function(t){if(this.elem.globalData.frameId!==this.frameId||t){this.mdf=t?!0:!1,this.frameId=this.elem.globalData.frameId;var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(),this.dynamicProperties[e].mdf&&(this.mdf=!0);if(this.mdf||t){var r=this.o.v%360/360;0>r&&(r+=1);var i=this.s.v+r,a=this.e.v+r;if(i>a){var n=i;i=a,a=n}this.sValue=i,this.eValue=a,this.oValue=r}}},TrimModifier.prototype.initModifierProperties=function(t,e){this.sValue=0,this.eValue=0,this.oValue=0,this.getValue=this.processKeys,this.s=PropertyFactory.getProp(t,e.s,0,.01,this.dynamicProperties),this.e=PropertyFactory.getProp(t,e.e,0,.01,this.dynamicProperties),this.o=PropertyFactory.getProp(t,e.o,0,0,this.dynamicProperties),this.m=e.m,this.dynamicProperties.length||this.getValue(!0)},TrimModifier.prototype.calculateShapeEdges=function(t,e,s,r,i){var a=[];1>=e?a.push({s:t,e:e}):t>=1?a.push({s:t-1,e:e-1}):(a.push({s:t,e:1}),a.push({s:0,e:e-1}));var n,o,h=[],l=a.length;for(n=0;l>n;n+=1)if(o=a[n],o.e*i<r||o.s*i>r+s);else{var p,m;p=o.s*i<=r?0:(o.s*i-r)/s,m=o.e*i>=r+s?1:(o.e*i-r)/s,h.push([p,m])}return h.length||h.push([0,0]),h},TrimModifier.prototype.processShapes=function(t){var e,s,r,i,a,n,o,h=this.shapes.length,l=this.sValue,p=this.eValue,m=0;if(p===l)for(s=0;h>s;s+=1)this.shapes[s].localShapeCollection.releaseShapes(),this.shapes[s].shape.mdf=!0,this.shapes[s].shape.paths=this.shapes[s].localShapeCollection;else if(1===p&&0===l||0===p&&1===l){if(this.mdf)for(s=0;h>s;s+=1)this.shapes[s].shape.mdf=!0}else{var f,c,d=[];for(s=0;h>s;s+=1)if(f=this.shapes[s],f.shape.mdf||this.mdf||t||2===this.m){if(e=f.shape.paths,i=e._length,o=0,!f.shape.mdf&&f.pathsData)o=f.totalShapeLength;else{for(a=[],r=0;i>r;r+=1)n=bez.getSegmentsLength(e.shapes[r]),a.push(n),o+=n.totalLength;f.totalShapeLength=o,f.pathsData=a}m+=o,f.shape.mdf=!0}else f.shape.paths=f.localShapeCollection;var r,i,u=l,y=p,g=0;for(s=h-1;s>=0;s-=1)if(f=this.shapes[s],f.shape.mdf){if(c=f.localShapeCollection,c.releaseShapes(),2===this.m&&h>1){var v=this.calculateShapeEdges(l,p,f.totalShapeLength,g,m);g+=f.totalShapeLength}else v=[[u,y]];for(i=v.length,r=0;i>r;r+=1){u=v[r][0],y=v[r][1],d.length=0,1>=y?d.push({s:f.totalShapeLength*u,e:f.totalShapeLength*y}):u>=1?d.push({s:f.totalShapeLength*(u-1),e:f.totalShapeLength*(y-1)}):(d.push({s:f.totalShapeLength*u,e:f.totalShapeLength}),d.push({s:0,e:f.totalShapeLength*(y-1)}));var b=this.addShapes(f,d[0]);if(d[0].s!==d[0].e){if(d.length>1)if(f.shape.v.c){var E=b.pop();this.addPaths(b,c),b=this.addShapes(f,d[1],E)}else this.addPaths(b,c),b=this.addShapes(f,d[1]);this.addPaths(b,c)}}f.shape.paths=c}}this.dynamicProperties.length||(this.mdf=!1)},TrimModifier.prototype.addPaths=function(t,e){var s,r=t.length;for(s=0;r>s;s+=1)e.addShape(t[s])},TrimModifier.prototype.addSegment=function(t,e,s,r,i,a,n){i.setXYAt(e[0],e[1],"o",a),i.setXYAt(s[0],s[1],"i",a+1),n&&i.setXYAt(t[0],t[1],"v",a),i.setXYAt(r[0],r[1],"v",a+1)},TrimModifier.prototype.addShapes=function(t,e,s){var r,i,a,n,o,h,l,p,m=t.pathsData,f=t.shape.paths.shapes,c=t.shape.paths._length,d=0,u=[],y=!0;for(s?(o=s._length,p=s._length):(s=shape_pool.newShape(),o=0,p=0),u.push(s),r=0;c>r;r+=1){for(h=m[r].lengths,s.c=f[r].c,a=f[r].c?h.length:h.length+1,i=1;a>i;i+=1)if(n=h[i-1],d+n.addedLength<e.s)d+=n.addedLength,s.c=!1;else{if(d>e.e){s.c=!1;break}e.s<=d&&e.e>=d+n.addedLength?(this.addSegment(f[r].v[i-1],f[r].o[i-1],f[r].i[i],f[r].v[i],s,o,y),y=!1):(l=bez.getNewSegment(f[r].v[i-1],f[r].v[i],f[r].o[i-1],f[r].i[i],(e.s-d)/n.addedLength,(e.e-d)/n.addedLength,h[i-1]),this.addSegment(l.pt1,l.pt3,l.pt4,l.pt2,s,o,y),y=!1,s.c=!1),d+=n.addedLength,o+=1}if(f[r].c){if(n=h[i-1],d<=e.e){var g=h[i-1].addedLength;e.s<=d&&e.e>=d+g?(this.addSegment(f[r].v[i-1],f[r].o[i-1],f[r].i[0],f[r].v[0],s,o,y),y=!1):(l=bez.getNewSegment(f[r].v[i-1],f[r].v[0],f[r].o[i-1],f[r].i[0],(e.s-d)/g,(e.e-d)/g,h[i-1]),this.addSegment(l.pt1,l.pt3,l.pt4,l.pt2,s,o,y),y=!1,s.c=!1)}else s.c=!1;d+=n.addedLength,o+=1}if(s._length&&(s.setXYAt(s.v[p][0],s.v[p][1],"i",p),s.setXYAt(s.v[s._length-1][0],s.v[s._length-1][1],"o",s._length-1)),d>e.e)break;c-1>r&&(s=shape_pool.newShape(),y=!0,u.push(s),o=0)}return u},ShapeModifiers.registerModifier("tm",TrimModifier),extendPrototype(ShapeModifier,RoundCornersModifier),RoundCornersModifier.prototype.processKeys=function(t){if(this.elem.globalData.frameId!==this.frameId||t){this.mdf=t?!0:!1,this.frameId=this.elem.globalData.frameId;var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(),this.dynamicProperties[e].mdf&&(this.mdf=!0)}},RoundCornersModifier.prototype.initModifierProperties=function(t,e){this.getValue=this.processKeys,this.rd=PropertyFactory.getProp(t,e.r,0,null,this.dynamicProperties),this.dynamicProperties.length||this.getValue(!0)},RoundCornersModifier.prototype.processPath=function(t,e){var s=shape_pool.newShape();s.c=t.c;var r,i,a,n,o,h,l,p,m,f,c,d,u,y=t._length,g=0;for(r=0;y>r;r+=1)i=t.v[r],n=t.o[r],a=t.i[r],i[0]===n[0]&&i[1]===n[1]&&i[0]===a[0]&&i[1]===a[1]?0!==r&&r!==y-1||t.c?(o=0===r?t.v[y-1]:t.v[r-1],h=Math.sqrt(Math.pow(i[0]-o[0],2)+Math.pow(i[1]-o[1],2)),l=h?Math.min(h/2,e)/h:0,p=d=i[0]+(o[0]-i[0])*l,m=u=i[1]-(i[1]-o[1])*l,f=p-(p-i[0])*roundCorner,c=m-(m-i[1])*roundCorner,s.setTripleAt(p,m,f,c,d,u,g),g+=1,o=r===y-1?t.v[0]:t.v[r+1],h=Math.sqrt(Math.pow(i[0]-o[0],2)+Math.pow(i[1]-o[1],2)),l=h?Math.min(h/2,e)/h:0,p=f=i[0]+(o[0]-i[0])*l,m=c=i[1]+(o[1]-i[1])*l,d=p-(p-i[0])*roundCorner,u=m-(m-i[1])*roundCorner,s.setTripleAt(p,m,f,c,d,u,g),g+=1):(s.setTripleAt(i[0],i[1],n[0],n[1],a[0],a[1],g),g+=1):(s.setTripleAt(t.v[r][0],t.v[r][1],t.o[r][0],t.o[r][1],t.i[r][0],t.i[r][1],g),g+=1);return s},RoundCornersModifier.prototype.processShapes=function(t){var e,s,r,i,a=this.shapes.length,n=this.rd.v;if(0!==n){var o,h,l;for(s=0;a>s;s+=1){if(o=this.shapes[s],h=o.shape.paths,l=o.localShapeCollection,o.shape.mdf||this.mdf||t)for(l.releaseShapes(),o.shape.mdf=!0,e=o.shape.paths.shapes,i=o.shape.paths._length,r=0;i>r;r+=1)l.addShape(this.processPath(e[r],n));o.shape.paths=o.localShapeCollection}}this.dynamicProperties.length||(this.mdf=!1)},ShapeModifiers.registerModifier("rd",RoundCornersModifier),RepeaterModifier.prototype.processKeys=function(t){if(this.elem.globalData.frameId!==this.frameId||t){this.mdf=t?!0:!1;var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(),this.dynamicProperties[e].mdf&&(this.mdf=!0)}},RepeaterModifier.prototype.initModifierProperties=function(t,e){this.getValue=this.processKeys,this.c=PropertyFactory.getProp(t,e.c,0,null,this.dynamicProperties),this.o=PropertyFactory.getProp(t,e.o,0,null,this.dynamicProperties),this.tr=PropertyFactory.getProp(t,e.tr,2,null,this.dynamicProperties),this.data=e,this.dynamicProperties.length||this.getValue(!0),this.pMatrix=new Matrix,this.rMatrix=new Matrix,this.sMatrix=new Matrix,this.tMatrix=new Matrix,this.matrix=new Matrix},RepeaterModifier.prototype.applyTransforms=function(t,e,s,r,i,a){var n=a?-1:1,o=r.s.v[0]+(1-r.s.v[0])*(1-i),h=r.s.v[1]+(1-r.s.v[1])*(1-i);t.translate(r.p.v[0]*n*i,r.p.v[1]*n*i,r.p.v[2]),e.translate(-r.a.v[0],-r.a.v[1],r.a.v[2]),e.rotate(-r.r.v*n*i),e.translate(r.a.v[0],r.a.v[1],r.a.v[2]),s.translate(-r.a.v[0],-r.a.v[1],r.a.v[2]),s.scale(a?1/o:o,a?1/h:h),s.translate(r.a.v[0],r.a.v[1],r.a.v[2])},RepeaterModifier.prototype.init=function(t,e,s,r,i){this.elem=t,this.arr=e,this.pos=s,this.elemsData=r,this._currentCopies=0,this._elements=[],this._groups=[],this.dynamicProperties=[],this.frameId=-1,this.initModifierProperties(t,e[s]);for(var a=0;s>0;)s-=1,this._elements.unshift(e[s]),a+=1;this.dynamicProperties.length?(this.k=!0,i.push(this)):this.getValue(!0)},RepeaterModifier.prototype.resetElements=function(t){var e,s=t.length;for(e=0;s>e;e+=1)t[e]._processed=!1,"gr"===t[e].ty&&this.resetElements(t[e].it)},RepeaterModifier.prototype.cloneElements=function(t){var e=(t.length,JSON.parse(JSON.stringify(t)));return this.resetElements(e),e},RepeaterModifier.prototype.changeGroupRender=function(t,e){var s,r=t.length;for(s=0;r>s;s+=1)t[s]._render=e,"gr"===t[s].ty&&this.changeGroupRender(t[s].it,e)},RepeaterModifier.prototype.processShapes=function(t){if(this.elem.globalData.frameId!==this.frameId&&(this.frameId=this.elem.globalData.frameId,this.dynamicProperties.length||t||(this.mdf=!1),this.mdf)){var e=Math.ceil(this.c.v);if(this._groups.length<e){for(;this._groups.length<e;){var s={it:this.cloneElements(this._elements),ty:"gr"};s.it.push({a:{a:0,ix:1,k:[0,0]},nm:"Transform",o:{a:0,ix:7,k:100},p:{a:0,ix:2,k:[0,0]},r:{a:0,ix:6,k:0},s:{a:0,ix:3,k:[100,100]},sa:{a:0,ix:5,k:0},sk:{a:0,ix:4,k:0},ty:"tr"}),this.arr.splice(0,0,s),this._groups.splice(0,0,s),this._currentCopies+=1}this.elem.reloadShapes()}var r,i,a=0;for(r=0;r<=this._groups.length-1;r+=1)i=e>a,this._groups[r]._render=i,this.changeGroupRender(this._groups[r].it,i),a+=1;this._currentCopies=e,this.elem.firstFrame=!0;var n=this.o.v,o=n%1,h=n>0?Math.floor(n):Math.ceil(n),l=(this.tr.v.props,this.pMatrix.props),p=this.rMatrix.props,m=this.sMatrix.props;this.pMatrix.reset(),this.rMatrix.reset(),this.sMatrix.reset(),this.tMatrix.reset(),this.matrix.reset();var f=0;if(n>0){for(;h>f;)this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,!1),f+=1;o&&(this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,o,!1),f+=o)}else if(0>n){for(;f>h;)this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,!0),f-=1;o&&(this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,-o,!0),f-=o)}r=1===this.data.m?0:this._currentCopies-1;var c=1===this.data.m?1:-1;for(a=this._currentCopies;a;){if(0!==f){(0!==r&&1===c||r!==this._currentCopies-1&&-1===c)&&this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,!1),this.matrix.transform(p[0],p[1],p[2],p[3],p[4],p[5],p[6],p[7],p[8],p[9],p[10],p[11],p[12],p[13],p[14],p[15]),this.matrix.transform(m[0],m[1],m[2],m[3],m[4],m[5],m[6],m[7],m[8],m[9],m[10],m[11],m[12],m[13],m[14],m[15]),this.matrix.transform(l[0],l[1],l[2],l[3],l[4],l[5],l[6],l[7],l[8],l[9],l[10],l[11],l[12],l[13],l[14],l[15]);var d,u=this.elemsData[r].it,y=u[u.length-1].transform.mProps.v.props,g=y.length;for(d=0;g>d;d+=1)y[d]=this.matrix.props[d];this.matrix.reset()}else{this.matrix.reset();var d,u=this.elemsData[r].it,y=u[u.length-1].transform.mProps.v.props,g=y.length;for(d=0;g>d;d+=1)y[d]=this.matrix.props[d]}f+=1,a-=1,r+=c}}},RepeaterModifier.prototype.addShape=function(){},ShapeModifiers.registerModifier("rp",RepeaterModifier),ShapeCollection.prototype.addShape=function(t){this._length===this._maxLength&&(this.shapes=this.shapes.concat(Array.apply(null,{length:this._maxLength})),this._maxLength*=2),this.shapes[this._length]=t,this._length+=1},ShapeCollection.prototype.releaseShapes=function(){var t;for(t=0;t<this._length;t+=1)shape_pool.release(this.shapes[t]);this._length=0};var ImagePreloader=function(){function t(){this.loadedAssets+=1,this.loadedAssets===this.totalImages&&n&&n(null)}function e(t){var e="";if(this.assetsPath){var s=t.p;-1!==s.indexOf("images/")&&(s=s.split("/")[1]),e=this.assetsPath+s}else e=this.path,e+=t.u?t.u:"",e+=t.p;return e}function s(e){var s=document.createElement("img");s.addEventListener("load",t.bind(this),!1),s.addEventListener("error",t.bind(this),!1),s.src=e}function r(t,r){n=r,this.totalAssets=t.length;var i;for(i=0;i<this.totalAssets;i+=1)t[i].layers||(s.bind(this)(e.bind(this)(t[i])),this.totalImages+=1)}function i(t){this.path=t||""}function a(t){this.assetsPath=t||""}var n;return function(){this.loadAssets=r,this.setAssetsPath=a,this.setPath=i,this.assetsPath="",this.path="",this.totalAssets=0,this.totalImages=0,this.loadedAssets=0}}(),featureSupport=function(){var t={maskType:!0};return(/MSIE 10/i.test(navigator.userAgent)||/MSIE 9/i.test(navigator.userAgent)||/rv:11.0/i.test(navigator.userAgent)||/Edge\/\d./i.test(navigator.userAgent))&&(t.maskType=!1),t}(),filtersFactory=function(){function t(t){var e=document.createElementNS(svgNS,"filter");return e.setAttribute("id",t),e.setAttribute("filterUnits","objectBoundingBox"),e.setAttribute("x","0%"),e.setAttribute("y","0%"),e.setAttribute("width","100%"),e.setAttribute("height","100%"),e}function e(){var t=document.createElementNS(svgNS,"feColorMatrix");return t.setAttribute("type","matrix"),t.setAttribute("color-interpolation-filters","sRGB"),t.setAttribute("values","0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"),t}var s={};return s.createFilter=t,s.createAlphaToLuminanceFilter=e,s}();TextAnimatorProperty.prototype.searchProperties=function(t){var e,s,r,i=this._textData.a.length,a=PropertyFactory.getProp;for(e=0;i>e;e+=1)r=this._textData.a[e],s={a:{},s:{}},"r"in r.a&&(s.a.r=a(this._elem,r.a.r,0,degToRads,this._dynamicProperties)),"rx"in r.a&&(s.a.rx=a(this._elem,r.a.rx,0,degToRads,this._dynamicProperties)),"ry"in r.a&&(s.a.ry=a(this._elem,r.a.ry,0,degToRads,this._dynamicProperties)),"sk"in r.a&&(s.a.sk=a(this._elem,r.a.sk,0,degToRads,this._dynamicProperties)),"sa"in r.a&&(s.a.sa=a(this._elem,r.a.sa,0,degToRads,this._dynamicProperties)),"s"in r.a&&(s.a.s=a(this._elem,r.a.s,1,.01,this._dynamicProperties)),"a"in r.a&&(s.a.a=a(this._elem,r.a.a,1,0,this._dynamicProperties)),"o"in r.a&&(s.a.o=a(this._elem,r.a.o,0,.01,this._dynamicProperties)),"p"in r.a&&(s.a.p=a(this._elem,r.a.p,1,0,this._dynamicProperties)),"sw"in r.a&&(s.a.sw=a(this._elem,r.a.sw,0,0,this._dynamicProperties)),"sc"in r.a&&(s.a.sc=a(this._elem,r.a.sc,1,0,this._dynamicProperties)),"fc"in r.a&&(s.a.fc=a(this._elem,r.a.fc,1,0,this._dynamicProperties)),"fh"in r.a&&(s.a.fh=a(this._elem,r.a.fh,0,0,this._dynamicProperties)),"fs"in r.a&&(s.a.fs=a(this._elem,r.a.fs,0,.01,this._dynamicProperties)),"fb"in r.a&&(s.a.fb=a(this._elem,r.a.fb,0,.01,this._dynamicProperties)),"t"in r.a&&(s.a.t=a(this._elem,r.a.t,0,0,this._dynamicProperties)),s.s=PropertyFactory.getTextSelectorProp(this._elem,r.s,this._dynamicProperties),s.s.t=r.s.t,this._animatorsData[e]=s;this._textData.p&&"m"in this._textData.p?(this._pathData={f:a(this._elem,this._textData.p.f,0,0,this._dynamicProperties),l:a(this._elem,this._textData.p.l,0,0,this._dynamicProperties),r:this._textData.p.r,m:this._elem.maskManager.getMaskProperty(this._textData.p.m)},this._hasMaskedPath=!0):this._hasMaskedPath=!1,this._moreOptions.alignment=a(this._elem,this._textData.m.a,1,0,this._dynamicProperties),this._dynamicProperties.length&&t.push(this)},TextAnimatorProperty.prototype.getMeasures=function(t,e){if(this.lettersChangedFlag=e,this.mdf||this._firstFrame||e||this._hasMaskedPath&&this._pathData.m.mdf){this._firstFrame=!1;var s,r,i,a,n=this._moreOptions.alignment.v,o=this._animatorsData,h=this._textData,l=this.mHelper,p=this._renderType,m=this.renderedLetters.length,f=(this.data,t.l);if(this._hasMaskedPath){var c=this._pathData.m;if(!this._pathData.n||this._pathData.mdf){var d=c.v;this._pathData.r&&(d=reversePath(d));var u={tLength:0,segments:[]};a=d._length-1;var y,g=0;for(i=0;a>i;i+=1)y={s:d.v[i],e:d.v[i+1],to:[d.o[i][0]-d.v[i][0],d.o[i][1]-d.v[i][1]],ti:[d.i[i+1][0]-d.v[i+1][0],d.i[i+1][1]-d.v[i+1][1]]},bez.buildBezierData(y),u.tLength+=y.bezierData.segmentLength,u.segments.push(y),g+=y.bezierData.segmentLength;i=a,c.v.c&&(y={s:d.v[i],e:d.v[0],to:[d.o[i][0]-d.v[i][0],d.o[i][1]-d.v[i][1]],ti:[d.i[0][0]-d.v[0][0],d.i[0][1]-d.v[0][1]]},bez.buildBezierData(y),u.tLength+=y.bezierData.segmentLength,u.segments.push(y),g+=y.bezierData.segmentLength),this._pathData.pi=u}var v,b,E,u=this._pathData.pi,P=this._pathData.f.v,x=0,S=1,C=0,k=!0,A=u.segments;if(0>P&&c.v.c)for(u.tLength<Math.abs(P)&&(P=-Math.abs(P)%u.tLength),x=A.length-1,E=A[x].bezierData.points,S=E.length-1;0>P;)P+=E[S].partialLength,S-=1,0>S&&(x-=1,E=A[x].bezierData.points,S=E.length-1);E=A[x].bezierData.points,b=E[S-1],v=E[S];var M,D,T=v.partialLength}a=f.length,s=0,r=0;var w,_,I,F,V,R=1.2*t.s*.714,N=!0;if(F=o.length,e)for(I=0;F>I;I+=1)_=o[I].s,_.getValue(!0);var B,L,O,G,j,H,z,W,q,Y,X,J,K,U=-1,Z=P,Q=x,$=S,tt=-1,et=0,st="",rt=this.defaultPropsArray;for(i=0;a>i;i+=1){if(l.reset(),j=1,f[i].n)s=0,r+=t.yOffset,r+=N?1:0,P=Z,N=!1,et=0,this._hasMaskedPath&&(x=Q,S=$,E=A[x].bezierData.points,b=E[S-1],v=E[S],T=v.partialLength,C=0),K=Y=J=st="",rt=this.defaultPropsArray;else{if(this._hasMaskedPath){if(tt!==f[i].line){switch(t.j){case 1:P+=g-t.lineWidths[f[i].line];break;case 2:P+=(g-t.lineWidths[f[i].line])/2}tt=f[i].line}U!==f[i].ind&&(f[U]&&(P+=f[U].extra),P+=f[i].an/2,U=f[i].ind),P+=n[0]*f[i].an/200;var it=0;for(I=0;F>I;I+=1)w=o[I].a,"p"in w&&(_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),it+=B.length?w.p.v[0]*B[0]:w.p.v[0]*B),"a"in w&&(_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),it+=B.length?w.a.v[0]*B[0]:w.a.v[0]*B);for(k=!0;k;)C+T>=P+it||!E?(M=(P+it-C)/v.partialLength,O=b.point[0]+(v.point[0]-b.point[0])*M,G=b.point[1]+(v.point[1]-b.point[1])*M,l.translate(-n[0]*f[i].an/200,-(n[1]*R/100)),k=!1):E&&(C+=v.partialLength,S+=1,S>=E.length&&(S=0,x+=1,A[x]?E=A[x].bezierData.points:c.v.c?(S=0,x=0,E=A[x].bezierData.points):(C-=v.partialLength,E=null)),E&&(b=v,v=E[S],T=v.partialLength));L=f[i].an/2-f[i].add,l.translate(-L,0,0)}else L=f[i].an/2-f[i].add,l.translate(-L,0,0),l.translate(-n[0]*f[i].an/200,-n[1]*R/100,0);for(et+=f[i].l/2,I=0;F>I;I+=1)w=o[I].a,"t"in w&&(_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),this._hasMaskedPath?P+=B.length?w.t*B[0]:w.t*B:s+=B.length?w.t.v*B[0]:w.t.v*B);for(et+=f[i].l/2,t.strokeWidthAnim&&(z=t.sw||0),t.strokeColorAnim&&(H=t.sc?[t.sc[0],t.sc[1],t.sc[2]]:[0,0,0]),t.fillColorAnim&&t.fc&&(W=[t.fc[0],t.fc[1],t.fc[2]]),I=0;F>I;I+=1)w=o[I].a,"a"in w&&(_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),B.length?l.translate(-w.a.v[0]*B[0],-w.a.v[1]*B[1],w.a.v[2]*B[2]):l.translate(-w.a.v[0]*B,-w.a.v[1]*B,w.a.v[2]*B));for(I=0;F>I;I+=1)w=o[I].a,"s"in w&&(_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),B.length?l.scale(1+(w.s.v[0]-1)*B[0],1+(w.s.v[1]-1)*B[1],1):l.scale(1+(w.s.v[0]-1)*B,1+(w.s.v[1]-1)*B,1));for(I=0;F>I;I+=1){if(w=o[I].a,_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),"sk"in w&&(B.length?l.skewFromAxis(-w.sk.v*B[0],w.sa.v*B[1]):l.skewFromAxis(-w.sk.v*B,w.sa.v*B)),"r"in w&&l.rotateZ(B.length?-w.r.v*B[2]:-w.r.v*B),"ry"in w&&l.rotateY(B.length?w.ry.v*B[1]:w.ry.v*B),"rx"in w&&l.rotateX(B.length?w.rx.v*B[0]:w.rx.v*B),"o"in w&&(j+=B.length?(w.o.v*B[0]-j)*B[0]:(w.o.v*B-j)*B),t.strokeWidthAnim&&"sw"in w&&(z+=B.length?w.sw.v*B[0]:w.sw.v*B),t.strokeColorAnim&&"sc"in w)for(q=0;3>q;q+=1)H[q]=B.length?H[q]+(w.sc.v[q]-H[q])*B[0]:H[q]+(w.sc.v[q]-H[q])*B;if(t.fillColorAnim&&t.fc){if("fc"in w)for(q=0;3>q;q+=1)W[q]=B.length?W[q]+(w.fc.v[q]-W[q])*B[0]:W[q]+(w.fc.v[q]-W[q])*B;"fh"in w&&(W=B.length?addHueToRGB(W,w.fh.v*B[0]):addHueToRGB(W,w.fh.v*B)),"fs"in w&&(W=B.length?addSaturationToRGB(W,w.fs.v*B[0]):addSaturationToRGB(W,w.fs.v*B)),"fb"in w&&(W=B.length?addBrightnessToRGB(W,w.fb.v*B[0]):addBrightnessToRGB(W,w.fb.v*B))}}for(I=0;F>I;I+=1)w=o[I].a,"p"in w&&(_=o[I].s,B=_.getMult(f[i].anIndexes[I],h.a[I].s.totalChars),this._hasMaskedPath?B.length?l.translate(0,w.p.v[1]*B[0],-w.p.v[2]*B[1]):l.translate(0,w.p.v[1]*B,-w.p.v[2]*B):B.length?l.translate(w.p.v[0]*B[0],w.p.v[1]*B[1],-w.p.v[2]*B[2]):l.translate(w.p.v[0]*B,w.p.v[1]*B,-w.p.v[2]*B));if(t.strokeWidthAnim&&(Y=0>z?0:z),t.strokeColorAnim&&(X="rgb("+Math.round(255*H[0])+","+Math.round(255*H[1])+","+Math.round(255*H[2])+")"),t.fillColorAnim&&t.fc&&(J="rgb("+Math.round(255*W[0])+","+Math.round(255*W[1])+","+Math.round(255*W[2])+")"),this._hasMaskedPath){if(l.translate(0,-t.ls),l.translate(0,n[1]*R/100+r,0),h.p.p){D=(v.point[1]-b.point[1])/(v.point[0]-b.point[0]);var at=180*Math.atan(D)/Math.PI;v.point[0]<b.point[0]&&(at+=180),l.rotate(-at*Math.PI/180)}l.translate(O,G,0),P-=n[0]*f[i].an/200,f[i+1]&&U!==f[i+1].ind&&(P+=f[i].an/2,P+=t.tr/1e3*t.s)}else{switch(l.translate(s,r,0),t.ps&&l.translate(t.ps[0],t.ps[1]+t.ascent,0),t.j){case 1:l.translate(t.justifyOffset+(t.boxWidth-t.lineWidths[f[i].line]),0,0);break;case 2:l.translate(t.justifyOffset+(t.boxWidth-t.lineWidths[f[i].line])/2,0,0)}l.translate(0,-t.ls),l.translate(L,0,0),l.translate(n[0]*f[i].an/200,n[1]*R/100,0),s+=f[i].l+t.tr/1e3*t.s}"html"===p?st=l.toCSS():"svg"===p?st=l.to2dCSS():rt=[l.props[0],l.props[1],l.props[2],l.props[3],l.props[4],l.props[5],l.props[6],l.props[7],l.props[8],l.props[9],l.props[10],l.props[11],l.props[12],l.props[13],l.props[14],l.props[15]],K=j}i>=m?(V=new LetterProps(K,Y,X,J,st,rt),this.renderedLetters.push(V),m+=1,this.lettersChangedFlag=!0):(V=this.renderedLetters[i],this.lettersChangedFlag=V.update(K,Y,X,J,st,rt)||this.lettersChangedFlag)}}},TextAnimatorProperty.prototype.getValue=function(){if(this._elem.globalData.frameId!==this._frameId){this._frameId=this._elem.globalData.frameId;var t,e=this._dynamicProperties.length;for(this.mdf=!1,t=0;e>t;t+=1)this._dynamicProperties[t].getValue(),this.mdf=this._dynamicProperties[t].mdf||this.mdf}},TextAnimatorProperty.prototype.mHelper=new Matrix,TextAnimatorProperty.prototype.defaultPropsArray=[],LetterProps.prototype.update=function(t,e,s,r,i,a){this.mdf.o=!1,this.mdf.sw=!1,this.mdf.sc=!1,this.mdf.fc=!1,this.mdf.m=!1,this.mdf.p=!1;var n=!1;return this.o!==t&&(this.o=t,this.mdf.o=!0,n=!0),this.sw!==e&&(this.sw=e,this.mdf.sw=!0,n=!0),this.sc!==s&&(this.sc=s,this.mdf.sc=!0,n=!0),this.fc!==r&&(this.fc=r,this.mdf.fc=!0,n=!0),this.m!==i&&(this.m=i,this.mdf.m=!0,n=!0),!a.length||this.p[0]===a[0]&&this.p[1]===a[1]&&this.p[4]===a[4]&&this.p[5]===a[5]&&this.p[12]===a[12]&&this.p[13]===a[13]||(this.p=a,this.mdf.p=!0,n=!0),n},TextProperty.prototype.setCurrentData=function(t){var e=this.currentData;e.ascent=t.ascent,e.boxWidth=t.boxWidth?t.boxWidth:e.boxWidth,e.f=t.f,e.fStyle=t.fStyle,e.fWeight=t.fWeight,e.fc=t.fc,e.j=t.j,e.justifyOffset=t.justifyOffset,e.l=t.l,e.lh=t.lh,e.lineWidths=t.lineWidths,e.ls=t.ls,e.of=t.of,e.s=t.s,e.sc=t.sc,e.sw=t.sw,e.t=t.t,e.tr=t.tr,e.fillColorAnim=t.fillColorAnim||e.fillColorAnim,e.strokeColorAnim=t.strokeColorAnim||e.strokeColorAnim,e.strokeWidthAnim=t.strokeWidthAnim||e.strokeWidthAnim,e.yOffset=t.yOffset,e.__complete=!1},TextProperty.prototype.searchProperty=function(){return this.kf=this.data.d.k.length>1,this.kf},TextProperty.prototype.getValue=function(){this.mdf=!1;var t=this.elem.globalData.frameId;if(t!==this._frameId&&this.kf||this.firstFrame){for(var e,s=this.data.d.k,r=0,i=s.length;i-1>=r&&(e=s[r].s,!(r===i-1||s[r+1].t>t));)r+=1;this.keysIndex!==r&&(e.__complete||this.completeTextData(e),this.setCurrentData(e),this.mdf=this.firstFrame?!1:!0,this.pv=this.v=this.currentData.t,this.keysIndex=r),this._frameId=t}},TextProperty.prototype.completeTextData=function(t){t.__complete=!0;var e,s,r,i,a,n,o,h=this.elem.globalData.fontManager,l=this.data,p=[],m=0,f=l.m.g,c=0,d=0,u=0,y=[],g=0,v=0,b=h.getFontByName(t.f),E=0,P=b.fStyle.split(" "),x="normal",S="normal";s=P.length;var C;for(e=0;s>e;e+=1)switch(C=P[e].toLowerCase()){case"italic":S="italic";break;case"bold":x="700";break;case"black":x="900";break;case"medium":x="500";break;case"regular":case"normal":x="400";case"light":case"thin":x="200"}t.fWeight=x,t.fStyle=S,s=t.t.length;var k=t.tr/1e3*t.s;if(t.sz){var A=t.sz[0],M=-1;for(e=0;s>e;e+=1)r=!1," "===t.t.charAt(e)?M=e:13===t.t.charCodeAt(e)&&(g=0,r=!0),h.chars?(o=h.getCharData(t.t.charAt(e),b.fStyle,b.fFamily),E=r?0:o.w*t.s/100):E=h.measureText(t.t.charAt(e),t.f,t.s),g+E>A&&" "!==t.t.charAt(e)?(-1===M?s+=1:e=M,t.t=t.t.substr(0,e)+"\r"+t.t.substr(e===M?e+1:e),M=-1,g=0):(g+=E,g+=k);s=t.t.length}g=-k,E=0;var D,T=0;for(e=0;s>e;e+=1)if(r=!1,D=t.t.charAt(e)," "===D?i="\xa0":13===D.charCodeAt(0)?(T=0,y.push(g),v=g>v?g:v,g=-2*k,i="",r=!0,u+=1):i=t.t.charAt(e),h.chars?(o=h.getCharData(D,b.fStyle,h.getFontByName(t.f).fFamily),E=r?0:o.w*t.s/100):E=h.measureText(i,t.f,t.s)," "===D?T+=E+k:(g+=E+k+T,T=0),p.push({l:E,an:E,add:c,n:r,anIndexes:[],val:i,line:u}),2==f){if(c+=E,""==i||"\xa0"==i||e==s-1){for((""==i||"\xa0"==i)&&(c-=E);e>=d;)p[d].an=c,p[d].ind=m,p[d].extra=E,d+=1;m+=1,c=0}}else if(3==f){if(c+=E,""==i||e==s-1){for(""==i&&(c-=E);e>=d;)p[d].an=c,p[d].ind=m,p[d].extra=E,d+=1;c=0,m+=1}}else p[m].ind=m,p[m].extra=0,m+=1;if(t.l=p,v=g>v?g:v,y.push(g),t.sz)t.boxWidth=t.sz[0],t.justifyOffset=0;else switch(t.boxWidth=v,t.j){case 1:t.justifyOffset=-t.boxWidth;break;case 2:t.justifyOffset=-t.boxWidth/2;break;default:t.justifyOffset=0}t.lineWidths=y;var w,_,I=l.a;n=I.length;var F,V,R=[];for(a=0;n>a;a+=1){for(w=I[a],w.a.sc&&(t.strokeColorAnim=!0),w.a.sw&&(t.strokeWidthAnim=!0),
(w.a.fc||w.a.fh||w.a.fs||w.a.fb)&&(t.fillColorAnim=!0),V=0,F=w.s.b,e=0;s>e;e+=1)_=p[e],_.anIndexes[a]=V,(1==F&&""!=_.val||2==F&&""!=_.val&&"\xa0"!=_.val||3==F&&(_.n||"\xa0"==_.val||e==s-1)||4==F&&(_.n||e==s-1))&&(1===w.s.rn&&R.push(V),V+=1);l.a[a].s.totalChars=V;var N,B=-1;if(1===w.s.rn)for(e=0;s>e;e+=1)_=p[e],B!=_.anIndexes[a]&&(B=_.anIndexes[a],N=R.splice(Math.floor(Math.random()*R.length),1)[0]),_.anIndexes[a]=N}t.yOffset=t.lh||1.2*t.s,t.ls=t.ls||0,t.ascent=b.ascent*t.s/100},TextProperty.prototype.updateDocumentData=function(t,e){e=void 0===e?this.keysIndex:e;var s=this.data.d.k[e].s;s.__complete=!1,s.t=t.t,this.keysIndex=-1,this.firstFrame=!0,this.getValue()};var pooling=function(){function t(t){return t.concat(Array.apply(null,{length:t.length}))}return{"double":t}}(),point_pool=function(){function t(){var t;return r?(r-=1,t=a[r]):t=[.1,.1],t}function e(t){r===i&&(a=pooling["double"](a),i=2*i),a[r]=t,r+=1}var s={newPoint:t,release:e},r=0,i=8,a=Array.apply(null,{length:i});return s}(),shape_pool=function(){function t(){var t;return a?(a-=1,t=o[a]):t=new ShapePath,t}function e(t){a===n&&(o=pooling["double"](o),n=2*n);var e,s=t._length;for(e=0;s>e;e+=1)point_pool.release(t.v[e]),point_pool.release(t.i[e]),point_pool.release(t.o[e]),t.v[e]=null,t.i[e]=null,t.o[e]=null;t._length=0,t.c=!1,o[a]=t,a+=1}function s(t,s){for(;s--;)e(t[s])}function r(e,s){var r,i=void 0===e._length?e.v.length:e._length,a=t();a.setLength(i),a.c=e.c;var n;for(r=0;i>r;r+=1)s?(n=s.applyToPointArray(e.v[r][0],e.v[r][1],0,2),a.setXYAt(n[0],n[1],"v",r),point_pool.release(n),n=s.applyToPointArray(e.o[r][0],e.o[r][1],0,2),a.setXYAt(n[0],n[1],"o",r),point_pool.release(n),n=s.applyToPointArray(e.i[r][0],e.i[r][1],0,2),a.setXYAt(n[0],n[1],"i",r),point_pool.release(n)):a.setTripleAt(e.v[r][0],e.v[r][1],e.o[r][0],e.o[r][1],e.i[r][0],e.i[r][1],r);return a}var i={clone:r,newShape:t,release:e,releaseArray:s},a=0,n=4,o=Array.apply(null,{length:n});return i}(),shapeCollection_pool=function(){function t(){var t;return i?(i-=1,t=n[i]):t=new ShapeCollection,t}function e(t){var e,s=t._length;for(e=0;s>e;e+=1)shape_pool.release(t.shapes[e]);t._length=0,i===a&&(n=pooling["double"](n),a=2*a),n[i]=t,i+=1}function s(t,s){e(t),i===a&&(n=pooling["double"](n),a=2*a),n[i]=t,i+=1}var r={newShapeCollection:t,release:e,clone:s},i=0,a=4,n=Array.apply(null,{length:a});return r}();BaseRenderer.prototype.checkLayers=function(t){var e,s,r=this.layers.length;for(this.completeLayers=!0,e=r-1;e>=0;e--)this.elements[e]||(s=this.layers[e],s.ip-s.st<=t-this.layers[e].st&&s.op-s.st>t-this.layers[e].st&&this.buildItem(e)),this.completeLayers=this.elements[e]?this.completeLayers:!1;this.checkPendingElements()},BaseRenderer.prototype.createItem=function(t){switch(t.ty){case 2:return this.createImage(t);case 0:return this.createComp(t);case 1:return this.createSolid(t);case 4:return this.createShape(t);case 5:return this.createText(t);case 13:return this.createCamera(t);case 99:return null}return this.createBase(t)},BaseRenderer.prototype.createCamera=function(){throw new Error("You're using a 3d camera. Try the html renderer.")},BaseRenderer.prototype.buildAllItems=function(){var t,e=this.layers.length;for(t=0;e>t;t+=1)this.buildItem(t);this.checkPendingElements()},BaseRenderer.prototype.includeLayers=function(t){this.completeLayers=!1;var e,s,r=t.length,i=this.layers.length;for(e=0;r>e;e+=1)for(s=0;i>s;){if(this.layers[s].id==t[e].id){this.layers[s]=t[e];break}s+=1}},BaseRenderer.prototype.setProjectInterface=function(t){this.globalData.projectInterface=t},BaseRenderer.prototype.initItems=function(){this.globalData.progressiveLoad||this.buildAllItems()},BaseRenderer.prototype.buildElementParenting=function(t,e,s){s=s||[];for(var r=this.elements,i=this.layers,a=0,n=i.length;n>a;)i[a].ind==e&&(r[a]&&r[a]!==!0?void 0!==i[a].parent?(s.push(r[a]),r[a]._isParent=!0,this.buildElementParenting(t,i[a].parent,s)):(s.push(r[a]),r[a]._isParent=!0,t.setHierarchy(s)):(this.buildItem(a),this.addPendingElement(t))),a+=1},BaseRenderer.prototype.addPendingElement=function(t){this.pendingElements.push(t)},extendPrototype(BaseRenderer,SVGRenderer),SVGRenderer.prototype.createBase=function(t){return new SVGBaseElement(t,this.layerElement,this.globalData,this)},SVGRenderer.prototype.createShape=function(t){return new IShapeElement(t,this.layerElement,this.globalData,this)},SVGRenderer.prototype.createText=function(t){return new SVGTextElement(t,this.layerElement,this.globalData,this)},SVGRenderer.prototype.createImage=function(t){return new IImageElement(t,this.layerElement,this.globalData,this)},SVGRenderer.prototype.createComp=function(t){return new ICompElement(t,this.layerElement,this.globalData,this)},SVGRenderer.prototype.createSolid=function(t){return new ISolidElement(t,this.layerElement,this.globalData,this)},SVGRenderer.prototype.configAnimation=function(t){this.layerElement=document.createElementNS(svgNS,"svg"),this.layerElement.setAttribute("xmlns","http://www.w3.org/2000/svg"),this.layerElement.setAttribute("viewBox","0 0 "+t.w+" "+t.h),this.renderConfig.viewBoxOnly||(this.layerElement.setAttribute("width",t.w),this.layerElement.setAttribute("height",t.h),this.layerElement.style.width="100%",this.layerElement.style.height="100%"),this.renderConfig.className&&this.layerElement.setAttribute("class",this.renderConfig.className),this.layerElement.setAttribute("preserveAspectRatio",this.renderConfig.preserveAspectRatio),this.animationItem.wrapper.appendChild(this.layerElement);var e=document.createElementNS(svgNS,"defs");this.globalData.defs=e,this.layerElement.appendChild(e),this.globalData.getAssetData=this.animationItem.getAssetData.bind(this.animationItem),this.globalData.getAssetsPath=this.animationItem.getAssetsPath.bind(this.animationItem),this.globalData.progressiveLoad=this.renderConfig.progressiveLoad,this.globalData.frameId=0,this.globalData.nm=t.nm,this.globalData.compSize={w:t.w,h:t.h},this.data=t,this.globalData.frameRate=t.fr;var s=document.createElementNS(svgNS,"clipPath"),r=document.createElementNS(svgNS,"rect");r.setAttribute("width",t.w),r.setAttribute("height",t.h),r.setAttribute("x",0),r.setAttribute("y",0);var i="animationMask_"+randomString(10);s.setAttribute("id",i),s.appendChild(r);var a=document.createElementNS(svgNS,"g");a.setAttribute("clip-path","url("+locationHref+"#"+i+")"),this.layerElement.appendChild(a),e.appendChild(s),this.layerElement=a,this.layers=t.layers,this.globalData.fontManager=new FontManager,this.globalData.fontManager.addChars(t.chars),this.globalData.fontManager.addFonts(t.fonts,e),this.elements=Array.apply(null,{length:t.layers.length})},SVGRenderer.prototype.destroy=function(){this.animationItem.wrapper.innerHTML="",this.layerElement=null,this.globalData.defs=null;var t,e=this.layers?this.layers.length:0;for(t=0;e>t;t++)this.elements[t]&&this.elements[t].destroy();this.elements.length=0,this.destroyed=!0,this.animationItem=null},SVGRenderer.prototype.updateContainerSize=function(){},SVGRenderer.prototype.buildItem=function(t){var e=this.elements;if(!e[t]&&99!=this.layers[t].ty){e[t]=!0;var s=this.createItem(this.layers[t]);e[t]=s,expressionsPlugin&&(0===this.layers[t].ty&&this.globalData.projectInterface.registerComposition(s),s.initExpressions()),this.appendElementInPos(s,t),this.layers[t].tt&&(this.elements[t-1]&&this.elements[t-1]!==!0?s.setMatte(e[t-1].layerId):(this.buildItem(t-1),this.addPendingElement(s)))}},SVGRenderer.prototype.checkPendingElements=function(){for(;this.pendingElements.length;){var t=this.pendingElements.pop();if(t.checkParenting(),t.data.tt)for(var e=0,s=this.elements.length;s>e;){if(this.elements[e]===t){t.setMatte(this.elements[e-1].layerId);break}e+=1}}},SVGRenderer.prototype.renderFrame=function(t){if(this.renderedFrame!=t&&!this.destroyed){null===t?t=this.renderedFrame:this.renderedFrame=t,this.globalData.frameNum=t,this.globalData.frameId+=1,this.globalData.projectInterface.currentFrame=t;var e,s=this.layers.length;for(this.completeLayers||this.checkLayers(t),e=s-1;e>=0;e--)(this.completeLayers||this.elements[e])&&this.elements[e].prepareFrame(t-this.layers[e].st);for(e=s-1;e>=0;e--)(this.completeLayers||this.elements[e])&&this.elements[e].renderFrame()}},SVGRenderer.prototype.appendElementInPos=function(t,e){var s=t.getBaseElement();if(s){for(var r,i=0;e>i;)this.elements[i]&&this.elements[i]!==!0&&this.elements[i].getBaseElement()&&(r=this.elements[i].getBaseElement()),i+=1;r?this.layerElement.insertBefore(s,r):this.layerElement.appendChild(s)}},SVGRenderer.prototype.hide=function(){this.layerElement.style.display="none"},SVGRenderer.prototype.show=function(){this.layerElement.style.display="block"},SVGRenderer.prototype.searchExtraCompositions=function(t){var e,s=t.length,r=document.createElementNS(svgNS,"g");for(e=0;s>e;e+=1)if(t[e].xt){var i=this.createComp(t[e],r,this.globalData.comp,null);i.initExpressions(),this.globalData.projectInterface.registerComposition(i)}},MaskElement.prototype.getMaskProperty=function(t){return this.viewData[t].prop},MaskElement.prototype.prepareFrame=function(){var t,e=this.dynamicProperties.length;for(t=0;e>t;t+=1)this.dynamicProperties[t].getValue()},MaskElement.prototype.renderFrame=function(t){var e,s=this.masksProperties.length;for(e=0;s>e;e++)if((this.viewData[e].prop.mdf||this.firstFrame)&&this.drawPath(this.masksProperties[e],this.viewData[e].prop.v,this.viewData[e]),(this.viewData[e].op.mdf||this.firstFrame)&&this.viewData[e].elem.setAttribute("fill-opacity",this.viewData[e].op.v),"n"!==this.masksProperties[e].mode&&(this.viewData[e].invRect&&(this.element.finalTransform.mProp.mdf||this.firstFrame)&&(this.viewData[e].invRect.setAttribute("x",-t.props[12]),this.viewData[e].invRect.setAttribute("y",-t.props[13])),this.storedData[e].x&&(this.storedData[e].x.mdf||this.firstFrame))){var r=this.storedData[e].expan;this.storedData[e].x.v<0?("erode"!==this.storedData[e].lastOperator&&(this.storedData[e].lastOperator="erode",this.storedData[e].elem.setAttribute("filter","url("+locationHref+"#"+this.storedData[e].filterId+")")),r.setAttribute("radius",-this.storedData[e].x.v)):("dilate"!==this.storedData[e].lastOperator&&(this.storedData[e].lastOperator="dilate",this.storedData[e].elem.setAttribute("filter",null)),this.storedData[e].elem.setAttribute("stroke-width",2*this.storedData[e].x.v))}this.firstFrame=!1},MaskElement.prototype.getMaskelement=function(){return this.maskElement},MaskElement.prototype.createLayerSolidPath=function(){var t="M0,0 ";return t+=" h"+this.globalData.compSize.w,t+=" v"+this.globalData.compSize.h,t+=" h-"+this.globalData.compSize.w,t+=" v-"+this.globalData.compSize.h+" "},MaskElement.prototype.drawPath=function(t,e,s){var r,i,a=" M"+e.v[0][0]+","+e.v[0][1];for(i=e._length,r=1;i>r;r+=1)a+=" C"+bm_rnd(e.o[r-1][0])+","+bm_rnd(e.o[r-1][1])+" "+bm_rnd(e.i[r][0])+","+bm_rnd(e.i[r][1])+" "+bm_rnd(e.v[r][0])+","+bm_rnd(e.v[r][1]);e.c&&i>1&&(a+=" C"+bm_rnd(e.o[r-1][0])+","+bm_rnd(e.o[r-1][1])+" "+bm_rnd(e.i[0][0])+","+bm_rnd(e.i[0][1])+" "+bm_rnd(e.v[0][0])+","+bm_rnd(e.v[0][1])),s.lastPath!==a&&(s.elem&&(e.c?t.inv?s.elem.setAttribute("d",this.solidPath+a):s.elem.setAttribute("d",a):s.elem.setAttribute("d","")),s.lastPath=a)},MaskElement.prototype.destroy=function(){this.element=null,this.globalData=null,this.maskElement=null,this.data=null,this.masksProperties=null},BaseElement.prototype.checkMasks=function(){if(!this.data.hasMask)return!1;for(var t=0,e=this.data.masksProperties.length;e>t;){if("n"!==this.data.masksProperties[t].mode&&this.data.masksProperties[t].cl!==!1)return!0;t+=1}return!1},BaseElement.prototype.checkParenting=function(){void 0!==this.data.parent&&this.comp.buildElementParenting(this,this.data.parent)},BaseElement.prototype.prepareFrame=function(t){this.data.ip-this.data.st<=t&&this.data.op-this.data.st>t?this.isVisible!==!0&&(this.elemMdf=!0,this.globalData.mdf=!0,this.isVisible=!0,this.firstFrame=!0,this.data.hasMask&&(this.maskManager.firstFrame=!0)):this.isVisible!==!1&&(this.elemMdf=!0,this.globalData.mdf=!0,this.isVisible=!1);var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)(this.isVisible||this._isParent&&"transform"===this.dynamicProperties[e].type)&&(this.dynamicProperties[e].getValue(),this.dynamicProperties[e].mdf&&(this.elemMdf=!0,this.globalData.mdf=!0));return this.data.hasMask&&this.isVisible&&this.maskManager.prepareFrame(t*this.data.sr),this.currentFrameNum=t*this.data.sr,this.isVisible},BaseElement.prototype.globalToLocal=function(t){var e=[];e.push(this.finalTransform);for(var s=!0,r=this.comp;s;)r.finalTransform?(r.data.hasMask&&e.splice(0,0,r.finalTransform),r=r.comp):s=!1;var i,a,n=e.length;for(i=0;n>i;i+=1)a=e[i].mat.applyToPointArray(0,0,0),t=[t[0]-a[0],t[1]-a[1],0];return t},BaseElement.prototype.initExpressions=function(){this.layerInterface=LayerExpressionInterface(this),this.data.hasMask&&this.layerInterface.registerMaskInterface(this.maskManager);var t=EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);this.layerInterface.registerEffectsInterface(t),0===this.data.ty||this.data.xt?this.compInterface=CompExpressionInterface(this):4===this.data.ty?this.layerInterface.shapeInterface=ShapeExpressionInterface.createShapeInterface(this.shapesData,this.itemsData,this.layerInterface):5===this.data.ty&&(this.layerInterface.textInterface=TextExpressionInterface(this))},BaseElement.prototype.setBlendMode=function(){var t="";switch(this.data.bm){case 1:t="multiply";break;case 2:t="screen";break;case 3:t="overlay";break;case 4:t="darken";break;case 5:t="lighten";break;case 6:t="color-dodge";break;case 7:t="color-burn";break;case 8:t="hard-light";break;case 9:t="soft-light";break;case 10:t="difference";break;case 11:t="exclusion";break;case 12:t="hue";break;case 13:t="saturation";break;case 14:t="color";break;case 15:t="luminosity"}var e=this.baseElement||this.layerElement;e.style["mix-blend-mode"]=t},BaseElement.prototype.init=function(){this.data.sr||(this.data.sr=1),this.dynamicProperties=this.dynamicProperties||[],this.data.ef&&(this.effects=new EffectsManager(this.data,this,this.dynamicProperties)),this.hidden=!1,this.firstFrame=!0,this.isVisible=!1,this._isParent=!1,this.currentFrameNum=-99999,this.lastNum=-99999,this.data.ks&&(this.finalTransform={mProp:PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),matMdf:!1,opMdf:!1,mat:new Matrix,opacity:1},this.data.ao&&(this.finalTransform.mProp.autoOriented=!0),this.finalTransform.op=this.finalTransform.mProp.o,this.transform=this.finalTransform.mProp,11!==this.data.ty&&this.createElements(),this.data.hasMask&&this.addMasks(this.data)),this.elemMdf=!1},BaseElement.prototype.getType=function(){return this.type},BaseElement.prototype.resetHierarchy=function(){this.hierarchy?this.hierarchy.length=0:this.hierarchy=[]},BaseElement.prototype.getHierarchy=function(){return this.hierarchy||(this.hierarchy=[]),this.hierarchy},BaseElement.prototype.setHierarchy=function(t){this.hierarchy=t},BaseElement.prototype.getLayerSize=function(){return 5===this.data.ty?{w:this.data.textData.width,h:this.data.textData.height}:{w:this.data.width,h:this.data.height}},BaseElement.prototype.hide=function(){},BaseElement.prototype.sourceRectAtTime=function(){return{top:0,left:0,width:100,height:100}},BaseElement.prototype.mHelper=new Matrix,createElement(BaseElement,SVGBaseElement),SVGBaseElement.prototype.createElements=function(){this.layerElement=document.createElementNS(svgNS,"g"),this.transformedElement=this.layerElement,this.data.hasMask&&(this.maskedElement=this.layerElement);var t=null;if(this.data.td){if(3==this.data.td||1==this.data.td){var e=document.createElementNS(svgNS,"mask");if(e.setAttribute("id",this.layerId),e.setAttribute("mask-type",3==this.data.td?"luminance":"alpha"),e.appendChild(this.layerElement),t=e,this.globalData.defs.appendChild(e),!featureSupport.maskType&&1==this.data.td){e.setAttribute("mask-type","luminance");var s=randomString(10),r=filtersFactory.createFilter(s);this.globalData.defs.appendChild(r),r.appendChild(filtersFactory.createAlphaToLuminanceFilter());var i=document.createElementNS(svgNS,"g");i.appendChild(this.layerElement),t=i,e.appendChild(i),i.setAttribute("filter","url("+locationHref+"#"+s+")")}}else if(2==this.data.td){var a=document.createElementNS(svgNS,"mask");a.setAttribute("id",this.layerId),a.setAttribute("mask-type","alpha");var n=document.createElementNS(svgNS,"g");a.appendChild(n);var s=randomString(10),r=filtersFactory.createFilter(s),o=document.createElementNS(svgNS,"feColorMatrix");o.setAttribute("type","matrix"),o.setAttribute("color-interpolation-filters","sRGB"),o.setAttribute("values","1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1"),r.appendChild(o),this.globalData.defs.appendChild(r);var h=document.createElementNS(svgNS,"rect");if(h.setAttribute("width",this.comp.data.w),h.setAttribute("height",this.comp.data.h),h.setAttribute("x","0"),h.setAttribute("y","0"),h.setAttribute("fill","#ffffff"),h.setAttribute("opacity","0"),n.setAttribute("filter","url("+locationHref+"#"+s+")"),n.appendChild(h),n.appendChild(this.layerElement),t=n,!featureSupport.maskType){a.setAttribute("mask-type","luminance"),r.appendChild(filtersFactory.createAlphaToLuminanceFilter());var i=document.createElementNS(svgNS,"g");n.appendChild(h),i.appendChild(this.layerElement),t=i,n.appendChild(i)}this.globalData.defs.appendChild(a)}}else(this.data.hasMask||this.data.tt)&&this.data.tt?(this.matteElement=document.createElementNS(svgNS,"g"),this.matteElement.appendChild(this.layerElement),t=this.matteElement,this.baseElement=this.matteElement):this.baseElement=this.layerElement;if(!this.data.ln&&!this.data.cl||4!==this.data.ty&&0!==this.data.ty||(this.data.ln&&this.layerElement.setAttribute("id",this.data.ln),this.data.cl&&this.layerElement.setAttribute("class",this.data.cl)),0===this.data.ty){var l=document.createElementNS(svgNS,"clipPath"),p=document.createElementNS(svgNS,"path");p.setAttribute("d","M0,0 L"+this.data.w+",0 L"+this.data.w+","+this.data.h+" L0,"+this.data.h+"z");var m="cp_"+randomString(8);if(l.setAttribute("id",m),l.appendChild(p),this.globalData.defs.appendChild(l),this.checkMasks()){var f=document.createElementNS(svgNS,"g");f.setAttribute("clip-path","url("+locationHref+"#"+m+")"),f.appendChild(this.layerElement),this.transformedElement=f,t?t.appendChild(this.transformedElement):this.baseElement=this.transformedElement}else this.layerElement.setAttribute("clip-path","url("+locationHref+"#"+m+")")}0!==this.data.bm&&this.setBlendMode(),this.layerElement!==this.parentContainer&&(this.placeholder=null),this.data.ef&&(this.effectsManager=new SVGEffects(this)),this.checkParenting()},SVGBaseElement.prototype.setBlendMode=BaseElement.prototype.setBlendMode,SVGBaseElement.prototype.renderFrame=function(t){if(3===this.data.ty||this.data.hd||!this.isVisible)return!1;this.lastNum=this.currentFrameNum,this.finalTransform.opMdf=this.firstFrame||this.finalTransform.op.mdf,this.finalTransform.matMdf=this.firstFrame||this.finalTransform.mProp.mdf,this.finalTransform.opacity=this.finalTransform.op.v;var e,s=this.finalTransform.mat;if(this.hierarchy){var r=0,i=this.hierarchy.length;if(!this.finalTransform.matMdf)for(;i>r;){if(this.hierarchy[r].finalTransform.mProp.mdf){this.finalTransform.matMdf=!0;break}r+=1}if(this.finalTransform.matMdf)for(e=this.finalTransform.mProp.v.props,s.cloneFromProps(e),r=0;i>r;r+=1)e=this.hierarchy[r].finalTransform.mProp.v.props,s.transform(e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8],e[9],e[10],e[11],e[12],e[13],e[14],e[15])}else this.isVisible&&(s=this.finalTransform.mProp.v);return this.finalTransform.matMdf&&this.layerElement&&this.transformedElement.setAttribute("transform",s.to2dCSS()),this.finalTransform.opMdf&&this.layerElement&&(this.finalTransform.op.v<=0?!this.isTransparent&&this.globalData.renderConfig.hideOnTransparent&&(this.isTransparent=!0,this.hide()):this.hidden&&this.isTransparent&&(this.isTransparent=!1,this.show()),this.transformedElement.setAttribute("opacity",this.finalTransform.op.v)),this.data.hasMask&&this.maskManager.renderFrame(s),this.effectsManager&&this.effectsManager.renderFrame(this.firstFrame),this.isVisible},SVGBaseElement.prototype.destroy=function(){this.layerElement=null,this.parentContainer=null,this.matteElement&&(this.matteElement=null),this.maskManager&&this.maskManager.destroy()},SVGBaseElement.prototype.getBaseElement=function(){return this.baseElement},SVGBaseElement.prototype.addMasks=function(t){this.maskManager=new MaskElement(t,this,this.globalData)},SVGBaseElement.prototype.setMatte=function(t){this.matteElement&&this.matteElement.setAttribute("mask","url("+locationHref+"#"+t+")")},SVGBaseElement.prototype.hide=function(){this.hidden||(this.layerElement.style.display="none",this.hidden=!0)},SVGBaseElement.prototype.show=function(){this.isVisible&&!this.isTransparent&&(this.hidden=!1,this.layerElement.style.display="block")},createElement(SVGBaseElement,IShapeElement),IShapeElement.prototype.identityMatrix=new Matrix,IShapeElement.prototype.lcEnum={1:"butt",2:"round",3:"square"},IShapeElement.prototype.ljEnum={1:"miter",2:"round",3:"butt"},IShapeElement.prototype.searchProcessedElement=function(t){for(var e=this.processedElements.length;e;)if(e-=1,this.processedElements[e].elem===t)return this.processedElements[e].pos;return 0},IShapeElement.prototype.addProcessedElement=function(t,e){for(var s=this.processedElements.length;s;)if(s-=1,this.processedElements[s].elem===t){this.processedElements[s].pos=e;break}0===s&&this.processedElements.push({elem:t,pos:e})},IShapeElement.prototype.buildExpressionInterface=function(){},IShapeElement.prototype.createElements=function(){this._parent.createElements.call(this),this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0,[],!0),(!this.data.hd||this.data.td)&&styleUnselectableDiv(this.layerElement)},IShapeElement.prototype.setGradientData=function(t,e,s){var r,i="gr_"+randomString(10);r=1===e.t?document.createElementNS(svgNS,"linearGradient"):document.createElementNS(svgNS,"radialGradient"),r.setAttribute("id",i),r.setAttribute("spreadMethod","pad"),r.setAttribute("gradientUnits","userSpaceOnUse");var a,n,o,h=[];for(o=4*e.g.p,n=0;o>n;n+=4)a=document.createElementNS(svgNS,"stop"),r.appendChild(a),h.push(a);t.setAttribute("gf"===e.ty?"fill":"stroke","url(#"+i+")"),this.globalData.defs.appendChild(r),s.gf=r,s.cst=h},IShapeElement.prototype.setGradientOpacity=function(t,e,s){if(t.g.k.k[0].s&&t.g.k.k[0].s.length>4*t.g.p||t.g.k.k.length>4*t.g.p){var r,i,a,n,o=document.createElementNS(svgNS,"mask"),h=document.createElementNS(svgNS,"path");o.appendChild(h);var l="op_"+randomString(10),p="mk_"+randomString(10);o.setAttribute("id",p),r=1===t.t?document.createElementNS(svgNS,"linearGradient"):document.createElementNS(svgNS,"radialGradient"),r.setAttribute("id",l),r.setAttribute("spreadMethod","pad"),r.setAttribute("gradientUnits","userSpaceOnUse"),n=t.g.k.k[0].s?t.g.k.k[0].s.length:t.g.k.k.length;var m=[];for(a=4*t.g.p;n>a;a+=2)i=document.createElementNS(svgNS,"stop"),i.setAttribute("stop-color","rgb(255,255,255)"),r.appendChild(i),m.push(i);return h.setAttribute("gf"===t.ty?"fill":"stroke","url(#"+l+")"),this.globalData.defs.appendChild(r),this.globalData.defs.appendChild(o),e.of=r,e.ost=m,s.msElem=h,p}},IShapeElement.prototype.createStyleElement=function(t,e,s){var r={},i={data:t,type:t.ty,d:"",ld:"",lvl:e,mdf:!1,closed:!1},a=document.createElementNS(svgNS,"path");if(r.o=PropertyFactory.getProp(this,t.o,0,.01,s),("st"==t.ty||"gs"==t.ty)&&(a.setAttribute("stroke-linecap",this.lcEnum[t.lc]||"round"),a.setAttribute("stroke-linejoin",this.ljEnum[t.lj]||"round"),a.setAttribute("fill-opacity","0"),1==t.lj&&a.setAttribute("stroke-miterlimit",t.ml),r.w=PropertyFactory.getProp(this,t.w,0,null,s),t.d)){var n=PropertyFactory.getDashProp(this,t.d,"svg",s);n.k||(a.setAttribute("stroke-dasharray",n.dasharray),a.setAttribute("stroke-dashoffset",n.dashoffset)),r.d=n}if("fl"==t.ty||"st"==t.ty)r.c=PropertyFactory.getProp(this,t.c,1,255,s);else{r.g=PropertyFactory.getGradientProp(this,t.g,s),2==t.t&&(r.h=PropertyFactory.getProp(this,t.h,0,.01,s),r.a=PropertyFactory.getProp(this,t.a,0,degToRads,s)),r.s=PropertyFactory.getProp(this,t.s,1,null,s),r.e=PropertyFactory.getProp(this,t.e,1,null,s),this.setGradientData(a,t,r,i);var o=this.setGradientOpacity(t,r,i);o&&a.setAttribute("mask","url(#"+o+")")}return r.elem=a,2===t.r&&a.setAttribute("fill-rule","evenodd"),t.ln&&a.setAttribute("id",t.ln),t.cl&&a.setAttribute("class",t.cl),i.pElem=a,this.stylesList.push(i),r.style=i,r},IShapeElement.prototype.createGroupElement=function(t){var e={it:[],prevViewData:[]},s=document.createElementNS(svgNS,"g");return e.gr=s,t.ln&&e.gr.setAttribute("id",t.ln),e},IShapeElement.prototype.createTransformElement=function(t,e){var s={transform:{op:PropertyFactory.getProp(this,t.o,0,.01,e),mProps:PropertyFactory.getProp(this,t,2,null,e)},elements:[]};return s},IShapeElement.prototype.createShapeElement=function(t,e,s,r){var i={elements:[],caches:[],styles:[],transformers:e,lStr:""},a=4;return"rc"==t.ty?a=5:"el"==t.ty?a=6:"sr"==t.ty&&(a=7),i.sh=ShapePropertyFactory.getShapeProp(this,t,a,r),i.lvl=s,this.shapes.push(i.sh),this.addShapeToModifiers(i),i};var cont=0;IShapeElement.prototype.setElementStyles=function(){var t,e=this.stylesList.length,s=[];for(t=0;e>t;t+=1)this.stylesList[t].closed||s.push(this.stylesList[t]);return s},IShapeElement.prototype.reloadShapes=function(){this.firstFrame=!0;var t,e=this.itemsData.length;for(t=0;e>t;t+=1)this.prevViewData[t]=this.itemsData[t];this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0,[],!0);var t,e=this.dynamicProperties.length;for(t=0;e>t;t+=1)this.dynamicProperties[t].getValue();this.renderModifiers()},IShapeElement.prototype.searchShapes=function(t,e,s,r,i,a,n,o){var h,l,p,m,f,c,d=[].concat(n),u=t.length-1,y=[],g=[];for(h=u;h>=0;h-=1){if(c=this.searchProcessedElement(t[h]),c?e[h]=s[c-1]:t[h]._render=o,"fl"==t[h].ty||"st"==t[h].ty||"gf"==t[h].ty||"gs"==t[h].ty)c?e[h].style.closed=!1:e[h]=this.createStyleElement(t[h],a,i),t[h]._render&&r.appendChild(e[h].elem),y.push(e[h].style);else if("gr"==t[h].ty){if(c)for(p=e[h].it.length,l=0;p>l;l+=1)e[h].prevViewData[l]=e[h].it[l];else e[h]=this.createGroupElement(t[h]);this.searchShapes(t[h].it,e[h].it,e[h].prevViewData,e[h].gr,i,a+1,d,o),t[h]._render&&r.appendChild(e[h].gr)}else"tr"==t[h].ty?(c||(e[h]=this.createTransformElement(t[h],i)),m=e[h].transform,d.push(m)):"sh"==t[h].ty||"rc"==t[h].ty||"el"==t[h].ty||"sr"==t[h].ty?(c||(e[h]=this.createShapeElement(t[h],d,a,i)),e[h].elements=this.setElementStyles()):"tm"==t[h].ty||"rd"==t[h].ty||"ms"==t[h].ty?(c?(f=e[h],f.closed=!1):(f=ShapeModifiers.getModifier(t[h].ty),f.init(this,t[h],i),e[h]=f,this.shapeModifiers.push(f)),g.push(f)):"rp"==t[h].ty&&(c?(f=e[h],f.closed=!0):(f=ShapeModifiers.getModifier(t[h].ty),e[h]=f,f.init(this,t,h,e,i),this.shapeModifiers.push(f),o=!1),g.push(f));this.addProcessedElement(t[h],h+1)}for(u=y.length,h=0;u>h;h+=1)y[h].closed=!0;for(u=g.length,h=0;u>h;h+=1)g[h].closed=!0},IShapeElement.prototype.addShapeToModifiers=function(t){var e,s=this.shapeModifiers.length;for(e=0;s>e;e+=1)this.shapeModifiers[e].addShape(t)},IShapeElement.prototype.renderModifiers=function(){if(this.shapeModifiers.length){var t,e=this.shapes.length;for(t=0;e>t;t+=1)this.shapes[t].reset();for(e=this.shapeModifiers.length,t=e-1;t>=0;t-=1)this.shapeModifiers[t].processShapes(this.firstFrame)}},IShapeElement.prototype.renderFrame=function(t){var e=this._parent.renderFrame.call(this,t);if(e===!1)return void this.hide();this.hidden&&(this.layerElement.style.display="block",this.hidden=!1),this.renderModifiers();var s,r=this.stylesList.length;for(s=0;r>s;s+=1)this.stylesList[s].d="",this.stylesList[s].mdf=!1;for(this.renderShape(this.shapesData,this.itemsData,null),s=0;r>s;s+=1)"0"===this.stylesList[s].ld&&(this.stylesList[s].ld="1",this.stylesList[s].pElem.style.display="block"),(this.stylesList[s].mdf||this.firstFrame)&&(this.stylesList[s].pElem.setAttribute("d",this.stylesList[s].d),this.stylesList[s].msElem&&this.stylesList[s].msElem.setAttribute("d",this.stylesList[s].d));this.firstFrame&&(this.firstFrame=!1)},IShapeElement.prototype.hide=function(){if(!this.hidden){this.layerElement.style.display="none";var t,e=this.stylesList.length;for(t=e-1;t>=0;t-=1)"0"!==this.stylesList[t].ld&&(this.stylesList[t].ld="0",this.stylesList[t].pElem.style.display="none",this.stylesList[t].pElem.parentNode&&(this.stylesList[t].parent=this.stylesList[t].pElem.parentNode));this.hidden=!0}},IShapeElement.prototype.renderShape=function(t,e,s){var r,i,a=t.length-1;for(r=a;r>=0;r-=1)i=t[r].ty,"tr"==i?((this.firstFrame||e[r].transform.op.mdf&&s)&&s.setAttribute("opacity",e[r].transform.op.v),(this.firstFrame||e[r].transform.mProps.mdf&&s)&&s.setAttribute("transform",e[r].transform.mProps.v.to2dCSS())):"sh"==i||"el"==i||"rc"==i||"sr"==i?this.renderPath(t[r],e[r]):"fl"==i?this.renderFill(t[r],e[r]):"gf"==i?this.renderGradient(t[r],e[r]):"gs"==i?(this.renderGradient(t[r],e[r]),this.renderStroke(t[r],e[r])):"st"==i?this.renderStroke(t[r],e[r]):"gr"==i&&this.renderShape(t[r].it,e[r].it,e[r].gr)},IShapeElement.prototype.buildShapeString=function(t,e,s,r){var i,a="";for(i=1;e>i;i+=1)1===i&&(a+=" M"+r.applyToPointStringified(t.v[0][0],t.v[0][1])),a+=" C"+r.applyToPointStringified(t.o[i-1][0],t.o[i-1][1])+" "+r.applyToPointStringified(t.i[i][0],t.i[i][1])+" "+r.applyToPointStringified(t.v[i][0],t.v[i][1]);return 1===e&&(a+=" M"+r.applyToPointStringified(t.v[0][0],t.v[0][1])),s&&e&&(a+=" C"+r.applyToPointStringified(t.o[i-1][0],t.o[i-1][1])+" "+r.applyToPointStringified(t.i[0][0],t.i[0][1])+" "+r.applyToPointStringified(t.v[0][0],t.v[0][1]),a+="z"),a},IShapeElement.prototype.renderPath=function(t,e){var s,r,i,a,n,o,h=e.elements.length,l=e.lvl;if(t._render)for(o=0;h>o;o+=1)if(e.elements[o].data._render){a=e.sh.mdf||this.firstFrame,i="M0 0";var p=e.sh.paths;if(r=p._length,e.elements[o].lvl<l){for(var m,f=this.mHelper.reset(),c=l-e.elements[o].lvl,d=e.transformers.length-1;c>0;)a=e.transformers[d].mProps.mdf||a,m=e.transformers[d].mProps.v.props,f.transform(m[0],m[1],m[2],m[3],m[4],m[5],m[6],m[7],m[8],m[9],m[10],m[11],m[12],m[13],m[14],m[15]),c--,d--;if(a){for(s=0;r>s;s+=1)n=p.shapes[s],n&&n._length&&(i+=this.buildShapeString(n,n._length,n.c,f));e.caches[o]=i}else i=e.caches[o]}else if(a){for(s=0;r>s;s+=1)n=p.shapes[s],n&&n._length&&(i+=this.buildShapeString(n,n._length,n.c,this.identityMatrix));e.caches[o]=i}else i=e.caches[o];e.elements[o].d+=i,e.elements[o].mdf=a||e.elements[o].mdf}else e.elements[o].mdf=!0},IShapeElement.prototype.renderFill=function(t,e){var s=e.style;(e.c.mdf||this.firstFrame)&&s.pElem.setAttribute("fill","rgb("+bm_floor(e.c.v[0])+","+bm_floor(e.c.v[1])+","+bm_floor(e.c.v[2])+")"),(e.o.mdf||this.firstFrame)&&s.pElem.setAttribute("fill-opacity",e.o.v)},IShapeElement.prototype.renderGradient=function(t,e){var s=e.gf,r=e.of,i=e.s.v,a=e.e.v;if(e.o.mdf||this.firstFrame){var n="gf"===t.ty?"fill-opacity":"stroke-opacity";e.elem.setAttribute(n,e.o.v)}if(e.s.mdf||this.firstFrame){var o=1===t.t?"x1":"cx",h="x1"===o?"y1":"cy";s.setAttribute(o,i[0]),s.setAttribute(h,i[1]),r&&(r.setAttribute(o,i[0]),r.setAttribute(h,i[1]))}var l,p,m,f;if(e.g.cmdf||this.firstFrame){l=e.cst;var c=e.g.c;for(m=l.length,p=0;m>p;p+=1)f=l[p],f.setAttribute("offset",c[4*p]+"%"),f.setAttribute("stop-color","rgb("+c[4*p+1]+","+c[4*p+2]+","+c[4*p+3]+")")}if(r&&(e.g.omdf||this.firstFrame)){l=e.ost;var d=e.g.o;for(m=l.length,p=0;m>p;p+=1)f=l[p],f.setAttribute("offset",d[2*p]+"%"),f.setAttribute("stop-opacity",d[2*p+1])}if(1===t.t)(e.e.mdf||this.firstFrame)&&(s.setAttribute("x2",a[0]),s.setAttribute("y2",a[1]),r&&(r.setAttribute("x2",a[0]),r.setAttribute("y2",a[1])));else{var u;if((e.s.mdf||e.e.mdf||this.firstFrame)&&(u=Math.sqrt(Math.pow(i[0]-a[0],2)+Math.pow(i[1]-a[1],2)),s.setAttribute("r",u),r&&r.setAttribute("r",u)),e.e.mdf||e.h.mdf||e.a.mdf||this.firstFrame){
u||(u=Math.sqrt(Math.pow(i[0]-a[0],2)+Math.pow(i[1]-a[1],2)));var y=Math.atan2(a[1]-i[1],a[0]-i[0]),g=e.h.v>=1?.99:e.h.v<=-1?-.99:e.h.v,v=u*g,b=Math.cos(y+e.a.v)*v+i[0],E=Math.sin(y+e.a.v)*v+i[1];s.setAttribute("fx",b),s.setAttribute("fy",E),r&&(r.setAttribute("fx",b),r.setAttribute("fy",E))}}},IShapeElement.prototype.renderStroke=function(t,e){var s=e.style,r=e.d;r&&r.k&&(r.mdf||this.firstFrame)&&(s.pElem.setAttribute("stroke-dasharray",r.dasharray),s.pElem.setAttribute("stroke-dashoffset",r.dashoffset)),e.c&&(e.c.mdf||this.firstFrame)&&s.pElem.setAttribute("stroke","rgb("+bm_floor(e.c.v[0])+","+bm_floor(e.c.v[1])+","+bm_floor(e.c.v[2])+")"),(e.o.mdf||this.firstFrame)&&s.pElem.setAttribute("stroke-opacity",e.o.v),(e.w.mdf||this.firstFrame)&&(s.pElem.setAttribute("stroke-width",e.w.v),s.msElem&&s.msElem.setAttribute("stroke-width",e.w.v))},IShapeElement.prototype.destroy=function(){this._parent.destroy.call(this._parent),this.shapeData=null,this.itemsData=null,this.parentContainer=null,this.placeholder=null},ITextElement.prototype.init=function(){this.lettersChangedFlag=!0,this.dynamicProperties=this.dynamicProperties||[],this.textAnimator=new TextAnimatorProperty(this.data.t,this.renderType,this),this.textProperty=new TextProperty(this,this.data.t,this.dynamicProperties),this._parent.init.call(this),this.textAnimator.searchProperties(this.dynamicProperties)},ITextElement.prototype.prepareFrame=function(t){this._parent.prepareFrame.call(this,t),(this.textProperty.mdf||this.textProperty.firstFrame)&&(this.buildNewText(),this.textProperty.firstFrame=!1)},ITextElement.prototype.createPathShape=function(t,e){var s,r,i=e.length,a="";for(s=0;i>s;s+=1)r=e[s].ks.k,a+=this.buildShapeString(r,r.i.length,!0,t);return a},ITextElement.prototype.updateDocumentData=function(t,e){this.textProperty.updateDocumentData(t,e)},ITextElement.prototype.applyTextPropertiesToMatrix=function(t,e,s,r,i){switch(t.ps&&e.translate(t.ps[0],t.ps[1]+t.ascent,0),e.translate(0,-t.ls,0),t.j){case 1:e.translate(t.justifyOffset+(t.boxWidth-t.lineWidths[s]),0,0);break;case 2:e.translate(t.justifyOffset+(t.boxWidth-t.lineWidths[s])/2,0,0)}e.translate(r,i,0)},ITextElement.prototype.buildColor=function(t){return"rgb("+Math.round(255*t[0])+","+Math.round(255*t[1])+","+Math.round(255*t[2])+")"},ITextElement.prototype.buildShapeString=IShapeElement.prototype.buildShapeString,ITextElement.prototype.emptyProp=new LetterProps,ITextElement.prototype.destroy=function(){this._parent.destroy.call(this._parent)},createElement(SVGBaseElement,SVGTextElement),extendPrototype(ITextElement,SVGTextElement),SVGTextElement.prototype.createElements=function(){this._parent.createElements.call(this),this.data.ln&&this.layerElement.setAttribute("id",this.data.ln),this.data.cl&&this.layerElement.setAttribute("class",this.data.cl),this.data.singleShape&&!this.globalData.fontManager.chars&&(this.textContainer=document.createElementNS(svgNS,"text"))},SVGTextElement.prototype.buildNewText=function(){var t,e,s=this.textProperty.currentData;this.renderedLetters=Array.apply(null,{length:s?s.l.length:0}),s.fc?this.layerElement.setAttribute("fill",this.buildColor(s.fc)):this.layerElement.setAttribute("fill","rgba(0,0,0,0)"),s.sc&&(this.layerElement.setAttribute("stroke",this.buildColor(s.sc)),this.layerElement.setAttribute("stroke-width",s.sw)),this.layerElement.setAttribute("font-size",s.s);var r=this.globalData.fontManager.getFontByName(s.f);if(r.fClass)this.layerElement.setAttribute("class",r.fClass);else{this.layerElement.setAttribute("font-family",r.fFamily);var i=s.fWeight,a=s.fStyle;this.layerElement.setAttribute("font-style",a),this.layerElement.setAttribute("font-weight",i)}var n=s.l||[],o=this.globalData.fontManager.chars;if(e=n.length){var h,l,p=this.mHelper,m="",f=this.data.singleShape,c=0,d=0,u=!0,y=s.tr/1e3*s.s;if(f&&!o){var g=this.textContainer,v="";switch(s.j){case 1:v="end";break;case 2:v="middle";break;case 2:v="start"}g.setAttribute("text-anchor",v),g.setAttribute("letter-spacing",y);var b=s.t.split(String.fromCharCode(13));e=b.length;var d=s.ps?s.ps[1]+s.ascent:0;for(t=0;e>t;t+=1)h=this.textSpans[t]||document.createElementNS(svgNS,"tspan"),h.textContent=b[t],h.setAttribute("x",0),h.setAttribute("y",d),h.style.display="inherit",g.appendChild(h),this.textSpans[t]=h,d+=s.lh;this.layerElement.appendChild(g)}else{var E,P,x=this.textSpans.length;for(t=0;e>t;t+=1)o&&f&&0!==t||(h=x>t?this.textSpans[t]:document.createElementNS(svgNS,o?"path":"text"),t>=x&&(h.setAttribute("stroke-linecap","butt"),h.setAttribute("stroke-linejoin","round"),h.setAttribute("stroke-miterlimit","4"),this.textSpans[t]=h,this.layerElement.appendChild(h)),h.style.display="inherit"),p.reset(),o?(p.scale(s.s/100,s.s/100),f&&(n[t].n&&(c=-y,d+=s.yOffset,d+=u?1:0,u=!1),this.applyTextPropertiesToMatrix(s,p,n[t].line,c,d),c+=n[t].l||0,c+=y),P=this.globalData.fontManager.getCharData(s.t.charAt(t),r.fStyle,this.globalData.fontManager.getFontByName(s.f).fFamily),E=P&&P.data||{},l=E.shapes?E.shapes[0].it:[],f?m+=this.createPathShape(p,l):h.setAttribute("d",this.createPathShape(p,l))):(h.textContent=n[t].val,h.setAttributeNS("http://www.w3.org/XML/1998/namespace","xml:space","preserve"));f&&h.setAttribute("d",m)}for(;t<this.textSpans.length;)this.textSpans[t].style.display="none",t+=1;this._sizeChanged=!0}},SVGTextElement.prototype.sourceRectAtTime=function(t){if(this.prepareFrame(this.comp.renderedFrame-this.data.st),this.renderLetters(),this._sizeChanged){this._sizeChanged=!1;var e=this.layerElement.getBBox();this.bbox={top:e.y,left:e.x,width:e.width,height:e.height}}return this.bbox},SVGTextElement.prototype.renderLetters=function(){if(!this.data.singleShape&&(this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag),this.lettersChangedFlag||this.textAnimator.lettersChangedFlag)){this._sizeChanged=!0;var t,e,s=this.textAnimator.renderedLetters,r=this.textProperty.currentData.l;e=r.length;var i,a;for(t=0;e>t;t+=1)r[t].n||(i=s[t],a=this.textSpans[t],i.mdf.m&&a.setAttribute("transform",i.m),i.mdf.o&&a.setAttribute("opacity",i.o),i.mdf.sw&&a.setAttribute("stroke-width",i.sw),i.mdf.sc&&a.setAttribute("stroke",i.sc),i.mdf.fc&&a.setAttribute("fill",i.fc))}},SVGTextElement.prototype.renderFrame=function(t){var e=this._parent.renderFrame.call(this,t);return e===!1?void this.hide():(this.hidden&&this.show(),this.firstFrame&&(this.firstFrame=!1),void this.renderLetters())},SVGTintFilter.prototype.renderFrame=function(t){if(t||this.filterManager.mdf){var e=this.filterManager.effectElements[0].p.v,s=this.filterManager.effectElements[1].p.v,r=this.filterManager.effectElements[2].p.v/100;this.matrixFilter.setAttribute("values",s[0]-e[0]+" 0 0 0 "+e[0]+" "+(s[1]-e[1])+" 0 0 0 "+e[1]+" "+(s[2]-e[2])+" 0 0 0 "+e[2]+" 0 0 0 "+r+" 0")}},SVGFillFilter.prototype.renderFrame=function(t){if(t||this.filterManager.mdf){var e=this.filterManager.effectElements[2].p.v,s=this.filterManager.effectElements[6].p.v;this.matrixFilter.setAttribute("values","0 0 0 0 "+e[0]+" 0 0 0 0 "+e[1]+" 0 0 0 0 "+e[2]+" 0 0 0 "+s+" 0")}},SVGStrokeEffect.prototype.initialize=function(){var t,e,s,r,i=this.elem.layerElement.children||this.elem.layerElement.childNodes;for(1===this.filterManager.effectElements[1].p.v?(r=this.elem.maskManager.masksProperties.length,s=0):(s=this.filterManager.effectElements[0].p.v-1,r=s+1),e=document.createElementNS(svgNS,"g"),e.setAttribute("fill","none"),e.setAttribute("stroke-linecap","round"),e.setAttribute("stroke-dashoffset",1),s;r>s;s+=1)t=document.createElementNS(svgNS,"path"),e.appendChild(t),this.paths.push({p:t,m:s});if(3===this.filterManager.effectElements[10].p.v){var a=document.createElementNS(svgNS,"mask"),n="stms_"+randomString(10);a.setAttribute("id",n),a.setAttribute("mask-type","alpha"),a.appendChild(e),this.elem.globalData.defs.appendChild(a);var o=document.createElementNS(svgNS,"g");o.setAttribute("mask","url("+locationHref+"#"+n+")"),i[0]&&o.appendChild(i[0]),this.elem.layerElement.appendChild(o),this.masker=a,e.setAttribute("stroke","#fff")}else if(1===this.filterManager.effectElements[10].p.v||2===this.filterManager.effectElements[10].p.v){if(2===this.filterManager.effectElements[10].p.v)for(var i=this.elem.layerElement.children||this.elem.layerElement.childNodes;i.length;)this.elem.layerElement.removeChild(i[0]);this.elem.layerElement.appendChild(e),this.elem.layerElement.removeAttribute("mask"),e.setAttribute("stroke","#fff")}this.initialized=!0,this.pathMasker=e},SVGStrokeEffect.prototype.renderFrame=function(t){this.initialized||this.initialize();var e,s,r,i=this.paths.length;for(e=0;i>e;e+=1)if(s=this.elem.maskManager.viewData[this.paths[e].m],r=this.paths[e].p,(t||this.filterManager.mdf||s.prop.mdf)&&r.setAttribute("d",s.lastPath),t||this.filterManager.effectElements[9].p.mdf||this.filterManager.effectElements[4].p.mdf||this.filterManager.effectElements[7].p.mdf||this.filterManager.effectElements[8].p.mdf||s.prop.mdf){var a;if(0!==this.filterManager.effectElements[7].p.v||100!==this.filterManager.effectElements[8].p.v){var n=Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100,o=Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100,h=r.getTotalLength();a="0 0 0 "+h*n+" ";var l,p=h*(o-n),m=1+2*this.filterManager.effectElements[4].p.v*this.filterManager.effectElements[9].p.v/100,f=Math.floor(p/m);for(l=0;f>l;l+=1)a+="1 "+2*this.filterManager.effectElements[4].p.v*this.filterManager.effectElements[9].p.v/100+" ";a+="0 "+10*h+" 0 0"}else a="1 "+2*this.filterManager.effectElements[4].p.v*this.filterManager.effectElements[9].p.v/100;r.setAttribute("stroke-dasharray",a)}if((t||this.filterManager.effectElements[4].p.mdf)&&this.pathMasker.setAttribute("stroke-width",2*this.filterManager.effectElements[4].p.v),(t||this.filterManager.effectElements[6].p.mdf)&&this.pathMasker.setAttribute("opacity",this.filterManager.effectElements[6].p.v),(1===this.filterManager.effectElements[10].p.v||2===this.filterManager.effectElements[10].p.v)&&(t||this.filterManager.effectElements[3].p.mdf)){var c=this.filterManager.effectElements[3].p.v;this.pathMasker.setAttribute("stroke","rgb("+bm_floor(255*c[0])+","+bm_floor(255*c[1])+","+bm_floor(255*c[2])+")")}},SVGTritoneFilter.prototype.renderFrame=function(t){if(t||this.filterManager.mdf){var e=this.filterManager.effectElements[0].p.v,s=this.filterManager.effectElements[1].p.v,r=this.filterManager.effectElements[2].p.v,i=r[0]+" "+s[0]+" "+e[0],a=r[1]+" "+s[1]+" "+e[1],n=r[2]+" "+s[2]+" "+e[2];this.feFuncR.setAttribute("tableValues",i),this.feFuncG.setAttribute("tableValues",a),this.feFuncB.setAttribute("tableValues",n)}},SVGProLevelsFilter.prototype.createFeFunc=function(t,e){var s=document.createElementNS(svgNS,t);return s.setAttribute("type","table"),e.appendChild(s),s},SVGProLevelsFilter.prototype.getTableValue=function(t,e,s,r,i){for(var a,n,o=0,h=256,l=Math.min(t,e),p=Math.max(t,e),m=Array.call(null,{length:h}),f=0,c=i-r,d=e-t;256>=o;)a=o/256,n=l>=a?0>d?i:r:a>=p?0>d?r:i:r+c*Math.pow((a-t)/d,1/s),m[f++]=n,o+=256/(h-1);return m.join(" ")},SVGProLevelsFilter.prototype.renderFrame=function(t){if(t||this.filterManager.mdf){var e,s=this.filterManager.effectElements;this.feFuncRComposed&&(t||s[2].p.mdf||s[3].p.mdf||s[4].p.mdf||s[5].p.mdf||s[6].p.mdf)&&(e=this.getTableValue(s[2].p.v,s[3].p.v,s[4].p.v,s[5].p.v,s[6].p.v),this.feFuncRComposed.setAttribute("tableValues",e),this.feFuncGComposed.setAttribute("tableValues",e),this.feFuncBComposed.setAttribute("tableValues",e)),this.feFuncR&&(t||s[9].p.mdf||s[10].p.mdf||s[11].p.mdf||s[12].p.mdf||s[13].p.mdf)&&(e=this.getTableValue(s[9].p.v,s[10].p.v,s[11].p.v,s[12].p.v,s[13].p.v),this.feFuncR.setAttribute("tableValues",e)),this.feFuncG&&(t||s[16].p.mdf||s[17].p.mdf||s[18].p.mdf||s[19].p.mdf||s[20].p.mdf)&&(e=this.getTableValue(s[16].p.v,s[17].p.v,s[18].p.v,s[19].p.v,s[20].p.v),this.feFuncG.setAttribute("tableValues",e)),this.feFuncB&&(t||s[23].p.mdf||s[24].p.mdf||s[25].p.mdf||s[26].p.mdf||s[27].p.mdf)&&(e=this.getTableValue(s[23].p.v,s[24].p.v,s[25].p.v,s[26].p.v,s[27].p.v),this.feFuncB.setAttribute("tableValues",e)),this.feFuncA&&(t||s[30].p.mdf||s[31].p.mdf||s[32].p.mdf||s[33].p.mdf||s[34].p.mdf)&&(e=this.getTableValue(s[30].p.v,s[31].p.v,s[32].p.v,s[33].p.v,s[34].p.v),this.feFuncA.setAttribute("tableValues",e))}},SVGDropShadowEffect.prototype.renderFrame=function(t){if(t||this.filterManager.mdf){if((t||this.filterManager.effectElements[4].p.mdf)&&this.feGaussianBlur.setAttribute("stdDeviation",this.filterManager.effectElements[4].p.v/4),t||this.filterManager.effectElements[0].p.mdf){var e=this.filterManager.effectElements[0].p.v;this.feFlood.setAttribute("flood-color",rgbToHex(Math.round(255*e[0]),Math.round(255*e[1]),Math.round(255*e[2])))}if((t||this.filterManager.effectElements[1].p.mdf)&&this.feFlood.setAttribute("flood-opacity",this.filterManager.effectElements[1].p.v/255),t||this.filterManager.effectElements[2].p.mdf||this.filterManager.effectElements[3].p.mdf){var s=this.filterManager.effectElements[3].p.v,r=(this.filterManager.effectElements[2].p.v-90)*degToRads,i=s*Math.cos(r),a=s*Math.sin(r);this.feOffset.setAttribute("dx",i),this.feOffset.setAttribute("dy",a)}}},SVGMatte3Effect.prototype.setElementAsMask=function(t,e){var s=document.createElementNS(svgNS,"mask");s.setAttribute("id",e.layerId),s.setAttribute("mask-type","alpha"),s.appendChild(e.layerElement),t.setMatte(e.layerId),e.data.hd=!1;var r=t.globalData.defs;r.appendChild(s)},SVGMatte3Effect.prototype.initialize=function(){for(var t=this.filterManager.effectElements[0].p.v,e=0,s=this.elem.comp.elements.length;s>e;)this.elem.comp.elements[e].data.ind===t&&this.setElementAsMask(this.elem,this.elem.comp.elements[e]),e+=1;this.initialized=!0},SVGMatte3Effect.prototype.renderFrame=function(){this.initialized||this.initialize()},SVGEffects.prototype.renderFrame=function(t){var e,s=this.filters.length;for(e=0;s>e;e+=1)this.filters[e].renderFrame(t)},createElement(SVGBaseElement,ICompElement),ICompElement.prototype.hide=function(){if(!this.hidden){this._parent.hide.call(this);var t,e=this.elements.length;for(t=0;e>t;t+=1)this.elements[t]&&this.elements[t].hide()}},ICompElement.prototype.prepareFrame=function(t){if(this._parent.prepareFrame.call(this,t),this.isVisible!==!1||this.data.xt){if(this.tm){var e=this.tm.v;e===this.data.op&&(e=this.data.op-1),this.renderedFrame=e}else this.renderedFrame=t/this.data.sr;var s,r=this.elements.length;for(this.completeLayers||this.checkLayers(this.renderedFrame),s=0;r>s;s+=1)(this.completeLayers||this.elements[s])&&this.elements[s].prepareFrame(this.renderedFrame-this.layers[s].st)}},ICompElement.prototype.renderFrame=function(t){var e,s=this._parent.renderFrame.call(this,t),r=this.layers.length;if(s===!1)return void this.hide();for(this.hidden&&this.show(),e=0;r>e;e+=1)(this.completeLayers||this.elements[e])&&this.elements[e].renderFrame();this.firstFrame&&(this.firstFrame=!1)},ICompElement.prototype.setElements=function(t){this.elements=t},ICompElement.prototype.getElements=function(){return this.elements},ICompElement.prototype.destroy=function(){this._parent.destroy.call(this._parent);var t,e=this.layers.length;for(t=0;e>t;t+=1)this.elements[t]&&this.elements[t].destroy()},ICompElement.prototype.checkLayers=SVGRenderer.prototype.checkLayers,ICompElement.prototype.buildItem=SVGRenderer.prototype.buildItem,ICompElement.prototype.buildAllItems=SVGRenderer.prototype.buildAllItems,ICompElement.prototype.buildElementParenting=SVGRenderer.prototype.buildElementParenting,ICompElement.prototype.createItem=SVGRenderer.prototype.createItem,ICompElement.prototype.createImage=SVGRenderer.prototype.createImage,ICompElement.prototype.createComp=SVGRenderer.prototype.createComp,ICompElement.prototype.createSolid=SVGRenderer.prototype.createSolid,ICompElement.prototype.createShape=SVGRenderer.prototype.createShape,ICompElement.prototype.createText=SVGRenderer.prototype.createText,ICompElement.prototype.createBase=SVGRenderer.prototype.createBase,ICompElement.prototype.appendElementInPos=SVGRenderer.prototype.appendElementInPos,ICompElement.prototype.checkPendingElements=SVGRenderer.prototype.checkPendingElements,ICompElement.prototype.addPendingElement=SVGRenderer.prototype.addPendingElement,createElement(SVGBaseElement,IImageElement),IImageElement.prototype.createElements=function(){var t=this.globalData.getAssetsPath(this.assetData);this._parent.createElements.call(this),this.innerElem=document.createElementNS(svgNS,"image"),this.innerElem.setAttribute("width",this.assetData.w+"px"),this.innerElem.setAttribute("height",this.assetData.h+"px"),this.innerElem.setAttribute("preserveAspectRatio","xMidYMid slice"),this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink","href",t),this.maskedElement=this.innerElem,this.layerElement.appendChild(this.innerElem),this.data.ln&&this.layerElement.setAttribute("id",this.data.ln),this.data.cl&&this.layerElement.setAttribute("class",this.data.cl)},IImageElement.prototype.renderFrame=function(t){var e=this._parent.renderFrame.call(this,t);return e===!1?void this.hide():(this.hidden&&this.show(),void(this.firstFrame&&(this.firstFrame=!1)))},IImageElement.prototype.destroy=function(){this._parent.destroy.call(this._parent),this.innerElem=null},createElement(SVGBaseElement,ISolidElement),ISolidElement.prototype.createElements=function(){this._parent.createElements.call(this);var t=document.createElementNS(svgNS,"rect");t.setAttribute("width",this.data.sw),t.setAttribute("height",this.data.sh),t.setAttribute("fill",this.data.sc),this.layerElement.appendChild(t),this.innerElem=t,this.data.ln&&this.layerElement.setAttribute("id",this.data.ln),this.data.cl&&this.layerElement.setAttribute("class",this.data.cl)},ISolidElement.prototype.renderFrame=IImageElement.prototype.renderFrame,ISolidElement.prototype.destroy=IImageElement.prototype.destroy;var animationManager=function(){function t(t){for(var e=0,s=t.target;C>e;)x[e].animation===s&&(x.splice(e,1),e-=1,C-=1,s.isPaused||r()),e+=1}function e(t,e){if(!t)return null;for(var s=0;C>s;){if(x[s].elem==t&&null!==x[s].elem)return x[s].animation;s+=1}var r=new AnimationItem;return i(r,t),r.setData(t,e),r}function s(){A+=1,E()}function r(){A-=1,0===A&&(k=!0)}function i(e,i){e.addEventListener("destroy",t),e.addEventListener("_active",s),e.addEventListener("_idle",r),x.push({elem:i,animation:e}),C+=1}function a(t){var e=new AnimationItem;return i(e,null),e.setParams(t),e}function n(t,e){var s;for(s=0;C>s;s+=1)x[s].animation.setSpeed(t,e)}function o(t,e){var s;for(s=0;C>s;s+=1)x[s].animation.setDirection(t,e)}function h(t){var e;for(e=0;C>e;e+=1)x[e].animation.play(t)}function l(t,e){S=Date.now();var s;for(s=0;C>s;s+=1)x[s].animation.moveFrame(t,e)}function p(t){var e,s=t-S;for(e=0;C>e;e+=1)x[e].animation.advanceTime(s);S=t,k||window.requestAnimationFrame(p)}function m(t){S=t,window.requestAnimationFrame(p)}function f(t){var e;for(e=0;C>e;e+=1)x[e].animation.pause(t)}function c(t,e,s){var r;for(r=0;C>r;r+=1)x[r].animation.goToAndStop(t,e,s)}function d(t){var e;for(e=0;C>e;e+=1)x[e].animation.stop(t)}function u(t){var e;for(e=0;C>e;e+=1)x[e].animation.togglePause(t)}function y(t){var e;for(e=C-1;e>=0;e-=1)x[e].animation.destroy(t)}function g(t,s,r){var i,a=document.getElementsByClassName("bodymovin"),n=a.length;for(i=0;n>i;i+=1)r&&a[i].setAttribute("data-bm-type",r),e(a[i],t);if(s&&0===n){r||(r="svg");var o=document.getElementsByTagName("body")[0];o.innerHTML="";var h=document.createElement("div");h.style.width="100%",h.style.height="100%",h.setAttribute("data-bm-type",r),o.appendChild(h),e(h,t)}}function v(){var t;for(t=0;C>t;t+=1)x[t].animation.resize()}function b(){window.requestAnimationFrame(m)}function E(){k&&(k=!1,window.requestAnimationFrame(m))}var P={},x=[],S=0,C=0,k=!0,A=0;return setTimeout(b,0),P.registerAnimation=e,P.loadAnimation=a,P.setSpeed=n,P.setDirection=o,P.play=h,P.moveFrame=l,P.pause=f,P.stop=d,P.togglePause=u,P.searchAnimations=g,P.resize=v,P.start=b,P.goToAndStop=c,P.destroy=y,P}(),AnimationItem=function(){this._cbs=[],this.name="",this.path="",this.isLoaded=!1,this.currentFrame=0,this.currentRawFrame=0,this.totalFrames=0,this.frameRate=0,this.frameMult=0,this.playSpeed=1,this.playDirection=1,this.pendingElements=0,this.playCount=0,this.prerenderFramesFlag=!0,this.animationData={},this.layers=[],this.assets=[],this.isPaused=!0,this.autoplay=!1,this.loop=!0,this.renderer=null,this.animationID=randomString(10),this.scaleMode="fit",this.assetsPath="",this.timeCompleted=0,this.segmentPos=0,this.subframeEnabled=subframeEnabled,this.segments=[],this.pendingSegment=!1,this._idle=!0,this.projectInterface=ProjectInterface()};AnimationItem.prototype.setParams=function(t){var e=this;t.context&&(this.context=t.context),(t.wrapper||t.container)&&(this.wrapper=t.wrapper||t.container);var s=t.animType?t.animType:t.renderer?t.renderer:"svg";switch(s){case"canvas":this.renderer=new CanvasRenderer(this,t.rendererSettings);break;case"svg":this.renderer=new SVGRenderer(this,t.rendererSettings);break;case"hybrid":case"html":default:this.renderer=new HybridRenderer(this,t.rendererSettings)}if(this.renderer.setProjectInterface(this.projectInterface),this.animType=s,""===t.loop||null===t.loop||(this.loop=t.loop===!1?!1:t.loop===!0?!0:parseInt(t.loop)),this.autoplay="autoplay"in t?t.autoplay:!0,this.name=t.name?t.name:"",this.prerenderFramesFlag="prerender"in t?t.prerender:!0,this.autoloadSegments=t.hasOwnProperty("autoloadSegments")?t.autoloadSegments:!0,t.animationData)e.configAnimation(t.animationData);else if(t.path){"json"!=t.path.substr(-4)&&("/"!=t.path.substr(-1,1)&&(t.path+="/"),t.path+="data.json");var r=new XMLHttpRequest;this.path=-1!=t.path.lastIndexOf("\\")?t.path.substr(0,t.path.lastIndexOf("\\")+1):t.path.substr(0,t.path.lastIndexOf("/")+1),this.assetsPath=t.assetsPath,this.fileName=t.path.substr(t.path.lastIndexOf("/")+1),this.fileName=this.fileName.substr(0,this.fileName.lastIndexOf(".json")),r.open("GET",t.path,!0),r.send(),r.onreadystatechange=function(){if(4==r.readyState)if(200==r.status)e.configAnimation(JSON.parse(r.responseText));else try{var t=JSON.parse(r.responseText);e.configAnimation(t)}catch(s){}}}},AnimationItem.prototype.setData=function(t,e){var s={wrapper:t,animationData:e?"object"==typeof e?e:JSON.parse(e):null},r=t.attributes;s.path=r.getNamedItem("data-animation-path")?r.getNamedItem("data-animation-path").value:r.getNamedItem("data-bm-path")?r.getNamedItem("data-bm-path").value:r.getNamedItem("bm-path")?r.getNamedItem("bm-path").value:"",s.animType=r.getNamedItem("data-anim-type")?r.getNamedItem("data-anim-type").value:r.getNamedItem("data-bm-type")?r.getNamedItem("data-bm-type").value:r.getNamedItem("bm-type")?r.getNamedItem("bm-type").value:r.getNamedItem("data-bm-renderer")?r.getNamedItem("data-bm-renderer").value:r.getNamedItem("bm-renderer")?r.getNamedItem("bm-renderer").value:"canvas";var i=r.getNamedItem("data-anim-loop")?r.getNamedItem("data-anim-loop").value:r.getNamedItem("data-bm-loop")?r.getNamedItem("data-bm-loop").value:r.getNamedItem("bm-loop")?r.getNamedItem("bm-loop").value:"";""===i||(s.loop="false"===i?!1:"true"===i?!0:parseInt(i));var a=r.getNamedItem("data-anim-autoplay")?r.getNamedItem("data-anim-autoplay").value:r.getNamedItem("data-bm-autoplay")?r.getNamedItem("data-bm-autoplay").value:r.getNamedItem("bm-autoplay")?r.getNamedItem("bm-autoplay").value:!0;s.autoplay="false"!==a,s.name=r.getNamedItem("data-name")?r.getNamedItem("data-name").value:r.getNamedItem("data-bm-name")?r.getNamedItem("data-bm-name").value:r.getNamedItem("bm-name")?r.getNamedItem("bm-name").value:"";var n=r.getNamedItem("data-anim-prerender")?r.getNamedItem("data-anim-prerender").value:r.getNamedItem("data-bm-prerender")?r.getNamedItem("data-bm-prerender").value:r.getNamedItem("bm-prerender")?r.getNamedItem("bm-prerender").value:"";"false"===n&&(s.prerender=!1),this.setParams(s)},AnimationItem.prototype.includeLayers=function(t){t.op>this.animationData.op&&(this.animationData.op=t.op,this.totalFrames=Math.floor(t.op-this.animationData.ip),this.animationData.tf=this.totalFrames);var e,s,r=this.animationData.layers,i=r.length,a=t.layers,n=a.length;for(s=0;n>s;s+=1)for(e=0;i>e;){if(r[e].id==a[s].id){r[e]=a[s];break}e+=1}if((t.chars||t.fonts)&&(this.renderer.globalData.fontManager.addChars(t.chars),this.renderer.globalData.fontManager.addFonts(t.fonts,this.renderer.globalData.defs)),t.assets)for(i=t.assets.length,e=0;i>e;e+=1)this.animationData.assets.push(t.assets[e]);this.animationData.__complete=!1,dataManager.completeData(this.animationData,this.renderer.globalData.fontManager),this.renderer.includeLayers(t.layers),expressionsPlugin&&expressionsPlugin.initExpressions(this),this.renderer.renderFrame(null),this.loadNextSegment()},AnimationItem.prototype.loadNextSegment=function(){var t=this.animationData.segments;if(!t||0===t.length||!this.autoloadSegments)return this.trigger("data_ready"),void(this.timeCompleted=this.animationData.tf);var e=t.shift();this.timeCompleted=e.time*this.frameRate;var s=new XMLHttpRequest,r=this,i=this.path+this.fileName+"_"+this.segmentPos+".json";this.segmentPos+=1,s.open("GET",i,!0),s.send(),s.onreadystatechange=function(){if(4==s.readyState)if(200==s.status)r.includeLayers(JSON.parse(s.responseText));else try{var t=JSON.parse(s.responseText);r.includeLayers(t)}catch(e){}}},AnimationItem.prototype.loadSegments=function(){var t=this.animationData.segments;t||(this.timeCompleted=this.animationData.tf),this.loadNextSegment()},AnimationItem.prototype.configAnimation=function(t){var e=this;this.renderer&&this.renderer.destroyed||(this.animationData=t,this.totalFrames=Math.floor(this.animationData.op-this.animationData.ip),this.animationData.tf=this.totalFrames,this.renderer.configAnimation(t),t.assets||(t.assets=[]),t.comps&&(t.assets=t.assets.concat(t.comps),t.comps=null),this.renderer.searchExtraCompositions(t.assets),this.layers=this.animationData.layers,this.assets=this.animationData.assets,this.frameRate=this.animationData.fr,this.firstFrame=Math.round(this.animationData.ip),this.frameMult=this.animationData.fr/1e3,this.trigger("config_ready"),this.imagePreloader=new ImagePreloader,this.imagePreloader.setAssetsPath(this.assetsPath),this.imagePreloader.setPath(this.path),this.imagePreloader.loadAssets(t.assets,function(t){t||e.trigger("loaded_images")}),this.loadSegments(),this.updaFrameModifier(),this.renderer.globalData.fontManager?this.waitForFontsLoaded():(dataManager.completeData(this.animationData,this.renderer.globalData.fontManager),this.checkLoaded()))},AnimationItem.prototype.waitForFontsLoaded=function(){function t(){this.renderer.globalData.fontManager.loaded?(dataManager.completeData(this.animationData,this.renderer.globalData.fontManager),this.checkLoaded()):setTimeout(t.bind(this),20)}return function(){t.bind(this)()}}(),AnimationItem.prototype.addPendingElement=function(){this.pendingElements+=1},AnimationItem.prototype.elementLoaded=function(){this.pendingElements--,this.checkLoaded()},AnimationItem.prototype.checkLoaded=function(){0===this.pendingElements&&(expressionsPlugin&&expressionsPlugin.initExpressions(this),this.renderer.initItems(),setTimeout(function(){this.trigger("DOMLoaded")}.bind(this),0),this.isLoaded=!0,this.gotoFrame(),this.autoplay&&this.play())},AnimationItem.prototype.resize=function(){this.renderer.updateContainerSize()},AnimationItem.prototype.setSubframe=function(t){this.subframeEnabled=t?!0:!1},AnimationItem.prototype.gotoFrame=function(){this.currentFrame=this.subframeEnabled?this.currentRawFrame:Math.floor(this.currentRawFrame),this.timeCompleted!==this.totalFrames&&this.currentFrame>this.timeCompleted&&(this.currentFrame=this.timeCompleted),this.trigger("enterFrame"),this.renderFrame()},AnimationItem.prototype.renderFrame=function(){this.isLoaded!==!1&&this.renderer.renderFrame(this.currentFrame+this.firstFrame)},AnimationItem.prototype.play=function(t){t&&this.name!=t||this.isPaused===!0&&(this.isPaused=!1,this._idle&&(this._idle=!1,this.trigger("_active")))},AnimationItem.prototype.pause=function(t){t&&this.name!=t||this.isPaused===!1&&(this.isPaused=!0,this.pendingSegment||(this._idle=!0,this.trigger("_idle")))},AnimationItem.prototype.togglePause=function(t){t&&this.name!=t||(this.isPaused===!0?this.play():this.pause())},AnimationItem.prototype.stop=function(t){t&&this.name!=t||(this.pause(),this.currentFrame=this.currentRawFrame=0,this.playCount=0,this.gotoFrame())},AnimationItem.prototype.goToAndStop=function(t,e,s){s&&this.name!=s||(this.setCurrentRawFrameValue(e?t:t*this.frameModifier),this.pause())},AnimationItem.prototype.goToAndPlay=function(t,e,s){this.goToAndStop(t,e,s),this.play()},AnimationItem.prototype.advanceTime=function(t){return this.pendingSegment?(this.pendingSegment=!1,this.adjustSegment(this.segments.shift()),void(this.isPaused&&this.play())):void(this.isPaused!==!0&&this.isLoaded!==!1&&this.setCurrentRawFrameValue(this.currentRawFrame+t*this.frameModifier))},AnimationItem.prototype.updateAnimation=function(t){this.setCurrentRawFrameValue(this.totalFrames*t)},AnimationItem.prototype.moveFrame=function(t,e){e&&this.name!=e||this.setCurrentRawFrameValue(this.currentRawFrame+t)},AnimationItem.prototype.adjustSegment=function(t){this.playCount=0,t[1]<t[0]?(this.frameModifier>0&&(this.playSpeed<0?this.setSpeed(-this.playSpeed):this.setDirection(-1)),this.totalFrames=t[0]-t[1],this.firstFrame=t[1],this.setCurrentRawFrameValue(this.totalFrames-.01)):t[1]>t[0]&&(this.frameModifier<0&&(this.playSpeed<0?this.setSpeed(-this.playSpeed):this.setDirection(1)),this.totalFrames=t[1]-t[0],this.firstFrame=t[0],this.setCurrentRawFrameValue(0)),this.trigger("segmentStart")},AnimationItem.prototype.setSegment=function(t,e){var s=-1;this.isPaused&&(this.currentRawFrame+this.firstFrame<t?s=t:this.currentRawFrame+this.firstFrame>e&&(s=e-t-.01)),this.firstFrame=t,this.totalFrames=e-t,-1!==s&&this.goToAndStop(s,!0)},AnimationItem.prototype.playSegments=function(t,e){if("object"==typeof t[0]){var s,r=t.length;for(s=0;r>s;s+=1)this.segments.push(t[s])}else this.segments.push(t);e&&this.adjustSegment(this.segments.shift()),this.isPaused&&this.play()},AnimationItem.prototype.resetSegments=function(t){this.segments.length=0,this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op-this.animationData.ip+this.animationData.ip*this.frameRate)]),t&&this.adjustSegment(this.segments.shift())},AnimationItem.prototype.checkSegments=function(){this.segments.length&&(this.pendingSegment=!0)},AnimationItem.prototype.remove=function(t){t&&this.name!=t||this.renderer.destroy()},AnimationItem.prototype.destroy=function(t){t&&this.name!=t||this.renderer&&this.renderer.destroyed||(this.renderer.destroy(),this.trigger("destroy"),this._cbs=null,this.onEnterFrame=this.onLoopComplete=this.onComplete=this.onSegmentStart=this.onDestroy=null)},AnimationItem.prototype.setCurrentRawFrameValue=function(t){if(this.currentRawFrame=t,this.currentRawFrame>=this.totalFrames){if(this.checkSegments(),this.loop===!1)return this.currentRawFrame=this.totalFrames-.01,this.gotoFrame(),this.pause(),void this.trigger("complete");if(this.trigger("loopComplete"),this.playCount+=1,this.loop!==!0&&this.playCount==this.loop||this.pendingSegment)return this.currentRawFrame=this.totalFrames-.01,this.gotoFrame(),this.pause(),void this.trigger("complete");this.currentRawFrame=this.currentRawFrame%this.totalFrames}else if(this.currentRawFrame<0)return this.checkSegments(),this.playCount-=1,this.playCount<0&&(this.playCount=0),this.loop===!1||this.pendingSegment?(this.currentRawFrame=0,this.gotoFrame(),this.pause(),void this.trigger("complete")):(this.trigger("loopComplete"),this.currentRawFrame=(this.totalFrames+this.currentRawFrame)%this.totalFrames,void this.gotoFrame());this.gotoFrame()},AnimationItem.prototype.setSpeed=function(t){this.playSpeed=t,this.updaFrameModifier()},AnimationItem.prototype.setDirection=function(t){this.playDirection=0>t?-1:1,this.updaFrameModifier();

},AnimationItem.prototype.updaFrameModifier=function(){this.frameModifier=this.frameMult*this.playSpeed*this.playDirection},AnimationItem.prototype.getPath=function(){return this.path},AnimationItem.prototype.getAssetsPath=function(t){var e="";if(this.assetsPath){var s=t.p;-1!==s.indexOf("images/")&&(s=s.split("/")[1]),e=this.assetsPath+s}else e=this.path,e+=t.u?t.u:"",e+=t.p;return e},AnimationItem.prototype.getAssetData=function(t){for(var e=0,s=this.assets.length;s>e;){if(t==this.assets[e].id)return this.assets[e];e+=1}},AnimationItem.prototype.hide=function(){this.renderer.hide()},AnimationItem.prototype.show=function(){this.renderer.show()},AnimationItem.prototype.getAssets=function(){return this.assets},AnimationItem.prototype.trigger=function(t){if(this._cbs&&this._cbs[t])switch(t){case"enterFrame":this.triggerEvent(t,new BMEnterFrameEvent(t,this.currentFrame,this.totalFrames,this.frameMult));break;case"loopComplete":this.triggerEvent(t,new BMCompleteLoopEvent(t,this.loop,this.playCount,this.frameMult));break;case"complete":this.triggerEvent(t,new BMCompleteEvent(t,this.frameMult));break;case"segmentStart":this.triggerEvent(t,new BMSegmentStartEvent(t,this.firstFrame,this.totalFrames));break;case"destroy":this.triggerEvent(t,new BMDestroyEvent(t,this));break;default:this.triggerEvent(t)}"enterFrame"===t&&this.onEnterFrame&&this.onEnterFrame.call(this,new BMEnterFrameEvent(t,this.currentFrame,this.totalFrames,this.frameMult)),"loopComplete"===t&&this.onLoopComplete&&this.onLoopComplete.call(this,new BMCompleteLoopEvent(t,this.loop,this.playCount,this.frameMult)),"complete"===t&&this.onComplete&&this.onComplete.call(this,new BMCompleteEvent(t,this.frameMult)),"segmentStart"===t&&this.onSegmentStart&&this.onSegmentStart.call(this,new BMSegmentStartEvent(t,this.firstFrame,this.totalFrames)),"destroy"===t&&this.onDestroy&&this.onDestroy.call(this,new BMDestroyEvent(t,this))},AnimationItem.prototype.addEventListener=_addEventListener,AnimationItem.prototype.removeEventListener=_removeEventListener,AnimationItem.prototype.triggerEvent=_triggerEvent,extendPrototype(BaseRenderer,CanvasRenderer),CanvasRenderer.prototype.createBase=function(t){return new CVBaseElement(t,this,this.globalData)},CanvasRenderer.prototype.createShape=function(t){return new CVShapeElement(t,this,this.globalData)},CanvasRenderer.prototype.createText=function(t){return new CVTextElement(t,this,this.globalData)},CanvasRenderer.prototype.createImage=function(t){return new CVImageElement(t,this,this.globalData)},CanvasRenderer.prototype.createComp=function(t){return new CVCompElement(t,this,this.globalData)},CanvasRenderer.prototype.createSolid=function(t){return new CVSolidElement(t,this,this.globalData)},CanvasRenderer.prototype.ctxTransform=function(t){if(1!==t[0]||0!==t[1]||0!==t[4]||1!==t[5]||0!==t[12]||0!==t[13]){if(!this.renderConfig.clearCanvas)return void this.canvasContext.transform(t[0],t[1],t[4],t[5],t[12],t[13]);this.transformMat.cloneFromProps(t),this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15]),this.contextData.cTr.cloneFromProps(this.transformMat.props);var e=this.contextData.cTr.props;this.canvasContext.setTransform(e[0],e[1],e[4],e[5],e[12],e[13])}},CanvasRenderer.prototype.ctxOpacity=function(t){if(1!==t){if(!this.renderConfig.clearCanvas)return void(this.canvasContext.globalAlpha*=0>t?0:t);this.contextData.cO*=0>t?0:t,this.canvasContext.globalAlpha=this.contextData.cO}},CanvasRenderer.prototype.reset=function(){return this.renderConfig.clearCanvas?(this.contextData.cArrPos=0,this.contextData.cTr.reset(),void(this.contextData.cO=1)):void this.canvasContext.restore()},CanvasRenderer.prototype.save=function(t){if(!this.renderConfig.clearCanvas)return void this.canvasContext.save();t&&this.canvasContext.save();var e=this.contextData.cTr.props;(null===this.contextData.saved[this.contextData.cArrPos]||void 0===this.contextData.saved[this.contextData.cArrPos])&&(this.contextData.saved[this.contextData.cArrPos]=new Array(16));var s,r=this.contextData.saved[this.contextData.cArrPos];for(s=0;16>s;s+=1)r[s]=e[s];this.contextData.savedOp[this.contextData.cArrPos]=this.contextData.cO,this.contextData.cArrPos+=1},CanvasRenderer.prototype.restore=function(t){if(!this.renderConfig.clearCanvas)return void this.canvasContext.restore();t&&this.canvasContext.restore(),this.contextData.cArrPos-=1;var e,s=this.contextData.saved[this.contextData.cArrPos],r=this.contextData.cTr.props;for(e=0;16>e;e+=1)r[e]=s[e];this.canvasContext.setTransform(s[0],s[1],s[4],s[5],s[12],s[13]),s=this.contextData.savedOp[this.contextData.cArrPos],this.contextData.cO=s,this.canvasContext.globalAlpha=s},CanvasRenderer.prototype.configAnimation=function(t){this.animationItem.wrapper?(this.animationItem.container=document.createElement("canvas"),this.animationItem.container.style.width="100%",this.animationItem.container.style.height="100%",this.animationItem.container.style.transformOrigin=this.animationItem.container.style.mozTransformOrigin=this.animationItem.container.style.webkitTransformOrigin=this.animationItem.container.style["-webkit-transform"]="0px 0px 0px",this.animationItem.wrapper.appendChild(this.animationItem.container),this.canvasContext=this.animationItem.container.getContext("2d"),this.renderConfig.className&&this.animationItem.container.setAttribute("class",this.renderConfig.className)):this.canvasContext=this.renderConfig.context,this.data=t,this.globalData.canvasContext=this.canvasContext,this.globalData.renderer=this,this.globalData.isDashed=!1,this.globalData.totalFrames=Math.floor(t.tf),this.globalData.compWidth=t.w,this.globalData.compHeight=t.h,this.globalData.frameRate=t.fr,this.globalData.frameId=0,this.globalData.compSize={w:t.w,h:t.h},this.globalData.progressiveLoad=this.renderConfig.progressiveLoad,this.layers=t.layers,this.transformCanvas={},this.transformCanvas.w=t.w,this.transformCanvas.h=t.h,this.globalData.fontManager=new FontManager,this.globalData.fontManager.addChars(t.chars),this.globalData.fontManager.addFonts(t.fonts,document.body),this.globalData.getAssetData=this.animationItem.getAssetData.bind(this.animationItem),this.globalData.getAssetsPath=this.animationItem.getAssetsPath.bind(this.animationItem),this.globalData.elementLoaded=this.animationItem.elementLoaded.bind(this.animationItem),this.globalData.addPendingElement=this.animationItem.addPendingElement.bind(this.animationItem),this.globalData.transformCanvas=this.transformCanvas,this.elements=Array.apply(null,{length:t.layers.length}),this.updateContainerSize()},CanvasRenderer.prototype.updateContainerSize=function(){var t,e;this.animationItem.wrapper&&this.animationItem.container?(t=this.animationItem.wrapper.offsetWidth,e=this.animationItem.wrapper.offsetHeight,this.animationItem.container.setAttribute("width",t*this.renderConfig.dpr),this.animationItem.container.setAttribute("height",e*this.renderConfig.dpr)):(t=this.canvasContext.canvas.width*this.renderConfig.dpr,e=this.canvasContext.canvas.height*this.renderConfig.dpr);var s,r;if(-1!==this.renderConfig.preserveAspectRatio.indexOf("meet")||-1!==this.renderConfig.preserveAspectRatio.indexOf("slice")){var i=this.renderConfig.preserveAspectRatio.split(" "),a=i[1]||"meet",n=i[0]||"xMidYMid",o=n.substr(0,4),h=n.substr(4);s=t/e,r=this.transformCanvas.w/this.transformCanvas.h,r>s&&"meet"===a||s>r&&"slice"===a?(this.transformCanvas.sx=t/(this.transformCanvas.w/this.renderConfig.dpr),this.transformCanvas.sy=t/(this.transformCanvas.w/this.renderConfig.dpr)):(this.transformCanvas.sx=e/(this.transformCanvas.h/this.renderConfig.dpr),this.transformCanvas.sy=e/(this.transformCanvas.h/this.renderConfig.dpr)),this.transformCanvas.tx="xMid"===o&&(s>r&&"meet"===a||r>s&&"slice"===a)?(t-this.transformCanvas.w*(e/this.transformCanvas.h))/2*this.renderConfig.dpr:"xMax"===o&&(s>r&&"meet"===a||r>s&&"slice"===a)?(t-this.transformCanvas.w*(e/this.transformCanvas.h))*this.renderConfig.dpr:0,this.transformCanvas.ty="YMid"===h&&(r>s&&"meet"===a||s>r&&"slice"===a)?(e-this.transformCanvas.h*(t/this.transformCanvas.w))/2*this.renderConfig.dpr:"YMax"===h&&(r>s&&"meet"===a||s>r&&"slice"===a)?(e-this.transformCanvas.h*(t/this.transformCanvas.w))*this.renderConfig.dpr:0}else"none"==this.renderConfig.preserveAspectRatio?(this.transformCanvas.sx=t/(this.transformCanvas.w/this.renderConfig.dpr),this.transformCanvas.sy=e/(this.transformCanvas.h/this.renderConfig.dpr),this.transformCanvas.tx=0,this.transformCanvas.ty=0):(this.transformCanvas.sx=this.renderConfig.dpr,this.transformCanvas.sy=this.renderConfig.dpr,this.transformCanvas.tx=0,this.transformCanvas.ty=0);this.transformCanvas.props=[this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];var l,p=this.elements.length;for(l=0;p>l;l+=1)this.elements[l]&&0===this.elements[l].data.ty&&this.elements[l].resize(this.globalData.transformCanvas)},CanvasRenderer.prototype.destroy=function(){this.renderConfig.clearCanvas&&(this.animationItem.wrapper.innerHTML="");var t,e=this.layers?this.layers.length:0;for(t=e-1;t>=0;t-=1)this.elements[t]&&this.elements[t].destroy();this.elements.length=0,this.globalData.canvasContext=null,this.animationItem.container=null,this.destroyed=!0},CanvasRenderer.prototype.renderFrame=function(t){if(!(this.renderedFrame==t&&this.renderConfig.clearCanvas===!0||this.destroyed||null===t)){this.renderedFrame=t,this.globalData.frameNum=t-this.animationItem.firstFrame,this.globalData.frameId+=1,this.globalData.projectInterface.currentFrame=t,this.renderConfig.clearCanvas===!0?(this.reset(),this.canvasContext.save(),this.canvasContext.clearRect(this.transformCanvas.tx,this.transformCanvas.ty,this.transformCanvas.w*this.transformCanvas.sx,this.transformCanvas.h*this.transformCanvas.sy)):this.save(),this.ctxTransform(this.transformCanvas.props),this.canvasContext.beginPath(),this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h),this.canvasContext.closePath(),this.canvasContext.clip();var e,s=this.layers.length;for(this.completeLayers||this.checkLayers(t),e=0;s>e;e++)(this.completeLayers||this.elements[e])&&this.elements[e].prepareFrame(t-this.layers[e].st);for(e=s-1;e>=0;e-=1)(this.completeLayers||this.elements[e])&&this.elements[e].renderFrame();this.renderConfig.clearCanvas!==!0?this.restore():this.canvasContext.restore()}},CanvasRenderer.prototype.buildItem=function(t){var e=this.elements;if(!e[t]&&99!=this.layers[t].ty){var s=this.createItem(this.layers[t],this,this.globalData);e[t]=s,s.initExpressions(),0===this.layers[t].ty&&s.resize(this.globalData.transformCanvas)}},CanvasRenderer.prototype.checkPendingElements=function(){for(;this.pendingElements.length;){var t=this.pendingElements.pop();t.checkParenting()}},CanvasRenderer.prototype.hide=function(){this.animationItem.container.style.display="none"},CanvasRenderer.prototype.show=function(){this.animationItem.container.style.display="block"},CanvasRenderer.prototype.searchExtraCompositions=function(t){{var e,s=t.length;document.createElementNS(svgNS,"g")}for(e=0;s>e;e+=1)if(t[e].xt){var r=this.createComp(t[e],this.globalData.comp,this.globalData);r.initExpressions(),this.globalData.projectInterface.registerComposition(r)}},extendPrototype(BaseRenderer,HybridRenderer),HybridRenderer.prototype.buildItem=SVGRenderer.prototype.buildItem,HybridRenderer.prototype.checkPendingElements=function(){for(;this.pendingElements.length;){var t=this.pendingElements.pop();t.checkParenting()}},HybridRenderer.prototype.appendElementInPos=function(t,e){var s=t.getBaseElement();if(s){var r=this.layers[e];if(r.ddd&&this.supports3d)this.addTo3dContainer(s,e);else{for(var i,a,n=0;e>n;)this.elements[n]&&this.elements[n]!==!0&&this.elements[n].getBaseElement&&(a=this.elements[n],i=this.layers[n].ddd?this.getThreeDContainerByPos(n):a.getBaseElement()),n+=1;i?r.ddd&&this.supports3d||this.layerElement.insertBefore(s,i):r.ddd&&this.supports3d||this.layerElement.appendChild(s)}}},HybridRenderer.prototype.createBase=function(t){return new SVGBaseElement(t,this.layerElement,this.globalData,this)},HybridRenderer.prototype.createShape=function(t){return this.supports3d?new HShapeElement(t,this.layerElement,this.globalData,this):new IShapeElement(t,this.layerElement,this.globalData,this)},HybridRenderer.prototype.createText=function(t){return this.supports3d?new HTextElement(t,this.layerElement,this.globalData,this):new SVGTextElement(t,this.layerElement,this.globalData,this)},HybridRenderer.prototype.createCamera=function(t){return this.camera=new HCameraElement(t,this.layerElement,this.globalData,this),this.camera},HybridRenderer.prototype.createImage=function(t){return this.supports3d?new HImageElement(t,this.layerElement,this.globalData,this):new IImageElement(t,this.layerElement,this.globalData,this)},HybridRenderer.prototype.createComp=function(t){return this.supports3d?new HCompElement(t,this.layerElement,this.globalData,this):new ICompElement(t,this.layerElement,this.globalData,this)},HybridRenderer.prototype.createSolid=function(t){return this.supports3d?new HSolidElement(t,this.layerElement,this.globalData,this):new ISolidElement(t,this.layerElement,this.globalData,this)},HybridRenderer.prototype.getThreeDContainerByPos=function(t){for(var e=0,s=this.threeDElements.length;s>e;){if(this.threeDElements[e].startPos<=t&&this.threeDElements[e].endPos>=t)return this.threeDElements[e].perspectiveElem;e+=1}},HybridRenderer.prototype.createThreeDContainer=function(t){var e=document.createElement("div");styleDiv(e),e.style.width=this.globalData.compSize.w+"px",e.style.height=this.globalData.compSize.h+"px",e.style.transformOrigin=e.style.mozTransformOrigin=e.style.webkitTransformOrigin="50% 50%";var s=document.createElement("div");styleDiv(s),s.style.transform=s.style.webkitTransform="matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)",e.appendChild(s),this.resizerElem.appendChild(e);var r={container:s,perspectiveElem:e,startPos:t,endPos:t};return this.threeDElements.push(r),r},HybridRenderer.prototype.build3dContainers=function(){var t,e,s=this.layers.length;for(t=0;s>t;t+=1)this.layers[t].ddd?(e||(e=this.createThreeDContainer(t)),e.endPos=Math.max(e.endPos,t)):e=null},HybridRenderer.prototype.addTo3dContainer=function(t,e){for(var s=0,r=this.threeDElements.length;r>s;){if(e<=this.threeDElements[s].endPos){for(var i,a=this.threeDElements[s].startPos;e>a;)this.elements[a]&&this.elements[a].getBaseElement&&(i=this.elements[a].getBaseElement()),a+=1;i?this.threeDElements[s].container.insertBefore(t,i):this.threeDElements[s].container.appendChild(t);break}s+=1}},HybridRenderer.prototype.configAnimation=function(t){var e=document.createElement("div"),s=this.animationItem.wrapper;e.style.width=t.w+"px",e.style.height=t.h+"px",this.resizerElem=e,styleDiv(e),e.style.transformStyle=e.style.webkitTransformStyle=e.style.mozTransformStyle="flat",this.renderConfig.className&&s.setAttribute("class",this.renderConfig.className),s.appendChild(e),e.style.overflow="hidden";var r=document.createElementNS(svgNS,"svg");r.setAttribute("width","1"),r.setAttribute("height","1"),styleDiv(r),this.resizerElem.appendChild(r);var i=document.createElementNS(svgNS,"defs");r.appendChild(i),this.globalData.defs=i,this.data=t,this.globalData.getAssetData=this.animationItem.getAssetData.bind(this.animationItem),this.globalData.getAssetsPath=this.animationItem.getAssetsPath.bind(this.animationItem),this.globalData.elementLoaded=this.animationItem.elementLoaded.bind(this.animationItem),this.globalData.frameId=0,this.globalData.compSize={w:t.w,h:t.h},this.globalData.frameRate=t.fr,this.layers=t.layers,this.globalData.fontManager=new FontManager,this.globalData.fontManager.addChars(t.chars),this.globalData.fontManager.addFonts(t.fonts,r),this.layerElement=this.resizerElem,this.build3dContainers(),this.updateContainerSize()},HybridRenderer.prototype.destroy=function(){this.animationItem.wrapper.innerHTML="",this.animationItem.container=null,this.globalData.defs=null;var t,e=this.layers?this.layers.length:0;for(t=0;e>t;t++)this.elements[t].destroy();this.elements.length=0,this.destroyed=!0,this.animationItem=null},HybridRenderer.prototype.updateContainerSize=function(){var t,e,s,r,i=this.animationItem.wrapper.offsetWidth,a=this.animationItem.wrapper.offsetHeight,n=i/a,o=this.globalData.compSize.w/this.globalData.compSize.h;o>n?(t=i/this.globalData.compSize.w,e=i/this.globalData.compSize.w,s=0,r=(a-this.globalData.compSize.h*(i/this.globalData.compSize.w))/2):(t=a/this.globalData.compSize.h,e=a/this.globalData.compSize.h,s=(i-this.globalData.compSize.w*(a/this.globalData.compSize.h))/2,r=0),this.resizerElem.style.transform=this.resizerElem.style.webkitTransform="matrix3d("+t+",0,0,0,0,"+e+",0,0,0,0,1,0,"+s+","+r+",0,1)"},HybridRenderer.prototype.renderFrame=SVGRenderer.prototype.renderFrame,HybridRenderer.prototype.hide=function(){this.resizerElem.style.display="none"},HybridRenderer.prototype.show=function(){this.resizerElem.style.display="block"},HybridRenderer.prototype.initItems=function(){if(this.buildAllItems(),this.camera)this.camera.setup();else{var t,e=this.globalData.compSize.w,s=this.globalData.compSize.h,r=this.threeDElements.length;for(t=0;r>t;t+=1)this.threeDElements[t].perspectiveElem.style.perspective=this.threeDElements[t].perspectiveElem.style.webkitPerspective=Math.sqrt(Math.pow(e,2)+Math.pow(s,2))+"px"}},HybridRenderer.prototype.searchExtraCompositions=function(t){var e,s=t.length,r=document.createElement("div");for(e=0;s>e;e+=1)if(t[e].xt){var i=this.createComp(t[e],r,this.globalData.comp,null);i.initExpressions(),this.globalData.projectInterface.registerComposition(i)}},createElement(BaseElement,CVBaseElement),CVBaseElement.prototype.createElements=function(){this.checkParenting()},CVBaseElement.prototype.checkBlendMode=function(t){if(t.blendMode!==this.data.bm){t.blendMode=this.data.bm;var e="";switch(this.data.bm){case 0:e="normal";break;case 1:e="multiply";break;case 2:e="screen";break;case 3:e="overlay";break;case 4:e="darken";break;case 5:e="lighten";break;case 6:e="color-dodge";break;case 7:e="color-burn";break;case 8:e="hard-light";break;case 9:e="soft-light";break;case 10:e="difference";break;case 11:e="exclusion";break;case 12:e="hue";break;case 13:e="saturation";break;case 14:e="color";break;case 15:e="luminosity"}t.canvasContext.globalCompositeOperation=e}},CVBaseElement.prototype.renderFrame=function(t){if(3===this.data.ty)return!1;if(this.checkBlendMode(0===this.data.ty?this.parentGlobalData:this.globalData),!this.isVisible)return this.isVisible;this.finalTransform.opMdf=this.finalTransform.op.mdf,this.finalTransform.matMdf=this.finalTransform.mProp.mdf,this.finalTransform.opacity=this.finalTransform.op.v;var e,s=this.finalTransform.mat;if(this.hierarchy){var r,i=this.hierarchy.length;for(e=this.finalTransform.mProp.v.props,s.cloneFromProps(e),r=0;i>r;r+=1)this.finalTransform.matMdf=this.hierarchy[r].finalTransform.mProp.mdf?!0:this.finalTransform.matMdf,e=this.hierarchy[r].finalTransform.mProp.v.props,s.transform(e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8],e[9],e[10],e[11],e[12],e[13],e[14],e[15])}else t?(e=this.finalTransform.mProp.v.props,s.cloneFromProps(e)):s.cloneFromProps(this.finalTransform.mProp.v.props);return t&&(e=t.mat.props,s.transform(e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8],e[9],e[10],e[11],e[12],e[13],e[14],e[15]),this.finalTransform.opacity*=t.opacity,this.finalTransform.opMdf=t.opMdf?!0:this.finalTransform.opMdf,this.finalTransform.matMdf=t.matMdf?!0:this.finalTransform.matMdf),this.data.hasMask&&(this.globalData.renderer.save(!0),this.maskManager.renderFrame(0===this.data.ty?null:s)),this.data.hd&&(this.isVisible=!1),this.isVisible},CVBaseElement.prototype.addMasks=function(t){this.maskManager=new CVMaskElement(t,this,this.globalData)},CVBaseElement.prototype.destroy=function(){this.canvasContext=null,this.data=null,this.globalData=null,this.maskManager&&this.maskManager.destroy()},CVBaseElement.prototype.mHelper=new Matrix,createElement(CVBaseElement,CVCompElement),CVCompElement.prototype.ctxTransform=CanvasRenderer.prototype.ctxTransform,CVCompElement.prototype.ctxOpacity=CanvasRenderer.prototype.ctxOpacity,CVCompElement.prototype.save=CanvasRenderer.prototype.save,CVCompElement.prototype.restore=CanvasRenderer.prototype.restore,CVCompElement.prototype.reset=function(){this.contextData.cArrPos=0,this.contextData.cTr.reset(),this.contextData.cO=1},CVCompElement.prototype.resize=function(t){var e=Math.max(t.sx,t.sy);this.canvas.width=this.data.w*e,this.canvas.height=this.data.h*e,this.transformCanvas={sc:e,w:this.data.w*e,h:this.data.h*e,props:[e,0,0,0,0,e,0,0,0,0,1,0,0,0,0,1]};var s,r=this.elements.length;for(s=0;r>s;s+=1)this.elements[s]&&0===this.elements[s].data.ty&&this.elements[s].resize(t)},CVCompElement.prototype.prepareFrame=function(t){if(this.globalData.frameId=this.parentGlobalData.frameId,this.globalData.mdf=!1,this._parent.prepareFrame.call(this,t),this.isVisible!==!1||this.data.xt){var e=t;this.tm&&(e=this.tm.v,e===this.data.op&&(e=this.data.op-1)),this.renderedFrame=e/this.data.sr;var s,r=this.elements.length;for(this.completeLayers||this.checkLayers(t),s=0;r>s;s+=1)(this.completeLayers||this.elements[s])&&(this.elements[s].prepareFrame(e/this.data.sr-this.layers[s].st),0===this.elements[s].data.ty&&this.elements[s].globalData.mdf&&(this.globalData.mdf=!0));this.globalData.mdf&&!this.data.xt&&(this.canvasContext.clearRect(0,0,this.data.w,this.data.h),this.ctxTransform(this.transformCanvas.props))}},CVCompElement.prototype.renderFrame=function(t){if(this._parent.renderFrame.call(this,t)!==!1){if(this.globalData.mdf){var e,s=this.layers.length;for(e=s-1;e>=0;e-=1)(this.completeLayers||this.elements[e])&&this.elements[e].renderFrame()}this.data.hasMask&&this.globalData.renderer.restore(!0),this.firstFrame&&(this.firstFrame=!1),this.parentGlobalData.renderer.save(),this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props),this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity),this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h),this.parentGlobalData.renderer.restore(),this.globalData.mdf&&this.reset()}},CVCompElement.prototype.setElements=function(t){this.elements=t},CVCompElement.prototype.getElements=function(){return this.elements},CVCompElement.prototype.destroy=function(){var t,e=this.layers.length;for(t=e-1;t>=0;t-=1)this.elements[t].destroy();this.layers=null,this.elements=null,this._parent.destroy.call(this._parent)},CVCompElement.prototype.checkLayers=CanvasRenderer.prototype.checkLayers,CVCompElement.prototype.buildItem=CanvasRenderer.prototype.buildItem,CVCompElement.prototype.checkPendingElements=CanvasRenderer.prototype.checkPendingElements,CVCompElement.prototype.addPendingElement=CanvasRenderer.prototype.addPendingElement,CVCompElement.prototype.buildAllItems=CanvasRenderer.prototype.buildAllItems,CVCompElement.prototype.createItem=CanvasRenderer.prototype.createItem,CVCompElement.prototype.createImage=CanvasRenderer.prototype.createImage,CVCompElement.prototype.createComp=CanvasRenderer.prototype.createComp,CVCompElement.prototype.createSolid=CanvasRenderer.prototype.createSolid,CVCompElement.prototype.createShape=CanvasRenderer.prototype.createShape,CVCompElement.prototype.createText=CanvasRenderer.prototype.createText,CVCompElement.prototype.createBase=CanvasRenderer.prototype.createBase,CVCompElement.prototype.buildElementParenting=CanvasRenderer.prototype.buildElementParenting,createElement(CVBaseElement,CVImageElement),CVImageElement.prototype.createElements=function(){var t=function(){if(this.globalData.elementLoaded(),this.assetData.w!==this.img.width||this.assetData.h!==this.img.height){var t=document.createElement("canvas");t.width=this.assetData.w,t.height=this.assetData.h;var e,s,r=t.getContext("2d"),i=this.img.width,a=this.img.height,n=i/a,o=this.assetData.w/this.assetData.h;n>o?(s=a,e=s*o):(e=i,s=e/o),r.drawImage(this.img,(i-e)/2,(a-s)/2,e,s,0,0,this.assetData.w,this.assetData.h),this.img=t}}.bind(this),e=function(){this.failed=!0,this.globalData.elementLoaded()}.bind(this);this.img=new Image,this.img.addEventListener("load",t,!1),this.img.addEventListener("error",e,!1);var s=this.globalData.getAssetsPath(this.assetData);this.img.src=s,this._parent.createElements.call(this)},CVImageElement.prototype.renderFrame=function(t){if(!this.failed&&this._parent.renderFrame.call(this,t)!==!1){var e=this.canvasContext;this.globalData.renderer.save();var s=this.finalTransform.mat.props;this.globalData.renderer.ctxTransform(s),this.globalData.renderer.ctxOpacity(this.finalTransform.opacity),e.drawImage(this.img,0,0),this.globalData.renderer.restore(this.data.hasMask),this.firstFrame&&(this.firstFrame=!1)}},CVImageElement.prototype.destroy=function(){this.img=null,this._parent.destroy.call(this._parent)},CVMaskElement.prototype.prepareFrame=function(t){var e,s=this.dynamicProperties.length;for(e=0;s>e;e+=1)this.dynamicProperties[e].getValue(t),this.dynamicProperties[e].mdf&&(this.element.globalData.mdf=!0)},CVMaskElement.prototype.renderFrame=function(t){var e,s,r,i,a,n=this.element.canvasContext,o=this.data.masksProperties.length,h=!1;for(e=0;o>e;e++)if("n"!==this.masksProperties[e].mode){h===!1&&(n.beginPath(),h=!0),this.masksProperties[e].inv&&(n.moveTo(0,0),n.lineTo(this.element.globalData.compWidth,0),n.lineTo(this.element.globalData.compWidth,this.element.globalData.compHeight),n.lineTo(0,this.element.globalData.compHeight),n.lineTo(0,0)),a=this.viewData[e].v,s=t?t.applyToPointArray(a.v[0][0],a.v[0][1],0):a.v[0],n.moveTo(s[0],s[1]);var l,p=a._length;for(l=1;p>l;l++)s=t?t.applyToPointArray(a.o[l-1][0],a.o[l-1][1],0):a.o[l-1],r=t?t.applyToPointArray(a.i[l][0],a.i[l][1],0):a.i[l],i=t?t.applyToPointArray(a.v[l][0],a.v[l][1],0):a.v[l],n.bezierCurveTo(s[0],s[1],r[0],r[1],i[0],i[1]);s=t?t.applyToPointArray(a.o[l-1][0],a.o[l-1][1],0):a.o[l-1],r=t?t.applyToPointArray(a.i[0][0],a.i[0][1],0):a.i[0],i=t?t.applyToPointArray(a.v[0][0],a.v[0][1],0):a.v[0],n.bezierCurveTo(s[0],s[1],r[0],r[1],i[0],i[1])}h&&n.clip()},CVMaskElement.prototype.getMaskProperty=MaskElement.prototype.getMaskProperty,CVMaskElement.prototype.destroy=function(){this.element=null},createElement(CVBaseElement,CVShapeElement),CVShapeElement.prototype.transformHelper={opacity:1,mat:new Matrix,matMdf:!1,opMdf:!1},CVShapeElement.prototype.dashResetter=[],CVShapeElement.prototype.createElements=function(){this._parent.createElements.call(this),this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties,!0)},CVShapeElement.prototype.createStyleElement=function(t,e){var s={data:t,type:t.ty,elements:[]},r={};if(("fl"==t.ty||"st"==t.ty)&&(r.c=PropertyFactory.getProp(this,t.c,1,255,e),r.c.k||(s.co="rgb("+bm_floor(r.c.v[0])+","+bm_floor(r.c.v[1])+","+bm_floor(r.c.v[2])+")")),r.o=PropertyFactory.getProp(this,t.o,0,.01,e),"st"==t.ty){if(s.lc=this.lcEnum[t.lc]||"round",s.lj=this.ljEnum[t.lj]||"round",1==t.lj&&(s.ml=t.ml),r.w=PropertyFactory.getProp(this,t.w,0,null,e),r.w.k||(s.wi=r.w.v),t.d){var i=PropertyFactory.getDashProp(this,t.d,"canvas",e);r.d=i,r.d.k||(s.da=r.d.dasharray,s["do"]=r.d.dashoffset)}}else s.r=2===t.r?"evenodd":"nonzero";return this.stylesList.push(s),r.style=s,r},CVShapeElement.prototype.createGroupElement=function(t){var e={it:[],prevViewData:[]};return e},CVShapeElement.prototype.createTransformElement=function(t,e){var s={transform:{mat:new Matrix,opacity:1,matMdf:!1,opMdf:!1,op:PropertyFactory.getProp(this,t.o,0,.01,e),mProps:PropertyFactory.getProp(this,t,2,null,e)},elements:[]};return s},CVShapeElement.prototype.createShapeElement=function(t,e){var s={nodes:[],trNodes:[],tr:[0,0,0,0,0,0]},r=4;"rc"==t.ty?r=5:"el"==t.ty?r=6:"sr"==t.ty&&(r=7),s.sh=ShapePropertyFactory.getShapeProp(this,t,r,e),this.shapes.push(s.sh),this.addShapeToModifiers(s),jLen=this.stylesList.length;var i=!1,a=!1;for(j=0;j<jLen;j+=1)this.stylesList[j].closed||(this.stylesList[j].elements.push(s),"st"===this.stylesList[j].type?i=!0:a=!0);return s.st=i,s.fl=a,s},CVShapeElement.prototype.reloadShapes=function(){this.firstFrame=!0;var t,e=this.itemsData.length;for(t=0;e>t;t+=1)this.prevViewData[t]=this.itemsData[t];this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties,!0);var t,e=this.dynamicProperties.length;for(t=0;e>t;t+=1)this.dynamicProperties[t].getValue();this.renderModifiers()},CVShapeElement.prototype.searchShapes=function(t,e,s,r,i){var a,n,o,h,l=t.length-1,p=[],m=[];for(a=l;a>=0;a-=1){if(h=this.searchProcessedElement(t[a]),h?e[a]=s[h-1]:t[a]._render=i,"fl"==t[a].ty||"st"==t[a].ty)h?e[a].style.closed=!1:e[a]=this.createStyleElement(t[a],r),p.push(e[a].style);else if("gr"==t[a].ty){if(h)for(o=e[a].it.length,n=0;o>n;n+=1)e[a].prevViewData[n]=e[a].it[n];else e[a]=this.createGroupElement(t[a]);this.searchShapes(t[a].it,e[a].it,e[a].prevViewData,r,i)}else if("tr"==t[a].ty)h||(e[a]=this.createTransformElement(t[a],r));else if("sh"==t[a].ty||"rc"==t[a].ty||"el"==t[a].ty||"sr"==t[a].ty)h||(e[a]=this.createShapeElement(t[a],r));else if("tm"==t[a].ty||"rd"==t[a].ty){if(h)f=e[a],f.closed=!1;else{var f=ShapeModifiers.getModifier(t[a].ty);f.init(this,t[a],r),e[a]=f,this.shapeModifiers.push(f)}m.push(f)}else"rp"==t[a].ty&&(h?(f=e[a],f.closed=!0):(f=ShapeModifiers.getModifier(t[a].ty),e[a]=f,f.init(this,t,a,e,r),this.shapeModifiers.push(f),i=!1),m.push(f));this.addProcessedElement(t[a],a+1)}for(l=p.length,a=0;l>a;a+=1)p[a].closed=!0;for(l=m.length,a=0;l>a;a+=1)m[a].closed=!0},CVShapeElement.prototype.addShapeToModifiers=IShapeElement.prototype.addShapeToModifiers,CVShapeElement.prototype.renderModifiers=IShapeElement.prototype.renderModifiers,CVShapeElement.prototype.lcEnum=IShapeElement.prototype.lcEnum,CVShapeElement.prototype.ljEnum=IShapeElement.prototype.ljEnum,CVShapeElement.prototype.searchProcessedElement=IShapeElement.prototype.searchProcessedElement,CVShapeElement.prototype.addProcessedElement=IShapeElement.prototype.addProcessedElement,CVShapeElement.prototype.renderFrame=function(t){this._parent.renderFrame.call(this,t)!==!1&&(this.transformHelper.mat.reset(),this.transformHelper.opacity=this.finalTransform.opacity,this.transformHelper.matMdf=!1,this.transformHelper.opMdf=this.finalTransform.opMdf,this.renderModifiers(),this.renderShape(this.transformHelper,null,null,!0),this.data.hasMask&&this.globalData.renderer.restore(!0))},CVShapeElement.prototype.renderShape=function(t,e,s,r){var i,a;if(!e)for(e=this.shapesData,a=this.stylesList.length,i=0;a>i;i+=1)this.stylesList[i].d="",this.stylesList[i].mdf=!1;s||(s=this.itemsData),a=e.length-1;var n,o;for(n=t,i=a;i>=0;i-=1)if("tr"==e[i].ty){n=s[i].transform;var h=s[i].transform.mProps.v.props;if(n.matMdf=n.mProps.mdf,n.opMdf=n.op.mdf,o=n.mat,o.cloneFromProps(h),t){var l=t.mat.props;n.opacity=t.opacity,n.opacity*=s[i].transform.op.v,n.matMdf=t.matMdf?!0:n.matMdf,n.opMdf=t.opMdf?!0:n.opMdf,o.transform(l[0],l[1],l[2],l[3],l[4],l[5],l[6],l[7],l[8],l[9],l[10],l[11],l[12],l[13],l[14],l[15])}else n.opacity=n.op.o}else"sh"==e[i].ty||"el"==e[i].ty||"rc"==e[i].ty||"sr"==e[i].ty?this.renderPath(e[i],s[i],n):"fl"==e[i].ty?this.renderFill(e[i],s[i],n):"st"==e[i].ty?this.renderStroke(e[i],s[i],n):"gr"==e[i].ty?this.renderShape(n,e[i].it,s[i].it):"tm"==e[i].ty;if(r){a=this.stylesList.length;var p,m,f,c,d,u,y,g=this.globalData.renderer,v=this.globalData.canvasContext;for(g.save(),g.ctxTransform(this.finalTransform.mat.props),i=0;a>i;i+=1)if(y=this.stylesList[i].type,("st"!==y||0!==this.stylesList[i].wi)&&this.stylesList[i].data._render){for(g.save(),d=this.stylesList[i].elements,
"st"===y?(v.strokeStyle=this.stylesList[i].co,v.lineWidth=this.stylesList[i].wi,v.lineCap=this.stylesList[i].lc,v.lineJoin=this.stylesList[i].lj,v.miterLimit=this.stylesList[i].ml||0):v.fillStyle=this.stylesList[i].co,g.ctxOpacity(this.stylesList[i].coOp),"st"!==y&&v.beginPath(),m=d.length,p=0;m>p;p+=1){for("st"===y&&(v.beginPath(),this.stylesList[i].da?(v.setLineDash(this.stylesList[i].da),v.lineDashOffset=this.stylesList[i]["do"],this.globalData.isDashed=!0):this.globalData.isDashed&&(v.setLineDash(this.dashResetter),this.globalData.isDashed=!1)),u=d[p].trNodes,c=u.length,f=0;c>f;f+=1)"m"==u[f].t?v.moveTo(u[f].p[0],u[f].p[1]):"c"==u[f].t?v.bezierCurveTo(u[f].p1[0],u[f].p1[1],u[f].p2[0],u[f].p2[1],u[f].p3[0],u[f].p3[1]):v.closePath();"st"===y&&v.stroke()}"st"!==y&&v.fill(this.stylesList[i].r),g.restore()}g.restore(),this.firstFrame&&(this.firstFrame=!1)}},CVShapeElement.prototype.renderPath=function(t,e,s){var r,i,a,n,o=s.matMdf||e.sh.mdf||this.firstFrame;if(o){var h=e.sh.paths,l=s.mat;n=h._length;var p=e.trNodes;for(p.length=0,a=0;n>a;a+=1){var m=h.shapes[a];if(m&&m.v){for(r=m._length,i=1;r>i;i+=1)1==i&&p.push({t:"m",p:l.applyToPointArray(m.v[0][0],m.v[0][1],0)}),p.push({t:"c",p1:l.applyToPointArray(m.o[i-1][0],m.o[i-1][1],0),p2:l.applyToPointArray(m.i[i][0],m.i[i][1],0),p3:l.applyToPointArray(m.v[i][0],m.v[i][1],0)});1==r&&p.push({t:"m",p:l.applyToPointArray(m.v[0][0],m.v[0][1],0)}),m.c&&r&&(p.push({t:"c",p1:l.applyToPointArray(m.o[i-1][0],m.o[i-1][1],0),p2:l.applyToPointArray(m.i[0][0],m.i[0][1],0),p3:l.applyToPointArray(m.v[0][0],m.v[0][1],0)}),p.push({t:"z"})),e.lStr=p}}if(e.st)for(i=0;16>i;i+=1)e.tr[i]=s.mat.props[i];e.trNodes=p}},CVShapeElement.prototype.renderFill=function(t,e,s){var r=e.style;(e.c.mdf||this.firstFrame)&&(r.co="rgb("+bm_floor(e.c.v[0])+","+bm_floor(e.c.v[1])+","+bm_floor(e.c.v[2])+")"),(e.o.mdf||s.opMdf||this.firstFrame)&&(r.coOp=e.o.v*s.opacity)},CVShapeElement.prototype.renderStroke=function(t,e,s){var r=e.style,i=e.d;i&&(i.mdf||this.firstFrame)&&(r.da=i.dasharray,r["do"]=i.dashoffset),(e.c.mdf||this.firstFrame)&&(r.co="rgb("+bm_floor(e.c.v[0])+","+bm_floor(e.c.v[1])+","+bm_floor(e.c.v[2])+")"),(e.o.mdf||s.opMdf||this.firstFrame)&&(r.coOp=e.o.v*s.opacity),(e.w.mdf||this.firstFrame)&&(r.wi=e.w.v)},CVShapeElement.prototype.destroy=function(){this.shapesData=null,this.globalData=null,this.canvasContext=null,this.stylesList.length=0,this.itemData.length=0,this._parent.destroy.call(this._parent)},createElement(CVBaseElement,CVSolidElement),CVSolidElement.prototype.renderFrame=function(t){if(this._parent.renderFrame.call(this,t)!==!1){var e=this.canvasContext;this.globalData.renderer.save(),this.globalData.renderer.ctxTransform(this.finalTransform.mat.props),this.globalData.renderer.ctxOpacity(this.finalTransform.opacity),e.fillStyle=this.data.sc,e.fillRect(0,0,this.data.sw,this.data.sh),this.globalData.renderer.restore(this.data.hasMask),this.firstFrame&&(this.firstFrame=!1)}},createElement(CVBaseElement,CVTextElement),extendPrototype(ITextElement,CVTextElement),CVTextElement.prototype.tHelper=document.createElement("canvas").getContext("2d"),CVTextElement.prototype.createElements=function(){this._parent.createElements.call(this)},CVTextElement.prototype.buildNewText=function(){var t=this.textProperty.currentData;this.renderedLetters=Array.apply(null,{length:t.l?t.l.length:0});var e=!1;t.fc?(e=!0,this.values.fill=this.buildColor(t.fc)):this.values.fill="rgba(0,0,0,0)",this.fill=e;var s=!1;t.sc&&(s=!0,this.values.stroke=this.buildColor(t.sc),this.values.sWidth=t.sw);var r,i,a=this.globalData.fontManager.getFontByName(t.f),n=t.l,o=this.mHelper;this.stroke=s,this.values.fValue=t.s+"px "+this.globalData.fontManager.getFontByName(t.f).fFamily,i=t.t.length;var h,l,p,m,f,c,d,u,y,g,v=this.data.singleShape,b=t.tr/1e3*t.s,E=0,P=0,x=!0,S=0;for(r=0;i>r;r+=1){for(h=this.globalData.fontManager.getCharData(t.t.charAt(r),a.fStyle,this.globalData.fontManager.getFontByName(t.f).fFamily),l=h&&h.data||{},o.reset(),v&&n[r].n&&(E=-b,P+=t.yOffset,P+=x?1:0,x=!1),f=l.shapes?l.shapes[0].it:[],d=f.length,o.scale(t.s/100,t.s/100),v&&this.applyTextPropertiesToMatrix(t,o,n[r].line,E,P),y=Array.apply(null,{length:d}),c=0;d>c;c+=1){for(m=f[c].ks.k.i.length,u=f[c].ks.k,g=[],p=1;m>p;p+=1)1==p&&g.push(o.applyToX(u.v[0][0],u.v[0][1],0),o.applyToY(u.v[0][0],u.v[0][1],0)),g.push(o.applyToX(u.o[p-1][0],u.o[p-1][1],0),o.applyToY(u.o[p-1][0],u.o[p-1][1],0),o.applyToX(u.i[p][0],u.i[p][1],0),o.applyToY(u.i[p][0],u.i[p][1],0),o.applyToX(u.v[p][0],u.v[p][1],0),o.applyToY(u.v[p][0],u.v[p][1],0));g.push(o.applyToX(u.o[p-1][0],u.o[p-1][1],0),o.applyToY(u.o[p-1][0],u.o[p-1][1],0),o.applyToX(u.i[0][0],u.i[0][1],0),o.applyToY(u.i[0][0],u.i[0][1],0),o.applyToX(u.v[0][0],u.v[0][1],0),o.applyToY(u.v[0][0],u.v[0][1],0)),y[c]=g}v&&(E+=n[r].l,E+=b),this.textSpans[S]?this.textSpans[S].elem=y:this.textSpans[S]={elem:y},S+=1}},CVTextElement.prototype.renderFrame=function(t){if(this._parent.renderFrame.call(this,t)!==!1){var e=this.canvasContext,s=this.finalTransform.mat.props;this.globalData.renderer.save(),this.globalData.renderer.ctxTransform(s),this.globalData.renderer.ctxOpacity(this.finalTransform.opacity),e.font=this.values.fValue,e.lineCap="butt",e.lineJoin="miter",e.miterLimit=4,this.data.singleShape||this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);var r,i,a,n,o,h,l=this.textAnimator.renderedLetters,p=this.textProperty.currentData.l;i=p.length;var m,f,c,d=null,u=null,y=null;for(r=0;i>r;r+=1)if(!p[r].n){if(m=l[r],m&&(this.globalData.renderer.save(),this.globalData.renderer.ctxTransform(m.p),this.globalData.renderer.ctxOpacity(m.o)),this.fill){for(m&&m.fc?d!==m.fc&&(d=m.fc,e.fillStyle=m.fc):d!==this.values.fill&&(d=this.values.fill,e.fillStyle=this.values.fill),f=this.textSpans[r].elem,n=f.length,this.globalData.canvasContext.beginPath(),a=0;n>a;a+=1)for(c=f[a],h=c.length,this.globalData.canvasContext.moveTo(c[0],c[1]),o=2;h>o;o+=6)this.globalData.canvasContext.bezierCurveTo(c[o],c[o+1],c[o+2],c[o+3],c[o+4],c[o+5]);this.globalData.canvasContext.closePath(),this.globalData.canvasContext.fill()}if(this.stroke){for(m&&m.sw?y!==m.sw&&(y=m.sw,e.lineWidth=m.sw):y!==this.values.sWidth&&(y=this.values.sWidth,e.lineWidth=this.values.sWidth),m&&m.sc?u!==m.sc&&(u=m.sc,e.strokeStyle=m.sc):u!==this.values.stroke&&(u=this.values.stroke,e.strokeStyle=this.values.stroke),f=this.textSpans[r].elem,n=f.length,this.globalData.canvasContext.beginPath(),a=0;n>a;a+=1)for(c=f[a],h=c.length,this.globalData.canvasContext.moveTo(c[0],c[1]),o=2;h>o;o+=6)this.globalData.canvasContext.bezierCurveTo(c[o],c[o+1],c[o+2],c[o+3],c[o+4],c[o+5]);this.globalData.canvasContext.closePath(),this.globalData.canvasContext.stroke()}m&&this.globalData.renderer.restore()}this.globalData.renderer.restore(this.data.hasMask),this.firstFrame&&(this.firstFrame=!1)}},createElement(BaseElement,HBaseElement),HBaseElement.prototype.checkBlendMode=function(){},HBaseElement.prototype.setBlendMode=BaseElement.prototype.setBlendMode,HBaseElement.prototype.getBaseElement=function(){return this.baseElement},HBaseElement.prototype.createElements=function(){this.data.hasMask?(this.layerElement=document.createElementNS(svgNS,"svg"),styleDiv(this.layerElement),this.baseElement=this.layerElement,this.maskedElement=this.layerElement):this.layerElement=this.parentContainer,this.transformedElement=this.layerElement,!this.data.ln||4!==this.data.ty&&0!==this.data.ty||(this.layerElement===this.parentContainer&&(this.layerElement=document.createElementNS(svgNS,"g"),this.baseElement=this.layerElement),this.layerElement.setAttribute("id",this.data.ln)),this.setBlendMode(),this.layerElement!==this.parentContainer&&(this.placeholder=null),this.checkParenting()},HBaseElement.prototype.renderFrame=function(t){if(3===this.data.ty)return!1;if(this.currentFrameNum===this.lastNum||!this.isVisible)return this.isVisible;this.lastNum=this.currentFrameNum,this.finalTransform.opMdf=this.finalTransform.op.mdf,this.finalTransform.matMdf=this.finalTransform.mProp.mdf,this.finalTransform.opacity=this.finalTransform.op.v,this.firstFrame&&(this.finalTransform.opMdf=!0,this.finalTransform.matMdf=!0);var e,s=this.finalTransform.mat;if(this.hierarchy){var r,i=this.hierarchy.length;for(e=this.finalTransform.mProp.v.props,s.cloneFromProps(e),r=0;i>r;r+=1)this.finalTransform.matMdf=this.hierarchy[r].finalTransform.mProp.mdf?!0:this.finalTransform.matMdf,e=this.hierarchy[r].finalTransform.mProp.v.props,s.transform(e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8],e[9],e[10],e[11],e[12],e[13],e[14],e[15])}else this.isVisible&&this.finalTransform.matMdf&&(t?(e=this.finalTransform.mProp.v.props,s.cloneFromProps(e)):s.cloneFromProps(this.finalTransform.mProp.v.props));return this.data.hasMask&&this.maskManager.renderFrame(s),t&&(e=t.mat.props,s.cloneFromProps(e),this.finalTransform.opacity*=t.opacity,this.finalTransform.opMdf=t.opMdf?!0:this.finalTransform.opMdf,this.finalTransform.matMdf=t.matMdf?!0:this.finalTransform.matMdf),this.finalTransform.matMdf&&(this.transformedElement.style.transform=this.transformedElement.style.webkitTransform=s.toCSS(),this.finalMat=s),this.finalTransform.opMdf&&(this.transformedElement.style.opacity=this.finalTransform.opacity),this.isVisible},HBaseElement.prototype.destroy=function(){this.layerElement=null,this.transformedElement=null,this.parentContainer=null,this.matteElement&&(this.matteElement=null),this.maskManager&&(this.maskManager.destroy(),this.maskManager=null)},HBaseElement.prototype.getDomElement=function(){return this.layerElement},HBaseElement.prototype.addMasks=function(t){this.maskManager=new MaskElement(t,this,this.globalData)},HBaseElement.prototype.hide=function(){},HBaseElement.prototype.setMatte=function(){},HBaseElement.prototype.buildElementParenting=HybridRenderer.prototype.buildElementParenting,createElement(HBaseElement,HSolidElement),HSolidElement.prototype.createElements=function(){var t=document.createElement("div");styleDiv(t);var e=document.createElementNS(svgNS,"svg");styleDiv(e),e.setAttribute("width",this.data.sw),e.setAttribute("height",this.data.sh),t.appendChild(e),this.layerElement=t,this.transformedElement=t,this.baseElement=t,this.innerElem=t,this.data.ln&&this.innerElem.setAttribute("id",this.data.ln),0!==this.data.bm&&this.setBlendMode();var s=document.createElementNS(svgNS,"rect");s.setAttribute("width",this.data.sw),s.setAttribute("height",this.data.sh),s.setAttribute("fill",this.data.sc),e.appendChild(s),this.data.hasMask&&(this.maskedElement=s),this.checkParenting()},HSolidElement.prototype.hide=SVGBaseElement.prototype.hide,HSolidElement.prototype.show=SVGBaseElement.prototype.show,HSolidElement.prototype.renderFrame=IImageElement.prototype.renderFrame,HSolidElement.prototype.destroy=IImageElement.prototype.destroy,createElement(HBaseElement,HCompElement),HCompElement.prototype.createElements=function(){var t=document.createElement("div");if(styleDiv(t),this.data.ln&&t.setAttribute("id",this.data.ln),t.style.clip="rect(0px, "+this.data.w+"px, "+this.data.h+"px, 0px)",this.data.hasMask){var e=document.createElementNS(svgNS,"svg");styleDiv(e),e.setAttribute("width",this.data.w),e.setAttribute("height",this.data.h);var s=document.createElementNS(svgNS,"g");e.appendChild(s),t.appendChild(e),this.maskedElement=s,this.baseElement=t,this.layerElement=s,this.transformedElement=t}else this.layerElement=t,this.baseElement=this.layerElement,this.transformedElement=t;this.checkParenting()},HCompElement.prototype.hide=ICompElement.prototype.hide,HCompElement.prototype.prepareFrame=ICompElement.prototype.prepareFrame,HCompElement.prototype.setElements=ICompElement.prototype.setElements,HCompElement.prototype.getElements=ICompElement.prototype.getElements,HCompElement.prototype.destroy=ICompElement.prototype.destroy,HCompElement.prototype.renderFrame=function(t){var e,s=this._parent.renderFrame.call(this,t),r=this.layers.length;if(s===!1)return void this.hide();for(this.hidden=!1,e=0;r>e;e+=1)(this.completeLayers||this.elements[e])&&this.elements[e].renderFrame();this.firstFrame&&(this.firstFrame=!1)},HCompElement.prototype.checkLayers=BaseRenderer.prototype.checkLayers,HCompElement.prototype.buildItem=HybridRenderer.prototype.buildItem,HCompElement.prototype.checkPendingElements=HybridRenderer.prototype.checkPendingElements,HCompElement.prototype.addPendingElement=HybridRenderer.prototype.addPendingElement,HCompElement.prototype.buildAllItems=BaseRenderer.prototype.buildAllItems,HCompElement.prototype.createItem=HybridRenderer.prototype.createItem,HCompElement.prototype.buildElementParenting=HybridRenderer.prototype.buildElementParenting,HCompElement.prototype.createImage=HybridRenderer.prototype.createImage,HCompElement.prototype.createComp=HybridRenderer.prototype.createComp,HCompElement.prototype.createSolid=HybridRenderer.prototype.createSolid,HCompElement.prototype.createShape=HybridRenderer.prototype.createShape,HCompElement.prototype.createText=HybridRenderer.prototype.createText,HCompElement.prototype.createBase=HybridRenderer.prototype.createBase,HCompElement.prototype.appendElementInPos=HybridRenderer.prototype.appendElementInPos,createElement(HBaseElement,HShapeElement);var parent=HShapeElement.prototype._parent;extendPrototype(IShapeElement,HShapeElement),HShapeElement.prototype._parent=parent,HShapeElement.prototype._renderShapeFrame=HShapeElement.prototype.renderFrame,HShapeElement.prototype.createElements=function(){var t=document.createElement("div");styleDiv(t);var e=document.createElementNS(svgNS,"svg");styleDiv(e);var s=this.comp.data?this.comp.data:this.globalData.compSize;if(e.setAttribute("width",s.w),e.setAttribute("height",s.h),this.data.hasMask){var r=document.createElementNS(svgNS,"g");t.appendChild(e),e.appendChild(r),this.maskedElement=r,this.layerElement=r,this.shapesContainer=r}else t.appendChild(e),this.layerElement=e,this.shapesContainer=document.createElementNS(svgNS,"g"),this.layerElement.appendChild(this.shapesContainer);this.data.hd||(this.baseElement=t),this.innerElem=t,this.data.ln&&this.innerElem.setAttribute("id",this.data.ln),this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0,[],!0),this.buildExpressionInterface(),this.layerElement=t,this.transformedElement=t,this.shapeCont=e,0!==this.data.bm&&this.setBlendMode(),this.checkParenting()},HShapeElement.prototype.renderFrame=function(t){var e=this.firstFrame;if(this._renderShapeFrame(),this.isVisible&&(this.elemMdf||e)){var s=this.shapeCont.getBBox(),r=!1;this.currentBBox.w!==s.width&&(this.currentBBox.w=s.width,this.shapeCont.setAttribute("width",s.width),r=!0),this.currentBBox.h!==s.height&&(this.currentBBox.h=s.height,this.shapeCont.setAttribute("height",s.height),r=!0),(r||this.currentBBox.x!==s.x||this.currentBBox.y!==s.y)&&(this.currentBBox.w=s.width,this.currentBBox.h=s.height,this.currentBBox.x=s.x,this.currentBBox.y=s.y,this.shapeCont.setAttribute("viewBox",this.currentBBox.x+" "+this.currentBBox.y+" "+this.currentBBox.w+" "+this.currentBBox.h),this.shapeCont.style.transform=this.shapeCont.style.webkitTransform="translate("+this.currentBBox.x+"px,"+this.currentBBox.y+"px)")}},createElement(HBaseElement,HTextElement),extendPrototype(ITextElement,HTextElement),HTextElement.prototype.createElements=function(){this.isMasked=this.checkMasks();var t=document.createElement("div");if(styleDiv(t),this.layerElement=t,this.transformedElement=t,this.isMasked){this.renderType="svg";var e=document.createElementNS(svgNS,"svg");styleDiv(e),this.cont=e,this.compW=this.comp.data.w,this.compH=this.comp.data.h,e.setAttribute("width",this.compW),e.setAttribute("height",this.compH);var s=document.createElementNS(svgNS,"g");e.appendChild(s),t.appendChild(e),this.maskedElement=s,this.innerElem=s}else this.renderType="html",this.innerElem=t;this.baseElement=t,this.checkParenting()},HTextElement.prototype.buildNewText=function(){var t=this.textProperty.currentData;this.renderedLetters=Array.apply(null,{length:this.textProperty.currentData.l?this.textProperty.currentData.l.length:0});var e=this.innerElem.style;e.color=e.fill=t.fc?this.buildColor(t.fc):"rgba(0,0,0,0)",t.sc&&(e.stroke=this.buildColor(t.sc),e.strokeWidth=t.sw+"px");var s=this.globalData.fontManager.getFontByName(t.f);if(!this.globalData.fontManager.chars)if(e.fontSize=t.s+"px",e.lineHeight=t.s+"px",s.fClass)this.innerElem.className=s.fClass;else{e.fontFamily=s.fFamily;var r=t.fWeight,i=t.fStyle;e.fontStyle=i,e.fontWeight=r}var a,n,o=t.l;n=o.length;var h,l,p,m,f=this.mHelper,c="",d=0;for(a=0;n>a;a+=1){if(this.globalData.fontManager.chars?(this.textPaths[d]?h=this.textPaths[d]:(h=document.createElementNS(svgNS,"path"),h.setAttribute("stroke-linecap","butt"),h.setAttribute("stroke-linejoin","round"),h.setAttribute("stroke-miterlimit","4")),this.isMasked||(this.textSpans[d]?(l=this.textSpans[d],p=l.children[0]):(l=document.createElement("div"),p=document.createElementNS(svgNS,"svg"),p.appendChild(h),styleDiv(l)))):this.isMasked?h=this.textPaths[d]?this.textPaths[d]:document.createElementNS(svgNS,"text"):this.textSpans[d]?(l=this.textSpans[d],h=this.textPaths[d]):(l=document.createElement("span"),styleDiv(l),h=document.createElement("span"),styleDiv(h),l.appendChild(h)),this.globalData.fontManager.chars){var u,y=this.globalData.fontManager.getCharData(t.t.charAt(a),s.fStyle,this.globalData.fontManager.getFontByName(t.f).fFamily);if(u=y?y.data:null,f.reset(),u&&u.shapes&&(m=u.shapes[0].it,f.scale(t.s/100,t.s/100),c=this.createPathShape(f,m),h.setAttribute("d",c)),this.isMasked)this.innerElem.appendChild(h);else if(this.innerElem.appendChild(l),u&&u.shapes){document.body.appendChild(p);var g=p.getBBox();p.setAttribute("width",g.width+2),p.setAttribute("height",g.height+2),p.setAttribute("viewBox",g.x-1+" "+(g.y-1)+" "+(g.width+2)+" "+(g.height+2)),p.style.transform=p.style.webkitTransform="translate("+(g.x-1)+"px,"+(g.y-1)+"px)",o[a].yOffset=g.y-1,l.appendChild(p)}else p.setAttribute("width",1),p.setAttribute("height",1)}else h.textContent=o[a].val,h.setAttributeNS("http://www.w3.org/XML/1998/namespace","xml:space","preserve"),this.isMasked?this.innerElem.appendChild(h):(this.innerElem.appendChild(l),h.style.transform=h.style.webkitTransform="translate3d(0,"+-t.s/1.2+"px,0)");this.textSpans[d]=this.isMasked?h:l,this.textSpans[d].style.display="block",this.textPaths[d]=h,d+=1}for(;d<this.textSpans.length;)this.textSpans[d].style.display="none",d+=1},HTextElement.prototype.hide=SVGTextElement.prototype.hide,HTextElement.prototype.renderFrame=function(t){var e=this._parent.renderFrame.call(this,t);if(e===!1)return void this.hide();if(this.hidden&&(this.hidden=!1,this.innerElem.style.display="block",this.layerElement.style.display="block"),this.data.singleShape){if(!this.firstFrame&&!this.lettersChangedFlag)return;this.isMasked&&this.finalTransform.matMdf&&(this.cont.setAttribute("viewBox",-this.finalTransform.mProp.p.v[0]+" "+-this.finalTransform.mProp.p.v[1]+" "+this.compW+" "+this.compH),this.cont.style.transform=this.cont.style.webkitTransform="translate("+-this.finalTransform.mProp.p.v[0]+"px,"+-this.finalTransform.mProp.p.v[1]+"px)")}if(this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag),this.lettersChangedFlag||this.textAnimator.lettersChangedFlag){var s,r,i=0,a=this.textAnimator.renderedLetters,n=this.textProperty.currentData.l;r=n.length;var o,h,l;for(s=0;r>s;s+=1)n[s].n?i+=1:(h=this.textSpans[s],l=this.textPaths[s],o=a[i],i+=1,this.isMasked?h.setAttribute("transform",o.m):h.style.transform=h.style.webkitTransform=o.m,h.style.opacity=o.o,o.sw&&l.setAttribute("stroke-width",o.sw),o.sc&&l.setAttribute("stroke",o.sc),o.fc&&(l.setAttribute("fill",o.fc),l.style.color=o.fc));if(this.isVisible&&(this.elemMdf||this.firstFrame)&&this.innerElem.getBBox){var p=this.innerElem.getBBox();this.currentBBox.w!==p.width&&(this.currentBBox.w=p.width,this.cont.setAttribute("width",p.width)),this.currentBBox.h!==p.height&&(this.currentBBox.h=p.height,this.cont.setAttribute("height",p.height));var m=1;(this.currentBBox.w!==p.width+2*m||this.currentBBox.h!==p.height+2*m||this.currentBBox.x!==p.x-m||this.currentBBox.y!==p.y-m)&&(this.currentBBox.w=p.width+2*m,this.currentBBox.h=p.height+2*m,this.currentBBox.x=p.x-m,this.currentBBox.y=p.y-m,this.cont.setAttribute("viewBox",this.currentBBox.x+" "+this.currentBBox.y+" "+this.currentBBox.w+" "+this.currentBBox.h),this.cont.style.transform=this.cont.style.webkitTransform="translate("+this.currentBBox.x+"px,"+this.currentBBox.y+"px)")}this.firstFrame&&(this.firstFrame=!1)}},createElement(HBaseElement,HImageElement),HImageElement.prototype.createElements=function(){var t=this.globalData.getAssetsPath(this.assetData),e=new Image;if(this.data.hasMask){var s=document.createElement("div");styleDiv(s);var r=document.createElementNS(svgNS,"svg");styleDiv(r),r.setAttribute("width",this.assetData.w),r.setAttribute("height",this.assetData.h),s.appendChild(r),this.imageElem=document.createElementNS(svgNS,"image"),this.imageElem.setAttribute("width",this.assetData.w+"px"),this.imageElem.setAttribute("height",this.assetData.h+"px"),this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink","href",t),r.appendChild(this.imageElem),this.layerElement=s,this.transformedElement=s,this.baseElement=s,this.innerElem=s,this.maskedElement=this.imageElem}else styleDiv(e),this.layerElement=e,this.baseElement=e,this.innerElem=e,this.transformedElement=e;e.src=t,this.data.ln&&this.innerElem.setAttribute("id",this.data.ln),this.checkParenting()},HImageElement.prototype.show=HSolidElement.prototype.show,HImageElement.prototype.hide=HSolidElement.prototype.hide,HImageElement.prototype.renderFrame=HSolidElement.prototype.renderFrame,HImageElement.prototype.destroy=HSolidElement.prototype.destroy,createElement(HBaseElement,HCameraElement),HCameraElement.prototype.setup=function(){var t,e,s=this.comp.threeDElements.length;for(t=0;s>t;t+=1)e=this.comp.threeDElements[t],e.perspectiveElem.style.perspective=e.perspectiveElem.style.webkitPerspective=this.pe.v+"px",e.container.style.transformOrigin=e.container.style.mozTransformOrigin=e.container.style.webkitTransformOrigin="0px 0px 0px",e.perspectiveElem.style.transform=e.perspectiveElem.style.webkitTransform="matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)"},HCameraElement.prototype.createElements=function(){},HCameraElement.prototype.hide=function(){},HCameraElement.prototype.renderFrame=function(){var t,e,s=this.firstFrame;if(this.hierarchy)for(e=this.hierarchy.length,t=0;e>t;t+=1)s=this.hierarchy[t].finalTransform.mProp.mdf?!0:s;if(s||this.p&&this.p.mdf||this.px&&(this.px.mdf||this.py.mdf||this.pz.mdf)||this.rx.mdf||this.ry.mdf||this.rz.mdf||this.or.mdf||this.a&&this.a.mdf){if(this.mat.reset(),this.p?this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]):this.mat.translate(-this.px.v,-this.py.v,this.pz.v),this.a){var r=[this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]],i=Math.sqrt(Math.pow(r[0],2)+Math.pow(r[1],2)+Math.pow(r[2],2)),a=[r[0]/i,r[1]/i,r[2]/i],n=Math.sqrt(a[2]*a[2]+a[0]*a[0]),o=Math.atan2(a[1],n),h=Math.atan2(a[0],-a[2]);this.mat.rotateY(h).rotateX(-o)}if(this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]),this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0),this.mat.translate(0,0,this.pe.v),this.hierarchy){var l;for(e=this.hierarchy.length,t=0;e>t;t+=1)l=this.hierarchy[t].finalTransform.mProp.iv.props,this.mat.transform(l[0],l[1],l[2],l[3],l[4],l[5],l[6],l[7],l[8],l[9],l[10],l[11],-l[12],-l[13],l[14],l[15])}e=this.comp.threeDElements.length;var p;for(t=0;e>t;t+=1)p=this.comp.threeDElements[t],p.container.style.transform=p.container.style.webkitTransform=this.mat.toCSS()}this.firstFrame=!1},HCameraElement.prototype.destroy=function(){};var Expressions=function(){function t(t){t.renderer.compInterface=CompExpressionInterface(t.renderer),t.renderer.globalData.projectInterface.registerComposition(t.renderer)}var e={};return e.initExpressions=t,e}();expressionsPlugin=Expressions,function(){function t(){return this.pv}function e(t,e,s){if(!this.k||!this.keyframes)return this.pv;var r=this.comp.renderedFrame,i=this.keyframes,a=i[i.length-1].t;if(a>=r)return this.pv;var n,o;s?(n=e?Math.abs(a-elem.comp.globalData.frameRate*e):Math.max(0,a-this.elem.data.ip),o=a-n):((!e||e>i.length-1)&&(e=i.length-1),o=i[i.length-1-e].t,n=a-o);var h,l,p,m=this.offsetTime||0;if("pingpong"===t.toLowerCase()){var f=Math.floor((r-o)/n);if(f%2!==0)return this.getValueAtTime((n-(r-o)%n+o-m)/this.comp.globalData.frameRate,0)}else{if("offset"===t){var c=this.getValueAtTime(o/this.comp.globalData.frameRate,0),d=this.getValueAtTime(a/this.comp.globalData.frameRate,0),u=this.getValueAtTime(((r-o)%n+o)/this.comp.globalData.frameRate,0),y=Math.floor((r-o)/n);if(this.pv.length){for(p=new Array(c.length),l=p.length,h=0;l>h;h+=1)p[h]=(d[h]-c[h])*y+u[h];return p}return(d-c)*y+u}if("continue"===t){var g=this.getValueAtTime(a/this.comp.globalData.frameRate,0),v=this.getValueAtTime((a-.001)/this.comp.globalData.frameRate,0);if(this.pv.length){for(p=new Array(g.length),l=p.length,h=0;l>h;h+=1)p[h]=g[h]+(g[h]-v[h])*((r-a)/this.comp.globalData.frameRate)/5e-4;return p}return g+(g-v)*((r-a)/.001)}}return this.getValueAtTime(((r-o)%n+o-m)/this.comp.globalData.frameRate,0)}function s(t,e,s){if(!this.k)return this.pv;var r=time*elem.comp.globalData.frameRate,i=this.keyframes,a=i[0].t,n=this.offsetTime||0;if(r>=a)return this.pv;var o,h;s?(o=e?Math.abs(elem.comp.globalData.frameRate*e):Math.max(0,this.elem.data.op-a),h=a+o):((!e||e>i.length-1)&&(e=i.length-1),h=i[e].t,o=h-a);var l,p,m;if("pingpong"===t){var f=Math.floor((a-r)/o);if(f%2===0)return this.getValueAtTime(((a-r)%o+a-n)/this.comp.globalData.frameRate,0)}else{if("offset"===t){var c=this.getValueAtTime(a/this.comp.globalData.frameRate,0),d=this.getValueAtTime(h/this.comp.globalData.frameRate,0),u=this.getValueAtTime((o-(a-r)%o+a)/this.comp.globalData.frameRate,0),y=Math.floor((a-r)/o)+1;if(this.pv.length){for(m=new Array(c.length),p=m.length,l=0;p>l;l+=1)m[l]=u[l]-(d[l]-c[l])*y;return m}return u-(d-c)*y}if("continue"===t){var g=this.getValueAtTime(a/this.comp.globalData.frameRate,0),v=this.getValueAtTime((a+.001)/this.comp.globalData.frameRate,0);if(this.pv.length){for(m=new Array(g.length),p=m.length,l=0;p>l;l+=1)m[l]=g[l]+(g[l]-v[l])*(a-r)/.001;return m}return g+(g-v)*(a-r)/.001}}return this.getValueAtTime((o-(a-r)%o+a-n)/this.comp.globalData.frameRate,0)}function r(t){if(this._cachingAtTime||(this._cachingAtTime={lastValue:-99999,lastIndex:0}),t!==this._cachingAtTime.lastFrame){t*=this.elem.globalData.frameRate,t-=this.offsetTime;var e=this._caching.lastFrame<t?this._caching.lastIndex:0,s=this.interpolateValue(t,e,this.pv,this._cachingAtTime);this._cachingAtTime.lastIndex=s.iterationIndex,this._cachingAtTime.value=s.value,this._cachingAtTime.lastFrame=t}return this._cachingAtTime.value}function i(t){if(void 0!==this.vel)return this.vel;var e,s=-.01,r=this.getValueAtTime(t),i=this.getValueAtTime(t+s);if(r.length){e=Array.apply(null,{length:r.length});var a;for(a=0;a<r.length;a+=1)e[a]=(i[a]-r[a])/s}else e=(i-r)/s;return e}function a(t){this.propertyGroup=t}function n(t,e,s){e.x&&(s.k=!0,s.x=!0,s.getValue&&(s.getPreValue=s.getValue),s.getValue=ExpressionManager.initiateExpression.bind(s)(t,e,s))}function o(t){console.log("time:",t)}function h(t){}function l(t){if(this._shapeValueAtTime||(this._lastIndexAtTime=0,this._lastTimeAtTime=-999999,this._shapeValueAtTime=shape_pool.clone(this.pv)),t!==this._lastTimeAtTime){this._lastTimeAtTime=t,t*=this.elem.globalData.frameRate;var e=this.interpolateShape(t,this._lastIndexAtTime,this._shapeValueAtTime,!1);this._lastIndexAtTime=e.iterationIndex}return this._shapeValueAtTime}var p=function(){function e(t,e){return this.textIndex=t+1,this.textTotal=e,this.getValue(),this.v}return function(s,o){this.pv=1,this.comp=s.comp,this.elem=s,this.mult=.01,this.type="textSelector",this.textTotal=o.totalChars,this.selectorValue=100,this.lastValue=[1,1,1],n.bind(this)(s,o,this),this.getMult=e,this.getVelocityAtTime=i,this.getValueAtTime=this.kf?r.bind(this):t.bind(this),this.setGroupProperty=a}}(),m=PropertyFactory.getProp;PropertyFactory.getProp=function(l,p,f,c,d){var u=m(l,p,f,c,d);u.getValueAtTime=2===f?u.dynamicProperties.length?o.bind(u):h.bind(u):u.kf?r.bind(u):t.bind(u),u.setGroupProperty=a,u.loopOut=e,u.loopIn=s,u.getVelocityAtTime=i,u.numKeys=1===p.a?p.k.length:0;var y=u.k;return void 0!==p.ix&&Object.defineProperty(u,"propertyIndex",{get:function(){return p.ix}}),n(l,p,u),!y&&u.x&&d.push(u),u};var f=ShapePropertyFactory.getConstructorFunction(),c=ShapePropertyFactory.getKeyframedConstructorFunction();f.prototype.vertices=function(t,e){var s=this.v;void 0!==e&&(s=this.getValueAtTime(e,0));var r,i=s._length,a=s[t],n=s.v,o=Array.apply(null,{length:i});for(r=0;i>r;r+=1)o[r]="i"===t||"o"===t?[a[r][0]-n[r][0],a[r][1]-n[r][1]]:[a[r][0],a[r][1]];return o},f.prototype.points=function(t){return this.vertices("v",t)},f.prototype.inTangents=function(t){return this.vertices("i",t)},f.prototype.outTangents=function(t){return this.vertices("o",t)},f.prototype.isClosed=function(){return this.v.c},f.prototype.pointOnPath=function(t,e){var s=this.v;void 0!==e&&(s=this.getValueAtTime(e,0)),this._segmentsLength||(this._segmentsLength=bez.getSegmentsLength(s));for(var r,i=this._segmentsLength,a=i.lengths,n=i.totalLength*t,o=0,h=a.length,l=0;h>o;){if(l+a[o].addedLength>n){r=a[o].segments;var p=o,m=s.c&&o===h-1?0:o+1,f=(n-l)/a[o].addedLength,c=bez.getPointInSegment(s.v[p],s.v[m],s.o[p],s.i[m],f,a[o]);break}l+=a[o].addedLength,o+=1}return c||(c=s.c?[s.v[0][0],s.v[0][1]]:[s.v[s._length-1][0],s.v[s._length-1][1]]),c},f.prototype.vectorOnPath=function(t,e,s){t=1==t?this.v.c?0:.999:t;var r=this.pointOnPath(t,e),i=this.pointOnPath(t+.001,e),a=i[0]-r[0],n=i[1]-r[1],o=Math.sqrt(Math.pow(a,2)+Math.pow(n,2)),h="tangent"===s?[a/o,n/o]:[-n/o,a/o];return h},f.prototype.tangentOnPath=function(t,e){return this.vectorOnPath(t,e,"tangent")},f.prototype.normalOnPath=function(t,e){return this.vectorOnPath(t,e,"normal")},f.prototype.setGroupProperty=a,f.prototype.getValueAtTime=t,c.prototype.vertices=f.prototype.vertices,c.prototype.points=f.prototype.points,c.prototype.inTangents=f.prototype.inTangents,c.prototype.outTangents=f.prototype.outTangents,c.prototype.isClosed=f.prototype.isClosed,c.prototype.pointOnPath=f.prototype.pointOnPath,c.prototype.vectorOnPath=f.prototype.vectorOnPath,c.prototype.tangentOnPath=f.prototype.tangentOnPath,c.prototype.normalOnPath=f.prototype.normalOnPath,c.prototype.setGroupProperty=f.prototype.setGroupProperty,c.prototype.getValueAtTime=l;var d=ShapePropertyFactory.getShapeProp;ShapePropertyFactory.getShapeProp=function(t,e,s,r,i){var a=d(t,e,s,r,i),o=a.k;return void 0!==e.ix&&Object.defineProperty(a,"propertyIndex",{get:function(){return e.ix}}),3===s?n(t,e.pt,a):4===s&&n(t,e.ks,a),!o&&a.x&&r.push(a),a};var u=PropertyFactory.getTextSelectorProp;PropertyFactory.getTextSelectorProp=function(t,e,s){return 1===e.t?new p(t,e,s):u(t,e,s)}}(),function(){function t(){return this.data.d.x?(this.comp=this.elem.comp,this.getValue&&(this.getPreValue=this.getValue),this.calculateExpression=ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this),this.getValue=this.getExpressionValue,!0):!1}TextProperty.prototype.searchProperty=function(){return this.kf=this.searchExpressions()||this.data.d.k.length>1,this.kf},TextProperty.prototype.getExpressionValue=function(t){this.calculateExpression(),this.mdf&&(this.currentData.t=this.v.toString(),this.completeTextData(this.currentData))},TextProperty.prototype.searchExpressions=t}();var ExpressionManager=function(){function duplicatePropertyValue(t,e){if(e=e||1,"number"==typeof t||t instanceof Number)return t*e;if(t.i)return JSON.parse(JSON.stringify(t));var s,r=Array.apply(null,{length:t.length}),i=t.length;for(s=0;i>s;s+=1)r[s]=t[s]*e;

return r}function shapesEqual(t,e){if(t._length!==e._length||t.c!==e.c)return!1;var s,r=t._length;for(s=0;r>s;s+=1)if(t.v[s][0]!==e.v[s][0]||t.v[s][1]!==e.v[s][1]||t.o[s][0]!==e.o[s][0]||t.o[s][1]!==e.o[s][1]||t.i[s][0]!==e.i[s][0]||t.i[s][1]!==e.i[s][1])return!1;return!0}function $bm_neg(t){var e=typeof t;if("number"===e||"boolean"===e||t instanceof Number)return-t;if(t.constructor===Array){var s,r=t.length,i=[];for(s=0;r>s;s+=1)i[s]=-t[s];return i}}function sum(t,e){var s=typeof t,r=typeof e;if("string"===s||"string"===r)return t+e;if(("number"===s||"boolean"===s||"string"===s||t instanceof Number)&&("number"===r||"boolean"===r||"string"===r||e instanceof Number))return t+e;if(t.constructor===Array&&("number"===r||"boolean"===r||"string"===r||e instanceof Number))return t[0]=t[0]+e,t;if(("number"===s||"boolean"===s||"string"===s||t instanceof Number)&&e.constructor===Array)return e[0]=t+e[0],e;if(t.constructor===Array&&e.constructor===Array){for(var i=0,a=t.length,n=e.length,o=[];a>i||n>i;)o[i]=("number"==typeof t[i]||t[i]instanceof Number)&&("number"==typeof e[i]||e[i]instanceof Number)?t[i]+e[i]:void 0==e[i]?t[i]:t[i]||e[i],i+=1;return o}return 0}function sub(t,e){var s=typeof t,r=typeof e;if(("number"===s||"boolean"===s||"string"===s||t instanceof Number)&&("number"===r||"boolean"===r||"string"===r||e instanceof Number))return"string"===s&&(t=parseInt(t)),"string"===r&&(e=parseInt(e)),t-e;if(t.constructor===Array&&("number"===r||"boolean"===r||"string"===r||e instanceof Number))return t[0]=t[0]-e,t;if(("number"===s||"boolean"===s||"string"===s||t instanceof Number)&&e.constructor===Array)return e[0]=t-e[0],e;if(t.constructor===Array&&e.constructor===Array){for(var i=0,a=t.length,n=e.length,o=[];a>i||n>i;)o[i]="number"==typeof t[i]||t[i]instanceof Number?t[i]-e[i]:void 0==e[i]?t[i]:t[i]||e[i],i+=1;return o}return 0}function mul(t,e){var s,r=typeof t,i=typeof e;if(("number"===r||"boolean"===r||"string"===r||t instanceof Number)&&("number"===i||"boolean"===i||"string"===i||e instanceof Number))return t*e;var a,n;if(t.constructor===Array&&("number"===i||"boolean"===i||"string"===i||e instanceof Number)){for(n=t.length,s=Array.apply(null,{length:n}),a=0;n>a;a+=1)s[a]=t[a]*e;return s}if(("number"===r||"boolean"===r||"string"===r||t instanceof Number)&&e.constructor===Array){for(n=e.length,s=Array.apply(null,{length:n}),a=0;n>a;a+=1)s[a]=t*e[a];return s}return 0}function div(t,e){var s,r=typeof t,i=typeof e;if(("number"===r||"boolean"===r||"string"===r||t instanceof Number)&&("number"===i||"boolean"===i||"string"===i||e instanceof Number))return t/e;var a,n;if(t.constructor===Array&&("number"===i||"boolean"===i||"string"===i||e instanceof Number)){for(n=t.length,s=Array.apply(null,{length:n}),a=0;n>a;a+=1)s[a]=t[a]/e;return s}if(("number"===r||"boolean"===r||"string"===r||t instanceof Number)&&e.constructor===Array){for(n=e.length,s=Array.apply(null,{length:n}),a=0;n>a;a+=1)s[a]=t/e[a];return s}return 0}function mod(t,e){return"string"==typeof t&&(t=parseInt(t)),"string"==typeof e&&(e=parseInt(e)),t%e}function clamp(t,e,s){if(e>s){var r=s;s=e,e=r}return Math.min(Math.max(t,e),s)}function radiansToDegrees(t){return t/degToRads}function degreesToRadians(t){return t*degToRads}function length(t,e){if("number"==typeof t||t instanceof Number)return e=e||0,Math.abs(t-e);e||(e=helperLengthArray);var s,r=Math.min(t.length,e.length),i=0;for(s=0;r>s;s+=1)i+=Math.pow(e[s]-t[s],2);return Math.sqrt(i)}function normalize(t){return div(t,length(t))}function rgbToHsl(t){var e,s,r=t[0],i=t[1],a=t[2],n=Math.max(r,i,a),o=Math.min(r,i,a),h=(n+o)/2;if(n==o)e=s=0;else{var l=n-o;switch(s=h>.5?l/(2-n-o):l/(n+o),n){case r:e=(i-a)/l+(a>i?6:0);break;case i:e=(a-r)/l+2;break;case a:e=(r-i)/l+4}e/=6}return[e,s,h,t[3]]}function hslToRgb(t){function e(t,e,s){return 0>s&&(s+=1),s>1&&(s-=1),1/6>s?t+6*(e-t)*s:.5>s?e:2/3>s?t+(e-t)*(2/3-s)*6:t}var s,r,i,a=t[0],n=t[1],o=t[2];if(0==n)s=r=i=o;else{var h=.5>o?o*(1+n):o+n-o*n,l=2*o-h;s=e(l,h,a+1/3),r=e(l,h,a),i=e(l,h,a-1/3)}return[s,r,i,t[3]]}function linear(t,e,s,r,i){if(void 0===r||void 0===i)return linear(t,0,1,e,s);if(e>=t)return r;if(t>=s)return i;var a=s===e?0:(t-e)/(s-e);if(!r.length)return r+(i-r)*a;var n,o=r.length,h=Array.apply(null,{length:o});for(n=0;o>n;n+=1)h[n]=r[n]+(i[n]-r[n])*a;return h}function random(t,e){if(void 0===e&&(void 0===t?(t=0,e=1):(e=t,t=void 0)),e.length){var s,r=e.length;t||(t=Array.apply(null,{length:r}));var i=Array.apply(null,{length:r}),a=BMMath.random();for(s=0;r>s;s+=1)i[s]=t[s]+a*(e[s]-t[s]);return i}void 0===t&&(t=0);var n=BMMath.random();return t+n*(e-t)}function createPath(t,e,s,r){e=e&&e.length?e:t,s=s&&s.length?s:t;var a=shape_pool.newShape(),n=t.length;for(a.setPathData(r,n),i=0;i<n;i+=1)a.setTripleAt(t[i][0],t[i][1],s[i][0]+t[i][0],s[i][1]+t[i][1],e[i][0]+t[i][0],e[i][1]+t[i][1],i,!0);return a}function initiateExpression(elem,data,property){function lookAt(t,e){var s=[e[0]-t[0],e[1]-t[1],e[2]-t[2]],r=Math.atan2(s[0],Math.sqrt(s[1]*s[1]+s[2]*s[2]))/degToRads,i=-Math.atan2(s[1],s[2])/degToRads;return[i,r,0]}function easeOut(t,e,s){return-(s-e)*t*(t-2)+e}function nearestKey(t){var e,s,r,i=data.k.length;if(data.k.length&&"number"!=typeof data.k[0])if(s=-1,t*=elem.comp.globalData.frameRate,t<data.k[0].t)s=1,r=data.k[0].t;else{for(e=0;i-1>e;e+=1){if(t===data.k[e].t){s=e+1,r=data.k[e].t;break}if(t>data.k[e].t&&t<data.k[e+1].t){t-data.k[e].t>data.k[e+1].t-t?(s=e+2,r=data.k[e+1].t):(s=e+1,r=data.k[e].t);break}}-1===s&&(s=e+1,r=data.k[e].t)}else s=0,r=0;var a={};return a.index=s,a.time=r/elem.comp.globalData.frameRate,a}function key(t){var e,s,r;if(!data.k.length||"number"==typeof data.k[0])throw new Error("The property has no keyframe at index "+t);t-=1,e={time:data.k[t].t/elem.comp.globalData.frameRate};var i;for(i=t!==data.k.length-1||data.k[t].h?data.k[t].s:data.k[t-1].e,r=i.length,s=0;r>s;s+=1)e[s]=i[s];return e}function framesToTime(t,e){return e||(e=elem.comp.globalData.frameRate),t/e}function timeToFrames(t,e){return t||0===t||(t=time),e||(e=elem.comp.globalData.frameRate),t*e}function seedRandom(t){BMMath.seedrandom(randSeed+t)}function sourceRectAtTime(){return elem.sourceRectAtTime()}function executeExpression(){if(_needsRandom&&seedRandom(randSeed),this.frameExpressionId!==elem.globalData.frameId||"textSelector"===this.type){if(this.lock)return this.v=duplicatePropertyValue(this.pv,this.mult),!0;"textSelector"===this.type&&(textIndex=this.textIndex,textTotal=this.textTotal,selectorValue=this.selectorValue),thisLayer||(thisLayer=elem.layerInterface,thisComp=elem.comp.compInterface,toWorld=thisLayer.toWorld.bind(thisLayer),fromWorld=thisLayer.fromWorld.bind(thisLayer),fromComp=thisLayer.fromComp.bind(thisLayer),mask=thisLayer.mask?thisLayer.mask.bind(thisLayer):null,fromCompToSurface=fromComp),transform||(transform=elem.layerInterface("ADBE Transform Group"),anchorPoint=transform.anchorPoint),4!==elemType||content||(content=thisLayer("ADBE Root Vectors Group")),effect||(effect=thisLayer(4)),hasParent=!(!elem.hierarchy||!elem.hierarchy.length),hasParent&&!parent&&(parent=elem.hierarchy[0].layerInterface),this.lock=!0,this.getPreValue&&this.getPreValue(),value=this.pv,time=this.comp.renderedFrame/this.comp.globalData.frameRate,needsVelocity&&(velocity=velocityAtTime(time)),bindedFn(),this.frameExpressionId=elem.globalData.frameId;var t,e;if(this.mult)if("number"==typeof this.v||this.v instanceof Number||this.v instanceof String||"string"==typeof this.v)this.v*=this.mult;else if(1===this.v.length)this.v=this.v[0]*this.mult;else for(e=this.v.length,value===this.v&&(this.v=2===e?[value[0],value[1]]:[value[0],value[1],value[2]]),t=0;e>t;t+=1)this.v[t]*=this.mult;if(1===this.v.length&&(this.v=this.v[0]),"number"==typeof this.v||this.v instanceof Number||this.v instanceof String||"string"==typeof this.v)this.lastValue!==this.v&&(this.lastValue=this.v,this.mdf=!0);else if(this.v._length)shapesEqual(this.v,this.localShapeCollection.shapes[0])||(this.mdf=!0,this.localShapeCollection.releaseShapes(),this.localShapeCollection.addShape(shape_pool.clone(this.v)));else for(e=this.v.length,t=0;e>t;t+=1)this.v[t]!==this.lastValue[t]&&(this.lastValue[t]=this.v[t],this.mdf=!0);this.lock=!1}}var val=data.x,needsVelocity=/velocity(?![\w\d])/.test(val),_needsRandom=-1!==val.indexOf("random"),elemType=elem.data.ty,transform,content,effect,thisComp=elem.comp,thisProperty=property;elem.comp.frameDuration=1/elem.comp.globalData.frameRate;var inPoint=elem.data.ip/elem.comp.globalData.frameRate,outPoint=elem.data.op/elem.comp.globalData.frameRate,width=elem.data.sw?elem.data.sw:0,height=elem.data.sh?elem.data.sh:0,loopIn,loop_in,loopOut,loop_out,toWorld,fromWorld,fromComp,fromCompToSurface,anchorPoint,thisLayer,thisComp,mask,valueAtTime,velocityAtTime,fn=new Function,fn=eval("[function(){"+val+";if($bm_rt.__shapeObject){this.v=shape_pool.clone($bm_rt.v);}else{this.v=$bm_rt;}}]")[0],bindedFn=fn.bind(this),numKeys=property.kf?data.k.length:0,wiggle=function(t,e){var s,r,i=this.pv.length?this.pv.length:1,a=Array.apply(null,{len:i});for(r=0;i>r;r+=1)a[r]=0;t=5;var n=Math.floor(time*t);for(s=0,r=0;n>s;){for(r=0;i>r;r+=1)a[r]+=-e+2*e*BMMath.random();s+=1}var o=time*t,h=o-Math.floor(o),l=Array.apply({length:i});if(i>1){for(r=0;i>r;r+=1)l[r]=this.pv[r]+a[r]+(-e+2*e*BMMath.random())*h;return l}return this.pv+a[0]+(-e+2*e*BMMath.random())*h}.bind(this);thisProperty.loopIn&&(loopIn=thisProperty.loopIn.bind(thisProperty),loop_in=loopIn),thisProperty.loopOut&&(loopOut=thisProperty.loopOut.bind(thisProperty),loop_out=loopOut);var loopInDuration=function(t,e){return loopIn(t,e,!0)}.bind(this),loopOutDuration=function(t,e){return loopOut(t,e,!0)}.bind(this);this.getValueAtTime&&(valueAtTime=this.getValueAtTime.bind(this)),this.getVelocityAtTime&&(velocityAtTime=this.getVelocityAtTime.bind(this));var comp=elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface),time,velocity,value,textIndex,textTotal,selectorValue,index=elem.data.ind,hasParent=!(!elem.hierarchy||!elem.hierarchy.length),parent,randSeed=Math.floor(1e6*Math.random());return executeExpression}var ob={},Math=BMMath,window=null,document=null,add=sum,radians_to_degrees=radiansToDegrees,degrees_to_radians=radiansToDegrees,helperLengthArray=[0,0,0,0,0,0];return ob.initiateExpression=initiateExpression,ob}(),ShapeExpressionInterface=function(){function t(t,e,s){return d(t,e,s)}function e(t,e,s){return y(t,e,s)}function s(t,e,s){return g(t,e,s)}function r(t,e,s){return v(t,e,s)}function i(t,e,s){return b(t,e,s)}function a(t,e,s){return E(t,e,s)}function n(t,e,s){return P(t,e,s)}function o(t,e,s){return x(t,e,s)}function h(t,e,s){return S(t,e,s)}function l(t,e,s){return C(t,e,s)}function p(t,e,s){return k(t,e,s)}function m(t,e,s){return A(t,e,s)}function f(t,e,s){var r,i=[],a=t?t.length:0;for(r=0;a>r;r+=1)"gr"==t[r].ty?i.push(ShapeExpressionInterface.createGroupInterface(t[r],e[r],s)):"fl"==t[r].ty?i.push(ShapeExpressionInterface.createFillInterface(t[r],e[r],s)):"st"==t[r].ty?i.push(ShapeExpressionInterface.createStrokeInterface(t[r],e[r],s)):"tm"==t[r].ty?i.push(ShapeExpressionInterface.createTrimInterface(t[r],e[r],s)):"tr"==t[r].ty||("el"==t[r].ty?i.push(ShapeExpressionInterface.createEllipseInterface(t[r],e[r],s)):"sr"==t[r].ty?i.push(ShapeExpressionInterface.createStarInterface(t[r],e[r],s)):"sh"==t[r].ty?i.push(ShapeExpressionInterface.createPathInterface(t[r],e[r],s)):"rc"==t[r].ty?i.push(ShapeExpressionInterface.createRectInterface(t[r],e[r],s)):"rd"==t[r].ty?i.push(ShapeExpressionInterface.createRoundedInterface(t[r],e[r],s)):"rp"==t[r].ty&&i.push(ShapeExpressionInterface.createRepatearInterface(t[r],e[r],s)));return i}var c={createShapeInterface:t,createGroupInterface:e,createTrimInterface:i,createStrokeInterface:r,createTransformInterface:a,createEllipseInterface:n,createStarInterface:o,createRectInterface:h,createRoundedInterface:l,createRepatearInterface:p,createPathInterface:m,createFillInterface:s},d=function(){return function(t,e,s){function r(t){if("number"==typeof t)return i[t-1];for(var e=0,s=i.length;s>e;){if(i[e]._name===t)return i[e];e+=1}}var i;return r.propertyGroup=s,i=f(t,e,r),r}}(),u=function(){return function(t,e,s){var r,i=function(t){for(var e=0,s=r.length;s>e;){if(r[e]._name===t||r[e].mn===t||r[e].propertyIndex===t||r[e].ix===t||r[e].ind===t)return r[e];e+=1}return"number"==typeof t?r[t-1]:void 0};return i.propertyGroup=function(t){return 1===t?i:s(t-1)},r=f(t.it,e.it,i.propertyGroup),i.numProperties=r.length,i.propertyIndex=t.cix,i}}(),y=function(){return function(t,e,s){var r=function(t){switch(t){case"ADBE Vectors Group":case"Contents":case 2:return r.content;case"ADBE Vector Transform Group":case 3:default:return r.transform}};r.propertyGroup=function(t){return 1===t?r:s(t-1)};var i=u(t,e,r.propertyGroup),a=ShapeExpressionInterface.createTransformInterface(t.it[t.it.length-1],e.it[e.it.length-1],r.propertyGroup);return r.content=i,r.transform=a,Object.defineProperty(r,"_name",{get:function(){return t.nm}}),r.numProperties=t.np,r.propertyIndex=t.ix,r.nm=t.nm,r.mn=t.mn,r}}(),g=function(){return function(t,e,s){function r(t){return"Color"===t||"color"===t?r.color:"Opacity"===t||"opacity"===t?r.opacity:void 0}return Object.defineProperty(r,"color",{get:function(){return ExpressionValue(e.c,1/e.c.mult,"color")}}),Object.defineProperty(r,"opacity",{get:function(){return ExpressionValue(e.o,100)}}),Object.defineProperty(r,"_name",{value:t.nm}),Object.defineProperty(r,"mn",{value:t.mn}),e.c.setGroupProperty(s),e.o.setGroupProperty(s),r}}(),v=function(){return function(t,e,s){function r(t){return 1===t?c:s(t-1)}function i(t){return 1===t?l:r(t-1)}function a(s){Object.defineProperty(l,t.d[s].nm,{get:function(){return ExpressionValue(e.d.dataProps[s].p)}})}function n(t){return"Color"===t||"color"===t?n.color:"Opacity"===t||"opacity"===t?n.opacity:"Stroke Width"===t||"stroke width"===t?n.strokeWidth:void 0}var o,h=t.d?t.d.length:0,l={};for(o=0;h>o;o+=1)a(o),e.d.dataProps[o].p.setGroupProperty(i);return Object.defineProperty(n,"color",{get:function(){return ExpressionValue(e.c,1/e.c.mult,"color")}}),Object.defineProperty(n,"opacity",{get:function(){return ExpressionValue(e.o,100)}}),Object.defineProperty(n,"strokeWidth",{get:function(){return ExpressionValue(e.w)}}),Object.defineProperty(n,"dash",{get:function(){return l}}),Object.defineProperty(n,"_name",{value:t.nm}),Object.defineProperty(n,"mn",{value:t.mn}),e.c.setGroupProperty(r),e.o.setGroupProperty(r),e.w.setGroupProperty(r),n}}(),b=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return e===t.e.ix||"End"===e||"end"===e?i.end:e===t.s.ix?i.start:e===t.o.ix?i.offset:void 0}return i.propertyIndex=t.ix,e.s.setGroupProperty(r),e.e.setGroupProperty(r),e.o.setGroupProperty(r),i.propertyIndex=t.ix,Object.defineProperty(i,"start",{get:function(){return ExpressionValue(e.s,1/e.s.mult)}}),Object.defineProperty(i,"end",{get:function(){return ExpressionValue(e.e,1/e.e.mult)}}),Object.defineProperty(i,"offset",{get:function(){return ExpressionValue(e.o)}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.mn=t.mn,i}}(),E=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return t.a.ix===e?i.anchorPoint:t.o.ix===e?i.opacity:t.p.ix===e?i.position:t.r.ix===e?i.rotation:t.s.ix===e?i.scale:t.sk&&t.sk.ix===e?i.skew:t.sa&&t.sa.ix===e?i.skewAxis:"Opacity"===e?i.opacity:"Position"===e?i.position:"Anchor Point"===e?i.anchorPoint:"Scale"===e?i.scale:"Rotation"===e||"ADBE Vector Rotation"===e?i.rotation:"Skew"===e?i.skew:"Skew Axis"===e?i.skewAxis:void 0}e.transform.mProps.o.setGroupProperty(r),e.transform.mProps.p.setGroupProperty(r),e.transform.mProps.a.setGroupProperty(r),e.transform.mProps.s.setGroupProperty(r),e.transform.mProps.r.setGroupProperty(r),e.transform.mProps.sk&&(e.transform.mProps.sk.setGroupProperty(r),e.transform.mProps.sa.setGroupProperty(r)),e.transform.op.setGroupProperty(r),Object.defineProperty(i,"opacity",{get:function(){return ExpressionValue(e.transform.mProps.o,1/e.transform.mProps.o.mult)}}),Object.defineProperty(i,"position",{get:function(){return ExpressionValue(e.transform.mProps.p)}}),Object.defineProperty(i,"anchorPoint",{get:function(){return ExpressionValue(e.transform.mProps.a)}});return Object.defineProperty(i,"scale",{get:function(){return ExpressionValue(e.transform.mProps.s,1/e.transform.mProps.s.mult)}}),Object.defineProperty(i,"rotation",{get:function(){return ExpressionValue(e.transform.mProps.r,1/e.transform.mProps.r.mult)}}),Object.defineProperty(i,"skew",{get:function(){return ExpressionValue(e.transform.mProps.sk)}}),Object.defineProperty(i,"skewAxis",{get:function(){return ExpressionValue(e.transform.mProps.sa)}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.ty="tr",i.mn=t.mn,i}}(),P=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return t.p.ix===e?i.position:t.s.ix===e?i.size:void 0}i.propertyIndex=t.ix;var a="tm"===e.sh.ty?e.sh.prop:e.sh;return a.s.setGroupProperty(r),a.p.setGroupProperty(r),Object.defineProperty(i,"size",{get:function(){return ExpressionValue(a.s)}}),Object.defineProperty(i,"position",{get:function(){return ExpressionValue(a.p)}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.mn=t.mn,i}}(),x=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return t.p.ix===e?i.position:t.r.ix===e?i.rotation:t.pt.ix===e?i.points:t.or.ix===e||"ADBE Vector Star Outer Radius"===e?i.outerRadius:t.os.ix===e?i.outerRoundness:!t.ir||t.ir.ix!==e&&"ADBE Vector Star Inner Radius"!==e?t.is&&t.is.ix===e?i.innerRoundness:void 0:i.innerRadius}var a="tm"===e.sh.ty?e.sh.prop:e.sh;return i.propertyIndex=t.ix,a.or.setGroupProperty(r),a.os.setGroupProperty(r),a.pt.setGroupProperty(r),a.p.setGroupProperty(r),a.r.setGroupProperty(r),t.ir&&(a.ir.setGroupProperty(r),a.is.setGroupProperty(r)),Object.defineProperty(i,"position",{get:function(){return ExpressionValue(a.p)}}),Object.defineProperty(i,"rotation",{get:function(){return ExpressionValue(a.r,1/a.r.mult)}}),Object.defineProperty(i,"points",{get:function(){return ExpressionValue(a.pt)}}),Object.defineProperty(i,"outerRadius",{get:function(){return ExpressionValue(a.or)}}),Object.defineProperty(i,"outerRoundness",{get:function(){return ExpressionValue(a.os)}}),Object.defineProperty(i,"innerRadius",{get:function(){return a.ir?ExpressionValue(a.ir):0}}),Object.defineProperty(i,"innerRoundness",{get:function(){return a.is?ExpressionValue(a.is,1/a.is.mult):0}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.mn=t.mn,i}}(),S=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return t.p.ix===e?i.position:t.r.ix===e?i.roundness:t.s.ix===e||"Size"===e?i.size:void 0}var a="tm"===e.sh.ty?e.sh.prop:e.sh;return i.propertyIndex=t.ix,a.p.setGroupProperty(r),a.s.setGroupProperty(r),a.r.setGroupProperty(r),Object.defineProperty(i,"position",{get:function(){return ExpressionValue(a.p)}}),Object.defineProperty(i,"roundness",{get:function(){return ExpressionValue(a.r)}}),Object.defineProperty(i,"size",{get:function(){return ExpressionValue(a.s)}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.mn=t.mn,i}}(),C=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return t.r.ix===e||"Round Corners 1"===e?i.radius:void 0}var a=e;return i.propertyIndex=t.ix,a.rd.setGroupProperty(r),Object.defineProperty(i,"radius",{get:function(){return ExpressionValue(a.rd)}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.mn=t.mn,i}}(),k=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(e){return t.c.ix===e||"Copies"===e?i.copies:t.o.ix===e||"Offset"===e?i.offset:void 0}var a=e;return i.propertyIndex=t.ix,a.c.setGroupProperty(r),a.o.setGroupProperty(r),Object.defineProperty(i,"copies",{get:function(){return ExpressionValue(a.c)}}),Object.defineProperty(i,"offset",{get:function(){return ExpressionValue(a.o)}}),Object.defineProperty(i,"_name",{get:function(){return t.nm}}),i.mn=t.mn,i}}(),A=function(){return function(t,e,s){function r(t){return 1==t?i:s(--t)}function i(t){return"Shape"===t||"shape"===t||"Path"===t||"path"===t||"ADBE Vector Shape"===t||2===t?i.path:void 0}var a=e.sh;return a.setGroupProperty(r),Object.defineProperty(i,"path",{get:function(){return a.k&&a.getValue(),a}}),Object.defineProperty(i,"shape",{get:function(){return a.k&&a.getValue(),a}}),Object.defineProperty(i,"_name",{value:t.nm}),Object.defineProperty(i,"ix",{value:t.ix}),Object.defineProperty(i,"mn",{value:t.mn}),i}}();return c}(),TextExpressionInterface=function(){return function(t){function e(){}var s,r;return Object.defineProperty(e,"sourceText",{get:function(){var e=t.textProperty.currentData.t;return t.textProperty.currentData.t!==s&&(t.textProperty.currentData.t=s,r=new String(e),r.value=e?e:new String(e)),r}}),e}}(),LayerExpressionInterface=function(){function t(t,e){var s=new Matrix;s.reset();var r;if(r=e?this._elem.finalTransform.mProp:this._elem.finalTransform.mProp,r.applyToMatrix(s),this._elem.hierarchy&&this._elem.hierarchy.length){var i,a=this._elem.hierarchy.length;for(i=0;a>i;i+=1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(s);return s.applyToPointArray(t[0],t[1],t[2]||0)}return s.applyToPointArray(t[0],t[1],t[2]||0)}function e(t,e){var s=new Matrix;s.reset();var r;if(r=e?this._elem.finalTransform.mProp:this._elem.finalTransform.mProp,r.applyToMatrix(s),this._elem.hierarchy&&this._elem.hierarchy.length){var i,a=this._elem.hierarchy.length;for(i=0;a>i;i+=1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(s);return s.inversePoint(t)}return s.inversePoint(t)}function s(t){var e=new Matrix;if(e.reset(),this._elem.finalTransform.mProp.applyToMatrix(e),this._elem.hierarchy&&this._elem.hierarchy.length){var s,r=this._elem.hierarchy.length;for(s=0;r>s;s+=1)this._elem.hierarchy[s].finalTransform.mProp.applyToMatrix(e);return e.inversePoint(t)}return e.inversePoint(t)}return function(r){function i(t){n.mask=new MaskManagerInterface(t,r)}function a(t){n.effect=t}function n(t){switch(t){case"ADBE Root Vectors Group":case"Contents":case 2:return n.shapeInterface;case 1:case 6:case"Transform":case"transform":case"ADBE Transform Group":return o;case 4:case"ADBE Effect Parade":return n.effect}}var o=TransformExpressionInterface(r.transform);return n.toWorld=t,n.fromWorld=e,n.toComp=t,n.fromComp=s,n.sourceRectAtTime=r.sourceRectAtTime.bind(r),n._elem=r,Object.defineProperty(n,"hasParent",{get:function(){return!!r.hierarchy}}),Object.defineProperty(n,"parent",{get:function(){return r.hierarchy[0].layerInterface}}),Object.defineProperty(n,"rotation",{get:function(){return o.rotation}}),Object.defineProperty(n,"scale",{get:function(){return o.scale}}),Object.defineProperty(n,"position",{get:function(){return o.position}}),Object.defineProperty(n,"anchorPoint",{get:function(){return o.anchorPoint}}),Object.defineProperty(n,"transform",{get:function(){return o}}),Object.defineProperty(n,"width",{get:function(){return 0===r.data.ty?r.data.w:100}}),Object.defineProperty(n,"height",{get:function(){return 0===r.data.ty?r.data.h:100}}),Object.defineProperty(n,"source",{get:function(){return r.data.refId}}),Object.defineProperty(n,"index",{get:function(){return r.data.ind}}),Object.defineProperty(n,"_name",{value:r.data.nm}),Object.defineProperty(n,"content",{get:function(){return n.shapeInterface}}),Object.defineProperty(n,"active",{get:function(){return r.isVisible}}),Object.defineProperty(n,"text",{get:function(){return n.textInterface}}),n.registerMaskInterface=i,n.registerEffectsInterface=a,n}}(),CompExpressionInterface=function(){return function(t){function e(e){for(var s=0,r=t.layers.length;r>s;){if(t.layers[s].nm===e||t.layers[s].ind===e)return t.elements[s].layerInterface;s+=1}return{active:!1}}return Object.defineProperty(e,"_name",{value:t.data.nm}),e.layer=e,e.pixelAspect=1,e.height=t.globalData.compSize.h,e.width=t.globalData.compSize.w,e.pixelAspect=1,e.frameDuration=1/t.globalData.frameRate,e}}(),TransformExpressionInterface=function(){return function(t){function e(s){switch(s){case"scale":case"Scale":case"ADBE Scale":case 6:return e.scale;case"rotation":case"Rotation":case"ADBE Rotation":case"ADBE Rotate Z":case 10:return e.rotation;case"position":case"Position":case"ADBE Position":case 2:return t.position;case"anchorPoint":case"AnchorPoint":case"Anchor Point":case"ADBE AnchorPoint":case 1:return e.anchorPoint;case"opacity":case"Opacity":case 11:return e.opacity}}return Object.defineProperty(e,"rotation",{get:function(){return t.rotation}}),Object.defineProperty(e,"scale",{get:function(){return t.scale}}),Object.defineProperty(e,"position",{get:function(){return t.position}}),Object.defineProperty(e,"xPosition",{get:function(){return t.xPosition}}),Object.defineProperty(e,"yPosition",{get:function(){return t.yPosition}}),Object.defineProperty(e,"anchorPoint",{get:function(){return t.anchorPoint}}),Object.defineProperty(e,"opacity",{get:function(){return t.opacity}}),Object.defineProperty(e,"skew",{get:function(){return t.skew}}),Object.defineProperty(e,"skewAxis",{get:function(){return t.skewAxis}}),e}}(),ProjectInterface=function(){function t(t){this.compositions.push(t)}return function(){function e(t){for(var e=0,s=this.compositions.length;s>e;){if(this.compositions[e].data&&this.compositions[e].data.nm===t)return this.compositions[e].prepareFrame&&this.compositions[e].prepareFrame(this.currentFrame),this.compositions[e].compInterface;e+=1}}return e.compositions=[],e.currentFrame=0,e.registerComposition=t,e}}(),EffectsExpressionInterface=function(){function t(t,s){if(t.effects){var r,i=[],a=t.data.ef,n=t.effects.effectElements.length;for(r=0;n>r;r+=1)i.push(e(a[r],t.effects.effectElements[r],s,t));return function(e){for(var s=t.data.ef,r=0,a=s.length;a>r;){if(e===s[r].nm||e===s[r].mn||e===s[r].ix)return i[r];r+=1}}}}function e(t,r,i,a){function n(t){return 1===t?p:i(t-1)}var o,h=[],l=t.ef.length;for(o=0;l>o;o+=1)h.push(5===t.ef[o].ty?e(t.ef[o],r.effectElements[o],r.effectElements[o].propertyGroup,a):s(r.effectElements[o],t.ef[o].ty,a,n));var p=function(e){for(var s=t.ef,r=0,i=s.length;i>r;){if(e===s[r].nm||e===s[r].mn||e===s[r].ix)return 5===s[r].ty?h[r]:h[r]();r+=1}return h[0]()};return p.propertyGroup=n,"ADBE Color Control"===t.mn&&Object.defineProperty(p,"color",{get:function(){return h[0]()}}),Object.defineProperty(p,"numProperties",{get:function(){return t.np}}),p.active=0!==t.en,p}function s(t,e,s,r){function i(){return 10===e?s.comp.compInterface(t.p.v):ExpressionValue(t.p)}return t.p.setGroupProperty&&t.p.setGroupProperty(r),i}var r={createEffectsInterface:t};return r}(),MaskManagerInterface=function(){function t(t,e){this._mask=t,this._data=e}Object.defineProperty(t.prototype,"maskPath",{get:function(){return this._mask.prop.k&&this._mask.prop.getValue(),this._mask.prop}});var e=function(e,s){var r,i=Array.apply(null,{length:e.viewData.length}),a=e.viewData.length;for(r=0;a>r;r+=1)i[r]=new t(e.viewData[r],e.masksProperties[r]);var n=function(t){for(r=0;a>r;){if(e.masksProperties[r].nm===t)return i[r];r+=1}};return n};return e}(),ExpressionValue=function(){return function(t,e,s){var r;t.k&&t.getValue();var i,a,n;if(s){if("color"===s){for(a=4,r=Array.apply(null,{length:a}),n=Array.apply(null,{length:a}),i=0;a>i;i+=1)r[i]=n[i]=e&&3>i?t.v[i]*e:1;r.value=n}}else if("number"==typeof t.v||t.v instanceof Number)r=new Number(e?t.v*e:t.v),r.value=e?t.v*e:t.v;else{for(a=t.v.length,r=Array.apply(null,{length:a}),n=Array.apply(null,{length:a}),i=0;a>i;i+=1)r[i]=n[i]=e?t.v[i]*e:t.v[i];r.value=n}return r.numKeys=t.keyframes?t.keyframes.length:0,r.key=function(e){return r.numKeys?t.keyframes[e-1].t:0},r.valueAtTime=t.getValueAtTime,r.propertyGroup=t.propertyGroup,r}}();GroupEffect.prototype.getValue=function(){this.mdf=!1;var t,e=this.dynamicProperties.length;for(t=0;e>t;t+=1)this.dynamicProperties[t].getValue(),this.mdf=this.dynamicProperties[t].mdf?!0:this.mdf},GroupEffect.prototype.init=function(t,e,s){this.data=t,this.mdf=!1,this.effectElements=[];var r,i,a=this.data.ef.length,n=this.data.ef;for(r=0;a>r;r+=1)switch(n[r].ty){case 0:i=new SliderEffect(n[r],e,s),this.effectElements.push(i);break;case 1:i=new AngleEffect(n[r],e,s),this.effectElements.push(i);break;case 2:i=new ColorEffect(n[r],e,s),this.effectElements.push(i);break;case 3:i=new PointEffect(n[r],e,s),this.effectElements.push(i);break;case 4:case 7:i=new CheckboxEffect(n[r],e,s),this.effectElements.push(i);break;case 10:i=new LayerIndexEffect(n[r],e,s),this.effectElements.push(i);break;case 11:i=new MaskIndexEffect(n[r],e,s),this.effectElements.push(i);break;case 5:i=new EffectsManager(n[r],e,s),this.effectElements.push(i);break;case 6:i=new NoValueEffect(n[r],e,s),this.effectElements.push(i)}};var bodymovinjs={};bodymovinjs.play=play,bodymovinjs.pause=pause,bodymovinjs.setLocationHref=setLocationHref,bodymovinjs.togglePause=togglePause,bodymovinjs.setSpeed=setSpeed,bodymovinjs.setDirection=setDirection,bodymovinjs.stop=stop,bodymovinjs.moveFrame=moveFrame,bodymovinjs.searchAnimations=searchAnimations,bodymovinjs.registerAnimation=registerAnimation,bodymovinjs.loadAnimation=loadAnimation,bodymovinjs.setSubframeRendering=setSubframeRendering,bodymovinjs.resize=resize,bodymovinjs.start=start,bodymovinjs.goToAndStop=goToAndStop,bodymovinjs.destroy=destroy,bodymovinjs.setQuality=setQuality,bodymovinjs.inBrowser=inBrowser,bodymovinjs.installPlugin=installPlugin,bodymovinjs.__getFactory=getFactory,bodymovinjs.version="4.13.0";var standalone="__[STANDALONE]__",animationData="__[ANIMATIONDATA]__",renderer="";if(standalone){var scripts=document.getElementsByTagName("script"),index=scripts.length-1,myScript=scripts[index]||{src:""},queryString=myScript.src.replace(/^[^\?]+\??/,"");renderer=getQueryVariable("renderer")}var readyStateCheckInterval=setInterval(checkReady,100);return bodymovinjs});
var loadingSpinner = {"v":"4.6.0","fr":29.9700012207031,"ip":0,"op":49.0000019958109,"w":200,"h":200,"nm":"loading_ring_medium","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"green ring 1","ks":{"o":{"a":0,"k":100},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":0,"s":[0],"e":[360]},{"t":49.0000019958109}]},"p":{"a":0,"k":[100,100,0]},"a":{"a":0,"k":[0,0,0]},"s":{"a":0,"k":[200,200,100]}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[54,54]},"p":{"a":0,"k":[0,0]},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse"},{"ty":"st","c":{"a":0,"k":[1,1,1,1]},"o":{"a":0,"k":100},"w":{"a":0,"k":6},"lc":2,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke"},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"mn":"ADBE Vector Group"},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.644],"y":[0]},"n":["0p667_1_0p644_0"],"t":10,"s":[0],"e":[100]},{"t":50.0000020365418}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":-1,"s":[0],"e":[100]},{"t":37.0000015070409}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim"}],"ip":0,"op":50.0000020365418,"st":-1.00000004073083,"bm":0,"sr":1},{"ddd":0,"ind":2,"ty":4,"nm":"flamingo ring 3","parent":1,"ks":{"o":{"a":0,"k":100},"r":{"a":1,"k":[{"i":{"x":[0.785],"y":[1]},"o":{"x":[1],"y":[0]},"n":["0p785_1_1_0"],"t":17,"s":[14.2],"e":[360]},{"t":50.0000020365418}]},"p":{"a":0,"k":[0,0,0]},"a":{"a":0,"k":[0,0,0]},"s":{"a":0,"k":[100,100,100]}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[54,54]},"p":{"a":0,"k":[0,0]},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse"},{"ty":"st","c":{"a":0,"k":[0.847,0.847,0.847,1]},"o":{"a":0,"k":100},"w":{"a":0,"k":6},"lc":2,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke"},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"mn":"ADBE Vector Group"},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":42,"s":[0],"e":[1]},{"t":44.0000017921567}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p833_1_0p333_0"],"t":20,"s":[0],"e":[1]},{"t":44.0000017921567}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim"}],"ip":17.0000006924242,"op":44.0000017921567,"st":-1.00000004073083,"bm":0,"sr":1},{"ddd":0,"ind":3,"ty":4,"nm":"flamingo ring 2","parent":1,"ks":{"o":{"a":0,"k":100},"r":{"a":1,"k":[{"i":{"x":[0.612],"y":[1]},"o":{"x":[1],"y":[0]},"n":["0p612_1_1_0"],"t":17,"s":[14.2],"e":[360]},{"t":50.0000020365418}]},"p":{"a":0,"k":[0,0,0]},"a":{"a":0,"k":[0,0,0]},"s":{"a":0,"k":[100,100,100]}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[54,54]},"p":{"a":0,"k":[0,0]},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse"},{"ty":"st","c":{"a":0,"k":[0.847,0.847,0.847,1]},"o":{"a":0,"k":100},"w":{"a":0,"k":6},"lc":2,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke"},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"mn":"ADBE Vector Group"},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":42,"s":[0],"e":[13.7]},{"t":44.0000017921567}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p833_1_0p333_0"],"t":20,"s":[0],"e":[13.7]},{"t":44.0000017921567}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim"}],"ip":17.0000006924242,"op":44.0000017921567,"st":-1.00000004073083,"bm":0,"sr":1},{"ddd":0,"ind":4,"ty":4,"nm":"flaming ring 1","parent":1,"ks":{"o":{"a":0,"k":100},"r":{"a":0,"k":0},"p":{"a":0,"k":[0,0,0]},"a":{"a":0,"k":[0,0,0]},"s":{"a":0,"k":[100,100,100]}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[54,54]},"p":{"a":0,"k":[0,0]},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse"},{"ty":"st","c":{"a":0,"k":[0.847,0.847,0.847,1]},"o":{"a":0,"k":100},"w":{"a":0,"k":6},"lc":2,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke"},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"mn":"ADBE Vector Group"},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"n":["0p667_1_1_0"],"t":8,"s":[0],"e":[100]},{"t":48.0000019550801}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"n":["0p667_1_1_0"],"t":-1,"s":[0],"e":[100]},{"t":37.0000015070409}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim"}],"ip":15.0000006109625,"op":44.0000017921567,"st":-1.00000004073083,"bm":0,"sr":1}]};
CINC = (typeof CINC === 'undefined' ? {} : CINC);

CINC.Shared = {};

(function () {

    $(document).ready(function () {
        CINC.LocalGMT = new Date().getTimezoneOffset() / 60.0 * -1; //convert JS's backwards offset to ISO standard

        SetLanguageCookie();
        InitLingo();
        // pass all paste events as key up
        $(':text, textarea').on('paste', function () {
            $(this).trigger('keyup');
        });
    });

    var SetLanguageCookie = function () {
        if (!CINC.QS) return;

        var lang = CINC.QS.lang;
        if (!lang) return;

        var date = new Date();

        if (lang != 'english')
            date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000)); // a week?

        $.removeCookie("lang");
        $.cookie("lang", lang, { expires: date, domain: '.' + CINC.Site.DomainName, path: '/', secure: true });
    };

    var InitLingo = function () {
        var secLev = 0;
        if (CINC.User)
            secLev = CINC.User.securityLevel || CINC.User.SecurityLevel;

        if (secLev != 25) return;

        $('[data-lingo=1]').css('cursor', 'help').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var text = encodeURIComponent($(this).html());
            if (!text) text = $(this).val();
            var lingolang = encodeURIComponent($(this).data('lingolang') || 'none');
            window.open('/dashboard/settings/advanced/translations/?language=' + $.cookie('lang') + '&transid=' + text + '&translang=' + lingolang, '_blank');
        });
    };

    var InitWYSIWYG = CINC.Shared.InitWYSIWYG = function (options) {
        $('.js-wysiwyg').each(function () {
            CreateWYSIWYG($(this), options);
            $(this).removeClass('js-wysiwyg');
        });
    };

    var CreateWYSIWYG = CINC.Shared.CreateWYSIWYG = function (textarea, options) {
        options = options || {};
        var setup = options.setup;
        if ($(textarea).data('enforcehttp') === true) {
            options.ensureProtocolInUrl = true;
        }
        if ($(textarea).data('bodyclass')) {
            options.bodyClass = $(textarea).data('bodyclass');
        }
        if ($(textarea).data('hidden')) {
            options.hidden = JSON.parse($(textarea).data('hidden').toLowerCase());
        }
        if ($(textarea).data('placeholder')) {
            options.placeholder = $(textarea).data('placeholder');
        }

        var toolbar = 'undo redo | blocks | bold italic fontsize | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent link image media code';
        if ($(textarea).data('removetoolbaritems')) {
            var toolbarItems = toolbar.split(' ');
            var removeItems = $(textarea).data('removetoolbaritems').split(',');

            for (var i = 0; i < removeItems.length; i++) {
                var removeIndex = toolbarItems.indexOf(removeItems[i]);
                toolbarItems.splice(removeIndex, 1);
            }

            toolbar = toolbarItems.join(' ');
        }
        if ($(textarea).data('toolbar-items')) {
            toolbar = $(textarea).data('toolbar-items');
        }

        var css = $(textarea).data('css');

        tinyMCE.baseURL = window.document.baseURI + 'Content/build';

        //  The mceFocus command is the documented way to set focus to an MCE editor, and it works great the first call.
        //  It will scroll the editor into view and set the foucs into the editor so the user can just start typing.
        //  However, it only works completely properly the first time.  On subsequent calls it still sets the focus
        //  into the editor (so the user can immediately start typing), but it will not scroll the editor into view!
        //  Accessing the editorContainer element and calling focus() on it scrolls it into view.
        //  Then we call the mceFocus command to set the focus into the editor for immediate typing.
        if (typeof tinyMCE.setFocus != "function") {
            tinyMCE["setFocus"] = function (textareaId) {
                tinyMCE.get(textareaId).editorContainer.focus(); // Hack for subsequent calls to scroll editor into view.
                tinyMCE.execCommand('mceFocus', false, textareaId);
            };
        }

        if (typeof tinyMCE.isElementTinyMCE != "function") {
            tinyMCE["isElementTinyMCE"] = function (element) {
                if (!(element.id && element.tagName.toLowerCase() === 'textarea')) {
                    return false;
                }

                return tinyMCE.editors.some(function(e) { return e.id === element.id; });
            };
        }
        
        // Define a whitelist for custom elements
        const customValidElementsWhitelist = [
          'fello-home-sale-calculator-widget[widget-id|style]',
          'fello-mortgage-calculator-widget[widget-id|style]',
          'fello-affordability-calculator-widget[widget-id|style]'
        ];

        tinymce.init({
            selector: options.selectorText || "#" + textarea[0].id,
            baseURL: window.document.baseURI + 'Content/build',
            license_key: 'gpl',
            height: '350px',
            branding: false,
            plugins: 'link image media code advlist lists',
            menubar: false,
            toolbar: [toolbar],
            font_size_formats: "8.5pt 10pt 12pt 14pt 18pt 24pt 32pt 36pt",
            browser_spellcheck: true,
            contextmenu: false,
            sandbox_iframes: false,
            file_picker_callback: function (callback) {
                if (CINC.Dashboard.OpenUploadModal) {
                    CINC.Dashboard.OpenUploadModal(function (file) {
                        callback(file.FullURL, { title: file.OrigFileName });
                    });
                }
                else {
                    CINC.Dashboard.openGallery('', function (origFileName, fileURL, fileCat, fileDID) {
                        var file = { OrigFileName: origFileName, FullURL: fileURL, FileDID: fileDID, Category: fileCat };
                        callback(file.FullURL, { title: file.OrigFileName });
                    }, function () { });
                }
            },
            force_br_newlines: true,
            forced_root_block: 'div',
            convert_newlines_to_brs: false,
            image_advtab: true,
            convert_urls: false,
            relative_urls: false,
            remove_script_host: false,
            statusbar: false,
            placeholder: options.placeholder,
            extended_valid_elements: (options.allowScriptTag ? 'script[src|async|defer|type|charset],' : '') +
                customValidElementsWhitelist.join(','),
            setup: function (editor) {
                editor.on('init', function (e) {
                    if (options.showActiveEditor) {
                        tinymce.activeEditor.show();
                    }
                    if (options.activeContent && options.activeContent.length > 0) {
                        tinymce.activeEditor.setContent(options.activeContent)
                    }
                })
                if (options.placeholder) {
                    // A bulk clear (select-all + delete) can leave the editor in a state its own
                    // placeholder check doesn't immediately recognize as empty. Re-checking on blur
                    // guarantees the placeholder is visible once the user steps away from an empty field.
                    editor.on('blur', function () {
                        editor.fire('NodeChange');
                    });
                }
            }
        });
    };

    var getEmojiHTML = function (filterText, emojis) {
        // compile
        var emojiHtml = '<div id="mce-emoji-wrapper" class="cinc-plugin-wrapper">'
            + '{{#each this}}<a class="cinc-emoji" title="{{description}}">\{{value}}</a>{{/each}}'
            + '</div>';
        var emojiTemplate = Handlebars.compile(emojiHtml);
        var noEmojisHtml = '<div id="mce-emoji-wrapper" class="cinc-plugin-wrapper">'
            + '<span>No Emojis to display'
            + '</div>';

        // filter
        if (filterText) {
            filterText = filterText.toLowerCase();
            emojis = _.filter(emojis, function (emoji) {
                return emoji.description.toLowerCase().indexOf(filterText) >= 0;
            });
        }

        // return the html
        if (emojis && emojis.length > 0) {
            return emojiTemplate(emojis);
        }
        else {
            return noEmojisHtml;
        }
    };

    var getDynamicTagsHTML = function (filterText, dynamicTags, id) {
        // compile
        var dynamicTagHtml = '<div id="' + id + '" class="cinc-plugin-wrapper">'
            + '{{#each this}}<a class="cinc-dynamic-tag" title="{{description}}">\{{value}}</a>{{/each}}'
            + '</div>';
        var dynamicTagTemplate = Handlebars.compile(dynamicTagHtml);
        var noDynamicTagsHtml = '<div id="' + id + '" class="cinc-plugin-wrapper">'
            + '<span>No Tags to display'
            + '</div>';

        // filter
        if (filterText) {
            filterText = filterText.toLowerCase();
            dynamicTags = _.filter(dynamicTags, function (tag) {
                return tag.description.toLowerCase().indexOf(filterText) >= 0;
            });
        }

        // return the html
        if (dynamicTags && dynamicTags.length > 0) {
            return dynamicTagTemplate(dynamicTags);
        }
        else {
            return noDynamicTagsHtml;
        }
    };

    var getAttachedPropHTML = CINC.Shared.GetAttachedPropHTML = function (attachedProps, attachedPropsTemplate) {
        // compile
        var attachedPropTemplate = Handlebars.compile(attachedPropsTemplate);

        // return the html
        if (attachedProps && attachedProps.length > 0) {
            var json = {
                props: attachedProps.toJSON()
            };
            return attachedPropTemplate(json);
        }
        else {
            return '';
        }
    };

    var ExcludedSearchTags = CINC.Shared.ExcludedSearchTags = ["ignoreblacklist", "photos", "whitefeatured"];

    if (!String.prototype.includes)
    {
        String.prototype.includes = function (val, find) {
            return val.indexOf(find) > -1;
        };
    }

    var hideOtherSpaAppRegions = CINC.Shared.HideOtherSpaAppRegions = function (appRegionToShow, options) {
        options = options || {};
        var list = Backbone.Radio.channel("listingdetails");
        var lead = Backbone.Radio.channel("leaddetails");
        var wiz = Backbone.Radio.channel("wizard");
        
        if (!options.keepWizardAlive) {
            wiz.request("close");
        }

        if (options.isFullScreen === true) {
            $('.js-fullscreenhide').toggleClass('hidden', true);
            $('.contextual-container').toggleClass('full-screen-app', true);
        }
        else {
            $('.js-fullscreenhide').toggleClass('hidden', false);
            $('.contextual-container').toggleClass('full-screen-app', false);
        }

        //dismiss the listing details if we're leaving the properties app
        if (appRegionToShow.indexOf("properties") === -1 || options.forceCloseListingDetails === true) {
            list.request("close");
        }

        //dismiss the lead details if we're leaving the leads app
        if (appRegionToShow.indexOf('leads') === -1 /*&& appRegionToShow.indexOf('launchpad') === -1*/) {
            lead.request("close");
        }

        $(".spa-app").hide();
        $(".spa-leftnav").hide();
        $(".spa-centernav").hide();
        $(".spa-sidebar").addClass("hidden");
        $(".spa-sidebar-header").removeClass("active");
        $(appRegionToShow + "-sidebar-header").addClass("active");
        $(appRegionToShow + "-sidebar").removeClass("hidden");
        $(appRegionToShow + "-leftnav").show();
        $(appRegionToShow + "-centernav").show();
        $(appRegionToShow).show();
    };

    $(".js-build-lock-btn, .js-build-unlock-btn").on("click", function(e) {
        var jobName = $(this).data("build-job-name");
        var jobAction = $(this).data("build-job-action");
        var url = "/api/builds/" + jobAction + "?jobName=" + jobName;
        $.get(url, function(){
            $(".js-build-lock-btn").toggle();
            $(".js-build-unlock-btn").toggle();
        });
    });

    var addWindowLoadEvent = function(func) {
        var oldonload = window.onload;
        if (typeof window.onload !== 'function' && typeof func === 'function') {
            window.onload = func;
        }
        else {
            window.onload = function() {
                if (oldonload) {
                    oldonload();
                }
                if (func && typeof func === 'function') {
                    func();
                }
            };
        }
    };

    addWindowLoadEvent(function () {
        //support for older browsers to load images when page is first loaded
        if (!("IntersectionObserver" in window)) {
            var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
            lazyImages.forEach(function (lazyImage) {
                if (lazyImage.getBoundingClientRect().top <= window.innerHeight) {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                }
            });
        }
    });

    document.addEventListener("DOMContentLoaded", FireLazyLoad);

    function FireLazyLoad() {
        //lazy image loading for modern browsers
        var config = {
            rootMargin: '0px 0px 50px 0px',
            threshold: 0
        };

        if ("IntersectionObserver" in window) {
            var lazyImages1 = [].slice.call(document.querySelectorAll('img.lazy'));
            var lazyImageObserver = new IntersectionObserver(function(entries){
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        var lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            }, config);

            lazyImages1.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            //lazy image loading for ancient browsers (IE, Safari)
            var active = false;
            var lazyImages2 = [].slice.call(document.querySelectorAll('img.lazy'));
            var lazyLoad = function () {
                if (active === false) {
                    active = true;

                    setTimeout(function () {
                        lazyImages2.forEach(function (lazyImage) {
                            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                                lazyImage.getBoundingClientRect().bottom >= 0) &&
                                window.getComputedStyle(lazyImage).display !== "none") {
                                lazyImage.src = lazyImage.dataset.src;
                                lazyImage.classList.remove("lazy");

                                lazyImages2 = lazyImages2.filter(function (image) {
                                    return image !== lazyImage;
                                });

                                if (lazyImages2.length === 0) {
                                    document.removeEventListener("scroll", lazyLoad);
                                    window.removeEventListener("resize", lazyLoad);
                                    window.removeEventListener("orientationchange", lazyLoad);
                                }
                            }
                        });
                        active = false;
                    },200);
                }
            };
            document.addEventListener("scroll", lazyLoad);
            window.addEventListener("resize", lazyLoad);
            window.addEventListener("orientationchange", lazyLoad);
        }
    }

}());
CINC = (typeof CINC === 'undefined' ? {} : CINC);

(function () {

    CINC.Core = {
        el: {},
        g: {},
        Okta: function (redirecturl) {
            var redirecturl = encodeURIComponent(redirecturl || window.location.href);
                window.location = window.location.origin + "/account/login/admin?redirecturl=" + redirecturl;
        },
        LoadActionHandlers: {
            NotificationBanner: function (payload) {
                Notification.Banner[payload.type](payload.message, payload.title);
            }
        },
        LocalStorage: {
            IsAvailable: (typeof (Storage) !== 'undefined'),
            Get: function (key) {
                if (!CINC.Core.LocalStorage.IsAvailable) return undefined;
                var value = localStorage.getItem(key.toLowerCase());
                if (!value) return undefined;
                if (value[0] === '{' || value[0] === '[') {
                    try {
                        return JSON.parse(value);
                    } catch (e) { }
                }

                return value;
            },
            Set: function (key, value) {
                if (!CINC.Core.LocalStorage.IsAvailable) return;
                if (typeof value === 'object')
                    value = JSON.stringify(value);
                return localStorage.setItem(key.toLowerCase(), value);
            },
            Remove: function (key) {
                if (!CINC.Core.LocalStorage.IsAvailable) return;
                return localStorage.removeItem(key.toLowerCase());
            },
        },
        Cookies: {
            Get: function (key) {
                var value = $.cookie(key.toLowerCase());
                if (value === undefined)
                    return '';
                return value;
            },
            Set: function (key, value, expireDays) {
                var parms = {
                    domain: '.' + CINC.Site.DomainName,
                    expires: expireDays || 30,
                    path: '/'
                };
                $.cookie(key.toLowerCase(), value, parms);
            },
            Remove: function (key) {
                CINC.Core.Cookies.Set(key.toLowerCase(), '', -1);
            }
        },
        CookiesVanilla: {
            Get: function (cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            Set: function (cname, cvalue, exdays) {
                // if exdays is not a valid date format, the cookie will be set to expire with the session
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            Remove: function (key) {
                CINC.Core.CookiesVanilla.Set(key, '');
            }
        },

       IsBot: function () {
            return /nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver|bingbot|Google Web Preview|Mediapartners-Google|AdsBot-Google|Baiduspider|Ezooms|YahooSeeker|AltaVista|AVSearch|Mercator|Scooter|InfoSeek|Ultraseek|Lycos|Wget|YandexBot|Yandex|YaDirectFetcher|SiteBot|Exabot|AhrefsBot|MJ12bot|TurnitinBot|magpie-crawler|Nutch Crawler|CMS Crawler|rogerbot|Domnutch|ssearch_bot|XoviBot|netseer|digincore|fr-crawler|wesee|AliasIO/i.test(navigator.userAgent);
        },
        IsMobile: function () {
            return ($(window).width() < 770);
        },
        QueryString: function () {
            // make sure underscore is loaded
            if (typeof _ !== 'function') {
                return {};
            }

            return {
                // The functions ripped from https://github.com/sindresorhus/query-string/blob/master/index.js
                parse: function (str) {
                    if (!_.isString('str')) {
                        return {};
                    }

                    str = decodeURIComponent(str);

                    str = str.trim().replace(/^(\?|#|&)/, '');

                    if (!str) {
                        return {};
                    }

                    return _.reduce(str.split('&'), function (ret, param) {
                        var parts = param.replace(/\+/g, ' ').split('=');
                        var key = parts[0];
                        var val = parts[1];

                        key = decodeURIComponent(key);

                        // missing `=` should be `null`:
                        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
                        val = val === undefined ? null : decodeURIComponent(val);

                        if (!ret.hasOwnProperty(key)) {
                            ret[key] = val;
                        } else if (_.isArray(ret[key])) {
                            ret[key].push(val);
                        } else {
                            ret[key] = [ret[key], val];
                        }

                        return ret;
                    }, {});
                },
                stringify: function (obj) {
                    if (!obj) {
                        return '';
                    }

                    return _.filter(_.map(_.keys(obj).sort(), function (key) {
                        var val = obj[key];

                        if (_.isArray(val)) {
                            return val.sort().map(function (val2) {
                                return encodeURI(key) + '=' + encodeURIComponent(val2);
                            }).join('&');
                        }

                        return encodeURI(key) + '=' + encodeURIComponent(val);
                    }), function (x) {
                        return x.length > 0;
                    }).join('&');
                },
                remove: function (keyArray) {
                    var qs = CINC.Core.QueryString.parse(window.location.search);
                    for (var i = 0; i < keyArray.length; i++)
                        delete qs[keyArray[i]];

                    return CINC.Core.QueryString.stringify(qs);
                }
            };
        }(),
        EndBecomeUser: function () {
            var $trigger = $(this);
            if (!$trigger.hasClass('loading')) {
                $trigger.addClass('loading');
                $.ajax({
                    url: window.location.origin + '/api/account/become',
                    type: 'DELETE',
                    xhrFields: { withCredentials: true }
                }).done(function () {
                    var callbackUrl = $trigger.attr('data-callbackurl');
                    if (callbackUrl.length > 0) {
                        window.location.href = callbackUrl;
                    }
                    else {
                        window.location.reload();
                    }
                }).fail(function () {
                    alert('Error ending become user!');
                });
            }
        },
        GoToCorefact: function () {
            var ajx = CINC.Api.Dashboard.Settings.Corefact('getauthurl');
            ajx.get({})
                .success(function (response) {
                    if (response.ssoUrl) {
                        window.open(response.ssoUrl, '_blank');
                    }
                }).fail(CINC.Dashboard.ShowError);
        },
        GetXPath: function (element) {
            if (!element) return '';
            if (typeof element === 'string') element = $(element);
            if (element instanceof jQuery) {
                if (element.length === 0) return '';
                element = element[0];
            }

            if (element && element.id)
                return '//*[@id="' + element.id + '"]';
            else {
                var paths = [];  // Use nodeName (instead of localName) 
                var idFound = false;

                for (; element && element.nodeType == Node.ELEMENT_NODE && !idFound; element = element.parentNode) {
                    var index = 0;
                    var hasFollowingSiblings = false;
                    for (var sibling = element.previousSibling; sibling; sibling = sibling.previousSibling) {
                        // Ignore document type declaration.
                        if (sibling.nodeType == Node.DOCUMENT_TYPE_NODE)
                            continue;

                        if (sibling.nodeName == element.nodeName)
                            ++index;
                    }

                    for (var sibling = element.nextSibling; sibling && !hasFollowingSiblings; sibling = sibling.nextSibling) {
                        if (sibling.nodeName == element.nodeName)
                            hasFollowingSiblings = true;
                    }

                    var tagName = (element.prefix ? element.prefix + ":" : "") + element.localName;
                    var pathIndex = (index || hasFollowingSiblings ? "[" + (index + 1) + "]" : "");
                    if (element.id) {
                        tagName = '/*[@id="' + element.id + '"]';
                        pathIndex = "";
                        idFound = true;
                    }
                    paths.splice(0, 0, tagName + pathIndex);
                }

                return paths.length ? "/" + paths.join("/") : null;
            }
        },
        GetElementByXPath: function (xpath, context) {
            if (!xpath) return null;

            var doc = (context && context.ownerDocument) || window.document;
            var result = doc.evaluate(xpath, context || doc, null, XPathResult.ANY_TYPE, null);
            switch (result.resultType) {
                case XPathResult.NUMBER_TYPE:
                    return result.numberValue;
                case XPathResult.STRING_TYPE:
                    return result.stringValue;
                case XPathResult.BOOLEAN_TYPE:
                    return result.booleanValue;
                default:
                    var nodes = [];
                    var node;
                    while (node = result.iterateNext())
                        nodes.push(node);
                    return nodes;
            }
        }
    };

    CINC.QS = CINC.Core.QueryString.parse(window.location.search);
	
    $(document).ready(function () {
        $('body').on('click', '.js-endbecomeuser', CINC.Core.EndBecomeUser);
        $('body').on('click', '.js-corefact-button', CINC.Core.GoToCorefact);
    });

}());

$.fn.serializeObject = function (includeEmpty) {
    includeEmpty = (typeof includeEmpty !== 'undefined' ? includeEmpty : false);
    var o = {};
    var a = this.serializeArray();
    var val;
    $.each(a, function () {
        if (o[this.name]) {
            if (this.name !== 'beds' && this.name !== 'maxprice' && this.name !== 'minprice' && this.name !== 'baths') {
                o[this.name] += ',' + (this.value || '');
            }
        } else if (this.value !== '') {
            o[this.name] = this.value || '';
        } else if (includeEmpty) {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

$.fn.serializeCompositionObject = function () {
    var o = {};
    this.find(':input:disabled').removeAttr('disabled'); // preserve disabled inputs to preserve the integrity of the form model
    var a = this.serializeArray();
    var arrayNotation = /^([^\[\]]+)\[(\d+)\]$/;

    $.each(a, function () {
        var name = this.name;
        var value = this.value;

        // let's also allow for "dot notation" in the input names
        var props = name.split('.');
        var position = o;
        while (props.length) {
            var key = props.shift();
            var matches = arrayNotation.exec(key);   // is it an array property
            if (matches) {
                var p = matches[1];
                var n = matches[2];

                if (!position[p]) {
                    position[p] = [];
                }

                if (!position[p][n]) {
                     position[p][n] = {};
                }

                position = position[p][n];
            } else {
                if (!props.length) {
                    if (!position[key]) {
                         position[key] = value || '';
                    } else if (position[key]) {

                        if (!position[key].push) {
                             position[key] = [position[key]];
                        }

                        position[key].push(value || '');
                    }
                } else {

                    if (!position[key]) {
                        position[key] = {};
                    }
                    position = position[key];
                }
            }
        }
    });

    return o;
};

$.fn.scrollTo = function (target, options, callback) {
    if (typeof options == 'function' && arguments.length == 2) { callback = options; options = target; }
    var settings = $.extend({
        scrollTarget: target,
        offsetTop: 50,
        duration: 500,
        easing: 'swing'
    }, options);
    return this.each(function () {
        var scrollPane = $(this);
        var scrollTarget = (typeof settings.scrollTarget == "number") ? settings.scrollTarget : $(settings.scrollTarget);
        var scrollY = (typeof scrollTarget == "number") ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
        scrollPane.animate({ scrollTop: scrollY }, parseInt(settings.duration), settings.easing, function () {
            if (typeof callback == 'function') { callback.call(this); }
        });
    });
};

$.fn.copyNamedInputsTo = function(other) {
    return this.each(function() {
        $(':input[name]', this)
            .each(function() {
                $('[name=' + $(this).attr('name') + ']', other).val($(this).val());
            });
    });
};

$.fn.reverse = [].reverse;

CINC.GetSubdomain = function () {
    var subdomain = window.location.href.split("/")[2].split(".")[0];
    return subdomain === 'www' ? '' : subdomain;
};

CINC.GetAgentSubdomain = function () {
    if (CINC.User
        && CINC.User.securityLevel.between(10, 15)
        && (
            CINC.User.subdomain
            || CINC.User.firstName
        )
    ) {
        return CINC.User.subdomain
            ? CINC.User.subdomain
            : CINC.User.firstName;
    }
    return false;
}

CINC.GetFunctionFromString = function (value) {
    if (value) {
        var split = value.split('.'),
            splitLength = split.length,
            i = 1,
            exists = true,
            obj = window[split[0]];
        while (i < splitLength && exists) {
            if (obj) {
                obj = obj[split[i]];
                i += 1;
            }
            else
                exists = false;
        }
        if (exists && typeof obj === 'function')
            return obj;
        else
            console.log('CINC.Core.getFunction - could not derive function from "{0}".'.format(value));
    }
    return false;
};

CINC.IsNullOrEmpty = function (value) {
    return (value === undefined || value === null || value.trim() === "");
};

CINC.keysToLowerCase = function(obj) {
    if (!typeof (obj) === "object" || typeof (obj) === "string" || typeof (obj) === "number" || typeof (obj) === "boolean") {
        return obj;
    }
    var keys = Object.keys(obj);
    var n = keys.length;
    var lowKey;
    while (n--) {
        var key = keys[n];
        if (key === (lowKey = key.toLowerCase()))
            continue;
        obj[lowKey] = CINC.keysToLowerCase(obj[key]);
        delete obj[key];
    }
    return (obj);
};

CINC.ImageUrlFromFilename = function (imageDirectory, filename) {
    return CINC.BaseImageUrlTemplate.format(imageDirectory, filename);
};

CINC.currentTimezone = function() {
    return moment().format('ZZ').replace(/[0]/g,'');
}

//Authorization popup window code
CINC.OAuthPopup = function (options) {
    options.windowName = options.windowName || 'ConnectWithOAuth'; // should not include space for IE
    options.windowOptions = options.windowOptions || 'location=0,status=0,width=800,height=400';
    options.callback = options.callback || function () { window.location.reload(); };
    var self = this;
    self._oauthWindow = window.open(options.path, options.windowName, options.windowOptions);
    self._oauthInterval = window.setInterval(function () {
        if (self._oauthWindow.closed) {
            window.clearInterval(self._oauthInterval);
            options.callback();
        }
    }, 1000);
};

CINC.IsNonDismissableModal = false;

CINC = (typeof CINC === 'undefined' ? {} : CINC);

(function (CINC) {

    CINC.AjaxRequests = {};

    CINC.Api = {
        Root: function (subRoute, unique) { return new AjaxApi('/api', subRoute, unique); },
        CDN: {
            Static: function (subRoute) { return new AjaxApi('//s-static.cinccdn.com/', subRoute, false); },
            Uni: function (subRoute) { return new AjaxApi("//uni.cinccdn.com/", subRoute, false); }
        },
        Account: function (subRoute) { return new AjaxApi('/api/account', subRoute, false); },
        AccountSocialSign: function (subRoute) { return new AjaxApi('/api/account/social', subRoute, false); },
        Become: function (unique) { return new AjaxApi('/api/account/become', '', unique); },
        Photo: function (subRoute) { return new AjaxApi('/api/photo', subRoute, false) },
        ConsumerAccount: function (subRoute) { return new AjaxApi('/api/consumer/account', subRoute, false); },
        ContactInfo: {
            Email: function (email) { return new AjaxApi('/api/contactinfo/validate/email/' + email, '', false) },
            Phone: function (phone) { return new AjaxApi('/api/contactinfo/validate/phone/' + phone, '', false) }
        },
        ConsumerLead: function (subRoute) { return new AjaxApi('/api/consumer/lead', subRoute, false); },
        ConsumerProperty: {
            ForceABTest: function () { return new AjaxApi('/api/consumer/abtest/forcepdq') },
            RecordABTestEvent: function (eventKey) { return new AjaxApi('/api/consumer/abtest/trackevent/' + eventKey) }
        },
        Details: function (pdid, unique) { return new AjaxApi('/api/details/' + pdid, '', unique); },
        EmailIntegration: function (subRoute) { return new AjaxApi("/api/dashboard/emailintegration", subRoute); },
        Guide: function (id, unique) { return new AjaxApi('/api/guide/' + id, '', unique); },
        LegalAgreement: function () { return new AjaxApi('/api/lead/legal/agreed', '', false); },
        Organizer: {
            Root: function (subRoute) { return new AjaxApi('/api/organizer', subRoute, true); },
            Headers: function () { return new AjaxApi('/api/organizer/headers', '', true); },
            Focus: function (organizerdid) { return new AjaxApi('/api/organizer/focus', organizerdid, true); },
            Share: function (subRoute) { return new AjaxApi('/api/organizer/share', subRoute, false); },
            Schedule: function (subRoute) { return new AjaxApi('/api/organizer/schedule', subRoute, false); },
            Favorite: function (subRoute) { return new AjaxApi('/api/organizer/favorite', subRoute, false); },
            Opinion: function (subRoute) { return new AjaxApi('/api/organizer/opinion', subRoute, false); },
            Note: function (subRoute) { return new AjaxApi('/api/organizer/note', subRoute, false); },
            Searches: function (subRoute) { return new AjaxApi('/api/organizer/searches', subRoute, false); },
            Team: function (subRoute) { return new AjaxApi('/api/organizer/team', subRoute, false); },
            Ajax: function (subRoute) { return new AjaxApi('/ajax/organizer', subRoute, true); }
        },
        School: function (id, unique) { return new AjaxApi('/api/school', id, unique) },
        Search: {
            // for Autocomplete searches, trim whitespace & periods from word and suffix '/' to allow Web API to correct handle text with periods
            Autocomplete: function (inputName, word, unique) { return new AjaxApi('/api/search/autocomplete/' + inputName, word.replace(/^[.\s]+|[.\s]+$/gm,'') + '/', unique); }, 
            AutocompleteHtml: function (inputName, word, unique) { return new AjaxApi('/ajax/search/autocomplete/' + inputName, word.replace(/^[.\s]+|[.\s]+$/gm,'') + '/', unique); },
            OptionsHtml: function (inputName, unique) { return new AjaxApi('/ajax/search/options/' + inputName, unique); },
            Default: function (unique) { return new AjaxApi("/api/search", '', unique); },
            Html: function (unique) { return new AjaxApi('/ajax/search', '', unique); },
            Quick: function (unique) { return new AjaxApi('/ajax/search/quick', '', unique); },
            Map: function (unique) { return new AjaxApi('/ajax/search/map', '', unique); },
            PDIDs: function () { return new AjaxApi('/api/search/pdids', '', false); },
            Result: function (pdid, unique) { return new AjaxApi('/ajax/search/result', pdid, unique); },
            Split: function (unique) { return new AjaxApi('/ajax/search/split', '', unique); },
            Text: function (unique) { return new AjaxApi('/api/dashboard/propertysearch/fts', '', unique); },
            SavePdq: function (unique) { return new AjaxApi('/api/search/savepdq', '', unique); }
        },
        Style: {
            ColorPalette: function(unique) { return new AjaxApi('api/castle/styles/colorpalette', '', unique) },
            FontPack: function (unique) { return new AjaxApi('api/castle/styles/fontpack', '', unique) },
            HomeCover: function (unique) { return new AjaxApi('api/castle/styles/homecover', '', unique) }
        },
        Dashboard: {},
        BackOffice: {
            Search: function (unique) { return new AjaxApi('/api/backoffice/backoffice/search', '', unique); },
            FindMembers: function (unique) { return new AjaxApi('/api/backoffice/backoffice/findmembers', '', unique); },
            Ping: function () { return new AjaxApi('/api/backoffice/backoffice/ping', '', false); },
            LaunchStats: function (unique) { return new AjaxApi('/api/backoffice/backoffice/launchstats', '', unique); },
            SetupStats: function (unique) { return new AjaxApi('/api/backoffice/backoffice/setupstats', '', unique); },
            NPSScores: function (unique) { return new AjaxApi('/api/backoffice/backoffice/npsscores', '', unique); },
            ChurnStats: function (unique) { return new AjaxApi('/api/backoffice/backoffice/churnstats', '', unique); },
            KensingtonElement: function (unique) { return new AjaxApi('/api/backoffice/backoffice/kensingtonelement', '', unique); },
            Churn: {
                MinSecLevel: function (unique) { return new AjaxApi('/api/backoffice/churn/minseclevel', '', unique); },
                OffboardingDetails: function () { return new AjaxApi('/api/backoffice/churn/offboardingdetails', '', false); },
                OffboardingRequest: function () { return new AjaxApi('/api/backoffice/churn/offboardingrequest', '', false); },
                QuitRequest: function (mdid, unique) { return new AjaxApi('/api/backoffice/churn/quitrequest/' + mdid, '', unique); },
                QuitReason: function (mdid, unique) { return new AjaxApi('/api/backoffice/churn/quitreason/' + mdid, '', unique); },
                PlatformLocks: function (unique) { return new AjaxApi('/api/backoffice/churn/platformlock', '', unique); },
                PlatformSaveStatus: function (unique) { return new AjaxApi('/api/backoffice/churn/platformsavestatus', '', unique); },
                PauseMarketing: function (unique) { return new AjaxApi('/api/backoffice/churn/pausemarketing', '', unique); },
                RestoreDomain: function (unique) { return new AjaxApi('/api/backoffice/churn/restoredomain', '', unique); }
            },
        },
        Chat: {
            SendMessage: function (unique) { return new AjaxApi('/api/dashboard/chat/sendmessage'); },
            MarkMessageRead: function (unique) { return new AjaxApi('/api/dashboard/chat/readmessage'); },
            GetMessagesForUsers: function (unique) { return new AjaxApi('/api/dashboard/chat/getchat'); },
        },
        AWSPushNotification: {
            Preview: function (unique) { return new AjaxApi('/api/awspushnotification/preview'); },
            SendPMQMessage: function (unique) { return new AjaxApi('/api/awspushnotification/sendpmqmessage'); },
            SendCustomMessage: function (unique) { return new AjaxApi('/api/awspushnotification/sendcustommessage'); },
        }
    };

    if (CINC.Site && (CINC.Site.DomainName === 'mycinc.com' || CINC.Site.DomainName === 'cincghq.com')) {
        $.extend(CINC.Api.BackOffice, {
            Accounts: {
                MergeImpact: function (unique) { return new AjaxApi('/api/backoffice/accounts/mergeimpact', '', unique); },
                Merge: function (unique) { return new AjaxApi('/api/backoffice/accounts/merge', '', unique); },
                Note: function (unique) { return new AjaxApi('/api/backoffice/accounts/note', '', unique); },
                Link: function (unique) { return new AjaxApi('/api/backoffice/accounts/link', '', unique); },
                VcomRunDay: function (unique) { return new AjaxApi('/api/backoffice/accounts/vcomrunday', '', unique); }
            },
            PPC: {
                UpdatePPCName: function (unique) { return new AjaxApi('/api/backoffice/ppc/updateppcname', '', unique); },
                AutoCompleteGeo: function (unique) { return new AjaxApi('/api/backoffice/ppc/autocompletegeo', '', unique); },
                BatchJobStatus: function (unique) { return new AjaxApi('/api/backoffice/ppc/batchjobstatus', '', unique); },
            },
            Invoice: {
                CreditCard: function (unique) { return new AjaxApi('/api/backoffice/invoice/invoicecreditcard', '', unique); },
                Payment: function (unique) { return new AjaxApi('/api/backoffice/invoice/payment', '', unique); },
                Void: function (unique) { return new AjaxApi('/api/backoffice/invoice/void', '', unique); },
                Dispute: function (unique) { return new AjaxApi('/api/backoffice/invoice/dispute', '', unique); },
                Check: function (unique, transid) { return new AjaxApi('/api/backoffice/invoice/check' + (transid ? '/' + transid : ''), '', unique); },
                Credit: function (unique) { return new AjaxApi('/api/backoffice/invoice/credit', '', unique); },
                ApplyBalance: function (unique, invoiceid) { return new AjaxApi('/api/backoffice/invoice/applybalance/' + invoiceid, '', unique); },
                SaveInvoiceNotes: function (unique) { return new AjaxApi('/api/backoffice/invoice/saveinvoicenotes', '', unique); },
                SaveUnchargeNotes: function (unique) { return new AjaxApi('/api/backoffice/invoice/saveunchargenotes', '', unique); },
                SaveCustomMessage: function (unique) { return new AjaxApi('/api/backoffice/invoice/savecustommessage', '', unique); },
                ReconcileInvoice: function (unique) { return new AjaxApi('/api/backoffice/invoice/reconcileinvoice', '', unique); },
                EmailPreview: function (unique) { return new AjaxApi('/api/backoffice/invoice/emailpreview', '', unique); },
                SendEmail: function (unique) { return new AjaxApi('/api/backoffice/invoice/sendemail', '', unique); },
                ReSendEmail: function (unique) { return new AjaxApi('/api/backoffice/invoice/resendemail', '', unique); },
                SendNextMonthEmail: function (unique) { return new AjaxApi('/api/backoffice/invoice/sendnextmonthemail', '', unique); },
                CorrectInvoice: function (unique) { return new AjaxApi('/api/backoffice/invoice/correctinvoice', '', unique); },
                QueueItem: function (rowid, unique) { return new AjaxApi('/api/backoffice/invoice/queueitem/' + rowid, '', unique); },
                QueueItems: function (invoiceid, unique) { return new AjaxApi('/api/backoffice/invoice/queueitems/' + invoiceid, '', unique); },
                Reassign: function (unique) { return new AjaxApi('/api/backoffice/invoice/reassign', '', unique); },
                Writeoff: function (unique, transid) { return new AjaxApi('/api/backoffice/invoice/writeoff' + (transid ? '/' + transid : ''), '', unique); }
                //Check: function (unique, transid) { return new AjaxApi('/api/backoffice/invoice/check/' + transid, '', unique); },
            },
            Churn: {
                MinSecLevel: function (unique) { return new AjaxApi('/api/backoffice/churn/minseclevel', '', unique); },
                OffboardingDetails: function () { return new AjaxApi('/api/backoffice/churn/offboardingdetails', '', false); },
                OffboardingRequest: function () { return new AjaxApi('/api/backoffice/churn/offboardingrequest', '', false); },
                QuitRequest: function (mdid, unique) { return new AjaxApi('/api/backoffice/churn/quitrequest/' + mdid, '', unique); },
                QuitReason: function (mdid, unique) { return new AjaxApi('/api/backoffice/churn/quitreason/' + mdid, '', unique); },
                PlatformLocks: function (unique) { return new AjaxApi('/api/backoffice/churn/platformlock', '', unique); },
                PlatformSaveStatus: function (unique) { return new AjaxApi('/api/backoffice/churn/platformsavestatus', '', unique); },
                PauseMarketing: function (unique) { return new AjaxApi('/api/backoffice/churn/pausemarketing', '', unique); },
                RestoreDomain: function (unique) { return new AjaxApi('/api/backoffice/churn/restoredomain', '', unique); }
            },
            Platform: {
                SiteData: function (unique) { return new AjaxApi('/api/backoffice/platform/sitedata', '', unique); },
                Members: function (unique) { return new AjaxApi('/api/backoffice/platform/members', '', unique); },
                ProductUsages: function (unique) { return new AjaxApi('/api/backoffice/platform/productusages', '', unique); },
                ProductUsage: function (unique) { return new AjaxApi('/api/backoffice/platform/productusage', '', unique); },
                ChangeDomainName: function (unique) { return new AjaxApi('/api/backoffice/platform/changedomainname', '', unique); }
            },
            ClientServices: {
                MLSParticipants: function (mlsid, unique) { return new AjaxApi('/api/backoffice/clientservices/mlsparticipants/' + mlsid, '', unique); },
                ParticipantName: function (unique) { return new AjaxApi('/api/backoffice/clientservices/participantname', '', unique); },
                MLSReportConfig: function (unique) { return new AjaxApi('/api/backoffice/clientservices/mlsreportconfig', '', unique); },
                LeadFlowStats: function (unique) { return new AjaxApi('/api/backoffice/clientservices/leadflowstats', '', unique); },
                NPSByAgent: function (unique) { return new AjaxApi('/api/backoffice/clientservices/npsbyagent', '', unique); },
                MLSList: function (unique) { return new AjaxApi('/api/backoffice/clientservices/mlslist', '', unique); },
                MLSClients: function (mlsid, unique) { return new AjaxApi('/api/backoffice/clientservices/mlsclients/' + mlsid, '', unique); },
                ReassignClients: function (unique) { return new AjaxApi('/api/backoffice/clientservices/reassignclients', '', unique); }
            },
            HR: {
                Employee: function (unique) { return new AjaxApi('/api/backoffice/hr/employee', '', unique); }
            }
        });

        $.extend(CINC.Api, {
            ClientServices: {
                MLSParticipants: function (mlsid, unique) { return new AjaxApi('/api/backoffice/clientservices/mlsparticipants/' + mlsid, '', unique); },
                ParticipantName: function (unique) { return new AjaxApi('/api/backoffice/clientservices/participantname', '', unique); },
                MLSReportConfig: function (unique) { return new AjaxApi('/api/backoffice/clientservices/mlsreportconfig', '', unique); },
                LeadFlowStats: function (unique) { return new AjaxApi('/api/backoffice/clientservices/leadflowstats', '', unique); },
                NPSByAgent: function (unique) { return new AjaxApi('/api/backoffice/clientservices/npsbyagent', '', unique); },
                MLSList: function (unique) { return new AjaxApi('/api/backoffice/clientservices/mlslist', '', unique); },
                MLSClients: function (mlsid, unique) { return new AjaxApi('/api/backoffice/clientservices/mlsclients/' + mlsid, '', unique); }
            },
            Onboarding: {
                SetStatus: function (unique) { return new AjaxApi('/api/backoffice/onboarding/setstatus', '', unique); },
                DNSRecords: function (unique) { return new AjaxApi('/api/backoffice/onboarding/getdnsrecords', '', unique); },
                OnboardingNote: function (unique) { return new AjaxApi('/api/backoffice/onboarding/addonboardingnote', '', unique); },
                AddLead: function (unique) { return new AjaxApi('/api/backoffice/onboarding/addlead', '', unique); },
                GenerateSetupInvoice: function (unique) { return new AjaxApi('/api/backoffice/onboarding/generatesetupinvoice', '', unique); },
                SendMassAgentWelcomeEmail: function (unique) { return new AjaxApi('/api/backoffice/onboarding/sendmassagentwelcomeemail', '', unique); },
                CheckEmail: function (unique) { return new AjaxApi('/api/backoffice/onboarding/checkemail', '', unique); },
                PartnerAccount: function (unique) { return new AjaxApi('/api/backoffice/onboarding/partneraccount', '', unique); },
                CreatePartnerMembers: function (unique) { return new AjaxApi('/api/backoffice/onboarding/createpartnermembers', '', unique); },
                ResetSteps: function (unique) { return new AjaxApi('/api/backoffice/onboarding/resetsteps', '', unique); },
                SelfServiceEmail: function (unique) { return new AjaxApi('/api/backoffice/onboarding/selfserviceemail', '', unique); },
                LaunchSite: function (unique) { return new AjaxApi('/api/backoffice/onboarding/launchsite', '', unique); },
                ChangeDomainNameAndRegister: function (unique) { return new AjaxApi('/api/backoffice/onboarding/changedomainnameandregister', '', unique); }
            },
            Conference: {
                SyncLeads: function (unique) { return new AjaxApi('/api/backoffice/conference/syncleads', '', unique); },
                ChargeAttendees: function (unique) { return new AjaxApi('/api/backoffice/conference/chargeattendees', '', unique); },
                SetAttendeeStatus: function (unique) { return new AjaxApi('/api/backoffice/conference/setattendeestatus', '', unique); },
                AttendeeComp: function (unique) { return new AjaxApi('/api/backoffice/conference/attendeecomp', '', unique); },
                SiteFeatures: function (unique) { return new AjaxApi('/api/backoffice/conference/sitefeatures', '', unique); }
            },
            Keymaster: {
                Subscription: function (unique) { return new AjaxApi('/api/backoffice/keymaster/subscription', '', unique); }
            },
            CreditCard: {
                Disable: function (unique) { return new AjaxApi('/api/backoffice/creditcard/disable', '', unique); },
                Enable: function (unique) { return new AjaxApi('/api/backoffice/creditcard/enable', '', unique); },
                MakePrimary: function (unique) { return new AjaxApi('/api/backoffice/creditcard/makeprimary', '', unique); },
                Card: function (unique) { return new AjaxApi('/api/backoffice/creditcard/card', '', unique); },
                Cards: function (unique) { return new AjaxApi('/api/backoffice/creditcard/cards', '', unique); },
                Copy: function (unique) { return new AjaxApi('/api/backoffice/creditcard/copycard', '', unique); },
                New: function (unique) { return new AjaxApi('/api/backoffice/creditcard/newcard', '', unique); }
            }
        });
    }
    else {
        $.extend(CINC.Api, {
            Onboarding: {
                LaunchSite: function (unique) { return new AjaxApi('/api/backoffice/onboarding/launchsite', '', unique); },
                SendMassAgentWelcomeEmail: function (unique) { return new AjaxApi('/api/backoffice/onboarding/sendmassagentwelcomeemail', '', unique); },
                ChangeDomainNameAndRegister: function (unique) { return new AjaxApi('/api/backoffice/onboarding/changedomainnameandregister', '', unique); }
            }
        });
    }

    var AjaxApi = function (baseRoute, subRoute, unique) {

        this.unique = (unique || false);
        this.baseRoute = baseRoute;
        this.url = baseRoute + '/' + (subRoute || '');
        var isMyCinc = false;
        if (this.unique) {
            if (CINC.AjaxRequests[this.baseRoute]) {
                for (var i = 0; i < CINC.AjaxRequests[this.baseRoute].length; i++) {
                    CINC.AjaxRequests[this.baseRoute][i].abort();
                }
            }
            else {
                CINC.AjaxRequests[this.baseRoute] = [];
            }
        }

        this.useMyCinc = function () {
            if (!CINC.InDev && !CINC.InStaging) {
                this.url = "https://www.mycinc.com" + this.url;
                isMyCinc = true;
            }
        };

        this.handleReq = function (type, data, rawJson) {
            var options = {
                url: this.url,
                type: type,
                data: data,
            };

            if (isMyCinc) {
                options.headers = { 'gkdid': CINC.User.gkdid };
            }

            if (rawJson) {
                $.extend(options, {
                    processData: false,
                    contentType: 'application/json',
                    data: JSON.stringify(data)
                });
            }

            var req = $.ajax(options);
            if (this.unique) {
                CINC.AjaxRequests[this.baseRoute].push(req);
            }

            req.displayFailures = function (title) {
                req.fail(function (err) {
                    if (CINC && CINC.Dashboard && CINC.Dashboard.ShowError) {
                        CINC.Dashboard.ShowError(err, title);
                        return;
                    }

                    console.error(err); // leave this here
                    var text = (typeof err === 'string') ? err : err.responseText || err.statusText;
                    if (err.responseJSON && err.responseJSON.message) text = err.responseJSON.message;
                    Notification.Banner.Error(text, title);
                });

                return req;
            };

            if (this.laddaElement) {
                var el = this.laddaElement;
                if ($(el).is('form')) {
                    el = $(el).find('button[type="submit"]');
                }

                if ($(el).is('button')) {
                    var ladda = Ladda.create(el[0]).start();

                    req.always(function () {
                        ladda.stop();
                    });
                }
            }

            return req;
        };

        this.ladda = function (el) {
            this.laddaElement = el;
            return this;
        };

        this.get = function (data) {
            return this.handleReq('GET', data, false);
        };

        this.post = function (data) {
            return this.handleReq('POST', data, true);
        };

        this.patch = function (data) {
            return this.handleReq('PATCH', data, true);
        };

        this.put = function (data) {
            return this.handleReq('PUT', data, true);
        };

        this.del = function (data) {
            return this.handleReq('DELETE', data, true);
        };

    };

    CINC.AjaxApi = AjaxApi;

})(CINC);

(function (CINC) {
    /**
     * List of Enums for type of Notifications for SignalR
     */
    const notificationTypeEnum = {
        PLIPBATCHSTATUSUPDATE: 'plipbatchstatusupdate',
        MASSACTION: 'massaction',
        LISTINGGENERATED: 'listinggenerated',
        LOGOUT: 'logout',
        AGENTVIDEOENCODED: 'agentvideoencoded',
        VIDEOPREVIEW: 'videopreview'
    }
    //Freeze the ENUM to prevent changes
    Object.freeze(notificationTypeEnum);

    if (typeof CINC.Hubs == "undefined") {
        CINC.Hubs = {};
    }

    var hubConnections = [];

    var signalRAvailable = function () {
        return window.signalR && typeof signalR.HubConnectionBuilder === "function";
    };

    var resolveSignalRLogLevel = function () {
        if (!signalRAvailable()) {
            return null;
        }

        var level = signalR.LogLevel.Information;
        var config = CINC && CINC.SignalR ? CINC.SignalR : null;
        if (config) {
            if (config.DisableLibraryLogging) {
                level = signalR.LogLevel.None;
            } else if (typeof config.LogLevel === "string" && signalR.LogLevel[config.LogLevel] !== undefined) {
                level = signalR.LogLevel[config.LogLevel];
            } else if (typeof config.LogLevel === "number") {
                level = config.LogLevel;
            }
        }

        return level;
    };

    var createHubConnection = function (hubPath) {
        if (!signalRAvailable()) {
            return null;
        }

        var logLevel = resolveSignalRLogLevel();

        // When accessed through BrowserSync (port 3000), WebSocket upgrade
        // requests are not forwarded to Kestrel (proxy.ws is false).
        // Allow the client to negotiate and fall back to SSE/LongPolling.
        // On all other ports (e.g. 5001 → Kestrel direct) keep the
        // fast-path: skip negotiation and go straight to WebSockets.
        var isBrowserSyncProxy = window.location.port === "3000";
        var connectionOptions = isBrowserSyncProxy
            ? { transport: signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling }
            : { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets };

        return new signalR.HubConnectionBuilder()
            .withUrl(hubPath, connectionOptions)
            .configureLogging(logLevel)
            .build();
    };

    var registerHubConnection = function (hubName, hubPath) {
        var connection = createHubConnection(hubPath);
        if (!connection) {
            return null;
        }

        connection._cincHubName = hubName;
        connection._cincHubPath = hubPath;
        CINC.Hubs[hubName] = connection;
        hubConnections.push(connection);
        return connection;
    };

    var startHubConnection = function (connection, options) {
        var opts = options || {};
        var attempts = 0;
        var maxAttempts = typeof opts.maxAttempts === "number" ? opts.maxAttempts : Number.POSITIVE_INFINITY;
        var retryDelayMs = typeof opts.retryDelayMs === "number" ? opts.retryDelayMs : 5000;
        var onMaxAttempts = opts.onMaxAttempts;
        var hubName = connection._cincHubName || "SignalRHub";
        var hubPath = connection._cincHubPath || "";

        var scheduleStart = function () {
            setTimeout(function () {
                start();
            }, retryDelayMs);
        };

        var handleMaxAttempts = function () {
            if (typeof onMaxAttempts === "function") {
                return onMaxAttempts() !== false;
            }
            return true;
        };

        var start = function () {
            connection.start().then(function () {
                attempts = 0;
            }).catch(function () {
                attempts++;
                console.log("SignalR connect failed:", hubName, hubPath, "attempt", attempts);
                if (attempts >= maxAttempts) {
                    if (!handleMaxAttempts()) {
                        return;
                    }
                    attempts = 0;
                }
                scheduleStart();
            });
        };

        connection.onclose(function () {
            attempts++;
            console.log("SignalR disconnected:", hubName, hubPath);
            if (attempts >= maxAttempts) {
                if (!handleMaxAttempts()) {
                    return;
                }
                attempts = 0;
            }
            scheduleStart();
        });

        start();
    };

    var startHubConnections = function () {
        if (hubConnections.length === 0) {
            return;
        }

        hubConnections.forEach(function (connection) {
            if (connection === CINC.Hubs.Dialer) {
                startHubConnection(connection, {
                    maxAttempts: 5,
                    retryDelayMs: 5000,
                    onMaxAttempts: function () {
                        console.log('SignalR failed to connect after 5 attempts.');

                        if (CINC.User && CINC.User.onDialer && hasDialerCampaign()) {
                            recordSignalrFailure();
                            alert('Oops. Looks like your browser had a hiccup. Please refresh your browser to continue using the dialer.');
                            console.log('Bailing out on real-time push. Refresh browser.');
                            return false;
                        }

                        return true;
                    }
                });
                return;
            }

            startHubConnection(connection, {
                retryDelayMs: 5000
            });
        });
    };

    $(document).ready(function () {
        StartSignalR();
    });

    var setupDialer = function () {
        var dialerConnection = registerHubConnection("Dialer", "/signalr/hubs/dialer");
        if (dialerConnection) {
            dialerConnection.on("blah", function (notification) {
                console.log('dialer notify here' + JSON.stringify(notification));
            });
        }
    }

    var setupCRMChat = function() {
        var chatConnection = registerHubConnection("Chat", "/signalr/hubs/chat");
        if (chatConnection) {
            chatConnection.on("blah", function (notification) {
                console.log('chat notify here: ' + JSON.stringify(notification));
            });
        }
    }

    var setupCRMandDashboard = function () {
        var crmConnection = registerHubConnection("Crm", "/signalr/hubs/crm");
        var dashboardConnection = registerHubConnection("DashboardViewHub", "/signalr/hubs/dashboardview");

        if (crmConnection) {
            crmConnection.on("blah", function (notification) {
                console.log('crm notify here' + JSON.stringify(notification));
            });
        }

        if (dashboardConnection) {
            dashboardConnection.on("blah", function (notification) {
                console.log('DashboardViewHub notify here' + JSON.stringify(notification));
            });
        }
    }

    var StartSignalR = function () {
        if (!CINC.User) return;
        if (!signalRAvailable()) {
            console.log('SignalR client not loaded.');
            return;
        }

        if (CINC.User.onDialer) {
            setupDialer();
        }
        if (CINC.Site.On_CRMPlusChat) {
            setupCRMChat();
        }

        // only agents
        if (CINC.User.securityLevel >= 10) {
            setupCRMandDashboard();
            if (typeof CINC.Hubs !== "undefined") {
                if (CINC.Hubs.DashboardViewHub && Object.keys(CINC.Hubs.DashboardViewHub).length > 0) {
                    /**
                     * Dashboard AO/Plips Hub
                     */
                        CINC.Hubs.DashboardViewHub.on('notify', function (notification) {
                            console.log('DashboradHub Push: ' + JSON.stringify(notification));
                            const currentNotification = notificationTypeMapping[notification.NotificationType.toLowerCase()];

                            if (currentNotification) {
                            currentNotification.communicate(notification);
                        }
                    });
                } else {
                    console.log('No signalr CINC.Hubs.DashboardViewHub enabled.');
                }

                if (typeof CINC.Hubs.Crm !== "undefined" && Object.keys(CINC.Hubs.Crm).length > 0) {
                    /** 
                    * CRM Hub 
                    */
                    CINC.Hubs.Crm.on('notify', function (notification) {
                        // for now, create a modal, now, wherever, that shows done and a progress bar
                        console.log('Crm Push: ' + JSON.stringify(notification));
                        const currentNotification = notificationTypeMapping[notification.NotificationType.toLowerCase()];
                        if (currentNotification) {
                            currentNotification.communicate(notification);
                        }

                        CINC.Dashboard.Progress.AddMessage(notification.message);
                    });
                } else {
                    console.log('No signalr CINC.Hubs.Crm enabled.');
                }
            } else {
                console.log('No signalr hub enabled.');
            }
        }

        startHubConnections();
    }

    var recordSignalrFailure = function () {
        $.get('/api/dashboard/dialer/signalrfailed').done(function (response) {
            return true;
        }).fail(function (error) { });
        return false;
    }

    var hasDialerCampaign = function () {
        $.get('/api/dashboard/dialer/status').done(function (response) {
            if (response.dcdid) {
                return true;
            }
        }).fail(function (error) { });
        return false;
    }

    /**
     * Mapping for Any type of Notification Communicating. 
     * 
     * NotificationEnum: {
     *  communicate(notification) => void
     * }
     */
    const notificationTypeMapping = {
        'agentvideoencoded': {
            communicate: function (notification) {
                if (notification.Failed) {
                    var failureNotification = {
                        failed: true,
                        message: notification.Message,
                        raw: notification.Raw ? {
                            createDT: notification.Raw.CreateDT,
                            domainName: notification.Raw.DomainName,
                            fileDID: notification.Raw.FileDID,
                            filename: notification.Raw.Filename,
                            fullURL: notification.Raw.FullURL,
                            origFileName: notification.Raw.OrigFileName,
                            fileType: notification.Raw.FileType,
                            storeURL: notification.Raw.StoreURL,
                            tags: notification.Raw.Tags,
                            ownerExternalId: notification.Raw.OwnerExternalId,
                            referenceId: notification.Raw.ReferenceId,
                        } : null
                    };
                    Backbone.Radio.channel('uploads').trigger('video:encoded', failureNotification);
                    return;
                }

                var transformNotification = {
                    failed: false,
                    encoded: {
                        createDT: notification.Encoded.CreateDT,
                        domainName: notification.Encoded.DomainName,
                        fileDID: notification.Encoded.FileDID,
                        filename: notification.Encoded.Filename,
                        fullURL: notification.Encoded.FullURL,
                        origFileName: notification.Encoded.OrigFileName,
                        fileType: notification.Encoded.FileType,
                        storeURL: notification.Encoded.StoreURL,
                        tags: notification.Encoded.Tags,
                        ownerExternalId: notification.Encoded.OwnerExternalId,
                        referenceId: notification.Encoded.ReferenceId,
                    },
                    raw: {
                        createDT: notification.Raw.CreateDT,
                        domainName: notification.Raw.DomainName,
                        fileDID: notification.Raw.FileDID,
                        filename: notification.Raw.Filename,
                        fullURL: notification.Raw.FullURL,
                        origFileName: notification.Raw.OrigFileName,
                        fileType: notification.Raw.FileType,
                        storeURL: notification.Raw.StoreURL,
                        tags: notification.Raw.Tags,
                        ownerExternalId: notification.Raw.OwnerExternalId,
                        referenceId: notification.Raw.ReferenceId,
                    }
                };
                Backbone.Radio.channel('uploads').trigger('video:encoded', transformNotification);
            }
        },
        'listinggenerated': {
            communicate: function (notification) {
                CINC.Dashboard.Progress.Open({
                    title: 'Listing Dashboard Status',
                    value: 0,
                });
                CINC.Dashboard.Progress.SetValue(100);
            }
        },
        'logout': {
            communicate: function (notification) {
                window.location.href = "/";
            }
        },
        'massaction': {
            communicate: function (notification) {
                CINC.Dashboard.Progress.Open({
                    title: 'Mass Action Status',
                    value: 0,
                });
                CINC.Dashboard.Progress.SetValue(100);
            }
        },
        'plipbatchstatusupdate': {
            communicate: function (notification) {
                if(CINC.User.perm_Plips){
                    Backbone.Radio.channel('plips').trigger('update:plipbatchstats', notification);//plip communication
                }
            }
        },
        'videopreview': {
            communicate: function (notification) {
                Backbone.Radio.channel('properties').trigger('video:preview', notification);
            }
        }
    }

    CINC.Hubs.SafeApplyCallback = function(hub, eventName, callback) {
        if (!hub) {
            return;
        }

        if (!hub._cincCallbackMap) {
            hub._cincCallbackMap = {};
        }

        if (hub._cincCallbackMap[eventName]) {
            return;
        }

        hub._cincCallbackMap[eventName] = true;
        hub.on(eventName, callback);
    }

})(CINC);

CINC = (typeof CINC === 'undefined' ? {} : CINC);

CINC.Chat = {
    opened: false,
    dashboard: false
};

(function () {
    $(document).ready(function () {
        CINC.Chat.Open = open;
        CINC.Chat.OpenForAgent = openForAgent;
        CINC.Chat.Close = close;
        if (CINC.Hubs && CINC.Hubs.Chat) {
            CINC.Hubs.Chat.on('notify', function (notification) {
                console.log('RT Push: ' + JSON.stringify(notification));
                receiveMessage(notification);
            });
            $('.chat-button').click(function (event) {
                var mdid = $(this).data('mdid');
                if (mdid != undefined && mdid.length > 0) {
                    CINC.Chat.Open(mdid);
                }
            });
        }
    });

    var openForAgent = function (mdid) {
        CINC.Chat.dashboard = true;
        open(mdid);
    };

    var open = function (mdid) {
        if (!CINC.Site.On_CRMPlusChat)
            return;
        $('#chat-container').show();

        getChatDialog(mdid).show();
        openAndFetch(mdid);
        CINC.Chat.opened = true;
    };

    var close = function (el) {
        el.remove();
        CINC.Chat.opened = false;
    };

    var closeOldest = function () {
        $('.js-chat-dialog').first().remove();
    }

    var limitChatDialogs = function () {
        var chatWidth = $('#chat-container').width();
        var parentWidth = $('#chat-container').parent().width();
        if (chatWidth >= parentWidth) {
            closeOldest();
        }
    };

    var getChatDialog = function (mdid) {
        return $('.js-chat-dialog[data-mdid="' + mdid + '"]');
    }

    var setupBindings = function (el) {
        el.find('.js-chad-send').unbind().click(function (e) {
            e.preventDefault();
            sendMessage($(this).closest('.js-chat-dialog'));
        });
        el.find('.js-chad-message').unbind().keyup(function (event) {
            if (event.keyCode == 13) {
                var content = this.value;
                var caret = getCaret(this);
                if (event.shiftKey) {
                    this.value = content.substring(0, caret - 1) + "\n" + content.substring(caret, content.length);
                    event.stopPropagation();
                } else {
                    sendMessage($(this).closest('.js-chat-dialog'));
                }
            }
        });
        el.find('.js-chad-close').unbind().click(function (e) {
            e.preventDefault();
            close($(this).closest('.js-chat-dialog'));
        });
        var toggler = '[data-toggle~=panelcollapse]';
        $('.js-consumer-chat .panel-toolbar').on('click', toggler, function (e) {
            consumerPanelReplication(e);
        });
    };

    var openAndFetch = function (mdid) {
        if (mdid) {
            fetchData(mdid);
        }
    };

    var fetchData = function (mdid) {
        var self = this;
        var ajx = CINC.Api.Chat.GetMessagesForUsers(true).get({ mdid: mdid })
            .success(function (data) {
            for (var i = 0; i < data.chats.length; i++) {
                data.chats[i].receiving = data.chats[i].fromMDID == mdid;
                data.chats[i].modifyDT = ConvertTimeToLocal(data.chats[i].modifyDT);
                data.chats[i].createDT = ConvertTimeToLocal(data.chats[i].createDT);
                data.chats[i].readMsgDT = ConvertTimeToLocal(data.chats[i].readMsgDT);
            }
            compileHandlebars(data);
            var chatDialog = getChatDialog(mdid);
            scrollToBottom(chatDialog);
            limitChatDialogs();
            setupBindings(chatDialog);
            markUnreadAsReceived(data.chats, mdid);
        });
    };

    var compileHandlebars = function (chats) {
        chats.isConsumer = !CINC.Chat.dashboard;
        var chatContainer = Handlebars.compile($('#chad-panel').html());
        var html = chatContainer(chats);
        if (!chatAlreadyOpen(chats.mdid)) {
            $('#chat-container').append(html);
        } else {
            //getChatDialog(chats.mdid).show();
        }
    };

    var chatAlreadyOpen = function (mdid) {
        var result = false;
        $('.js-chat-dialog').each(function () {
            var currmdid = $(this).attr('data-mdid');
            if (currmdid === mdid) {
                result = true;
                return;
            }
        });
        return result;
    }

    var sendMessage = function (el) {
        var mdid = el.attr('data-mdid');
        var message = el.find('.js-chad-message').val();
        var ajx = CINC.Api.Chat.SendMessage(true).post({ Message: message, ToMDID: mdid })
            .success(function (response) {
                // fix dates first
                response.createDT = ConvertTimeToLocal(response.createDT);
                response.modifyDT = ConvertTimeToLocal(response.modifyDT);
                response.readMsgDT = ConvertTimeToLocal(response.readMsgDT);
                addMessage(el, response, false);
                scrollToBottom(el);
                el.find('.js-chad-message').val('');
            });
    };

    // temp convert method
    var ConvertTimeToLocal = function (timeStr) {
        var d = new Date(timeStr);
        d.setHours(d.getHours() - (CINC.ServerUTCOffset - CINC.LocalGMT));
        return d;
    }

    var receiveMessage = function (notification) {
        if (!notification)
            return false;

        var chatDialog = getChatDialog(notification.mdid);
        if (CINC.Chat.opened) {
            if (notification.isHandshake && notification.cdids && notification.cdids.length > 0) {
                var rows = $('.chat-history .message-data');
                for (var c = 0; c < notification.cdids.length; c++) {
                    for (var i = 0; i < rows.length; i++) {
                        if ($(rows[i]).data('cdid') == notification.cdids[c]) {
                            $(rows[i]).append('<i class="ico-checkmark text-success"></i>');
                            break;
                        }
                    }
                }
            }
            else {
                var notificationLocalized = Object.assign({}, notification);
                notificationLocalized.createDT = ConvertTimeToLocal(notification.createDT);
                addMessage(chatDialog, notificationLocalized, true);

                scrollToBottom(chatDialog);
                markAsReceived(notification);
            }
        }
        else if (!notification.isHandshake) {
            CINC.Chat.Open(notification.mdid);
        }
    };

    var addMessage = function (el, message, isreceived) {
        var html = '';
        if (isreceived) {
            var appendedContent = Handlebars.compile($('#chad-received-message').html());
            html = appendedContent(message);
        }
        else {
            var appendedContent = Handlebars.compile($('#chad-sent-message').html());
            html = appendedContent(message);
        }
        if (html.length > 0) {
            el.find('.chat-history').append(html);
        }
    };
    var markAsReceived = function (notification) {
        if (notification && notification.cdid) {
            var data = { cdids: [notification.cdid] };
            var ajx = CINC.Api.Chat.MarkMessageRead(true).put(data);
        }
    };

    var markUnreadAsReceived = function (chats, userMDID) {
        if (chats && chats.length > 0) {
            var data = { cdids: [] };
            for (var i = 0; i < chats.length; i++) {
                if (chats[i].fromMDID == userMDID && !chats[i].received) {
                    data.cdids.push(chats[i].cdid);
                }
            }
            if (data.cdids.length > 0) {
                var ajx = CINC.Api.Chat.MarkMessageRead(true).put(data);
            }
        }
    };

    var scrollToBottom = function (el) {
        el.find('.chat-history').scrollTop(el.find('.chat-history')[0].scrollHeight);
    };
    var getCaret = function (el) {
        if (el.selectionStart) {
            return el.selectionStart;
        } else if (document.selection) {
            el.focus();
            var r = document.selection.createRange();
            if (r == null) {
                return 0;
            }
            var re = el.createTextRange(), rc = re.duplicate();
            re.moveToBookmark(r.getBookmark());
            rc.setEndPoint('EndToStart', re);
            return rc.text.length;
        }
        return 0;
    };

    var consumerPanelReplication = function (e) {

        // find panel element
        var panel = $(e.currentTarget).closest('.panel'),
            target = panel.children('.panel-collapse'),
            height = target.height();

        console.log(panel);
        // error handling
        if (target.length === 0) {
            $.error('collapsable element need to be wrap inside ".panel-collapse"');
        }

        var open = function (toggler) {
            $(toggler).removeClass('down').addClass('up');
            $(target)
                .removeClass('pull').addClass('pulling')
                .css('height', '0px')
                .transition({ height: height }, function () {
                    $(this).removeClass('pulling').addClass('pull out');
                    $(this).css({ 'height': '' });
                });

            // publish event
            //$(element).trigger(settings.eventPrefix + '.panelcollapse.open', { 'element': $(panel) });
        };

        var close = function (toggler) {
            $(toggler).removeClass('up').addClass('down');
            $(target)
                .removeClass('pull out').addClass('pulling')
                .css('height', height)
                .transition({ height: '0px' }, function () {
                    $(this).removeClass('pulling').addClass('pull');
                    $(this).css({ 'height': '' });
                });

            // publish event
            //$(element).trigger(settings.eventPrefix + '.panelcollapse.close', { 'element': $(panel) });
        };

        // collapse the element
        if ($(target).hasClass('out')) {
            close(this);
        } else {
            open(this);
        }

        // prevent default
        e.preventDefault();
    };
}());
(function (Handlebars) {

    var OriginalCompile = Handlebars.compile;
    var OriginalRegisterPartial = Handlebars.registerPartial;

    Handlebars.compile = function (input, options) {
        if (!input) input = '';
        return _.compose(OriginalCompile(input, options), function (context) {
            return Handlebars.mixinGlobals(context);
        });
    };

    Handlebars.registerPartial = function (name, html) {
        if (!html) html = '';
        return OriginalRegisterPartial.call(Handlebars, name, html);
    };

    Handlebars.mixinGlobals = function (context) {
        var globals = {
            'CINC': function () {
                return CINC;
            }(),
            'Dex': function () {
                return window.Dex || {};
            }(),
        };

        return _.extend(globals, context);
    };

    Handlebars.registerHelper('var', function (name, value, options) {
        if (options && options.data)
            options.data[name] = value;
    });

    Handlebars.registerHelper('eval', function (js, options) {
        return eval(js);
    });

    Handlebars.registerHelper('handlebars', function (input, options) {
        if (!input) return '';

        if (typeof input == 'string')
            return Handlebars.compile(input)();

        if ($.isArray(input)) {
            var flatten = options && options.hash && options.hash.flatten;
            var compiledArr = [];
            $.each(input, function (index) {
                var value = Handlebars.compile(input[index])();
                if (flatten && $.isArray(value))
                    $.each(value, function (subIndex) {
                        compiledArr.push(value[subIndex]);
                    });
                else
                    compiledArr.push(value);
            });
            return compiledArr;
        }

        return input;
    });

    Handlebars.registerHelper('indexer', function (arr, index, options) {
        try {
            return arr[index];
        } catch (e) {
            console.log(e);
        }

        return null;
    });

    Handlebars.registerHelper('selectedif', function (value, comparator, otherValue, options) {
        return AttributeIf('selected', value, comparator, otherValue, options);
    });

    Handlebars.registerHelper('checkedif', function (value, comparator, otherValue, options) {
        return AttributeIf('checked', value, comparator, otherValue, options);
    });

    Handlebars.registerHelper('disabledif', function (value, comparator, otherValue, options) {
        return AttributeIf('disabled', value, comparator, otherValue, options);
    });

    var AttributeIf = function (attribute, value, comparator, otherValue, options) {
        // if we were given a value but the comparator is actually intended to be 'otherValue'
        // then make comparator an implicit ~=, so fix things up
        if (!options && otherValue && otherValue.hash) {
            options = otherValue;
            otherValue = comparator;
            comparator = "~=";
        }

        options = options || { hash: {} };

        // if there is no comparator, assume a boolean comparison
        if (typeof comparator !== 'string') {
            comparator = '===';
            otherValue = true;
        }

        options.hash.operator = comparator;
        options.fn = function () { return true; };
        options.inverse = function () { return false; };

        return HandlebarsCompare(value, otherValue, options) ? attribute : '';
    };

    Handlebars.registerHelper('contains', function (collection, item, options) {
        if (typeof collection === 'string') {
            var searchTerm = (options && options.hash && options.hash.toLower === true ? item.toLowerCase() : item);
            var searchCollection = (options && options.hash && options.hash.toLower === true ? collection.toLowerCase() : collection);
            var searchResponse = searchCollection.indexOf(searchTerm) >= 0;

            if (searchCollection.indexOf(',') >= 0 && options.hash.csvSearch) {
                var arr = searchCollection.split(',');
                var intersect = _.intersection(arr, [searchTerm]);
                searchResponse = intersect.length === 1;
            }

            if (searchResponse && (searchTerm !== '' || !options.hash.ignoreEmptyString)) {
                return options.fn(this);
            }
            else {
                return options.inverse(this);
            }
        }
        if (_.contains(collection, item)) {
            return options.fn(this);
        }

        return options.inverse(this);
    });

    Handlebars.registerHelper('log', function (item, options) {
        console.log(item);
    });

    Handlebars.registerHelper('json', function (context) {
        try {
            if (context.CINC)
                delete context.CINC;
            if (context.Dex)
                delete context.Dex;
            return JSON.stringify(context);
        } catch (e) {
            console.error(e, context);
        }

        return null;
    });

    Handlebars.registerHelper('toProperCase', function (text, options) {
        if (!_.isString(text))
            return text;

        return text.toProperCase();
    });

    Handlebars.registerHelper('replace', function (text, what, to, options) {
        if (!_.isString(text))
            return text;

        return text.split(what).join(to);
    });

    Handlebars.registerHelper('stripHtml', function (html, options) {
        if (!_.isString(html))
            return html;

        html = html.replace(/<img[^>]*>/g, "");
        truncOpt = {
            stripTags: true,
            length: options.hash.length,
            words: options.hash.words,
            noBreaks: options.hash.noBreaks,
        };
        return $.truncate(html, truncOpt);
        //return $("<div>" + html + "</div>").text();
    });

    Handlebars.registerHelper('truncateHtml', function (html, options) {
        truncOpt = {
            stripTags: false,
            length: (_.isNumber(options.hash.length) ? options.hash.length : 512),
            words: (_.isBoolean(options.hash.words) ? options.hash.words : true),
            noBreaks: (_.isBoolean(options.hash.noBreaks) ? options.hash.noBreaks : true),
        };

        var truncated = $.truncate(html, truncOpt);
        return truncated;
    });

    Handlebars.registerHelper('isNullOrEmpty', function (value, options) {
        if (_.isUndefined(value) || _.isEmpty(value) || (_.isString(value) && value.length === 0)) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    var HandlebarsCompare = function (lvalue, rvalue, options) {
        if (arguments.length < 3)
            throw new Error("Handlebars Helper 'compare' needs 2 parameters");

        var operator = options.hash.operator || "===";
        operator = operator.trim();

        // If a templateHelper is used for the lvalue or rvalue, they will be a function.
        if (typeof lvalue === "function") {
            lvalue = lvalue.call(this);
        }
        if (typeof rvalue === "function") {
            rvalue = rvalue.call(this);
        }
        // bit of a hack, but need a way to compare full string (didn't want to break anything relying on the implied contains)
        if (operator === 'modelProperty') {
            //NOTE: this was doing string.search(), breaks for csv values, consult Mitchell or Ben if this is breaking something else
            if (options && options.data && options.data.root && options.data.root.hasOwnProperty(lvalue) &&
                (options.data.root[lvalue] === rvalue || (_.isString(options.data.root[lvalue]) && rvalue !== "" && options.data.root[lvalue].indexOf(rvalue) >= 0))) {
                return options.fn(this);
            }
            return options.inverse(this);
        }
        else if (operator === 'modelPropertyCompareFull') {
            if (options && options.data && options.data.root && options.data.root.hasOwnProperty(lvalue) &&
                (options.data.root[lvalue] === rvalue || (_.isString(options.data.root[lvalue]) && rvalue !== "" && options.data.root[lvalue] === rvalue))) {
                return options.fn(this);
            }
            return options.inverse(this);
        }
        else if (operator === 'modelPropertyCompareFullCSV') {
            if (options && options.data && options.data.root && options.data.root.hasOwnProperty(lvalue)) {
                if (_.isString(options.data.root[lvalue]) && rvalue !== "" && options.data.root[lvalue] === rvalue) {
                    return options.fn(this);
                }

                var csvList = options.data.root[lvalue].split(',');

                var foundMatches = _.filter(csvList, function (val) {
                    return val.toLowerCase() === rvalue.toLowerCase();
                });

                if (foundMatches.length === 1) {
                    return options.fn(this);
                }
            }

            return options.inverse(this);
        }
        else if (operator === 'equalsIgnoreCase' || operator === '~=' || operator === '!~=') {
            var fn = operator[0] === '!' ? options.inverse : options.fn;
            var inverse = operator[0] === '!' ? options.fn : options.inverse;

            if ((lvalue || '').toString().toLowerCase() === (rvalue || '').toString().toLowerCase())
                return fn(this);
            return inverse(this);
        }

        var operators = {
            '==': function (l, r) { return l == r; },
            '===': function (l, r) { return l === r; },
            '!=': function (l, r) { return l != r; },
            '!==': function (l, r) { return l !== r; },
            '<': function (l, r) { return l < r; },
            '>': function (l, r) { return l > r; },
            '<=': function (l, r) { return l <= r; },
            '>=': function (l, r) { return l >= r; },
            //because sometimes handlebars is stupid
            '&lt;': function (l, r) { return l < r; },
            '&lt;=': function (l, r) { return l <= r; },
            '&gt;': function (l, r) { return l > r; },
            '&gt;=': function (l, r) { return l >= r; },
            '%': function (l, r) { return l % r; },
            'typeof': function (l, r) { return typeof l == r; },
            'regex': function (l, r) { return new RegExp(r, 'i').test(l); },
        };

        if (!operators[operator])
            throw new Error("Handlebars Helper 'compare' doesn't know the operator " + operator);

        var result = operators[operator](lvalue, rvalue);

        if (result) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    };

    Handlebars.registerHelper('compare', HandlebarsCompare);

    Handlebars.registerHelper('ifEither', function (first, second, options) {
        return first || second ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('ifBoth', function (first, second, options) {
        return first && second ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('mod', function (v, num, options) {
        return (v % num == 0 ? options.fn(this) : options.inverse(this));
    });
    Handlebars.registerHelper("add", function (value, num, options) {
        return parseInt(value) + parseInt(num);
    });
    Handlebars.registerHelper('plusonemod', function (v, num, options) {
        return ((v + 1) % num == 0 ? options.fn(this) : options.inverse(this));
    });

    Handlebars.registerHelper('getValueOfPropertyNamed', function (propertyName, context) {
        if (context.data && context.data.root && context.data.root.hasOwnProperty(propertyName)) {
            var output = context.data.root[propertyName];

            //pretty print Currency / Numbers
            var stripCur = parseFloat(output.replace(/[^\d\.]/g, ''));
            if (!_.isNaN(stripCur)) {
                if (propertyName.toLowerCase().indexOf('price') > -1 || propertyName.toLowerCase().indexOf('tax') > -1) {
                    return stripCur.formatPrice();
                } else if (propertyName.toLowerCase().indexOf('year') > -1 || propertyName.toLowerCase().indexOf('zip') > -1 || propertyName.toLowerCase().indexOf('postal') > -1) {
                    return output; //don't pretty print years
                }
                else {
                    return stripCur.toLocaleString();
                }
            }

            return output;
        }
    });

    Handlebars.registerHelper('securityLevel', function (operator, value, options) {
        options.hash.operator = operator;
        if (typeof value == 'string') {
            switch (value.toLowerCase()) {
                case 'cincadmin':
                    value = 25;
                    break;
                case 'broker':
                    value = 15;
                    break;
                case 'agent':
                    value = 10;
                    break;
                default:
                    console.error('Unknown security level name: ' + value);
                    return false;
            }
        }

        return HandlebarsCompare(CINC.User.securityLevel, value, options);
    });

    Handlebars.registerHelper('lookup', function (context, key, options) {
        if (context[key]) {
            if (typeof (context[key]) != 'string' && $.isArray(context[key])) {
                if (context[key].length > 0)
                    return options.fn(context[key], { data: { key: key } });
                else
                    return options.inverse(context, { data: { key: key } });
            }
            else
                return options.fn(context[key], { data: { key: key } });
        }
        else {
            return options.inverse(context, { data: { key: key } });
        }
    });

    Handlebars.registerHelper('lookupReal', function (context, key) {
        return context[key];        
    });

    Handlebars.registerHelper('charAt', function (txt, index) {
        if (txt !== undefined && txt !== null && txt.length > index && index >= 0) {
            return txt.charAt(index);
        }
        return '';
    });

    Handlebars.registerHelper('nl2br', function (text, options) {
        if (!!text) {
            return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    });

    Handlebars.registerHelper('censor', function (text, options) {
        if (!_.isString(text)) {
            return text;
        }

        return text.censorDirty();
    });

    Handlebars.registerHelper('linkify', function (text, options) {
        text = LinkAddresses(text || '');

        // TODO replace mailto: links with something internal that links to inbox
        return Autolinker.link(text || '');
    });

    var LinkAddresses = function (text) {
        var addressIdentifier = "Property Details: <br />  Address: ";
        var index = text.indexOf(addressIdentifier);
        if (index > 0) {
            var before = text.substring(0, index + addressIdentifier.length);
            var after = text.substring(index + addressIdentifier.length);
            var afterIndex = after.indexOf("<br />");
            var address = after.substring(0, afterIndex).trim();
            after = after.substring(afterIndex);

            text = before + "<a href='https://maps.google.com/maps/place/" + encodeURIComponent(address) + "' target='_blank'>" + address + "</a>" + after;
        }

        return text;
    };

    Handlebars.formatDate = (function () {
        var dateFormat = function () {
            var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
                timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
                timezoneClip = /[^-+\dA-Z]/g,
                pad = function (val, len) {
                    val = String(val);
                    len = len || 2;
                    while (val.length < len) val = "0" + val;
                    return val;
                };

            // Regexes and supporting functions are cached through closure
            return function (date, mask, utc) {
                var dF = dateFormat;

                // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
                if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
                    mask = date;
                    date = undefined;
                }

                // Passing date through Date applies Date.parse, if necessary
                date = date ? new Date(date) : new Date;
                if (isNaN(date)) throw SyntaxError("invalid date");

                mask = String(dF.masks[mask] || mask || dF.masks["default"]);

                // Allow setting the utc argument via the mask
                if (mask.slice(0, 4) == "UTC:") {
                    mask = mask.slice(4);
                    utc = true;
                }

                var _ = utc ? "getUTC" : "get",
                    d = date[_ + "Date"](),
                    D = date[_ + "Day"](),
                    m = date[_ + "Month"](),
                    y = date[_ + "FullYear"](),
                    H = date[_ + "Hours"](),
                    M = date[_ + "Minutes"](),
                    s = date[_ + "Seconds"](),
                    L = date[_ + "Milliseconds"](),
                    o = utc ? 0 : date.getTimezoneOffset(),
                    flags = {
                        d: d,
                        dd: pad(d),
                        ddd: dF.i18n.dayNames[D],
                        dddd: dF.i18n.dayNames[D + 7],
                        m: m + 1,
                        mm: pad(m + 1),
                        mmm: dF.i18n.monthNames[m],
                        mmmm: dF.i18n.monthNames[m + 12],
                        yy: String(y).slice(2),
                        yyyy: y,
                        h: H % 12 || 12,
                        hh: pad(H % 12 || 12),
                        H: H,
                        HH: pad(H),
                        M: M,
                        MM: pad(M),
                        s: s,
                        ss: pad(s),
                        l: pad(L, 3),
                        L: pad(L > 99 ? Math.round(L / 10) : L),
                        t: H < 12 ? "a" : "p",
                        tt: H < 12 ? "am" : "pm",
                        T: H < 12 ? "A" : "P",
                        TT: H < 12 ? "AM" : "PM",
                        Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                        o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                        S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
                    };

                return mask.replace(token, function ($0) {
                    return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
                });
            };
        }();

        // Some common format strings
        dateFormat.masks = {
            "default": "ddd mmm dd yyyy HH:MM",
            shortDate: "m/d/yy",
            mediumDate: "mmm d, yyyy",
            longDate: "mmmm d, yyyy",
            fullDate: "dddd, mmmm d, yyyy",
            shortTime: "h:MM TT",
            mediumTime: "h:MM TT",
            longTime: "h:MM TT Z",
            isoDate: "yyyy-mm-dd",
            isoTime: "HH:MM",
            isoDateTime: "yyyy-mm-dd'T'HH:MM",
            isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM'Z'",
            cincDate: "mmm d, yyyy 'at' h:MM TT",
        };

        // Internationalization strings
        dateFormat.i18n = {
            dayNames: [
                "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
                "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
            ],
            monthNames: [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
                "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
            ]
        };

        return dateFormat;
    })();

    Handlebars.registerHelper('placeholder', function (str, options) {
        var placeholder = '-';

        if (options && options.hash && options.hash.placeholder) {
            placeholder = options.hash.placeholder;
        }

        if (!str || str === '')
            return placeholder;
        else
            return str;
    });

    Handlebars.registerHelper('date', function (dt, options) {
        if (!dt)
            return '';

        //fix for Marionette TemplateHelpers that return a function
        if (typeof dt === 'function' && options && options.data && options.data.root) { //&& options.data.root.hasOwnProperty(options.name)
            var test = null;
            try {
                test = dt.call(options.data.root);
            } catch (err) {
                console.log('Handlebars date helper failed to call dt as function()');
            }
            dt = test || dt;
        }

        //if the date is still a function bail out
        if (typeof dt === 'function')
            return '';

        try {
            var pdt = dt.getMonth ? dt : ParseSqlDate(dt, false);
            if (pdt >= new Date('2050-01-01') && options.hash.ongoing)
                return 'ONGOING';

            if (pdt >= new Date('2050-01-01') && options.hash.never)
                return 'NEVER';

            if (pdt.getYear() <= 0 && options.hash.na)
                return 'n/a';

            if (options.hash.diff) {
                console.warn("Please use the 'timeago' handlebars helper instead");
                if (typeof moment === 'undefined') {
                    return moment(dt).fromNow();
                }
                return "n/a";
            }

            var formattedDate = Handlebars.formatDate(pdt, options.hash.format || 'mm/dd/yyyy');
            if (options.hash.uppercase) {
                formattedDate = formattedDate.toUpperCase();
            }
            return formattedDate;
        }
        catch (err) {
            console.log(err);
            return dt;
        }
    });

    // does this need to live somewhere else?
    var ParseSqlDate = function (sqlDate, toLocal) {
        if (!sqlDate)
            return new Date('1900-1-1');

        var a = sqlDate.split(/[^0-9]/);
        var date = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);

        return date;
    };

    // A wrapper for the fromNow() method from momentjs: http://momentjs.com/docs/#/displaying/fromnow/
    Handlebars.registerHelper('timeago', function (dt, options) {
        options = options || {}
        if (typeof moment === 'undefined') {
            console.warn('the "timeago" helper requires momentjs');
            return "N/A";
        }

        if (dt === undefined || dt === null || new Date(dt).getYear() <= 0) {
            if (options.hash.placeholder) {
                return options.hash.placeholder;
            }

            return "n/a";
        }

        if (options.hash.useDefaultBehavior && options.hash.useDefaultBehavior === true) {
            var m = moment(new Date(dt));
            return m.fromNow(!(options.hash.includeAgo && options.hash.includeAgo === true) || true);
        }

        //this is the legacy way - hooray!
        var mNow = moment(new Date());
        var mDate = moment(new Date(dt));
        var mDiff = mNow.diff(mDate);

        if (options.hash.invert && options.hash.invert === true) {
            mDiff = -mDiff;
            mNow = moment(new Date(dt));
            mDate = moment(new Date());
        }

        if (mDiff > 0) {
            if (Math.abs(mDiff) <= 60000) {
                return 'NOW';
            } else if (Math.abs(mDiff) < 3600000) {
                var minutes = Math.ceil(mNow.diff(mDate, 'minutes', true));
                return minutes + (Math.abs(minutes) > 1 ? ' mins' : ' min');
            } else if (Math.abs(mDiff) < 86400000) {
                var hours = Math.ceil(mNow.diff(mDate, 'hours', true));
                return hours + (Math.abs(hours) > 1 ? ' hours' : ' hour');
            } else {
                var days = Math.ceil(mNow.diff(mDate, 'days'));
                return days + (Math.abs(days) > 1 ? ' days' : ' day');
            }
        } else {
            if (Math.abs(mDiff) <= 60000) {
                return 'NOW';
            } else if (Math.abs(mDiff) < 3600000) {
                var minutes = Math.floor(mNow.diff(mDate, 'minutes', true));
                return minutes + (Math.abs(minutes) > 1 ? ' mins' : ' min');
            } else if (Math.abs(mDiff) < 86400000) {
                var hours = Math.floor(mNow.diff(mDate, 'hours', true));
                return hours + (Math.abs(hours) > 1 ? ' hours' : ' hour');
            } else {
                var days = Math.floor(mNow.diff(mDate, 'days'));
                return days + (Math.abs(days) > 1 ? ' days' : ' day');
            }
        }
    });

    Handlebars.registerHelper('timeDuration', function (seconds, options) {
        if (arguments.length < 2)
            throw new Error("Handlebars Helper 'timeDuration' needs 2 parameters");

        var format = options.hash.format || "HH:mm:ss";

        return moment().startOf('day').seconds(seconds).format(format)
    });

    Handlebars.registerHelper('appointmentDate', function (startDate, endDate, options) {
        options = options || {};
        options.omitDates = options.omitDates || false;
        if (!endDate)
            return formatAppointmentDate(startDate, options);

        if (typeof startDate === 'string') startDate = ParseSqlDate(startDate, false);
        if (typeof endDate === 'string') endDate = ParseSqlDate(endDate, false);

        var startOptions = { timeOnly: options.timeOnly || options.omitDates || false };
        var endOptions = { timeOnly: options.timeOnly || options.omitDates || false };

        if (new Date(startDate).setHours(0, 0, 0, 0) == new Date(endDate).setHours(0, 0, 0, 0))
            endOptions.timeOnly = true;

        return formatAppointmentDate(startDate, startOptions) + " to " + formatAppointmentDate(endDate, endOptions);
    });

    var formatAppointmentDate = function (date, options) {
        options = options || {};
        var timeOnly = options.timeOnly || false;

        if (!date)
            return "<unknown>";

        if (typeof date === 'string')
            date = ParseSqlDate(date, false);

        if (date._isAMomentObject) {
            date = date._d;
        }
        var hours = date.getHours();
        var ampm = hours >= 12 ? "pm" : "am";
        if (hours > 12) hours -= 12;

        var minutes = date.getMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        if (minutes == "00")
            minutes = "";
        else
            minutes = ":" + minutes;

        var timeString = hours + minutes + ampm;
        if (timeOnly) return timeString;

        return $.datepicker.formatDate("m/dd/yy", date) + " " + timeString;
    };

    Handlebars.registerHelper('agendaDuration', function (startDate, endDate) {
        if (!endDate)
            return 'None';
        if (typeof startDate === 'string') startDate = ParseSqlDate(startDate, false);
        if (typeof endDate === 'string') endDate = ParseSqlDate(endDate, false);

        var hours = Math.abs(endDate - startDate) / (1000 * 60 * 60);
        var days = Math.floor(hours / 24);
        var hoursRemainder = hours % 24;
        var minutes = hours * 60;

        if (hours < 1)
            return Math.floor(minutes) + ' minute' + (minutes > 1 ? 's' : '');
        else if (days > 0) {
            var string = days + ' day' + (days > 1 ? 's' : '');
            if (hoursRemainder > 0) {
                string = string + ' and ' + (Math.round(hoursRemainder * 10) / 10) + ' hour' + (hoursRemainder > 1 ? 's' : '');
            }
            return string;
        }
        else
            return (Math.round(hours * 10) / 10) + ' hour' + (hours > 1 ? 's' : '');
    });

    Handlebars.registerHelper('agendaDurationValue', function (startDate, endDate) {
        if (!endDate)
            return 'None';
        if (typeof startDate === 'string') startDate = ParseSqlDate(startDate, false);
        if (typeof endDate === 'string') endDate = ParseSqlDate(endDate, false);

        return Math.abs(endDate - startDate) / (1000 * 60 * 60);
    });

    Handlebars.registerHelper('agendaDate', function (startDate, endDate, options) {
        options = options || {};
        options.omitDates = options.omitDates || false;

        var startOptions = { timeOnly: true };
        var endOptions = { timeOnly: true };

        if (!endDate)
            return formatAgendaDate(startDate, startOptions);

        if (typeof startDate === 'string') startDate = ParseSqlDate(startDate, false);
        if (typeof endDate === 'string') endDate = ParseSqlDate(endDate, false);

        return formatAgendaDate(startDate, startOptions) + " - " + formatAgendaDate(endDate, endOptions);
    });

    Handlebars.registerHelper('agendaSingleDate', function (date) {
        if (typeof date === 'string')
            date = ParseSqlDate(date, false);

        if (date._isAMomentObject) {
            date = date._d;
        }
        return $.datepicker.formatDate("m/dd/yy", date);
    });

    var formatAgendaDate = function (date, options) {
        options = options || {};
        var timeOnly = options.timeOnly || false;
        var dateOnly = options.dateOnly || false;

        if (!date)
            return "<unknown>";

        if (typeof date === 'string')
            date = ParseSqlDate(date, false);

        if (date._isAMomentObject) {
            date = date._d;
        }
        var hours = date.getHours();
        var ampm = hours >= 12 ? "p" : "";
        if (hours > 12) hours -= 12;
        if (hours == 0) hours = 12;

        var minutes = date.getMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        if (minutes == "00")
            minutes = "";
        else
            minutes = ":" + minutes;

        var timeString = hours + minutes + ampm;
        var dateString = $.datepicker.formatDate("m/dd/yy", date);
        if (timeOnly) return timeString;
        if (dateOnly) return dateString;

        return dateString + " " + timeString;
    };
    //duplicated from CINC.Core.js
    var formatPrice = function (price) {
        return '$' + price.toLocaleString();
    };

    //duplicated from CINC.Core.js
    var formatShortPrice = function (price) {
        var val = parseInt(price);
        var str = String(val);
        if (val >= 1000 && val <= 999999) {
            val = '$' + str.substr(0, str.length - 3) + 'k';
        }
        else if (val >= 1000000) {
            val = '$' + str.substr(0, str.length - 6) + '.' + str.substr(str.length - 6, 1) + 'M';
        }
        else {
            val = '$' + val;
        }
        return val;
    };

    Handlebars.registerHelper('formatPrice', function (price, options) {
        options = options || {};
        if (!price && options.hash.useNA)
            return 'n/a';

        try {
            var priceInt = parseInt(price);
            if (!_.isNaN(priceInt)) {
                if (options.hash.useShortPrice) {
                    return formatShortPrice(priceInt);
                } else {
                    return formatPrice(priceInt);
                }
            } else {
                return '';
            }
        }
        catch (err) {
            console.log(err);
        }

        return price;
    });

    Handlebars.registerHelper('for', function (from, to, incr, block) {
        var accum = '';
        for (var i = from; i < to; i += incr)
            accum += block.fn(i);
        return accum;
    });

    Handlebars.registerHelper('add', function (num, num2) {
        return num + num2;
    });

    Handlebars.registerHelper('phone', function (phone, options) {
        if (!phone)
            return 'n/a';

        try {
            if (String(phone) !== 'n/a') {
                phone = phone.toString().replace(/\D/g, '');
                if (phone.length === 10)
                    phone = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
            }
        }
        catch (err) {
            console.log(err);
        }

        return phone;
    });

    Handlebars.registerHelper('numWithCommas', function (number, options) {
        if (number === undefined)
            return 'n/a';

        try {
            //fix for Marionette TemplateHelpers that return a function
            if (_.isFunction(number) && options && options.data && options.data.root) { //&& options.data.root.hasOwnProperty(options.name)
                var test = null;
                try {
                    test = number.call(options.data.root, options);
                } catch (err) {
                    console.log('Handlebars numWithCommas helper failed to call numberS as function()');
                }
                number = test;
            }
            if (!_.isNaN(Number(number))) {
                number = Number(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
        catch (err) {
            console.log(err);
        }

        return number;
    });


    Handlebars.registerHelper('skewLightOrDark', function (color, options) {
        return Handlebars.SkewLightOrDark(color, options);
    });

    Handlebars.registerHelper('partnerVerbiage', function () {
        return CINC.Verbiage.Get('partner');
    });

    Handlebars.registerHelper('brokerVerbiage', function () {
        return CINC.Verbiage.Get('broker');
    });

    Handlebars.SkewLightOrDark = function (color, options) {
        try {
            var light = options.hash.light || 'white';
            var dark = options.hash.dark || 'black';

            if (typeof color === 'undefined' || color.length == 0)
                return options.hash.standard || dark;

            if (color.indexOf('#') == 0)
                color = color.substring(1); // remove #

            var r = parseInt(color.substr(0, 2), 16);
            var g = parseInt(color.substr(2, 2), 16);
            var b = parseInt(color.substr(4, 2), 16);
            var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

            return (yiq >= 128) ? dark : light;
        }
        catch (err) {
            console.log(err);
        }

        return light;
    };

    Handlebars.registerHelper('truncate', function (str, len, options) {
        options = options || {};
        if (str && str.length > len && str.length > 0) {
            var new_str = str + " ";
            new_str = str.substr(0, len);
            if (!options.hash.exactLength) {
                new_str = str.substr(0, new_str.lastIndexOf(" "));
            }
            new_str = (new_str.length > 0) ? new_str : str.substr(0, len);
            return new Handlebars.SafeString(new_str + '...').string;
        }
        return str;
    });

    Handlebars.registerHelper('toLowerCase', function (str) {
        if (_.isString(str))
            return str.toLowerCase();
        else
            return str;
    });

    Handlebars.registerHelper('toUpperCase', function (str) {
        if (_.isString(str))
            return str.toUpperCase();
        else
            return str;
    });

    Handlebars.registerHelper('coalesce', function () {
        for (var i = 0; i < arguments.length - 1; i++) { // - 1 because last should be handlebars options var
            if (arguments[i]) {
                return arguments[i];
            }
        }
        return null;
    });

    Handlebars.registerHelper('exists', function (obj, options) {
        if ((_.isArray(obj) && obj.length > 0) || (obj !== undefined && obj !== null && obj !== "")) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('round', function (value, places, options) {
        return parseFloat(value).toFixed(places);
    });

    Handlebars.registerHelper('containsCSV', function (csv, value, options) {
        // handle blank csv value
        if (!csv) {
            return options.inverse(this);
        }

        var collection = csv.split(options.hash.delimiter || ',');
        if (collection.indexOf(value) != -1)
            return options.fn(this);
        else
            return options.inverse(this);
    });

    Handlebars.registerHelper('eachCSV', function (collection, options) {
        if (typeof collection === 'string') {
            collection = collection.split(options.hash.delimiter || ',');
        }

        if (collection && collection.length) {
            var html = '';
            for (var i = 0; i < collection.length; i++)
                html += options.fn(collection[i]);
            return html;
        }
        else {
            return options.inverse(null);
        }
    });

    Handlebars.registerHelper('formatFloat', function (context, options) {
        var fixed = options.hash.fixed || 2;
        //fix for Marionette TemplateHelpers that return a function
        if (_.isFunction(context) && options && options.data && options.data.root) { //&& options.data.root.hasOwnProperty(options.name)
            var test = null;
            try {
                test = context.call(options.data.root);
            } catch (err) {
                console.log('Handlebars date helper failed to call dt as function()');
            }
            context = test || context;
        }
        return parseFloat(context).toFixed(fixed);
    });

    Handlebars.registerHelper('formatPercent', function (context, options) {
        var fixed = options.hash.fixed || 2;
        return (context * 100).toFixed(fixed) + '%';
    });

    Handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
        lvalue = parseFloat(lvalue);
        rvalue = parseFloat(rvalue);

        switch (operator) {
            case "+":
                return lvalue + rvalue;
            case "-":
                return lvalue - rvalue;
            case "*":
                return lvalue * rvalue;
            case "/":
                return lvalue / rvalue;
            case "%":
                return lvalue % rvalue;
            case "^":
                return Math.pow(lvalue, rvalue);
            case "percent":
                return lvalue / rvalue * 100;
            case "percent.2":
                return (lvalue / rvalue * 100).toFixed(2);
        }
    });

}(Handlebars))

CINC = (typeof CINC === 'undefined' ? {} : CINC);
CINC.Core = (typeof CINC.Core === 'undefined' ? {} : CINC.Core);
CINC.Core.Cookies = (typeof CINC.Core.Cookies === 'undefined' ? {} : CINC.Core.Cookies);

(function (ga) {
    $(document).ready(function() {

        $('.app-banner > .close').on('click', function (e) {
            e.preventDefault();
            CINC.Core.Cookies.Set('hideAppBanner', 1, 1);
            $('.app-banner').hide();
        });
        $('.app-banner > a').on('click', function (e) {
        });
    });
})(typeof ga === 'undefined' ? function () { } : ga);
CINC = (typeof CINC === 'undefined' ? {} : CINC);

CINC.Registration = (function (ga, gtag_report_conversion) {
    var finishRegistration = function (shouldReload) {
        shouldReload = shouldReload !== false;

        CINC.Core.WriteConversionScripts();
        if (typeof gtag_report_conversion === "function") {
            if (shouldReload) {
                gtag_report_conversion(window.location.href);
            } else {
                gtag_report_conversion();
            }

            if (typeof ga !== 'undefined') {
            }
        }
        var firstname = "";
        if (CINC.User && CINC.User.firstName) {
            firstname = CINC.User.firstName;
        }
        SetLoadAction("NotificationBanner", {
            title: "Registration Successful",
            message: firstname === "" ? "You're all ready to go!" : "You're all ready to go, " + firstname + "!",
            type: "Success"
        });

       if(shouldReload) {
            setTimeout(function () { window.location.reload(); }, 500);
        }
    };

    var isDismissiblePage = function () {
        var restrictedSegments = ["homes"];
        var pathSegment = window.location.pathname.toLowerCase().split('/')[1];

        if ($.inArray(pathSegment, restrictedSegments) > -1) {
            return false;
        }
        return true;
    };

    return {
        elements: {
            SignUpForm: $('.js-signupform-form'),
            SignUpHomeValForm: $('.js-signupform-home-val-form'),
            QuestionHomeValForm: $('.js-question-home-val-form'),
            PhoneForm: $('.js-signupform-required-phone')
        },
        callbacks: {
            registrationSuccess: function (registrationResult) {

                if (registrationResult.userInfo) {
                    CINC.User = registrationResult.userInfo;
                    IsLoggedIn = true;
                }
                if (document.getElementById('conversion-tracking-scripts') === null) {
                    $('body').append('<div id="conversion-tracking-scripts">' + CINC.Site.ConversionTrackingScripts + '</div>');
                }

                CINC.Core.CookiesVanilla.Set('registration-state', 'registered', 5);

                if (CINC.Site.IsBrandedSite || (CINC.ControllerName === 'Home' && CINC.ActionName === 'App') || (CINC.Core.CookiesVanilla.Get('fbprompt') === '1' || (CINC.QS && CINC.QS['fbprompt'] === '1'))) {
                    finishRegistration();
                }
                else {
                    PromptForSignup('', CINC.CincProduct === "Houses", '2');
                }
            },
            registrationError: function (registrationResult, modalToClose) {
                CINC.Core.CookiesVanilla.Set('registration-state', 'registration-error', 5);
                modalToClose.Close();
                Notification.Banner.Error(registrationResult.description, "Registration Problem");
                PromptForSignup(registrationResult.description, isDismissiblePage());
            },
            registrationApiFailure: function (error, modalToClose) {
                CINC.Core.CookiesVanilla.Set('registration-state', 'registration-error', 5);
                modalToClose.Close();
                Notification.Banner.Error(error.responseText, "Registration Error");
                PromptForSignup("Registration Failed", isDismissiblePage());
            }
        },
        closeSignInModals: function (response) {
            Modals.SignInModal().CloseWithResponse(response);
        },
        finishRegistration: finishRegistration,
        isValid: {
            phoneInputValue: function (phoneInputElement, phoneInputValue) {
                if (phoneInputElement.length !== 1) {
                    return true;    // no phone element, so nothing to validate - technically it is true
                }

                var trimmedPhone = $.trim(phoneInputValue || '');
                var phone = trimmedPhone.replace(/[^0-9]/g, '');
                if (!phone || phone.length < 10) {
                    Notification.Tooltip.Show("Please enter a valid phone number", $(phoneInputElement));
                    return false;
                }
                return true;
            }
        }
    };
})(typeof ga === 'undefined' ? function () { } : ga, typeof gtag_report_conversion === 'undefined' ? function () { console.log("Emulating gtag_report_conversion function.");} : gtag_report_conversion );
if (CINC.Core.CookiesVanilla.Get('cookie_banner') === 'accepted') {
    RemoveCookieBanner();
}
var acceptCookieButton = document.getElementById("accept-cookie-notification");
if (acceptCookieButton) {
    acceptCookieButton.addEventListener("click", StoreAcceptedCookiePopUp);
}

function StoreAcceptedCookiePopUp() {
    // store cookie Set it expire in 90 days
    CINC.Core.CookiesVanilla.Set('cookie_banner', 'accepted', 90);
    RemoveCookieBanner();
}
function RemoveCookieBanner() {
    var cookieBanner = document.getElementById("cookie-banner");
    if (cookieBanner) {
        cookieBanner.parentNode.removeChild(cookieBanner);
    }
}

if (CINC.Core.CookiesVanilla.Get('emergency_banner') === 'closed') {
    RemoveEmergencyBanner();
}
var closeEmergencyButton = document.getElementById("close-emergency-notification");
if (closeEmergencyButton) {
    closeEmergencyButton.addEventListener("click", StoreClosedEmergencyBanner);
}

function StoreClosedEmergencyBanner() {
    // store Emergency closure to expire in 7 days
    CINC.Core.CookiesVanilla.Set('emergency_banner', 'closed', 7);
    RemoveEmergencyBanner();
}
function RemoveEmergencyBanner() {
    var emergencyBanner = document.getElementById("emergency-banner");
    if (emergencyBanner) {
        emergencyBanner.parentNode.removeChild(emergencyBanner);
    }
}
CINC = (typeof CINC === 'undefined' ? {} : CINC);
CINC.Integrations = {};
CINC.Integrations.Facebook = {};
CINC.Integrations.Google = {};

(function (ga) {
    $(document).ready(function () {
        HideAccountSettingsEditors();
        DoWireups();
        $("#user-timezone").val(new Date().getTimezoneOffset() / 60);
        if ( (!CINC.User || !CINC.User.IsLoggedIn) && !!CINC.QS.showSignIn && CINC.QS.showSignIn === "1") {
            PromptForLogin();
        }

        if (CINC.User && (CINC.User.securityLevel == 5) && (CINC.User.validCellPhone == "False") && (CINC.User.count_Login%3 == 0)  && document.cookie.indexOf('PromptForValidCellPhone=true') == -1) {
            document.cookie = "PromptForValidCellPhone=true";
            PromptForValidCellPhone();
        }

        if (window.location.search.indexOf('obliterate_all_communication') > 0 || window.location.search.indexOf('unsubscribe_email') > 0 || window.location.search.indexOf('unsubscribe_text') > 0 || window.location.search.indexOf('On_PropertyAlerts') > 0) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.pushState({ path: newurl }, '', newurl);
            Notification.Banner.Success('Your communication settings have been updated.', 'Updated Communication Settings!');
        }
    });

    var HideAccountSettingsEditors = function () {
        $(".js-accountsettingseditor").hide();
    };

    var DoWireups = function () {

        $('.js-update-cellphone').on('click', function (e) {
            e.preventDefault();
            var cellPhone = $('.js-new-cellphone').val().replace('-', '');

            if (cellPhone.length !== 10 || /[a-zA-Z]/i.test(cellPhone))
            { 
                Notification.Banner.Error("Phone number must be 10 digits and contain no characters.");
                return;
            }

            var args = {
                CellPhone: cellPhone,
            };
            CINC.Api.Account('update')
                .post(args)
                .success(function (u) {
                    Notification.Banner.Success('Your cell phone number has been updated successfully.', 'Updated Cell Phone!');
                    Modals.LeadValidCellModal().Close();
                })
                .fail(function (f) {
                    Modals.LeadValidCellModal().Close();
                });
        });

        $('.js-cancel-cellphone').on('click', function (e) {
            e.preventDefault();
            Modals.LeadValidCellModal().Close();
        });

        $(".js-promptforlogin").on('click', function (e) {
            e.preventDefault();
            PromptForLogin();
        });

        $(".js-logout").on('click', function (e) {
            e.preventDefault()
            CINC.Api.Account('logout')
                .post()
                .success(function (result) {
                    window.location = '/';
                })
                .fail(function (f) {
                });
        });

        $(".js-promptforsignup").on('click', function (e) {
            e.preventDefault();
            PromptForSignup();
        });

        $('.js-apply-now-loan').on('click', function (e) {
        });

        $("form.js-loginform").on('submit', function (e) {
            e.preventDefault();
            var data = $(this).serializeObject();
            if (!data.Email || !IsEmail(data.Email)) {
                var emailElement = $(this).find("[name=Email]");
                Notification.Tooltip.Show("Please enter a valid email", emailElement);
                return;
            }

            CINC.Registration.closeSignInModals('Sign In');
            data.Timezone = CINC.currentTimezone();
            data.TimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            CINC.Api.Account('login')
                .post(data)
                .success(function (result) {
                    if (result.isSuccess) {
                        if (result.userInfo && result.userInfo.securityLevel >= 10 && result.userInfo.securityLevel < 25 && _.isString(result.userInfo.dashboardUrl)) {

                            window.location = result.userInfo.dashboardUrl;

                        } else {
                            window.location.reload();
                        }
                    } else {
                        PromptForLogin("Invalid Login", true);
                        Notification.Banner.Error("Click here if you need help getting back into your account.", "Invalid Login", { onclick: function () { window.location = '/account/forgotpassword'; } });
                    }
                })
                .fail(function (f) { Notification.Banner.Error(f.responseText, "Login Error"); PromptForLogin("Login Failed", true); });
        });

        /* Inquiry Form */
        $('.js-inquiry-form').find('input, select, textarea').each(function () {
            var qsValue = CINC.QS[$(this).attr('name').toLowerCase()];
            if (qsValue)
                $(this).val(qsValue);
        });

        $('.js-inquiry-form').on('submit', function (e) {
            e.preventDefault();

            var $form = $(this);
            var data = $form.serializeObject();

            var searchTermsAgree = $form.find('.js-searchtermsagree');
            if (searchTermsAgree.length === 1 && !searchTermsAgree.prop('checked')) {
                Notification.Tooltip.Show("Please accept the terms and conditions", $form.find('.js-searchtermsagree'));
                return;
            }

            var subscribeTextingAgree = $form.find('.js-subscribeTexting');
            if ((subscribeTextingAgree.length === 0 ) || (subscribeTextingAgree.length === 1 && subscribeTextingAgree.prop('checked'))) {
                //if this checkbox doesnt exist we want to assume they want texts
                //this will set the Member Database field UnSubscribed_Text to False
                data.IsSubscribedToText = true;
            }
            else {
                data.IsSubscribedToText = false;
            }

            var $submit = $form.find('input[type="submit"]');
            if ($submit.hasClass('loading')) {
                return false;
            }
            $submit.addClass('loading');

            // Validate contact info; returns updated data if valid; false otherwise
            data = validateContactInfo($form, data);
            if (!data) return;

            var streetElement = $form.find('[name="Street"]');
            if (streetElement.length > 0 && !streetElement.val()) {
                Notification.Tooltip.Show("Please enter a street address", streetElement);
                return;
            }

            var cityElement = $form.find('[name="City"]');
            if (cityElement.length > 0 && !cityElement.val()) {
                Notification.Tooltip.Show("Please enter a city", cityElement);
                return;
            }

            var zipElement = $form.find('[name="Zip"]');
            if (zipElement.length > 0 && !zipElement.val()) {
                Notification.Tooltip.Show("Please enter a street address", zipElement);
                return;
            }

            data.Message = $.trim(data.Message || '');
            var crLf = '\r\n';
            if (data.BuyerLocation || data.BuyerMinPrice || data.BuyerMaxPrice || data.BuyerBeds) {
                data.Message += crLf + crLf +
                    'Buyer Info' + crLf +
                    'Location: ' + (data.BuyerLocation || 'n/a') + crLf +
                    'Price Range: ' + (data.BuyerMinPrice || '$0') + ' - ' + (data.BuyerMaxPrice || 'n/a') + crLf +
                    'Beds: ' + (data.BuyerBeds || 'Any');
                if (data.BuyerPropertyTypes) {
                    data.Message += crLf + 'Property Types: ' + data.BuyerPropertyTypes.replace(/,/g, ', ');
                }
            }
            if (data.PropertyAddress || data.PropertyStyle || data.PropertySqFt || data.PropertyAge || data.PropertyBeds | data.PropertyBaths || data.PropertyFeatures || data.SellerReason || data.SellerTimeframe) {
                data.Message += crLf + crLf +
                    'Seller Info' + crLf +
                    'Current Address: ' + (data.PropertyAddress || 'n/a') + crLf +
                    'Property Style: ' + (data.PropertyStyle || 'n/a') + crLf +
                    'Approx SqFt: ' + (data.PropertySqFt || 'n/a') + crLf +
                    'Property Age: ' + (data.PropertyAge || 'n/a') + crLf +
                    'Beds: ' + (data.PropertyBeds || 'n/a') + crLf +
                    'Baths: ' + (data.PropertyBaths || 'n/a') + crLf +
                    'Special Features: ' + (data.PropertyFeatures || 'n/a') + crLf +
                    'Reason: ' + (data.SellerReason || 'n/a') + crLf +
                    'Timeframe: ' + (data.SellerTimeframe || 'n/a');
            }
            if (data.ReferralFullName || data.ReferralEmail || data.ReferralPhone) {
                data.Message += crLf + crLf +
                    'Referral Info' + crLf +
                    'Referral Name: ' + (data.ReferralFullName || 'n/a') + crLf +
                    'Referral Email: ' + (data.ReferralEmail || 'n/a') + crLf +
                    'Referral Phone: ' + (data.ReferralPhone || 'n/a');
            }
            if (data.LeadType == 'Recruit' || data.ResumeUrl) {
                data.Message += crLf + crLf +
                    'Resume: ' + (data.ResumeUrl || 'n/a')
            }
            if (data.Street) {
                data.Message += crLf + crLf +
                    'Street: ' + (data.Street || 'n/a') + crLf +
                    'City: ' + (data.City || 'n/a') + crLf +
                    'State: ' + (data.State || 'n/a') + crLf +
                    'Zip: ' + (data.Zip || 'n/a')
            }

            data.Message = $.trim(data.Message);

            var loadingModal = Modals.Loading('').Open();

            //set the user_data for Google Analytics Enhanced Conversions if we have the email and phone
            if (data.Email && data.Phone) {
                gtag('set', 'user_data', {
                    "email": data.Email,
                    "phone_number": data.Phone
                });
            }

            CINC.Api.Account('inquiry')
                .post(data)
                .success(function (result) {
                    $('.js-inquiry-formwrap').hide();
                    $('.js-inquiry-success').show();

                    if (!IsLoggedIn) {
                        $('body').append(CINC.Site.ConversionTrackingScripts);

                        if (typeof ga !== 'undefined' && ga !== null) {
                        }
                    }

                    if ($('.js-inquiry-noreload').length == 0 && !IsLoggedIn) {
                        if (CINC.CincProduct.toLowerCase() == 'lender') {
                            loadingModal.Close();
                        } else {
                            window.location.reload(true);
                        }
                    }
                    else {
                        loadingModal.Close();
                    }
                })
                .fail(function (f) {
                    loadingModal.Close();
                    if (f.responseJSON && f.responseJSON.message && f.responseJSON.message == "Email already in use") {
                        var inquiryForm = $('.js-inquiry-form');
                        PromptForLogin({ email: inquiryForm.find('[name=Email]').val() });
                    }
                    else {
                        Notification.Banner.Error(f.responseText, "Error submitting form.");
                    }
                    $submit.removeClass('loading');
                });

            return false;
        });

        function validateContactInfo(form, data) {

            data.FullName = $.trim(data.FullName || '');
            if (!data.FullName || data.FullName.length === 0) {
                Notification.Tooltip.Show("Please enter your name", form.find('[name="FullName"]'));
                return false;
            }

            var firstLast = data.FullName.split(" ");
            if (firstLast.length < 1 || (firstLast.length === 1 && !CINC.Site.Registration_AllowPartialName)) {
                Notification.Tooltip.Show("Please enter your full name", form.find('[name="FullName"]'));
                return false;
            }

            for (var i = 0; i < firstLast.length; i++) {
                if (firstLast[i].length == 0) continue;

                firstLast[i] = firstLast[i].replace(/[^a-zA-Z]+/g, '');
                if (firstLast[i].length == 0) {
                    Notification.Tooltip.Show("Please enter a valid name", form.find('[name="FullName"]'));
                    return false;
                }
            }

            data.Email = $.trim(data.Email || '');
            if (!data.Email || !IsEmail(data.Email)) {
                Notification.Tooltip.Show("Please enter a valid email", form.find('[name="Email"]'));
                return false;
            }

            data.Phone = $.trim(data.Phone || '');
            if (!CINC.Registration.isValid.phoneInputValue(form.find('[name="Phone"]'), data.Phone)) {
                Notification.Tooltip.Show("Please enter a valid phone number", form.find('[name="Phone"]'));
                return false;
            }

            return data;
        }

        var loadingModal = null;
        $('.js-accountsettings-uploadphotoform').fineUploader({
            'request': {
                'endpoint': '/cincapi/upload/upload.aspx'
            }
        }).on('submit', function (event, id, name) {
            loadingModal = Modals.Loading("Uploading photo").Open();
            $(this).fineUploader('setParams', {
                'object': 'uploads',
                'action': 'uploadfiles'
            });
        }).on('complete', function (event, id, name, response) {
            if (response.success) {
                var photo = '/uploads/' + response.data.files[0].FileName;
                UpdatePhoto(photo);
            }
            else {
                Notification.Banner.Error(response.error || '', "Failed to update photo");
            }

            if (loadingModal) loadingModal.Close();
        });

        $('.js-inquiry-uploadresumeform').fineUploader({
            'request': {
                'endpoint': '/cincapi/upload/upload.aspx'
            }
        }).on('submit', function (event, id, name) {
            loadingModal = Modals.Loading("Uploading Resume").Open();
            $(this).fineUploader('setParams', {
                'object': 'uploads',
                'action': 'uploadfiles'
            });
        }).on('complete', function (event, id, name, response) {
            if (response.success) {
                var resumeUrl = response.data.files[0].FileURL;
                $('.js-inquiry-resumeurl').val(resumeUrl);
                $('.js-inquiry-resumeuploaded').show();
            }
            else {
                Notification.Banner.Error(response.error || '', "Failed to upload resume");
            }

            if (loadingModal) loadingModal.Close();
        });

        $('.js-accountsettings-uploadphoto, .js-inquiry-uploadresume').on('click', function (e) {
            e.preventDefault();

            $('.qq-uploader').find('[name=file]').trigger('click');
        });

        $(".js-accountsettingscancel").on('click', function (e) {
            e.preventDefault();

            $('.js-accountsettingsform')[0].reset();
            $(".js-accountsettingseditor").hide();
        });

        $(".js-accountsettingsedit").on('click', function (e) {
            e.preventDefault();

            var editorElement = $(this).closest('tr').next('tr');
            if (editorElement.is(':visible')) return;

            HideAccountSettingsEditors();
            editorElement.fadeIn('slow');
        });

        $(".js-accountsettingsform").on('submit', function (e) {
            e.preventDefault();

            CINC.Api.Account('update')
                .post($(this).serializeObject())
                .success(function (u) { CINC.User = u; window.location.reload(); })
                .displayFailures("Failed to Save");
        });

        $(".js-accountsettings-saveavatar").on('click', function (e) {
            e.preventDefault();

            var selectedAvatar = $('input[name=avatar]:checked', '.pick-avatar').attr('id');
            selectedAvatar = "/avatars/" + selectedAvatar + ".png";

            UpdatePhoto(selectedAvatar);
        });

        $(".js-accountsettings-unsubscribeemail").on('click', function (e) {
            e.preventDefault();
            var value = $(this).data('value');

            var submitEmailUpdate = function (value) {
                CINC.Api.Account('update')
                    .post({ UnsubscribeEmail: value })
                    .success(function () { window.location.reload(); })
                    .displayFailures("Failed to Save");
            };

            if (value) {
                Notification.Prompt.Confirm('Are you sure you would like to be unsubscribed from email?', 'Unsubscribe', {
                    submit: function (e, v) {
                        if (!v) return;
                        submitEmailUpdate(value);
                    }
                });
            }
            else {
                submitEmailUpdate(value);
            }
        });

        $(".js-accountsettings-unsubscribetext").on('click', function (e) {
            e.preventDefault();
            var value = $(this).data('value');

            var submitTextUpdate = function (value) {
                CINC.Api.Account('update')
                    .post({ UnsubscribeText: value })
                    .success(function () { window.location.reload(); })
                    .displayFailures("Failed to Save");
            };

            if (value) {
                Notification.Prompt.Confirm('Are you sure you would like to be unsubscribed from text?', 'Unsubscribe', {
                    submit: function (e, v) {
                        if (!v) return;
                        submitTextUpdate(value);
                    }
                });
            }
            else {
                submitTextUpdate(value);
            }
        });

        $(".js-accountsettings-onpropertyalerts").on('click', function (e) {
            e.preventDefault();
            var value = $(this).data('value');

            var submitPropertyAlertUpdate = function (value) {
                CINC.Api.Account('update')
                    .post({ On_PropertyAlerts: !value })
                    .success(function () { window.location.reload(); })
                    .displayFailures("Failed to Save");
            };

            if (value) {
                Notification.Prompt.Confirm('Are you sure you would like to be unsubscribed from property alerts?', 'Unsubscribe', {
                    submit: function (e, v) {
                        if (!v) return;
                        submitPropertyAlertUpdate(value);
                    }
                });
            }
            else {
                submitPropertyAlertUpdate(value);
            }
        });

        $(".js-accountsettings-onpropertyupdates").on('click', function (e) {
            e.preventDefault();
            var value = $(this).data('value');

            var submitPropertyUpdateUpdate = function (value) {
                CINC.Api.Account('update')
                    .post({ On_PropertyUpdates: !value })
                    .success(function () { window.location.reload(); })
                    .displayFailures("Failed to Save");
            };

            if (value) {
                Notification.Prompt.Confirm('Are you sure you would like to be unsubscribed from property updates?', 'Unsubscribe', {
                    submit: function (e, v) {
                        if (!v) return;
                        submitPropertyUpdateUpdate(value);
                    }
                });
            }
            else {
                submitPropertyUpdateUpdate(value);
            }
        });

        $('.js-facebooksignin').on('click', function (e) {
            e.preventDefault();

            if (IsLoggedIn) return;

            CINC.Registration.closeSignInModals('Log In With Facebook');

            FB.login(function (response) {
                if (response.status !== 'connected') return;

                // only bother with the loading modal if we're waiting for a seconds
                var loadingModal = Modals.Loading("Logging In");
                var loadingModalTimeout = setTimeout(function () {
                    clearTimeout(loadingModalTimeout);
                    loadingModal.Open();
                }, 1000);

                CINC.Api.Account('facebooksignin')
                    .post(response.authResponse)
                    .success(function (r) {
                        if (r.isSuccess) {
                            if (r.isNewUser)
                                SetLoadAction("NotificationBanner", { message: "Welcome to " + CINC.Site.DomainName + ", " + CINC.User.firstName + "!", type: "Info" });

                            window.location.reload();
                        }
                        else {
                            var description = r.description || "";
                            Notification.Banner.Error(description, "Login failed");
                        }
                    })
                    .fail(function (f) {
                        Notification.Banner.Error(f.responseText, "Failed to log in");
                    })
                    .always(function () {
                        loadingModal.Close();
                    });
            }, { scope: 'public_profile,email' });
        });

        function continueFacebookSignup(facebookProfile) {
            CINC.Registration.closeSignInModals('Log In With Facebook');
            CINC.Integrations.Facebook.Auth = facebookProfile.authResponse;
            CINC.Core.CookiesVanilla.Set('registration-state', 'unregistered', 5);

            if (CINC.Core.CookiesVanilla.Get('fbprompt') === '1' || (CINC.QS && CINC.QS['fbprompt'] === '1')) {
                var phoneInputElement = $('.js-signupform-required-phone').find('[name="Phone"]');
                phoneInputElement.val('123456789012345');
                $('.js-signupform-required-phone').trigger('submit');
            }
            else {
                if (CINC.Site.Registration_SocialWithoutPhone) {
                    var signupContext = CINC.Api.Account('facebooksignin');
                    var signupPayload = CINC.Integrations.Facebook.Auth;
                    var loadingModal = Modals.Loading("Signing up now! Give us a second to get you all set up.").Open();
                    signupContext.post(signupPayload).success(function(result) {
                        if (!result.isSuccess) {
                            CINC.Registration.callbacks.registrationError(result, loadingModal);
                        } else {
                            PromptForSignup('', false, '1-phone');
                        }
                        })
                        .fail(function (f) {
                            CINC.Registration.callbacks.registrationApiFailure(f, loadingModal);
                        });;
                } else {
                    PromptForSignup('', false, '1-phone');
                }
            }
        }

        function continueGoogleSignup(googleProfile) {
            CINC.Registration.closeSignInModals('Create Account');
            CINC.Integrations.Google.User = googleProfile;
            CINC.Core.CookiesVanilla.Set('registration-state', 'unregistered', 5);

            if (googleProfile.phoneNumber == null || googleProfile.phoneNumber === '') {
                if (CINC.Site.Registration_SocialWithoutPhone) {
                    var signupContext = CINC.Api.AccountSocialSign('google');
                    var loading = Modals.Loading("Signing up now! Give us a second to get you all set up.").Open();
                    signupContext.post(googleProfile).success(function(result) {
                        if (!result.isSuccess) {
                            CINC.Registration.callbacks.registrationError(result, loading);
                        } else {
                            PromptForSignup('', false, '1-phone');
                        }
                        })
                        .fail(function (f) {
                            CINC.Registration.callbacks.registrationApiFailure(f, loading);
                        });;
                } else {
                    PromptForSignup('', false, '1-phone');
                }
            } else {
                var loadingModal = Modals.Loading("Signing up now! Give us a second to get you all set up.").Open();
                CINC.Api.AccountSocialSign('google').post(googleProfile)
                    .success(function (result) {
                        if (result.isSuccess) {
                            CINC.Registration.callbacks.registrationSuccess(result);
                        } else {
                            CINC.Registration.callbacks.registrationError(result, loadingModal);
                        }
                    })
                    .fail(function (f) {
                        CINC.Registration.callbacks.registrationApiFailure(f, loadingModal);
                    });
            }
        }

        window.onmessage = function (e) {
            if (e.data === 'google-signin-fail') {
                Notification.Banner.Error(
                    'Sorry! We are unable to retrieve your Google profile information. Please register by entering your information in the form.',
                    'Unable to Get Google Profile');
            } else if (e.data === 'facebook-signin-fail') {
                Notification.Banner.Error(
                    'Sorry! We are unable to retrieve your Facebook profile information. Please register by entering your information in the form.',
                    'Unable to Get Facebook Profile');
            } else if (e.data && e.data.authResponse && e.data.status) {
                continueFacebookSignup(e.data);
            } else if (e.data && e.data.familyName && e.data.givenName && e.data.email) {
                continueGoogleSignup(e.data);
            }
        };
    };

    var UpdatePhoto = function (photo) {
        return CINC.Api.Account('update')
            .post({ PhotoLocation: photo })
            .success(function (u) { window.location.reload(); })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to Save Photo"); });
    }
})(typeof ga === 'undefined' || ga === null ? function () { } : ga);
/* 
Signup Form Step 1 (main)
The Castle product currently uses this form for the main signup form on Castle-branded pages.
*/
$(document).ready(function () {
    $('.js-signupform-form').on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var data = $form.serializeObject();
        if (_.isObject(CINC.Property)) {
            data.price = CINC.Property.price;
            data.city = CINC.Property.city;
            data.state = CINC.Property.state;
            data.zip = CINC.Property.zip;
            data.address = CINC.Property.FullAddress;
        }
        var searchTermsAgree = $form.find('.js-searchtermsagree');
        if (searchTermsAgree.length === 1 && !searchTermsAgree.prop('checked')) {
            Notification.Tooltip.Show("Please accept the terms and conditions", $form.find('.js-searchtermsagree'));
            return;
        }

        var subscribeTextingAgree = $form.find('.js-subscribeTexting');
        if ((subscribeTextingAgree.length === 0 ) || (subscribeTextingAgree.length === 1 && subscribeTextingAgree.prop('checked'))) {
            //if this checkbox doesnt exist we want to assume they want texts
            //this will set the Member Database field UnSubscribed_Text to False
            data.IsSubscribedToText = true;
        }
        else {
            data.IsSubscribedToText = false;
        }

        data.FirstName = $.trim(data.FirstName || '');
        if (!data.FirstName || data.FirstName.length === 0) {
            Notification.Tooltip.Show("Please enter your name", $form.find('[name="FirstName"]'));
            return;
        }

        var firstLast = data.FirstName.split(" ");
        if (firstLast.length < 1 || (firstLast.length === 1 && !CINC.Site.Registration_AllowPartialName)) {
            Notification.Tooltip.Show("Please enter your full name", $form.find('[name="FirstName"]'));
            return;
        }

        for (var i = 0; i < firstLast.length; i++) {
            if (firstLast[i].length === 0) continue;

            firstLast[i] = firstLast[i].replace(/[^a-zA-Z]+/g, '');
            if (firstLast[i].length === 0) {
                Notification.Tooltip.Show("Please enter a valid name", $form.find('[name="FirstName"]'));
                return;
            }
        }

        data.Email = $.trim(data.Email || '');
        if (!data.Email || !IsEmail(data.Email)) {
            Notification.Tooltip.Show("Please enter a valid email", $form.find('[name="Email"]'));
            return;
        }

        var phoneInputElement = $form.find('[name="Phone"]');
        if (!CINC.Registration.isValid.phoneInputValue(phoneInputElement, data.Phone)) {
            return;
        }

        var $password = $form.find('[name="Password"]');
        if ($password.length === 1) {
            if (!data.Password || data.Password.length === 0) {
                Notification.Tooltip.Show("Please enter a password", $password);
                return;
            }
        }
        else if (phoneInputElement.length === 1) {
            data.Password = data.Phone;
        }

        data.Timezone = CINC.currentTimezone();
        data.TimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        data.domainDocumentId = CINC.Site.DDID;

        CINC.Registration.closeSignInModals('Create Account');
        var loadingModal = Modals.Loading("Signing up now! Give us a second to get you all set up.").Open();

        CINC.Core.CookiesVanilla.Set('registration-state', 'unregistered', 5);

        /*
            We are switching the registration call from going through the old NewMember
            path to the Lead API endpoint. 12/10/2024
        */

        CINC.Api.ConsumerLead('register')
            .post(data)
            .success(function (result) {
                if (result.isSuccess) {
                    if (window.report_conversion) {
                        window.report_conversion();
                    }
                    CINC.Registration.callbacks.registrationSuccess(result);
                } else {
                    CINC.Registration.callbacks.registrationError(result, loadingModal);
                }
            })
            .fail(function (f) {
                CINC.Registration.callbacks.registrationApiFailure(f, loadingModal);
            })
            .always(function() {
            });

        return false;
    });

    /* Signup Form Step 1.5 (Phone only -- potential 3rd party sign in flow) */
    $('.js-signupform-required-phone').on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var data = $form.serializeObject();
        var phoneInputElement = $form.find('[name="Phone"]');

        if (!CINC.Registration.isValid.phoneInputValue(phoneInputElement, data.Phone)) {
            return;
        }

        // Set up of 3rd party (Facebook or Google) vars
        var signupContext = CINC.Integrations.Facebook.Auth ? CINC.Api.Account('facebooksignin') : CINC.Api.AccountSocialSign('google');
        var signupPayload = CINC.Integrations.Facebook.Auth || CINC.Integrations.Google.User;
        signupPayload.phoneNumber = data.Phone; // Add phone number obtained to payload

        CINC.Registration.closeSignInModals('Phone Number Registration');
        var loadingModal = Modals.Loading("Signing up now! Give us a second to get you all set up.").Open();
        signupContext.post(signupPayload)
            .success(function (result) {
                if (result.isSuccess) {
                    CINC.Registration.callbacks.registrationSuccess(result);
                } else {
                    CINC.Registration.callbacks.registrationError(result, loadingModal);
                }
            })
            .fail(function (f) {
                CINC.Registration.callbacks.registrationApiFailure(f, loadingModal);
            });
    });
});
$(document).ready(function () {
    /* Signup Form Step 2 (Extra Reg) */
    $('.js-signupform-extra').on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var data = $form.serializeObject();

        var fields = ['Prequalified', 'FirstTimeBuyer', 'TimeframeToBuy', 'HouseToSell'];
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (!data.hasOwnProperty(field)) {
                Notification.Tooltip.Show('Please fill out the fields so we can better assist in your home search', $form.find('[name="' + field + '"]').first());
                return;
            }
        }
        if (data.HouseToSell === 'true') {
            CINC.User.houseToSell = true;
        }

        CINC.Registration.closeSignInModals('Create Account');
        var loadingModal = Modals.Loading('').Open();
        CINC.Api.Account('register/extra')
            .post(data)
            .success(function (result) {
                if (CINC.Site.On_DiscQuestionaire) {
                    PromptForSignup('', false, '3');
                } else {
                    CINC.Registration.finishRegistration();
                }
            })
            .fail(function (f) {
                Notification.Banner.Error(f.responseText, "Submission Error");
                PromptForSignup('Submission Failed', false, '2');
            });

        return false;
    });
});
CINC = (typeof CINC === 'undefined' ? {} : CINC);

$(document).ready(function () {
    /* Signup Form Step 3 (DISC) */
    $('.js-signupform-disc').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);

        var $radio = $form.find('[name="DiscType"]:checked');
        if ($radio.length === 0) {
            Notification.Tooltip.Show('Please fill out the fields so we can better assist in your home search', $form.find('[name="DiscType"]').first());
            return;
        }

        var data = {
            DiscType: $radio.val(),
            DiscAnswer: $radio.next('label').text()
        };

        CINC.Registration.closeSignInModals('Create Account');
        var loadingModal = Modals.Loading('').Open();
        CINC.Api.Account('register/disc')
            .post(data)
            .success(function (result) {
                if (CINC.User.houseToSell) {
                    PromptForSignup('Submission Failed', false, '3a');
                    var standAloneAutoComplete = document.getElementById('autocomplete-claim-your-home');
                    standAloneAutoComplete.focus();
                }
                else {
                    CINC.Registration.finishRegistration();
                }
            })
            .fail(function (f) {
                Notification.Banner.Error(f.responseText, "Submission Error");
                PromptForSignup('Submission Failed', false, '3');
            });

        return false;
    });

    /* Signup Form Step 3a (Seller) */

    var standAloneAutoComplete = document.getElementById('autocomplete-claim-your-home');

    if (standAloneAutoComplete != null && standAloneAutoComplete && !CINC.Core.IsBot()) {
        var streetAddress = $('#claim-your-home-street-address');
        var streetNumber = $('#claim-your-home-street-number');
        var streetName = $('#claim-your-home-street-name');
        var city = $('#claim-your-home-city');
        var state = $('#claim-your-home-state');
        var zip = $('#claim-your-home-zip');
        var lat = $('#claim-your-home-lat');
        var long = $('#claim-your-home-long');
        initAutoComplete('autocomplete-claim-your-home');
    }

    //stand-alone autocomplete for Step 3a modal
    function initAutoComplete(autoCompleteId) {
        var input = document.getElementById(autoCompleteId);
        var _addEventListener = input.addEventListener
            ? input.addEventListener
            : input.attachEvent;
        function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.
            var orig_listener = listener;
            listener = function (event) {
                var suggestion_selected =
                    document.getElementsByClassName("pac-item-selected").length > 0;
                if (event.which == 13 && !suggestion_selected) {
                    input.dispatchEvent(new CustomEvent('enterKeyPressedWithSelectedProperty'));
                    var simulatedEvent = document.createEvent("Event");
                    simulatedEvent.keyCode = 40;
                    simulatedEvent.which = 40;
                    orig_listener.apply(input, [simulatedEvent]);
                }
                orig_listener.apply(input, [event]);
            };

            _addEventListener.apply(input, [type, listener]);
        }

        input.addEventListener = addEventListenerWrapper;
        input.attachEvent = addEventListenerWrapper;

        var autocomplete = new google.maps.places.Autocomplete(document.getElementById(autoCompleteId),
            { types: ['address'], componentRestrictions: { country: ['us', 'ca'] } });
        autocomplete.setFields(["address_components",
            "adr_address",
            "alt_id",
            "formatted_address",
            "geometry",
            "icon",
            "id",
            "name",
            "photo",
            "place_id",
            "scope",
            "type",
            "url",
            "vicinity"]);

        function formatResult(place) {
            var ADDRESS_COMPONENTS = {
                subpremise: "short_name",
                street_number: "short_name",
                route: "long_name",
                locality: "long_name",
                sublocality_level_1: "long_name",
                neighborhood: "long_name",
                administrative_area_level_1: "short_name",
                administrative_area_level_2: "long_name",
                country: "long_name",
                postal_code: "short_name",
            };
            var returnData = {};
            // Loop through google's address component object
            for (var i = 0; i < place.address_components.length; i++) {
                // Look through the list of types for a given component
                // Each component can have multiple types, and the first in the list is not always the one we're keying on
                for (var j = 0; j < place.address_components[i].types.length; j++) {
                    var addressType = place.address_components[i].types[j];
                    if (ADDRESS_COMPONENTS[addressType]) {
                        var val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                        returnData[addressType] = val;
                        break;
                    }
                }
            }
            returnData["latitude"] = place.geometry.location.lat();
            returnData["longitude"] = place.geometry.location.lng();
            return returnData;
        }

        function parseAddress(address) {
            if (address === null) return null;
            return {
                streetAddress: address.street_number
                    ? address.street_number + ' ' + address.route
                    : address.route,
                streetNumber: address.street_number,
                streetName: address.route,
                city: address.locality || address.sublocality_level_1 || address.neighborhood || "",
                state: address.administrative_area_level_1 || "",
                zip: address.postal_code || "00000",
                latitude: address.latitude,
                longitude: address.longitude
            };
        }

        autocomplete.addListener("place_changed", function () {
            const autocompleteElement = document.getElementById('autocomplete-claim-your-home');
            const GoogleMapsGeocoder = new google.maps.Geocoder();

            GoogleMapsGeocoder.geocode({ 'address': autocompleteElement.value }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    const place = results[0];

                    if (!place.geometry) {
                        // User entered the name of a Place that was not suggested and
                        // pressed the Enter key, or the Google Geocoder request failed.
                        Notification.Tooltip.Show('Please enter a valid address', autocompleteField);
                        return;
                    }

                    const resultingObject = formatResult(place);
                    const parsedAddress = parseAddress(resultingObject);
                    if (parsedAddress) {
                        if (streetNumber) {
                            streetNumber.attr('value', parsedAddress.streetNumber);
                        }
                        if (streetName) {
                            streetName.attr('value', parsedAddress.streetName);
                        }
                        if (streetAddress) {
                            streetAddress.attr('value', parsedAddress.streetAddress);
                        }
                        if (city)
                            city.attr('value', parsedAddress.city);
                        if (state) {
                            state.attr('value', parsedAddress.state);
                        }
                        if (zip) {
                            zip.attr('value', parsedAddress.zip);
                        }
                        if (lat) {
                            lat.attr('value', parsedAddress.latitude);
                        }
                        if (long) {
                            long.attr('value', parsedAddress.longitude);
                        }
                    }
                }
                else {
                    Notification.Tooltip.Show('Please enter a valid address', autocompleteElement);
                    return;
                }
            });

        });
    }

    $('.js-signupform-seller').on('submit', function (e) {
        e.preventDefault();

        var submittingStatusElement = $('#claim-your-home-submitting');
        var submittingStatus = submittingStatusElement[0].value;
        if (submittingStatus) {
            // Don't allow the ENTER key to spam requests.
            return false;
        }

        // Check hidden inputs for valid data to prevent form from attempting to submit before it has data
        // (this fixes a bug where an invalid request would be sent to the server)
        // (this also fixes the behavior where the form submits the first time the user presses ENTER)
        var hiddenStreetAddress = $('#claim-your-home-street-address')[0].value;
        if (!hiddenStreetAddress) {
            return false;
        }

        var $form = $(this);
        var data = $form.serializeObject();

        if (data.hasOwnProperty('Address') || $.trim(data['Address']).length > 0) {
            //This regex accepts minimum three character and there is no limit on max characters.Characters may include a - z, A - Z alphabets, whitespace, comma(,), dot(.), apostrophe('), and dash(-) symbols.
            var addressRGEX = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);
            var validAddress = addressRGEX.test(data['Address']);
            if (!validAddress) {
                Notification.Tooltip.Show('Please enter a valid address', $form.find('[name="Address"]').first());
                return;
            }
        } else {
            Notification.Tooltip.Show('Please fill out the fields so we can better assist in your home search', $form.find('[name="Address"]').first());
            return;
        }

        if (data.hasOwnProperty('UnitNumber') || $.trim(data['UnitNumber']).length > 0) {
            //Characters may include a - z, A - Z alphabets, whitespace, comma(,), dot(.), apostrophe('), and dash(-) symbols.
            var unitRGEX = /^[a-zA-Z0-9\s,.'-]*$/;

            var validUnit = unitRGEX.test(data['UnitNumber']);
            if (!validUnit) {
                Notification.Tooltip.Show('Please enter a valid unit number', $form.find('[name="UnitNumber"]').first());
                return;
            }
        }

        submittingStatusElement.val('submitting');

        CINC.Registration.closeSignInModals('Create Account');
        var loadingModal = Modals.Loading('').Open();

        //create a homepulse session
        var apiUrl;
        if (CINC.InDev || CINC.InStaging) {// use UAT endpoint
            apiUrl = "https://uat.consumer-seller.cincapi.com/api/sessionexternal";
        } else {// use PROD endpoint
            apiUrl = "https://consumer-seller.cincapi.com/api/sessionexternal";
        }

        var payload =
        {
            "streetAddress": data['StreetAddress'],
            "city": data['City'],
            "state": data['State'],
            "zip": data['Zip'],
            "longitude": parseFloat(data['Longitude']),
            "latitude": parseFloat(data['Latitude']),
            "unit": data['UnitNumber'],
            "memberId": CINC.User.mdid
        };

        $.ajax({
            url: apiUrl,
            type: "POST",
            headers: { "x-domain-document-id": CINC.Site.DDID },
            processData: false,
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: function (result) {
                //fullstory
                if (typeof FS !== "undefined" && FS !== null && FS.event) {
                    FS.event('buyer registration homepulse claimed', {
                        pageName_str: 'Registration Model',
                        leadType_str: 'buyer'
                    });
                }
                CINC.Registration.finishRegistration();
            },
            failure: function (f) {
                Notification.Banner.Error(f.responseText, "Submission Error");
                PromptForSignup('Submission Failed', false, '3a');
            }
        });
    });

    $('.js-signupform-seller-close').on('click', function () {
        CINC.Registration.finishRegistration();
    });
});



CINC = (typeof CINC === 'undefined' ? {} : CINC);

(function () {

    $('.js-agentbio-readmore').on('click', function () {
        var mdid = $(this).data('mdid');
        var target = $('.js-agentbio-readmore-' + mdid);
        var current = target.css('max-height');
        if (current === 'none') {
            target.css('max-height', '100px');
            $(this).html('READ MORE');
            target.removeClass('no-background');
        }
        else {
            target.css('max-height', 'none');
            $(this).html('LESS');
            target.addClass('no-background');
        }
    });

    var FinishMapInit = CINC.Core.FinishMapInit = function () {
        if (CINC.SellerSuite && CINC.SellerSuite.FinishMapInit) {
            CINC.SellerSuite.FinishMapInit();
            return;
        }
        InitRichMarker();
        EasyMapInit();
        if (CINC.Search && CINC.Search.FinishMapInit) {
            CINC.Search.FinishMapInit();
        }
        if (CINC.Details && CINC.Details.FinishMapInit) {
            CINC.Details.FinishMapInit();
        }
    };

    var EasyMapInit = function () {
        $('.js-easymap').each(function () {

            var $wrap = $(this);
            var controls = !($wrap.attr('data-easymap-controls') === 'false');
            var lat = parseFloat($wrap.attr('data-easymap-lat'));
            var lng = parseFloat($wrap.attr('data-easymap-lng'));
            var name = $.trim($wrap.attr('data-easymap-name'));
            var zoom = parseInt($wrap.attr('data-easymap-zoom'));

            if (lat === 0 || lng === 0) {
                $wrap.remove();
                return;
            }

            var mapOptions = {
                center: new google.maps.LatLng(lat, lng),
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.BOTTOM_LEFT
                },
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoom: (zoom > 0 ? zoom : 11),
                draggable: true,
                scrollwheel: false,
                disableDefaultUI: !controls
            };
            var map = new google.maps.Map(this, mapOptions);

            if (name.length > 0) {
                var marker = new RichMarker({
                    content: '<div class="map-marker map-marker-dark map-marker-noninteractive"><span class="map-marker-title">' + name.htmlEncode() + '</span></div>',
                    draggable: false,
                    map: map,
                    position: new google.maps.LatLng(lat, lng),
                    shadow: ''
                });
            }

        });
    };

    var InitRichMarker = function () {
        (function () {
            var b = true, f = false; function g(a) { var c = a || {}; this.d = this.c = f; if (a.visible === undefined) a.visible = b; if (a.shadow === undefined) a.shadow = "7px -3px 5px rgba(88,88,88,0.7)"; if (a.anchor == undefined) a.anchor = i.BOTTOM; this.setValues(c) } g.prototype = new google.maps.OverlayView; window.RichMarker = g; g.prototype.getVisible = function () { return this.get("visible") }; g.prototype.getVisible = g.prototype.getVisible; g.prototype.setVisible = function (a) { this.set("visible", a) }; g.prototype.setVisible = g.prototype.setVisible;
            g.prototype.s = function () { if (this.c) { this.a.style.display = this.getVisible() ? "" : "none"; this.draw() } }; g.prototype.visible_changed = g.prototype.s; g.prototype.setFlat = function (a) { this.set("flat", !!a) }; g.prototype.setFlat = g.prototype.setFlat; g.prototype.getFlat = function () { return this.get("flat") }; g.prototype.getFlat = g.prototype.getFlat; g.prototype.p = function () { return this.get("width") }; g.prototype.getWidth = g.prototype.p; g.prototype.o = function () { return this.get("height") }; g.prototype.getHeight = g.prototype.o;
            g.prototype.setShadow = function (a) { this.set("shadow", a); this.g() }; g.prototype.setShadow = g.prototype.setShadow; g.prototype.getShadow = function () { return this.get("shadow") }; g.prototype.getShadow = g.prototype.getShadow; g.prototype.g = function () { if (this.c) this.a.style.boxShadow = this.a.style.webkitBoxShadow = this.a.style.MozBoxShadow = this.getFlat() ? "" : this.getShadow() }; g.prototype.flat_changed = g.prototype.g; g.prototype.setZIndex = function (a) { this.set("zIndex", a) }; g.prototype.setZIndex = g.prototype.setZIndex;
            g.prototype.getZIndex = function () { return this.get("zIndex") }; g.prototype.getZIndex = g.prototype.getZIndex; g.prototype.t = function () { if (this.getZIndex() && this.c) this.a.style.zIndex = this.getZIndex() }; g.prototype.zIndex_changed = g.prototype.t; g.prototype.getDraggable = function () { return this.get("draggable") }; g.prototype.getDraggable = g.prototype.getDraggable; g.prototype.setDraggable = function (a) { this.set("draggable", !!a) }; g.prototype.setDraggable = g.prototype.setDraggable;
            g.prototype.k = function () { if (this.c) this.getDraggable() ? j(this, this.a) : k(this) }; g.prototype.draggable_changed = g.prototype.k; g.prototype.getPosition = function () { return this.get("position") }; g.prototype.getPosition = g.prototype.getPosition; g.prototype.setPosition = function (a) { this.set("position", a) }; g.prototype.setPosition = g.prototype.setPosition; g.prototype.q = function () { this.draw() }; g.prototype.position_changed = g.prototype.q; g.prototype.l = function () { return this.get("anchor") }; g.prototype.getAnchor = g.prototype.l;
            g.prototype.r = function (a) { this.set("anchor", a) }; g.prototype.setAnchor = g.prototype.r; g.prototype.n = function () { this.draw() }; g.prototype.anchor_changed = g.prototype.n; function l(a, c) { var d = document.createElement("DIV"); d.innerHTML = c; if (d.childNodes.length == 1) return d.removeChild(d.firstChild); else { for (var e = document.createDocumentFragment() ; d.firstChild;) e.appendChild(d.firstChild); return e } } function m(a, c) { if (c) for (var d; d = c.firstChild;) c.removeChild(d) }
            g.prototype.setContent = function (a) { this.set("content", a) }; g.prototype.setContent = g.prototype.setContent; g.prototype.getContent = function () { return this.get("content") }; g.prototype.getContent = g.prototype.getContent;
            g.prototype.j = function () {
                if (this.b) {
                    m(this, this.b); var a = this.getContent(); if (a) { if (typeof a == "string") { a = a.replace(/^\s*([\S\s]*)\b\s*$/, "$1"); a = l(this, a) } this.b.appendChild(a); var c = this; a = this.b.getElementsByTagName("IMG"); for (var d = 0, e; e = a[d]; d++) { google.maps.event.addDomListener(e, "mousedown", function (h) { if (c.getDraggable()) { h.preventDefault && h.preventDefault(); h.returnValue = f } }); google.maps.event.addDomListener(e, "load", function () { c.draw() }) } google.maps.event.trigger(this, "domready") } this.c &&
                    this.draw()
                }
            }; g.prototype.content_changed = g.prototype.j; function n(a, c) { if (a.c) { var d = ""; if (navigator.userAgent.indexOf("Gecko/") !== -1) { if (c == "dragging") d = "-moz-grabbing"; if (c == "dragready") d = "-moz-grab" } else if (c == "dragging" || c == "dragready") d = "move"; if (c == "draggable") d = "pointer"; if (a.a.style.cursor != d) a.a.style.cursor = d } }
            function o(a, c) { if (a.getDraggable()) if (!a.d) { a.d = b; var d = a.getMap(); a.m = d.get("draggable"); d.set("draggable", f); a.h = c.clientX; a.i = c.clientY; n(a, "dragready"); a.a.style.MozUserSelect = "none"; a.a.style.KhtmlUserSelect = "none"; a.a.style.WebkitUserSelect = "none"; a.a.unselectable = "on"; a.a.onselectstart = function () { return f }; p(a); google.maps.event.trigger(a, "dragstart") } }
            function q(a) { if (a.getDraggable()) if (a.d) { a.d = f; a.getMap().set("draggable", a.m); a.h = a.i = a.m = null; a.a.style.MozUserSelect = ""; a.a.style.KhtmlUserSelect = ""; a.a.style.WebkitUserSelect = ""; a.a.unselectable = "off"; a.a.onselectstart = function () { }; r(a); n(a, "draggable"); google.maps.event.trigger(a, "dragend"); a.draw() } }
            function s(a, c) { if (!a.getDraggable() || !a.d) q(a); else { var d = a.h - c.clientX, e = a.i - c.clientY; a.h = c.clientX; a.i = c.clientY; d = parseInt(a.a.style.left, 10) - d; e = parseInt(a.a.style.top, 10) - e; a.a.style.left = d + "px"; a.a.style.top = e + "px"; var h = t(a); a.setPosition(a.getProjection().fromDivPixelToLatLng(new google.maps.Point(d - h.width, e - h.height))); n(a, "dragging"); google.maps.event.trigger(a, "drag") } } function k(a) { if (a.f) { google.maps.event.removeListener(a.f); delete a.f } n(a, "") }
            function j(a, c) { if (c) { a.f = google.maps.event.addDomListener(c, "mousedown", function (d) { o(a, d) }); n(a, "draggable") } } function p(a) { if (a.a.setCapture) { a.a.setCapture(b); a.e = [google.maps.event.addDomListener(a.a, "mousemove", function (c) { s(a, c) }, b), google.maps.event.addDomListener(a.a, "mouseup", function () { q(a); a.a.releaseCapture() }, b)] } else a.e = [google.maps.event.addDomListener(window, "mousemove", function (c) { s(a, c) }, b), google.maps.event.addDomListener(window, "mouseup", function () { q(a) }, b)] }
            function r(a) { if (a.e) { for (var c = 0, d; d = a.e[c]; c++) google.maps.event.removeListener(d); a.e.length = 0 } }
            function t(a) { var c = a.l(); if (typeof c == "object") return c; var d = new google.maps.Size(0, 0); if (!a.b) return d; var e = a.b.offsetWidth; a = a.b.offsetHeight; switch (c) { case i.TOP: d.width = -e / 2; break; case i.TOP_RIGHT: d.width = -e; break; case i.LEFT: d.height = -a / 2; break; case i.MIDDLE: d.width = -e / 2; d.height = -a / 2; break; case i.RIGHT: d.width = -e; d.height = -a / 2; break; case i.BOTTOM_LEFT: d.height = -a; break; case i.BOTTOM: d.width = -e / 2; d.height = -a; break; case i.BOTTOM_RIGHT: d.width = -e; d.height = -a } return d }
            g.prototype.onAdd = function () {
                if (!this.a) { this.a = document.createElement("DIV"); this.a.style.position = "absolute" } if (this.getZIndex()) this.a.style.zIndex = this.getZIndex(); this.a.style.display = this.getVisible() ? "" : "none"; if (!this.b) {
                    this.b = document.createElement("DIV"); this.a.appendChild(this.b); var a = this; google.maps.event.addDomListener(this.b, "click", function () { google.maps.event.trigger(a, "click") }); google.maps.event.addDomListener(this.b, "mouseover", function () { google.maps.event.trigger(a, "mouseover") });
                    google.maps.event.addDomListener(this.b, "mouseout", function () { google.maps.event.trigger(a, "mouseout") })
                } this.c = b; this.j(); this.g(); this.k(); var c = this.getPanes(); c && c.overlayImage.appendChild(this.a); google.maps.event.trigger(this, "ready")
            }; g.prototype.onAdd = g.prototype.onAdd;
            g.prototype.draw = function () { if (!(!this.c || this.d)) { var a = this.getProjection(); if (a) { var c = this.get("position"); a = a.fromLatLngToDivPixel(c); c = t(this); this.a.style.top = a.y + c.height + "px"; this.a.style.left = a.x + c.width + "px"; a = this.b.offsetHeight; c = this.b.offsetWidth; c != this.get("width") && this.set("width", c); a != this.get("height") && this.set("height", a) } } }; g.prototype.draw = g.prototype.draw; g.prototype.onRemove = function () { this.a && this.a.parentNode && this.a.parentNode.removeChild(this.a); k(this) };
            g.prototype.onRemove = g.prototype.onRemove; var i = { TOP_LEFT: 1, TOP: 2, TOP_RIGHT: 3, LEFT: 4, MIDDLE: 5, RIGHT: 6, BOTTOM_LEFT: 7, BOTTOM: 8, BOTTOM_RIGHT: 9 }; window.RichMarkerPosition = i;
        })();
        google.maps.Polyline.prototype.simplifyLine = function (tolerance) {
            var res = null;

            if (this.getPath() && this.getPath().getLength()) {
                var points = this.getPath().getArray();

                var Line = function (p1, p2) {
                    this.p1 = p1;
                    this.p2 = p2;

                    this.distanceToPoint = function (point) {
                        // slope
                        var m = (this.p2.lat() - this.p1.lat()) / (this.p2.lng() - this.p1.lng()),
                            // y offset
                            b = this.p1.lat() - (m * this.p1.lng()),
                            d = [];
                        // distance to the linear equation
                        d.push(Math.abs(point.lat() - (m * point.lng()) - b) / Math.sqrt(Math.pow(m, 2) + 1));
                        // distance to p1
                        d.push(Math.sqrt(Math.pow((point.lng() - this.p1.lng()), 2) + Math.pow((point.lat() - this.p1.lat()), 2)));
                        // distance to p2
                        d.push(Math.sqrt(Math.pow((point.lng() - this.p2.lng()), 2) + Math.pow((point.lat() - this.p2.lat()), 2)));
                        // return the smallest distance
                        return d.sort(function (a, b) {
                            return (a - b); //causes an array to be sorted numerically and ascending
                        })[0];
                    };
                };

                var douglasPeucker = function (points, tolerance) {
                    if (points.length <= 2) {
                        return [points[0]];
                    }
                    var returnPoints = [],
                        // make line from start to end 
                        line = new Line(points[0], points[points.length - 1]),
                        // find the largest distance from intermediate poitns to this line
                        maxDistance = 0,
                        maxDistanceIndex = 0,
                        p;
                    for (var i = 1; i <= points.length - 2; i++) {
                        var distance = line.distanceToPoint(points[i]);
                        if (distance > maxDistance) {
                            maxDistance = distance;
                            maxDistanceIndex = i;
                        }
                    }
                    // check if the max distance is greater than our tollerance allows 
                    if (maxDistance >= tolerance) {
                        p = points[maxDistanceIndex];
                        line.distanceToPoint(p, true);
                        // include this point in the output 
                        returnPoints = returnPoints.concat(douglasPeucker(points.slice(0, maxDistanceIndex + 1), tolerance));
                        // returnPoints.push( points[maxDistanceIndex] );
                        returnPoints = returnPoints.concat(douglasPeucker(points.slice(maxDistanceIndex, points.length), tolerance));
                    } else {
                        // ditching this point
                        p = points[maxDistanceIndex];
                        line.distanceToPoint(p, true);
                        returnPoints = [points[0]];
                    }
                    return returnPoints;
                };
                res = douglasPeucker(points, tolerance);
                // always have to push the very last point on so it doesn't get left off
                res.push(points[points.length - 1]);
            }
            return res;
        };
        delete CINC.Search.InitRichMarker;
    };

    var ShowPrompt = CINC.Core.ShowPrompt = function (force) {
        force = (typeof force === 'undefined' ? false : force);

        if (CINC.User && CINC.User.securityLevel && CINC.User.securityLevel > 0) {
            return;
        }

        if (CINC.QS && CINC.QS['showprompt'] === '1') {
            force = true;
        }

        if (CINC.Core.CookiesVanilla.Get('fbprompt') == '1' || (CINC.QS && CINC.QS['fbprompt'] === '1')) {
            force = true;
            CINC.Core.CookiesVanilla.Set('fbprompt', '1', 1);

            // remove fbprompt=1 from the querystring so customers don't get any ideas
            try
            {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (window.location.search)
                {
                    var newsearch = "?" + $.grep(window.location.search.substring(1).split('&'), function (v) {
                        return v != 'fbprompt=1';
                    }).join('&');
                    if (newsearch != '?')
                        newurl += newsearch;
                }

                History.pushState({ path: newurl }, '', newurl);
            }
            catch (err)
            {

            }
        }

        if (CINC.QS && CINC.QS['mobilehideviews']) {
            var maxViews = parseInt(CINC.QS['mobilehideviews']);
            if (maxViews > 0) {
                CINC.Site.PromptViews = maxViews;
                CINC.Core.CookiesVanilla.Set('maxviews', maxViews, 1);
            }
        }
        else if (CINC.Core.CookiesVanilla.Get('maxviews') !== '') {
            var maxViews = parseInt(CINC.Core.CookiesVanilla.Get('maxviews'));
            if (maxViews > 0) {
                CINC.Site.PromptViews = maxViews;
            }
        }

        var controller = (CINC.ControllerName || '').toLowerCase();
        var views = (parseInt(CINC.Core.CookiesVanilla.Get('promptviews')) || 0);
        if (!force) {
            if (CINC.Site.PromptLevel === 0 || controller === 'sellersuite') {
                return;
            }
            switch (CINC.Site.PromptPages) {
                case 0:
                    if (controller === 'account') {
                        return;
                    }
                    break;
                case 1:
                    if (controller !== 'details') {
                        return;
                    }
                    break;
                case 2:
                    if (controller !== 'search') {
                        return;
                    }
                    break;
                case 3:
                    if (controller !== 'details' && controller !== 'search') {
                        return;
                    }
                    break;
            }
            CINC.Core.CookiesVanilla.Set('promptviews', ++views, 7);
            if (views <= CINC.Site.PromptViews) {
                return;
            }
        }

        var allowDismiss = !(force || CINC.Site.PromptLevel > 1);
        CINC.Core.PromptForSignup('', allowDismiss);
    };

    var acceptTermsCallback = null;
    var HandleAcceptCheckboxChange = function (e) {
        e.preventDefault();
        var checked = $(this).prop('checked');
        $('.js-acceptterms-checkbox').prop('checked', checked);
        CINC.Core.CookiesVanilla.Get('acceptterms', checked ? '1' : '0');
        e.stopPropagation();
        return false;
    };

    var BindAcceptTerms = CINC.Core.BindAcceptTerms = function () {
        $('.js-acceptterms-checkbox').off('change', HandleAcceptCheckboxChange).on('change', HandleAcceptCheckboxChange);
        if (CINC.Core.CookiesVanilla.Get('acceptterms') === '1') {
            $('.js-acceptterms-checkbox').prop('checked', true);
        }
    };

    var InitAcceptTerms = CINC.Core.InitAcceptTerms = function () {
        if (!CINC.Site.SearchRequiresAccept) {
            return;
        }
        $('.js-acceptterms-accept').on('click', function () {
            $.cookie('acceptterms', '1');
            $('.js-acceptterms-checkbox').prop('checked', true);
            $('#acceptterms-modal').prop('checked', false);
            if (acceptTermsCallback !== null && typeof acceptTermsCallback === 'function') {
                acceptTermsCallback();
                acceptTermsCallback = null;
            }
        });
        if ((CINC.ControllerName || '').toLowerCase() === 'search' && ((CINC.ActionName || '') !== 'PDQ')) {
            AcceptTerms(false);
        }
    };

    var InitOptIn = CINC.Core.InitOptIn = function () {
        if (!CINC.User || !CINC.User.user_IsImport) {
            return;
        }
        $('.js-importoptin-accept').on('click', function () {
            $('#optinimport-modal').prop('checked', false);
            // ajax request
            var data = {
                MDID: CINC.User.mdid,
                CellPhone: $('.optin-modal').find('input[name="cellphone"]').val(),
            };
            CINC.Api.Account('importoptin')
                .post(data);
        });
    };

    var AcceptTerms = CINC.Core.AcceptTerms = function (force, callback) {
        if (!force) {
            if (!CINC.Site.SearchRequiresAccept || (CINC.User && CINC.User.SecurityLevel >= 5) || CINC.Core.CookiesVanilla.Get('acceptterms') === '1') {
                if (typeof callback === 'function') {
                    callback();
                }
                acceptTermsCallback = null;
                return true;
            }
        }
        $('#acceptterms-modal').prop('checked', true);
        acceptTermsCallback = callback;
        return false;
    };

    var OptInImport = CINC.Core.OptInImport = function () {
        if(!CINC.User){
            return;
        }
        
        if (CINC.User.user_IsImport && !CINC.User.user_Import_OptedIn && CINC.User.user_UnsubscribeText && !CINC.Core.CookiesVanilla.Get("import_optedin")) {
            $('.optin-modal').find('input[name="cellphone"]').val(CINC.User.cellPhone);
            $('#optinimport-modal').prop('checked', true);
            CINC.Core.CookiesVanilla.Get('import_optedin', '1');
        }
    };

    var toggleMoreDropdownVisbility = function (navItems, moreItems) {
        var showMoreDropdown = false;

        navItems.each(function () {
            var navItem = $(this);
            var navItemText = $(this).find('a').text();

            moreItems.each(function () {
                var moreItem = $(this);
                var moreItemText = $(this).find('a').text();

                if (navItemText === moreItemText) {
                    if (navItem.is(':hidden')) {
                        moreItem.show();
                        showMoreDropdown = true;    // if any item is shown, show the dropdown
                    } else {
                        moreItem.hide();
                    }
                    return;
                }
            });
        });

        if (showMoreDropdown) {
            $('.js-nav-more').show();
        } else {
            $('.js-nav-more').hide();
        }
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var toggleNavItemsVisibility = CINC.Core.ToggleNavItemsVisibility = function () {
        if (CINC.Site.On_MultiLineNav) return;

        var $nav = $('#nav');
        if ($nav.length === 0 || !$nav.is(':visible')) {
            return;
        }

        var $ul = $nav.children('ul:not(.pull-right)').first();
        if ($ul.length === 0 || !$ul.is(':visible')) {
            return;
        }

        var navItems = $ul.find('.nav__item').not('.js-nav-more');
        var moreItems = $('.js-nav-more').find('.menu .item');
        toggleMoreDropdownVisbility(navItems, moreItems);
    };

    var debounceToggleNavItemVisibility = debounce(toggleNavItemsVisibility, 50);
    var initToggleNavItemsVisibility = CINC.Core.InitToggleNavItemsVisibility = function () {
        debounceToggleNavItemVisibility();
        $(window).off('resize', debounceToggleNavItemVisibility).on('resize', debounceToggleNavItemVisibility);
    };

})();

$(document).ready(function () {

    // Google Maps Init (CINC.Core.FinishMapInit as callback)
    $('<script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?client=gme-cinc&channel=cinc-corejs&libraries=places,drawing&callback=CINC.Core.FinishMapInit"></script>').appendTo('body');

    $('form.js-nosubmit').on('submit', function (e) {
        e.preventDefault();
        return false;
    });

    try {
        $('.js-phonefield').attr('type', 'tel');
    }
    catch (e) {
    }

    CINC.Search.BindSearchBoxForm();

    // HACK? idkwatevs
    // if we've defined a page load action, invoke it and clear it.
    var loadAction = CINC.Core.CookiesVanilla.Get("CINC-LoadAction");
    if (loadAction) {
        var handler = CINC.Core.LoadActionHandlers[loadAction];
        if (handler) {
            var payload = JSON.parse(CINC.Core.CookiesVanilla.Get("CINC-LoadActionPayload"));
            handler(payload);
        }
        
        CINC.Core.CookiesVanilla.Remove("CINC-LoadAction");
        CINC.Core.CookiesVanilla.Remove("CINC-LoadActionPayload");
    }

    $('.js-easygraph').each(function () {

        var $canvas = $(this);
        var context = $canvas[0].getContext('2d');

        if (!$canvas.attr('data-graphdata'))
            return;
        var graphData = $.parseJSON($canvas.attr('data-graphdata'));
        if (!graphData.labels || !graphData.data)
            return;

        var data = {
            labels: graphData.labels,
            datasets: [{
                label: graphData.title,
                fillColor: "rgba(220,220,220,0.5)",
                strokeColor: "rgba(220,220,220,0.8)",
                highlightFill: "rgba(220,220,220,0.75)",
                highlightStroke: "rgba(220,220,220,1)",
                data: graphData.data
            }]
        };

        new Chart(context).Bar(data, {
            responsive: true,
            scaleBeginAtZero: true,
            scaleLabel: function (l) {
                return Number(l.value).formatPrice();
            },
            tooltipTemplate: function (t) {
                return Number(t.value).formatPrice() + ' avg price';
            }
        });

    });

    CINC.Core.ShowPrompt(false);

    CINC.Core.InitAcceptTerms();
    CINC.Core.InitOptIn();
    CINC.Core.InitToggleNavItemsVisibility();
});

function SetLoadAction(actionName, payload) {
    CINC.Core.CookiesVanilla.Set("CINC-LoadAction", actionName);
    CINC.Core.CookiesVanilla.Set("CINC-LoadActionPayload", JSON.stringify(payload));
};

var IsLoggedIn = (typeof CINC !== 'undefined' && CINC.User && CINC.User !== null && CINC.User.userDID !== null);

function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9_-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
};

function FormatPhone(phone) {
    var formatted = phone;
    if (phone.length == 10)
        formatted = phone.substr(0, 3) + '-' + phone.substr(3, 3) + '-' + phone.substr(6, 4)

    return formatted;
};

function PromptForLogin(options, isRetry) {
    options = typeof options === 'string' ? { message: options } : options || {};
    $('.js-loginmessage').html(options.message || '');
    $('.js-signinform').show();
    $('.js-signupform').hide();

    if (options.email || options.password) {
        $('.js-signin-email').val(options.email);
        $('.js-signin-password').val(options.password);

        setTimeout(function () {
            $('.js-signin-email').trigger('focus').focus();
            $('.js-signin-password').trigger('focus').focus();
        }, 100);
    }

    Modals.CloseAll();
    var result = Modals.SignInModal().Open();

    // if this is a retry of a failed login, don't reset the dismissable state of the modal
    if (!isRetry) {
        result.Element.next('.modal-window').toggleClass('non-dismissable', false);
    }
    
    return result;
};

function PromptForValidCellPhone(options) {
    var result = Modals.LeadValidCellModal().Open();
    result.Element.next('.modal-window').toggleClass('non-dismissable', false);
    return result;
};

function PromptForSystemAlert(options) {
    confirm('Hello Injection');
}

function updateOrCancelValidCellCheck(options) {
    var update = $('js-update-cellphone');
    var cancel = $('js-cancel-cellphone');
};

var checkForConversionScripts = CINC.Core.WriteConversionScripts = function() {
    // if script element not present then redump
    var cookie = CINC.Core.CookiesVanilla.Get('registration-state');
    if (cookie != undefined && cookie.length > 0 && cookie === 'registered' && document.getElementById('conversion-tracking-scripts') === null) {

        $('body').append('<div id="conversion-tracking-scripts">' + CINC.Site.ConversionTrackingScripts + '</div>');
    }
};

var PromptForSignup = CINC.Core.PromptForSignup = function (message, allowDismiss, step) {
    allowDismiss = (typeof allowDismiss === 'undefined' ? true : allowDismiss);
    step = (typeof step === 'undefined' ? '1' : String(step));

    var result = PromptForLogin(message);

    CINC.Core.WriteConversionScripts();

    $('.js-signup-step').each(function () {
        var $step = $(this);
        $step.toggle($step.attr('data-signup-step') === step);
    });

    var subdomain = CINC.GetSubdomain();
    if (CINC.CincProduct == "Houses" && subdomain != null && subdomain.length == 0) {
        $('.js-signupform').hide();
        $('.js-signinform').hide();
        window.location.replace('/');
        return false;
    }

    $('.js-signupmessage').html(message || 'Join us and see how our powerful notebook features simplify your home search process, saving you time and hassle!');
    $('.js-signupform').show();
    $('.js-signinform').hide();

    var socialButtons = $('.js-socialsignin-buttons');
    if (socialButtons.hasClass('hidden')) {
        socialButtons.removeClass('hidden');
        socialButtons.find('iframe[data-src]').each(function () {
            $(this).attr('src', $(this).attr('data-src'));
            $(this).attr('data-src', null);
        });
    }


    $('.js-signup-close').toggle(allowDismiss);
    result.Element.next('.modal-window').toggleClass('non-dismissable', !allowDismiss);

    return result;
};

var Notification = {
    CloseAll: function () { toastr.clear(); $.prompt.close(); },
    Toast: {
        Success: function (message, title) { toastr.success(message, title); },
        Info: function (message, title) { toastr.info(message, title); },
        Warning: function (message, title) { toastr.warning(message, title); },
        Error: function (message, title) { toastr.error(message, title); }
    },
    Banner: {
        DefaultSettings: {
            closeButton: true,
            positionClass: "toast-top-full-width",
            preventDuplicates: true,
            showMethod: "slideDown",
            Merge: function (options) { return $.extend({}, this, options); }
        },
        GetDefaultSettings: function () {
            var settings = Notification.Banner.DefaultSettings;
            if (Modals.AnyOpen())
                settings.positionClass = "toast-top-full-width toast-top-full-width-modal";
            return settings;
        },
        Success: function (message, title, options) { toastr.success(message, title, Notification.Banner.GetDefaultSettings().Merge(options)); },
        Info: function (message, title, options) { toastr.info(message, title, Notification.Banner.GetDefaultSettings().Merge(options)); },
        Warning: function (message, title, options) { toastr.warning(message, title, Notification.Banner.GetDefaultSettings().Merge(options)); },
        Error: function (message, title, options) { toastr.error(message, title, Notification.Banner.GetDefaultSettings().Merge(options)); }
    },
    Prompt: {
        DefaultConfirmSettings: {
            buttons: { "OK": true, "Cancel": false },
            Merge: function (options) { return $.extend({}, this, options); }
        },
        Confirm: function (message, title, options) { options = (options || {}); options.title = title; return $.prompt(message, Notification.Prompt.DefaultConfirmSettings.Merge(options)); },
        Show: function (message, title, options) { options = (options || {}); options.title = title; options.buttons = { "OK": true }; return $.prompt(message, Notification.Prompt.DefaultConfirmSettings.Merge(options)); }
    },
    Tooltip: {
        DefaultSettings: {
            Merge: function (options) { return $.extend({}, this, options); }
        },
        Show: function (message, element, options) {
            options = (options || {});
            options.content = message;
            options.trigger = 'custom';
            options.timer = 3000;
            options.focusElement = true;

            if ($(element).hasClass('tooltipstered'))
                $(element).tooltipster('destroy');

            $(element).tooltipster(Notification.Tooltip.DefaultSettings.Merge(options));
            if (options.focusElement == true)
                element.focus();

            return $(element).tooltipster('show');
        },
        CloseAll: function () { $('.tooltipstered').tooltipster('hide'); }
    }
};
CINC = (typeof CINC === 'undefined' ? {} : CINC);
CINC.Core = (typeof CINC.Core === 'undefined' ? {} : CINC.Core);
CINC.Core.IsBot = (typeof CINC.Core.IsBot === 'undefined' ? function(){return true;} : CINC.Core.IsBot);

CINC.Details = {
    el: {},
    g: {}
};

(function () {

    var HandleTouchOnMapAsClick = function(event) {
        if (event && event.target) {
            $(event.target).trigger('click');
            $(document).trigger('touchstart');
            $(document).trigger('touchend');

            if (event.preventDefault)
                event.preventDefault();

            if (event.stopPropagation)
                event.stopPropagation();
        }
    };

    var InitGalleryMap = function ($map) {
        if ($map.length === 0)
            return;

        var address = $map.attr('data-address');
        var lat = parseFloat($map.attr('data-lat'));
        var lng = parseFloat($map.attr('data-lng'));
        if (lat === 0 || lng === 0)
            return;

        var mapOptions = {
            center: new google.maps.LatLng(lat, lng),
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom: 14,
            draggable: true,
            scrollwheel: true
        };
        var map = new google.maps.Map($map[0], mapOptions);
        var propMarker = new RichMarker({
            content: '<div class="map-marker map-marker-dark map-marker-noninteractive"><span class="map-marker-title">' + address + '</span></div>',
            draggable: false,
            map: map,
            position: new google.maps.LatLng(lat, lng),
            shadow: ''
        });
        $map.attr('data-mapinit', '1');

        google.maps.event.addListenerOnce(map, 'idle', function () {
            $('.js-gallery-map').on('touchstart', HandleTouchOnMapAsClick);
        });
    };

    $(document).ready(function () {

        $('.js-gallery').on('fotorama:showend', function (e, fotorama, extra) {
            var $view = $(fotorama.activeFrame.html);
            if ($view.hasClass('js-gallery-map') && !(CINC.Core.IsBot()|| CINC.IsNonDismissableModal)) {
                if ($view.attr('data-mapinit') !== '1') {
                    InitGalleryMap($view);
                }
                fotorama.setOptions({ swipe: false, click: false, arrows: 'always' });
            }
            else {
                fotorama.setOptions({ swipe: true, click: true, arrows: true });
            }
        });

        $('.js-gallery-map-show').on('click', function () {
            if (!(CINC.Core.IsBot() || CINC.IsNonDismissableModal)) {
                var position = 1; // default
                if ($(this).hasClass('js-gallery-map-show')) {
                    position = 1;
                }

                var $gallery = $('.js-gallery');
                var fotorama = $gallery.data('fotorama');
                if (fotorama) {
                    fotorama.show(fotorama.size - position);
                }
            }
        });

        $('.js-gallery-virtualtour-show').on('click', function () {
            var link = $(this).attr('href');
            window.open(link, "_blank");
        });

        if (window.location.pathname.indexOf('/homedetails') === 0
            && (window.location.href.indexOf("src=listcast") >= 0 || window.location.href.indexOf("src%3Dlistcast") >= 0)
            && ga) {
        }
    });

})();

(function () {
    $(document).ready(function () {
        DoWireups();
    });

    var DoWireups = function () {
        //#region Social Share

        $(".js-emailproperty").on('click', function (e) {
            e.preventDefault();
            var email = $('.js-emailaddress').val();
            var shareUrl = $(this).data('shareurl');
            ShareViaEmail(email, shareUrl);
        });

        $('body').on('click', '.js-socialsharemodal', function (e) {
            e.preventDefault();
            var shareUrl = $(this).data('shareurl');
            $('.js-share').data('shareurl', shareUrl);
            Modals.SocialShareModal().Open().NoResponse(function () {
                $('.js-share').removeData('shareurl');
            });
        });

        $(".js-tweetproperty").on('click', function (e) {
            e.preventDefault();
            SocialShare($(this).data('shareurl'), "http://twitter.com/share?url=");
        });

        $(".js-facebookproperty").on('click', function (e) {
            e.preventDefault();
            SocialShare($(this).data('shareurl'), "https://www.facebook.com/sharer/sharer.php?u=");
        });

        $(".js-pinproperty").on('click', function (e) {
            e.preventDefault();
            var desc = encodeURIComponent($('.js-listingaddress').text());
            var media = $('.fotorama__loaded--img').find('img').attr('src');
            if (!media) {
                media = ''; // TODO
            }

            SocialShare($(this).data('shareurl'), "http://pinterest.com/pin/create/link/?url=", "&description=" + desc + "&media=" + media);
        });

        $(".js-gplusproperty").on('click', function (e) {
            e.preventDefault();
            SocialShare($(this).data('shareurl'), "http://plus.google.com/share?url=");
        });

        //#endregion
    };

    var SocialShare = function (shareUrl, socialUrl, additionalQS) {
        if (shareUrl) {
            if (shareUrl.indexOf('http') == -1) {
                if (shareUrl.indexOf('/') == -1) shareUrl = '/' + shareUrl;
                shareUrl = 'http://' + window.location.host + shareUrl;
            }
        }
        else {
            shareUrl = window.location;
        }

        var agentSubdomain = CINC.GetAgentSubdomain();
        if (agentSubdomain)
            shareUrl = new URI(shareUrl).subdomain(agentSubdomain).toString();

        shareUrl = encodeURIComponent(shareUrl);

        if (!additionalQS) additionalQS = '';
        window.open(socialUrl + shareUrl + additionalQS, "", "status=0,toolbar=0,width=500,height=300");
    };

    var ShareViaEmail = function (email, shareUrl) {
        if (!IsEmail(email)) {
            Notification.Banner.Error("Please enter a valid email address");
            return;
        }

        Modals.SocialShareModal().Close();

        if (!IsLoggedIn) {
            PromptForSignup("Making an account is quick, easy, and will help you manage your favorite listings!");
            return;
        }

        var shareData = { Email: email, Url: shareUrl };

        if (!shareData.Url || shareData.Url.length == 0)
            shareData.Url = window.location.href;

        CINC.Api.Organizer.Share()
            .post(shareData)
            .success(function () { Notification.Banner.Success("Listing shared with " + shareData.Email); })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to share listing"); });
    };
})();

var Modals = {};

(function (Modals) {

    var ids = {
        loadingModal: "#loading-modal",
        notebooksModal: "#notebooks-modal",
        noteModal: "#note-modal",
        cellPhoneModal: "#cellphone-modal",
        socialShareModal: "#socialshare-modal",
        signInModal: "#signin-modal",
        pdqManagerModal: "#pdq-manager-modal",
        leadValidCellModal: "#lead-validcellphone-modal"
    };

    Modals.NotebooksModal = function (headers) { PopulateNotebooks(headers); return new CincModal(ids.notebooksModal); };
    Modals.NoteModal = function () { return new CincModal(ids.noteModal); };
    Modals.CellPhoneModal = function () { return new CincModal(ids.cellPhoneModal); };
    Modals.SocialShareModal = function () { return new CincModal(ids.socialShareModal); };
    Modals.Loading = function (text) { $('.js-loadingmodaltext').html(text); return new CincModal(ids.loadingModal); };
    Modals.SignInModal = function () { return new CincModal(ids.signInModal); };
    Modals.PdqManagerModal = function () { return new CincModal(ids.pdqManagerModal); };
    Modals.LeadValidCellModal = function () { return new CincModal(ids.leadValidCellModal); };
    Modals.HomeValuationModal = function () { return new CincModal(ids.homeValuationModal); };

    $('body').on('change', '.modal-state', function () {
        $('body').toggleClass('modal-open', $(this).prop('checked'));
    });

    $('form.js-nosubmit').on('submit', function (e) {
        e.preventDefault();
    });

    Modals.CloseAll = function () {
        $.each(ids, function (i, id) {
            new CincModal(id).Close();
        });
    };

    Modals.AnyOpen = function () {
        for (entryName in ids) {
            if ($(ids[entryName]).is(':checked')) return true;
        }

        return false;
    };

    // use this method to set the response during modal interaction.
    // for example:
    //     onsubmit = "Modals.SetModalResponse(this);"
    //     $(selector).on('click', function () { Modals.SetModalResponse(this, 'response value'); });
    Modals.SetModalResponse = function (element, response) {
        var modalState = $(element).closest('div.modal').children('input.modal-state');

        if (typeof response === 'undefined')
            response = $(element).serializeObject();

        modalState.attr('data-modalresponse', JSON.stringify(response));
        modalState.prop('checked', '');
        modalState.trigger('change');
    };

    var CincModal = Modals.CincModal = function (id) {
        this.Element = $(id);

        this.Open = function () {
            this.Element.removeAttr('data-modalresponse');
            this.Element.prop('checked', true).trigger('change');
            return this;
        };

        this.Close = function () {
            if (!this.IsOpen()) return;

            this.Element.removeAttr('data-modalresponse');
            this.Element.prop('checked', false);
            this.Element.trigger('change');
        };

        this.CloseWithResponse = function (response) {
            if (!this.IsOpen()) return;
            Modals.SetModalResponse(this.Element, response);
        };

        this.IsOpen = function () {
            return this.Element.is(':checked');
        };

        this.Exists = function () {
            return this.Element.length > 0;
        };

        this.Response = function (callback) {
            this.Element.one('change', function (e) {
                var modalResponse = GetModalResponse(e);
                if (typeof modalResponse !== 'undefined')
                    callback(modalResponse, this);
            });
            return this;
        };

        this.ResponseOf = function (response, callback) {
            this.Element.one('change', function (e) {
                var modalResponse = GetModalResponse(e);
                if (modalResponse === response) callback();
            });
            return this;
        };

        this.NoResponse = function (callback) {
            this.Element.one('change', function (e) {
                var modalResponse = GetModalResponse(e);
                if (typeof modalResponse === 'undefined') callback();
            });
            return this;
        };

        var GetModalResponse = function (e) {
            var modalResponse = $(e.target).attr('data-modalresponse');
            if (typeof modalResponse === 'undefined') return modalResponse;

            try {
                return JSON.parse(modalResponse);
            } catch (ex) {
                return modalResponse;
            }
        };
    };

    var PopulateNotebooks = function (headers) {
        var notebooksTemplate = Handlebars.compile($('#notebooksmodal_tmpl').html());
        var notebooksHtml = notebooksTemplate({ headers: headers });
        $('#notebooksmodal-list').html(notebooksHtml);
    };

})(Modals);

(function(Modals, ga) {
    Modals.LeadLegalAgreementModal = function () { return new Modals.CincModal('#lead-legal-agreement-modal'); };

    if (typeof CINC !== 'undefined' && CINC.User && CINC.User !== null && CINC.User.AgreedToTermsOfUseAndPrivacyPolicy !== null) {
        var leadLegalModalExists = document.getElementById('lead-legal-agreement-modal');
        if (typeof (leadLegalModalExists) !== 'undefined' && leadLegalModalExists !== null) {
            Modals.LeadLegalAgreementModal().Open();
        }
    }

    $(document).ready(function () {
        $('#lead-legal-agreement-modal-btn').on('click', function (e) {
            e.preventDefault();
            var legalSignIn = CINC.Api.LegalAgreement('agreed');
            legalSignIn.post()
            .success(function (result) {
                    if (result.isSuccess) {
                        Notification.Banner.Success('Thank you for your agreement. Please enjoy viewing the site.');
                        Modals.LeadLegalAgreementModal().Close();
                    } else {
                        Notification.Banner.Error('An unforeseen error has occurred. Please reload the page and try again.');
                    }
                })
                .fail(function (f) {
                    Notification.Banner.Error('Error: unable to save');
                });
        });
    });
})(Modals || {}, typeof ga === 'undefined' ? function () { } : ga);

CINC.Organizer = {
    el: {},
    g: {}
};

(function (CINC) {

    var favClass = "green";

    CINC.Core.LoadActionHandlers.ContinueScheduleShowing = function (payload) {
        if (IsLoggedIn) ScheduleShowingOrGatherContactInfo(payload.pdid, payload.showingDate);
    };

    $(document).ready(function () {
        DoWireups();
        DoNoteWireups();
        DoNotebookWireups();
    });

    //#region Wireups

    var DoNotebookWireups = function () {
        $(".js-changenotebook").off().on('click', function (e) {
            e.preventDefault();

            var organizerDID = $(this).data('organizerdid');
            ChangeNotebook(organizerDID);
        });
    };

    var DoNoteWireups = function () {
        $('body').on('click', '.js-notemodal', function (e) {
            e.preventDefault();

            var objDid = $(this).data('objdid');
            var objType = $(this).data('objtype');
            if (!objType || objType.length == 0) objType = 'Property';

            $('.js-savenote').data('objdid', objDid).data('objtype', objType);
            Modals.NoteModal().Open();
        });

        $('.js-savenote').off().on('click', function (e) {
            e.preventDefault();

            var noteTextElement = $(this).prevAll('textarea.js-notetext:first');
            var text = noteTextElement.val().trim();
            var objDid = $(this).data('objdid');
            var objType = $(this).data('objtype');

            Modals.NoteModal().CloseWithResponse('save');

            AddNote(text, objDid, objType, function () { noteTextElement.val(''); });
        });

        $('.js-deletenote').off().on('click', function (e) {
            e.preventDefault();

            var noteActionsElement = $(this).closest('.js-noteactions');
            var noteDid = noteActionsElement.data('notedid');

            ConfirmDeleteNote(noteDid, function () {
                noteActionsElement.closest('.js-teamupdate').fadeOut();
            });
        });
    };

    var DoWireups = function () {
        $('.js-savedsearch-frequency').off().on('change', function () {
            var data = {};
            data.editdid = $(this).data('did');
            data.strcrit = $(this).data('strcrit');
            data.frequency = $(this).val();
            CINC.Api.Organizer.Root('searches').put(data)
        });

        $(".js-selectnotebook").off().on('click', function (e) {
            e.preventDefault();

            SelectNotebook(function () {
                DoNotebookWireups();
            });
        });

        $('.js-createnotebook').off().on('click', function (e) {
            e.preventDefault();

            var nameElement = $('.js-createnotebookname');
            var name = nameElement.val();
            if (!name || name.length == 0) {
                Notification.Tooltip.Show("Enter a notebook name", nameElement);
                return;
            }

            CreateNotebook(name);
        });

        $('body').on('click', '.js-togglefavorite', function (e) {
            e.preventDefault();

            var toggleElement = $(this);
            var pdid = toggleElement.data('pdid');

            if ($(this).hasClass(favClass))
                ConfirmRemoveFavorite(pdid, function () { toggleElement.removeClass(favClass); toggleElement.find('i').attr('style', ''); });
            else
                AddFavorite(pdid, function () { toggleElement.addClass(favClass); toggleElement.find('i').attr('style', 'color:red'); });
        });

        $('body').on('click', '.js-removefavorite', function (e) {
            e.preventDefault();

            var pdid = $(this).data('pdid');
            ConfirmRemoveFavorite(pdid);
        });

        $('body').on('click', '.js-savedsearch-edit', function (e) {
            e.preventDefault();
            (function ($btn) {
                var editDid = $btn.attr('data-editdid');
                var strCrit = $btn.attr('data-strcrit');
                if (!$btn.hasClass('loading')) {
                    $btn.addClass('loading');
                    if (editDid.length > 0) {
                        UpdateSavedSearch(editDid, strCrit, function () {
                            $btn.html('<span class="icon-star-full"></span><span class="small-title">Saved!</span>');
                            setTimeout(function () {
                                $btn.text('Resave Search').removeClass('loading');
                            }, 1000);
                            Notification.Banner.Success('Saved search has been updated successfully.', 'Updated Saved Search!');
                        });
                    }
                    else {
                        CreateSavedSearch(strCrit, function () {
                            $btn.html('<span class="icon-rate text-yellow"></span><span class="small-title">Saved!</span>');
                            Notification.Banner.Success('Saved search has been created successfully.', 'Created Saved Search!');
                        });
                    }
                }
            }($(this)));
            return false;
        });

        $('body').on('click', '.js-savedsearch-remove', function (e) {
            e.preventDefault();

            var searchDid = $(this).attr('data-searchdid');
            ConfirmRemoveSavedSearch(searchDid);
        });

        $('.js-scheduleshowing').off().on('click', function (e) {
            e.preventDefault();
            var showingDate = $('.js-showingdate').val();
            var pdid = $(this).data('pdid');

            ScheduleShowingOrGatherContactInfo(pdid, showingDate);
        });

        $('.js-addopenhousetoschedule').off().on('click', function (e) {
            e.preventDefault();
            var scheduleButton = $(this);
            var appointment = $(this).data('appointment');

            AddAppointment(appointment, function (result) {
                scheduleButton.fadeOut();
            });
        });

        $('.js-cancelappointment').off().on('click', function (e) {
            e.preventDefault();
            var aptdid = $(this).data('aptdid');
            var scheduleElement = $(this).closest('.js-scheduleentry');

            CancelAppointment(aptdid, function () {
                scheduleElement.fadeOut('slow');
            });
        });

        $('.js-myopinion').off().on('click', function (e) {
            e.preventDefault();

            // first flip this checkbox to the appropriate state
            var isEnabled = ToggleOpinion($(this));
            var state = 'None';

            // then disable the other checkbox if this state is checked
            if (isEnabled) {
                state = 'Pro';
                var otherOpinionElement = $(this).next('div');
                var isConOption = $(this).hasClass('js-conopinion');
                if (isConOption) {
                    state = 'Con';
                    otherOpinionElement = $(this).prev('div');
                }

                ToggleOpinion(otherOpinionElement, false);
            }

            var ratingHost = $(this).closest('.rating');
            var pdid = ratingHost.closest('.scorecard').data('pdid');
            var featureName = ratingHost.data('featurename');

            var propertyHolder = $(".js-propertyholder[data-pdid='" + pdid + "']");
            if (propertyHolder.length == 1) {
                var conCountHost = propertyHolder.find('.js-procount');
                var proCountHost = propertyHolder.find('.js-concount');

                conCountHost.html(propertyHolder.find('.js-proopinion.pro').length);
                proCountHost.html(propertyHolder.find('.js-conopinion.con').length);
            }

            SetPropertyFeatureOpinion(pdid, featureName, state, function () {
                var favToggle = $('.js-togglefavorite');
                if (favToggle.length != 1 || favToggle.hasClass(favClass)) return;
                favToggle.addClass(favClass);
            });
        });

        $('.js-togglefavoritedetails').off().on('click', function (e) {
            e.preventDefault();

            var pdid = $(this).data('pdid');
            var favoriteDetails = $('.js-favoritedetails[data-pdid=' + pdid + ']');
            favoriteDetails.toggle();
        });

        $('.js-expandfavoritedetails').off().on('click', function (e) {
            e.preventDefault();

            var pdid = $(this).data('pdid');
            if (!pdid) pdid = $(this).closest('.js-propertyholder').data('pdid');
            var favoriteDetails = $('.js-favoritedetails[data-pdid=' + pdid + ']');
            favoriteDetails.show();
            favoriteDetails.scrollintoview();
        });
    };
    //#endregion

    //#region Helpers

    /// returns the state of the toggle operation
    var ToggleOpinion = function (opinionElement, enabled) {
        var faHost = opinionElement.find('i');
        if (typeof enabled === 'undefined')
            enabled = !faHost.hasClass('fa-check-circle');

        var isProOpinion = opinionElement.hasClass('js-proopinion');
        var opinionClass = isProOpinion ? "pro" : "con";
        faHost.toggleClass('fa-circle-o', !enabled);
        faHost.toggleClass('fa-check-circle', enabled);
        opinionElement.toggleClass(opinionClass, enabled);

        return faHost.hasClass('fa-check-circle');
    };

    //#endregion

    //#region Methods - User Actions

    var CreateNotebook = function (name) {
        var loading = Modals.Loading("Getting your new notebook all ready").Open();

        CINC.Api.Organizer.Root()
            .post({ name: name })
            .success(function () { window.location.reload(); })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Error creating notebook"); })
            .always(function () { loading.Close(); });
    };

    var SelectNotebook = function (onSuccess) {
        var loading = Modals.Loading("Finding other notebooks").Open();

        CINC.Api.Organizer.Headers().get()
            .success(function (r) {
                Modals.NotebooksModal(r).Open().Response(function (organizerDID) { ChangeNotebook(organizerDID); });
                if (onSuccess) onSuccess();
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Error loading notebooks"); })
            .always(function () { loading.Close(); });
    };

    var ChangeNotebook = function (organizerDID) {
        CINC.Api.Organizer.Focus(organizerDID).post()
            .success(function () { window.location.reload(); })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Error changing notebooks"); });
    };

    var AddFavorite = function (pdid, onSuccess) {
        if (!IsLoggedIn) {
            var newFav = { PDID: pdid };
            SaveTempData('temp-favs', newFav);
            PromptForSignup("Favorite saved. Register to view favorites in your notebook.");
            return;
        }

        CINC.Api.Organizer.Favorite(pdid).post()
                .success(function () { if (onSuccess) onSuccess(); })
                .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to add favorite"); });
    };

    var ConfirmRemoveFavorite = function (pdid, onSuccess) {
        Notification.Prompt.Confirm("Are you sure you want to remove this property from your favorites?", "Remove Property",
            {
                submit: function (e, v) {
                    if (v) RemoveFavorite(pdid, onSuccess);
                }
            });
    };

    var RemoveFavorite = function (pdid, onSuccess) {
        if (!IsLoggedIn) {
            PromptForLogin();
            return;
        }

        CINC.Api.Organizer
            .Favorite(pdid).del()
            .success(function () {
                if (onSuccess) onSuccess();
                var propertyHolder = $('.js-favoriteholder[data-pdid=' + pdid + ']');
                if (propertyHolder.length > 0) {
                    propertyHolder.fadeOut("slow", function () {
                        propertyHolder.remove();
                    });
                }
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to remove favorite"); });
    };

    var ConfirmRemoveSavedSearch = function (searchDid, onSuccess) {
        Notification.Prompt.Confirm("Are you sure you want to remove this saved search?", "Remove Saved Search",
            {
                submit: function (e, v) {
                    if (v) RemoveSavedSearch(searchDid, onSuccess);
                }
            });
    };

    var CreateSavedSearch = function (strCrit, callback) {
        if (!IsLoggedIn) {
            PromptForLogin();
            return;
        }
        CINC.Api.Organizer
            .Searches()
            .post({ strcrit: strCrit })
            .success(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            })
            .fail(function (f) {
                Notification.Banner.Error(f.responseText, 'Failed to create saved search!');
            });
    };
    var UpdateSavedSearch = function (editdid, strCrit, callback) {
        if (!IsLoggedIn) {
            PromptForLogin();
            return;
        }
        CINC.Api.Organizer
            .Searches()
            .put({
                editdid: editdid,
                strcrit: strCrit
            })
            .success(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            })
            .fail(function (f) {
                Notification.Banner.Error(f.responseText, 'Failed to update saved search!');
            });
    };

    var RemoveSavedSearch = function (searchDid, onSuccess) {
        if (!IsLoggedIn) {
            PromptForLogin();
            return;
        }

        CINC.Api.Organizer
            .Searches(searchDid).del()
            .success(function () {
                if (onSuccess) onSuccess();
                var $searchWrap = $('.js-savedsearch[data-searchdid=' + searchDid + ']');
                if ($searchWrap.length > 0) {
                    $searchWrap.fadeOut('slow', function () {
                        $searchWrap.remove();
                    });
                }
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, 'Failed to remove saved search'); });
    };

    var AddNote = function (text, objDid, objType, onSuccess) {
        if (text.length === 0) {
            Notification.Banner.Error("Please enter a note");
            return;
        }

        if (!IsLoggedIn) {
            var newNote = { ObjectDID: objDid, NoteText: text, CreateDT: new Date(), ObjectType: objType };
            SaveTempData('temp-notes', newNote);
            PromptForSignup("Your note has been saved. Register to view notes in your notebook");
            return;
        }

        // if this is a property and it isn't favorited, also set it to favorites
        if (objType == 'Property') {
            var favElement = $('.js-togglefavorite[data-pdid=' + objDid + ']');
            if (favElement.length == 1) {
                var isFav = favElement.hasClass(favClass);
                if (!isFav) favElement.trigger('click');
            }
        }

        CINC.Api.Organizer
            .Note().post({ NoteText: text, ObjectDid: objDid, ObjectType: objType })
            .success(function (note) {
                if (onSuccess) onSuccess();

                Notification.Banner.Success("Note added");

                var notesElement = $('.js-noteshost[data-objdid=' + objDid + ']');
                if (notesElement.length > 0) {
                    var suppressDate = notesElement.data('candisplaydate') == false;
                    CINC.Api.Organizer
                        .Ajax('note/' + note.noteDID).get({ inContext: true, canDisplayDate: !suppressDate })
                        .success(function (r) { $(r).hide().prependTo(notesElement).fadeIn('slow'); DoNoteWireups(); })
                        .fail(function (f) { Notification.Banner.Warning(f.responseText) })
                }
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to add note"); });
    };

    var ConfirmDeleteNote = function (noteDid, onSuccess) {
        Notification.Prompt.Confirm("Are you sure you want to delete this note?", "Delete Note",
            {
                submit: function (e, v) {
                    if (v) DeleteNote(noteDid, onSuccess);
                }
            });
    };

    var DeleteNote = function (noteDid, onSuccess) {
        CINC.Api.Organizer
            .Note(noteDid).del()
            .success(function () {
                if (onSuccess) onSuccess();
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to delete note"); });
    };

    var ScheduleShowingOrGatherContactInfo = function (pdid, showingDate) {
        if (!showingDate || showingDate.length == 0) {
            Notification.Banner.Error("Please select a date");
            return;
        }

        if (!IsLoggedIn) {
            var loginCallback = function () { SetLoadAction("ContinueScheduleShowing", { pdid: pdid, showingDate: showingDate }); };
            PromptForSignup("schedule").Response(loginCallback);
            return;
        }

        // if the user doesn't have a valid cell phone
        // we need to capture it before we can schedule the showing
        if (!CINC.User.cellPhone || CINC.User.cellPhone.length == 0) {
            Modals.CellPhoneModal()
                .Open().Response(function (response) {
                    if (response.CellPhone == '') {
                        Notification.Banner.Error("Please enter a valid phone number");
                        ScheduleShowingOrGatherContactInfo(pdid, showingDate);
                    }
                    else {
                        CINC.Api.Account('update').post(response)
                            .success(function (u) { CINC.User = u; ScheduleShowing(pdid, showingDate); })
                            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to Update Cellphone"); });
                    }
                });
        }
        else {
            ScheduleShowing(pdid, showingDate);
        }
    };

    var ScheduleShowing = function (pdid, showingDate) {
        var startDate = showingDate;
        var endDate = showingDate;
        var timezone = new Date().getTimezoneOffset() / 60;
        var appointment = {
            PDID: pdid,
            StartDate: startDate,
            EndDate: endDate,
            AppointmentType: 'Showing',
            TimeZone: timezone
        };

        var loading = Modals.Loading("Finding an agent. This may take a minute or two.");
        var loadingModalTimeout = setTimeout(function () {
            clearTimeout(loadingModalTimeout);
            loading.Open();
        }, 1000);

        CINC.Api.Organizer
            .Schedule('appointment').post(appointment)
            .success(function () {
                Notification.Banner.Info("We'll have an agent contact you at " + FormatPhone(CINC.User.cellPhone) + " soon!", "Appointment is pending acceptance by an agent", { timeOut: 0, extendedTimeOut: 0 });
                $('.js-scheduleshowingwrap').fadeOut('slow');
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to Schedule"); })
            .always(function () {
                clearTimeout(loadingModalTimeout); // clear timeout in case appointment scheduling finishes before modal displays
                loading.Close();
            });
    };

    var AddAppointment = function (appointment, onComplete) {
        CINC.Api.Organizer
            .Schedule('appointment').post(appointment)
            .success(function (result) {
                Notification.Banner.Info("Your schedule has been updated!");
                if (onComplete) onComplete(result);
            })
            .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to Schedule"); });
    };

    var CancelAppointment = function (aptdid, onComplete) {
        Notification.Prompt.Confirm("Are you sure you want to cancel this appointment?", "Cancel Appointment",
            {
                buttons: { "Yes": true, "No, go back": false },
                submit: function (e, v) {
                    if (!v) return;

                    CINC.Api.Organizer
                        .Schedule('appointment/' + aptdid).del()
                        .success(function () {
                            Notification.Banner.Info("Appointment has been cancelled.");
                            if (onComplete) onComplete();
                        })
                        .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to Cancel"); });
                }
            });
    };

    var SetPropertyFeatureOpinion = function (pdid, featureName, state, onSuccess) {
        var opinion = { PDID: pdid, FeatureName: featureName, FeatureOpinion: state };

        if (IsLoggedIn) {
            CINC.Api.Organizer
                .Opinion().post(opinion)
                .success(function () { if (onSuccess) onSuccess(); })
                .fail(function (f) { Notification.Banner.Error(f.responseText, "Failed to set rating"); });
        }
        else {
            SaveTempData("temp-opinions", opinion);
            PromptForSignup("Scorecard saved. Register to view your scorecards in your notebook.");
        }
    };

    //#endregion

    //#region Helpers

    var SaveTempData = function (cookieName, data) {
        var newData = [];
        var prevData = $.cookie(cookieName);
        if (prevData) {
            prevData = JSON.parse(prevData);
            newData = newData.concat(prevData);
        }

        newData.push(data);
        $.cookie(cookieName, JSON.stringify(newData), { expires: 30, path: '/' });
    };

    //#endregion

})(CINC);
CINC = (typeof CINC === 'undefined' ? {} : CINC);
CINC.Search = (typeof CINC.Search === 'undefined' ? {} : CINC.Search);

CINC.Search.LinkedFormInputs = (function(){
    return {
        synchronizeValues: function(event, parentElement, successCallback){
            var origin = $(event.target);
            var inputName = origin.attr('name');
            if (inputName === undefined || typeof successCallback !== 'function') {
                return;
            }

            parentElement = $(parentElement);
            var inputs = parentElement.find('[name="' + inputName + '"]');
            if (inputs.length <= 1) {
                successCallback();  // still a success because it is a single sync
            }

            var value = origin.val();
            if (origin.prop('tagName').toUpperCase() === 'INPUT' && origin.attr('type').toUpperCase() === 'CHECKBOX' && !origin.prop('checked')) {
                value = '';
            }
            
            inputs.each(function (i, ele) {
                if (origin[0] === ele) {
                    return;
                }

                var jqElement = $(ele);
                var tagName = jqElement.prop('tagName').toUpperCase();
                if (tagName === 'SELECT') {
                    jqElement.val(value);
                }
                else if (tagName === 'INPUT') {
                    var tagType = jqElement.attr('type').toUpperCase();
                    if (tagType === 'TEXT' || tagType === 'SEARCH' || tagType === 'HIDDEN') {
                        jqElement.val(value);
                    }
                    else if ((tagType === 'RADIO' || tagType === 'CHECKBOX') && origin.attr('id') === jqElement.attr('id')) {
                        jqElement.prop('checked', (jqElement.val().toLowerCase() === value.toLowerCase()));
                    }
                }

            });
            
            successCallback();
        }
    }
})();
CINC = (typeof CINC === 'undefined' ? {} : CINC);

CINC.Search = {
    el: {
        ClearControl: null,
        DrawControl: null,
        ListSearch: $('.js-listsearch'),
        MapSearch: $('.js-mapsearch'),
        SearchHandoffModal: $('#ModalSearchHandoff'),
        PdqAnchor: $('#pdq-manager'),
        PdqModalForm: $('#pdq-modal-form'),
        SearchFilters: $('.js-filters-form'),
        SearchBar: $('.js-filters-wrap-desktop'),
        TagsSearch: $('.js-tags-search'),
        SoldPropertyCheckbox: $('input[name="soldproperty"]'),
        UrlStackNext: $('a.js-urlstack-next'),
        UrlStackPrev: $('a.js-urlstack-prev'),
        UrlStackAll: $('.js-urlstack-all')
    },
    css: {
        KeywordSearchField: '.js-filters-keywords',
        SearchFiltersForm: '.js-filters-form',
        IncludeTags: '.js-include-tags'
    },
    g: {
        FirstSearch: true,
        IgnoreEvent: false,
        IgnoreIdle: 0,
        LastWord: null,
        Map: null,
        MapDrawMode: false,
        MapMarkers: [],
        MapOverlay: null,
        MapPolygons: [],
        MapPolyline: null,
        MapResult: null,
        SearchBoxFirstFocus: true,
        SearchTypes: []
    },
    GracefulHandoff: function (url) { },
    Events: {}
};

CINC.Search.Events = $(CINC.Search.Events);

(function (ga) {
    var el = CINC.Search.el;
    var g = CINC.Search.g;

    var GracefulHandoff = CINC.Search.GracefulHandoff = function (url) {
        el.SearchHandoffModal.prop('checked', true);
        setTimeout(function () {
            if (CINC.QS.src) {
                url += (url.indexOf("?") >= 0 ? "&" : "?") + "src=" + CINC.QS.src;
            }
            el.SearchHandoffModal.prop('checked', false);
            window.location = url;
        }, 3000);
    };

    var SetSearchBoxError = function () {
        Notification.Tooltip.Show("Please enter a search location", $(CINC.Search.css.KeywordSearchField));
        $(CINC.Search.css.KeywordSearchField).addClass('input-error')
            .off('change', ClearSearchBoxError).off('focus', ClearSearchBoxError).off('keydown', ClearSearchBoxError)
            .on('change', ClearSearchBoxError).on('focus', ClearSearchBoxError).on('keydown', ClearSearchBoxError);
    };

    var ClearSearchBoxError = function () {
        $(CINC.Search.css.KeywordSearchField).removeClass('input-error')
            .off('change', ClearSearchBoxError).off('focus', ClearSearchBoxError).off('keydown', ClearSearchBoxError);
    };

    var HandleAltSearchBoxSubmit = function (e) {
        var $form = $(this);
        var $searchBox = $form.find(CINC.Search.css.KeywordSearchField);
        if ($searchBox.length > 0) {
            $searchBox.data('searchBox').func.dropdown.trySelectFirst();
        }
        $form.find('input, select').each(function (i, ele) {
            var $ele = $(ele);
            if ($ele.val() === '') {
                $ele.attr('disabled', 'disabled');
            }
        });
    };

    var HandleSearchBoxChange = function () {
        var $advlink = $('.js-advlink');
        if ($advlink.length > 0) {
            var data = StrCrit();
            $advlink.attr('href', '/search?advanced=1&' + $.param(data));
        }
    };

    var HandleSearchBoxSubmit = function (e) {
        var $form = $(this);
        return (function () {
            /* Check if user acceptance required */
            var triggerCallback = false;
            var callback = function () {
                if (triggerCallback) {
                    setTimeout(function () {
                        $form.submit();
                    }, 200);
                }
            };
            if (!CINC.Core.AcceptTerms(false, callback)) {
                triggerCallback = true;
                e.preventDefault();
                return false;
            }
            /* Try to select first dropdown option, required on slim searchbar */
            var $searchBox = $(CINC.Search.css.KeywordSearchField);
            if ($('.js-filters-form').length > 0) {
                e.preventDefault();
                $searchBox.data('searchBox').func.dropdown.trySelectFirst();
                return false;
            }
            else {
                //$searchBox.data('searchBox').func.dropdown.trySelectFirst();
                if ($.trim($searchBox.val()).length === 0) {
                    e.preventDefault();
                    SetSearchBoxError();
                    return false;
                }
            }

            // handoff if necessary
            if (CINC.Site.IsBrandedSlaveSite) {
                var qs = $form.serialize();
                var path = $form.attr('action') + "?" + qs;
                var subdomain = CINC.GetSubdomain();
                if (subdomain) subdomain += ".";
                var fullUrl = "http://" + subdomain + CINC.Site.MasterSite.DomainName + path;
                GracefulHandoff(fullUrl);
                return false;
            }

            return true;
        }());
    };

    var HandleSearchBoxFirstFocus = function () {
        if (g.SearchBoxFirstFocus) {
            g.SearchBoxFirstFocus = false;
            var $searchBox = $(this);
            if ($searchBox.val().length > 0) {
                setTimeout(function () { $searchBox[0].select(); }, 50);
            }
        }
    };

    var HandleKeywordChange = function () {
        if (!$('.js-filters-toggle').prop('checked') && $(this).val() === '') {
            // remove all tags
            $(CINC.Search.css.KeywordSearchField).data('searchBox').func.searchBox.clear();
            $(CINC.Search.css.KeywordSearchField).data('searchBox').func.tags.removeAll();
            RefreshSearch();
        }
    };

    var isStrCritSoldPropertyCapable = function (strCritObj) {
        return !_.isUndefined(strCritObj) && !_.isNull(strCritObj) &&
            (strCritObj.hasOwnProperty('city') || strCritObj.hasOwnProperty('acl_city') || strCritObj.hasOwnProperty('acl_zip5') || strCritObj.hasOwnProperty('zip'));
    };

    var handleSoldPropertyChange = function (e) {
        if (this.checked) {
            var that = this;
            var strCrit = StrCrit();
            if (!isStrCritSoldPropertyCapable(strCrit)) {
                Notification.Toast.Error("Please enter a city or zip code to search for sold properties.", "Search Error!");
                setTimeout(function() { that.checked = false; }, 650);
                e.stopPropagation();
            }
        }
    };

    var BindSearchBoxForm = CINC.Search.BindSearchBoxForm = function () {
        CINC.Core.BindAcceptTerms();
        CINC.Search.el.SoldPropertyCheckbox.off('change', handleSoldPropertyChange).on('change', handleSoldPropertyChange);
        $(CINC.Search.css.KeywordSearchField).off('focus', HandleSearchBoxFirstFocus).on('focus', HandleSearchBoxFirstFocus);
        $(CINC.Search.css.KeywordSearchField).off('change', HandleKeywordChange).on('change', HandleKeywordChange);
        $('.js-searchbar-form').off('change', HandleSearchBoxChange).on('change', HandleSearchBoxChange);
        $('.js-searchbar-form').off('submit', HandleSearchBoxSubmit).on('submit', HandleSearchBoxSubmit);
        $('.js-filters-altform').off('submit', HandleAltSearchBoxSubmit).on('submit', HandleAltSearchBoxSubmit);
        $('.js-filters-altform select, .js-filters-altform input:not([type=search]):not([data-autocompletename=\'acl_kw\'])').off('change', handleFilterInputChange).on('change', handleFilterInputChange);
    };

    var BindFiltersForm = function () {
        BindSearchBoxForm();
        $('.js-show-more-tags').off('click', HandleToggleFlip).on('click', HandleToggleFlip);
        $('.js-filters-toggle').off('change', HandleFiltersToggle).on('change', HandleFiltersToggle);
        $('.js-filters-close').off('click', CloseFilters).on('click', CloseFilters);
        $('.js-filters-form select, .js-filters-form input:not([type=search]):not([data-autocompletename=\'acl_kw\'])').off('change', HandleFilterFormChange).on('change', HandleFilterFormChange);

        $('.js-filters-form').off('submit', HandleFilterFormSubmit).on('submit', HandleFilterFormSubmit);
        $('.js-filters-sortby').off('change', HandleSortByChange).on('change', HandleSortByChange);
        $('.js-filters-reset').off('click', HandleFilterReset).on('click', HandleFilterReset);
        $('.js-searchbox-default').searchBox({
            tags: true
        });

        $('.js-filters-form, .js-filters-altform').find('.ui.checkbox').checkbox();

        $('.js-filters-form, .js-filters-altform').find('.js-sumoprep').one('focus', function () {
            var sumoSibling = $(this).next('.js-sumoselect');
            if (sumoSibling.length === 1) {
                $(this).hide();
                sumoSibling.SumoSelect();
                sumoSibling.show();
                $(sumoSibling)[0].sumo.showOpts();
                console.log('did it');
            }
        });

        $("#js-pdq-trigger").click(function () {
            $('.pdq-moreoptions').toggleClass("open");
            $('.js-listsearch').toggleClass("hide");
        });

        if (window.SidebarMenuEffects) {
            SidebarMenuEffects();
        }
        
        $(window).off('resize', HandleFiltersResize).on('resize', HandleFiltersResize);
        HandleFiltersResize();
    };

    var HandleFiltersResize = function () {
        var $desktopWrap = $('.js-filters-wrap-desktop');
        var $mobileWrap = $('.js-filters-wrap-mobile');
        if ($desktopWrap.length === 1 && $mobileWrap.length === 1) {
            if (CINC.Core.IsMobile())
                $desktopWrap.find('.js-filters-basic').prependTo($mobileWrap);
            else
                $mobileWrap.find('.js-filters-basic').appendTo($desktopWrap);
        }
        var $basic = $('.js-filters-basic');
        if (CINC.Core.IsMobile()) {
            $basic.find('.js-searchbox-wrap').addClass('searchbox-anchor');
            $basic.removeClass('searchbox-anchor');
        }
        else {
            $basic.find('.js-searchbox-wrap').removeClass('searchbox-anchor');
            $basic.addClass('searchbox-anchor');
        }
    };

    var HandleFilterReset = function (e) {
        e.preventDefault();
        var $form = $('.js-filters-form');
        $form.find('input, select').each(function (i, ele) {
            var $ele = $(ele);
            var tagName = $ele.prop('tagName').toUpperCase();
            if (tagName === 'SELECT') {
                $ele.val('');
            }
            else if (tagName === 'INPUT' && !$ele.hasClass('tgl')) {
                var tagType = $ele.attr('type').toUpperCase();
                if (tagType === 'TEXT' || tagType === 'SEARCH' || tagType === 'HIDDEN') {
                    $ele.val('');
                }
                else if (tagType === 'RADIO' || tagType === 'CHECKBOX') {
                    $ele.prop('checked', ($ele.val() === ''));
                }
            }
        });
        $form.append('<input type="hidden" name="reset" value="1" />');
        RefreshSearch();
        CloseFilters();
        return false;
    };

    var HandleFilterFormChange = function (e) {
        CINC.Search.LinkedFormInputs.synchronizeValues(e, $('.js-filters-form'), RefreshSearch);
    };

    var handleFilterInputChange = function (e) {
        var additionalCriteria = $('.pdq-view').length === 1 && $('.pdq-moreoptions').is(':visible') ? $('.js-filters-altform').serializeObject() : null;
        CINC.Search.LinkedFormInputs.synchronizeValues(e, $('.pdq-view'), RefreshSearch(additionalCriteria));
    }

    var HandleFilterFormSubmit = function (e) {
        e.preventDefault();
        var additionalCriteria = $('.pdq-view').length === 1 && $('.pdq-moreoptions').is(':visible') ? $('.js-filters-altform').serializeObject() : null;
        RefreshSearch(additionalCriteria);
        return false;
    };

    var HandleSortByChange = function () {
        RefreshSearch();
    };

    var searchIncludeTags = function (tagsArray, tagSearchInput, searchValue) {
        var tagInputName = '';

        tagsArray.every(function (tag) {
            var innerText = $(tag).text();
            var cleanedInnerText = innerText.replace(/ \([0-9]*\)/, '').toLowerCase().trim();
            if (cleanedInnerText === searchValue.toLowerCase()) {
                tagInputName = $(tag).parent().prev('input').attr('name'); // check the input associated with the tag span
                return false; // exit the enumeration now
            }
            return true; // keep iterating
        });

        return tagInputName;
    };

    var StrCrit = CINC.Search.StrCrit = function (additionalCriteria) {
        var $form = $('.js-filters-form');
        if ($form.length === 0) {
            $form = $('.js-searchbar-form');
            if ($form.length === 0) {
                return {};
            }
        }

        var data = $form.serializeObject();
        data['page'] = '1';

        if (additionalCriteria !== undefined && additionalCriteria !== null) {
            for(var criterion in additionalCriteria){
                data[criterion] = additionalCriteria[criterion];
            }
        }

        var $sortBy = $('.js-filters-sortby');
        if ($sortBy.length === 1) {
            data['sortby'] = $sortBy.val();
        }

        if (data.hasOwnProperty('tag')) {
            // get the div that contains both the input and checkbox tags
            var tags = CINC.Search.el.TagsSearch.parent().parent().find(CINC.Search.css.IncludeTags).find('span');
            var tag = searchIncludeTags($(tags).toArray(), CINC.Search.el.TagsSearch, data.tag);
            if (tag !== undefined && tag !== '') {
                // set this tag to include - NOTE if exclude is ever needed for searching the return type must change
                data[tag] = 1;
            } else {
                data['kw'] = data.tag;
            }
            delete data['tag'];
        }

        var listingTypeDrop = $form.find('select[name=listingtype]');
        if (listingTypeDrop.length > 0) {
            var listingtype = listingTypeDrop.val() || [];
            data.listingtype = listingtype.join(',');
        }

        var mapSearch = (g.SearchTypes.indexOf('MAP') > -1);
        if (mapSearch) {
            $.extend(data, {
                'page': '1',
                'perpage': CINC.MaxPinCount || 100
            });
            if (g.MapPolygons.length > 0) {
                var coordsArrArr = [];
                $.each(g.MapPolygons, function (i, polygon) {

                    var coordsArr = [];
                    var polyArr = polygon.getPath().getArray();

                    if (polyArr[0].lat && polyArr[0].lng) {
                        if (polyArr[0].lat() < polyArr[1].lat()) {
                            polyArr.reverse();
                        }
                    }
                    else {
                        var latChar = (polyArr[0]['D'] ? 'D' : (polyArr[0]['B'] ? 'B' : 'A'));
                        if (polyArr[0][latChar] < polyArr[1][latChar]) {
                            polyArr.reverse();
                        }
                    }

                    for (var i = 0; i < polyArr.length; i++) {
                        if (polyArr[i].lat && polyArr[i].lng) {
                            coordsArr.push(parseFloat(polyArr[i].lat()).toFixed(6) + ' ' + parseFloat(polyArr[i].lng()).toFixed(6));
                        }
                        else {
                            var latChar = (polyArr[i]['D'] ? 'D' : (polyArr[i]['B'] ? 'B' : 'A'));
                            coordsArr.push(parseFloat(polyArr[i][latChar]).toFixed(6) + ' ' + parseFloat(polyArr[i]['k']).toFixed(6));
                        }
                    }

                    coordsArr.push(coordsArr[0]);
                    coordsArrArr.push(coordsArr.join(', '));

                });
                data.polygonmap = coordsArrArr.join(':');
                delete data['radius'];
            }
            else {
                if (g.FirstSearch) {
                    delete data['lat'];
                    delete data['long'];
                    delete data['minlat'];
                    delete data['maxlat'];
                    delete data['minlong'];
                    delete data['maxlong'];
                    delete data['sortby'];
                }
                else {
                    var bounds = g.Map.getBounds();
                    var center = g.Map.getCenter();
                    $.extend(data, {
                        'lat': center.lat(),
                        'long': center.lng(),
                        'minlat': bounds.getSouthWest().lat(),
                        'maxlat': bounds.getNorthEast().lat(),
                        'minlong': bounds.getSouthWest().lng(),
                        'maxlong': bounds.getNorthEast().lng(),
                        'sortby': ($sortBy.length === 1 ? data.sortby : 'nearest')
                    });
                }
            }
        } 

        if (data.acl_city != null && data.acl_city != undefined && data.kw != null && data.kw != undefined && data.kw.indexOf(data.acl_city) > -1) {
            data.kw = data.kw.replace(data.acl_city, "")
        }

        return data;
    };

    var RefreshSearch = CINC.Search.RefreshSearch = function (additionalCriteria) {
        if (g.SearchTypes.length === 0) {
            return;
        }

        var data = StrCrit(additionalCriteria);

        if (data['soldproperty'] === '1' && !isStrCritSoldPropertyCapable(data)) {
            Notification.Toast.Error("Sold property searching requires a city or zip. Disabling sold property search.", "Search Error!");
            CINC.Search.el.SoldPropertyCheckbox.attr("checked", false);
            delete data['soldproperty'];
        }

        var listSearch = (g.SearchTypes.indexOf('LIST') > -1);
        var mapSearch = (g.SearchTypes.indexOf('MAP') > -1);

        $('.js-filters-submit').addClass('submit-loading');
        if (listSearch && mapSearch) {
            data['type'] = 'split';
            CINC.Api.Search.Split(true).post(data).success(function (response) {
                var $html = $(response.html);
                HandleFiltersResponse($html.find('.js-filters-form'));
                //HandleFiltersToggle.call($('.js-filters-toggle')); // why are we calling this? Not calling to fix a bug. YOLO
                HandleListResponse($html.find('.js-listsearch'));
                HandleMapResponse(response.results);
                BindFiltersForm();
                BindSearchBox();
                BindResults();
                SetUrlStack();
                FinalizeSearchResponse(response.results.searchQs, response.results.searchTitle, response.results.searchUrl);
            }).error(HandleSearchError);
        } else if (listSearch) {
            data['type'] = 'list';
            var method = ($('.pdq-view').length === 1 ? 'Quick' : 'Html');
            CINC.Api.Search[method](true).get(data).success(function (response) {
                var $html = $(response);
                var $list = $html.find('.js-listsearch');
                var $alt = $html.find('.js-filters-altform');
                HandleFiltersResponse($html.find('.js-filters-form'));
                //HandleFiltersToggle.call($('.js-filters-toggle')); // why are we calling this? Not calling to fix a bug. YOLO
                HandleListResponse($list);
                HandleAltFiltersResponse($alt);
                BindFiltersForm();
                BindSearchBox();
                BindResults();
                SetUrlStack();
                FinalizeSearchResponse($list.attr('data-strcrit'), $list.attr('data-searchtitle'), $list.attr('data-searchurl'));
            }).error(HandleSearchError);
        } else if (mapSearch) {
            data['type'] = 'map';
            CINC.Api.Search.Map(true).post(data).success(function (response) {
                var $html = $(response.html);
                HandleFiltersResponse($html.find('.js-filters-form'));
                //HandleFiltersToggle.call($('.js-filters-toggle')); // why are we calling this? Not calling to fix a bug. YOLO
                HandleMapResponse(response.results);
                BindFiltersForm();
                BindSearchBox();
                BindResults();
                SetUrlStack();
                FinalizeSearchResponse(response.results.searchQs, response.results.searchTitle, response.results.searchUrl);
            }).error(HandleSearchError);
        }
    };

    var ApplyUrlStack = function () {
        var urlStack = GetUrlStack();
        if (!urlStack || urlStack.length == 0)
            return false;

        var stackIndex = urlStack.indexOf(window.location.pathname);
        if (stackIndex == -1)
            return false;

        if (el.UrlStackNext.length == 0 || el.UrlStackPrev.length == 0)
            return false;

        var nextUrl = urlStack[stackIndex + 1] || "";
        var prevUrl = urlStack[stackIndex - 1] || "";

        if (nextUrl != "")
            el.UrlStackNext.attr('href', nextUrl).removeClass('hidden');

        if (prevUrl != "")
            el.UrlStackPrev.attr('href', prevUrl).removeClass('hidden');

        if (nextUrl && prevUrl)
            el.UrlStackAll.removeClass('hidden');
    };

    var GetUrlStack = function () {
        return CINC.Core.LocalStorage.Get('UrlStack');
    };

    var SetUrlStack = function () {
        var resultsUrlElements = $('.js-urlstack-values input[type=hidden]');
        if (resultsUrlElements.length <= 0) {
            // if there are no stack elements present, see if the current url is in the existing url stack.
            // if it is, leave everything alone.
            var urlStack = GetUrlStack();
            if (urlStack && urlStack.indexOf(window.location.pathname) >= 0)
                return;

            // otherwise remove the existing stack
            CINC.Core.LocalStorage.Remove('UrlStack');
            return;
        }

        var urlStack = [];
        resultsUrlElements.each(function () {
            urlStack.push($(this).val());
        });

        CINC.Core.LocalStorage.Set('UrlStack', urlStack);
    };

    var HandleGalleryShowEnd = function (e, fotorama, extra) {
        $(this).siblings().find('.js-gallery-photocount').text((fotorama.activeIndex + 1));
    };

    var BindResults = CINC.Search.BindResults = function () {
        $('.js-searchresult').each(function () {
            BindResult($(this));
        });
    };

    var BindResult = function ($result) {

        $result.off('mouseenter', HandleResultEnter).on('mouseenter', HandleResultEnter);
        $result.off('mouseleave', HandleResultLeave).on('mouseleave', HandleResultLeave);

        var waypointOptions = {
            offset: '100%'
        };
        var $splitWrap = $('.js-splitwrap');
        if ($splitWrap.length === 1)
            waypointOptions.context = $splitWrap[0];
        else if (CINC.Core.IsMobile())
            waypointOptions.context = $('.content-wrap')[0];
        $result.find('.js-gallery').waypoint(function () {
            var $gallery = $(this.element);
            if (!$gallery.data('fotorama')) {
                $gallery.fotorama();
            }
            $gallery.off('fotorama:showend', HandleGalleryShowEnd).on('fotorama:showend', HandleGalleryShowEnd);
            this.disable();
        }, waypointOptions);

    };

    var HandleResultEnter = function () {
        var pdid = $(this).attr('data-pdid').toLowerCase();
        $.each(g.MapMarkers, function (i, marker) {
            var $marker = $(marker.getContent());
            if (marker.pdid.toLowerCase() === pdid.toLowerCase())
                $marker.addClass('map-marker-selected');
            else
                $marker.removeClass('map-marker-selected');
        });
    };

    var HandleResultLeave = function () {
        var pdid = $(this).attr('data-pdid').toLowerCase();
        $.each(g.MapMarkers, function (i, marker) {
            var $marker = $(marker.getContent());
            if (marker.pdid.toLowerCase() === pdid.toLowerCase()) {
                $marker.removeClass('map-marker-selected');
                return false;
            }
        });
    };

    var FinalizeSearchResponse = function (strCrit, searchTitle, searchUrl) {
        g.FirstSearch = false;
        PushSearchState(strCrit, searchTitle, searchUrl);
        CINC.Search.Events.trigger('resultsFinalized');
    };

    var HandleSearchError = function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.getAllResponseHeaders()) {
            $('.js-filters-submit').removeClass('submit-loading');
            alert('Error loading search results, please try again');
        }
    };

    var PushSearchState = function (strCrit, searchTitle, searchUrl) {
        History.replaceState(strCrit, searchTitle + ' | ' + CINC.Site.SiteName, searchUrl);
    };

    var HandleFiltersResponse = function ($form) {
        var toggleStates = {};
        $('.js-tgl-flip').each(function (i, ele) {
            var $ele = $(ele);
            toggleStates[$ele.attr('id')] = $ele.prop('checked');
        });

        var $oldForm = $('.js-filters-form');
        $oldForm.replaceWith($form);

        SetToggleStates(toggleStates, null);
    };

    var recordAbTestEvent = function (event) {
        CINC.Api.ConsumerProperty.RecordABTestEvent(event).post()
    };

    var HandleFiltersToggle = function (e) {
        if (e !== null && e !== undefined) {
            e.preventDefault();
        }
        var $checkbox = $(this);
        if ($checkbox.prop('checked')) {
            recordAbTestEvent('pdq_open_search_options_mobile');
            $(".js-filters-buttons").removeClass('filter-buttons-hidden');
            $(".js-filters-wrap").removeClass('filter-panel-mobile');
            $(".js-filters-toggle-btn").html('<span class="icon-close"></span><span class="small-title">Close</span>');
            $(".js-filters-grid").slideDown(function () {
                Waypoint.refreshAll();
            });
        } else {
            recordAbTestEvent('pdq_close_search_options_mobile');;
            $(".js-filters-buttons").addClass('filter-buttons-hidden');
            $(".js-filters-wrap").addClass('filter-panel-mobile');
            $(".js-filters-toggle-btn").html('<span class="icon-filter"></span><span class="small-title">Filters</span>');
            $(".js-filters-grid").slideUp(function () {
                Waypoint.refreshAll();
            });
        }
        return false;
    };

    var OpenFilters = CINC.Search.OpenFilters = function () {
        SetToggleStates({}, true);
    };

    var CloseFilters = CINC.Search.CloseFilters = function () {
        SetToggleStates({}, false);
    };

    var HandleToggleFlip = function (e) {
        e.preventDefault();
        var targetElement = $(e.target);
        var extraTags = targetElement.parent().find(targetElement.data('target'));

        if (extraTags.hasClass('hidden'))
            targetElement.text('Hide Tags');
        else
            targetElement.text('More Tags');

        extraTags.toggleClass('hidden');

        return false;
    };

    var SetToggleStates = function (toggleStates, forceAll) {
        $('.js-tgl-flip').each(function (i, ele) {
            var $checkbox = $(ele);
            var id = $checkbox.attr('id');
            if ((toggleStates[id] || forceAll === true) && forceAll !== false) {
                $checkbox.prop('checked', true).trigger('change');
                $('#' + $checkbox.attr('data-toggle-for')).css('display', 'block');
            }
            else {
                $checkbox.prop('checked', false).trigger('change');
                $('#' + $checkbox.attr('data-toggle-for')).css('display', 'none');
            }
        });
    };

    var HandleAltFiltersResponse = function ($form) {
        if ($form !== null && $form.length === 1) {
            $('.js-filters-altform').replaceWith($form);
        }
    };

    var HandleListResponse = function ($results) {
        $results.find('script').each(function () {
            var $script = $(this);
            try {
                eval($script.html());
            }
            catch (err){ }
            $script.remove();
        });
        $('.js-listsearch').replaceWith($results);
    };

    var HandleMapResponse = function (results) {
        $('.js-mapsearch-link').attr('href', '/search?' + results.searchQs);
        $('.js-mapsearch-link-split').attr('href', '/search/split?' + results.searchQs);

        while (g.MapMarkers[0]) {
            g.MapMarkers.pop().setMap(null);
        }

        var persistResult = false;
        $.each(results.results, function (i, result) {
            if (!result.latitude || !result.longitude)
                return;

            var marker = new RichMarker({
                content: $('<div class="map-marker"><span class="map-marker-title">' + result.priceShort + '</span></div>')[0],
                draggable: false,
                map: g.Map,
                pdid: result.pdid,
                position: new google.maps.LatLng(result.latitude, result.longitude),
                shadow: ''
            });

            google.maps.event.addListener(marker, 'click', function () {
                CINC.Api.Search.Result(this.pdid, true).get().success(function (response) {
                    var $html = $(response);
                    var lat = parseFloat($html.attr('data-lat'));
                    var lng = parseFloat($html.attr('data-lng'));
                    var pdid = $html.attr('data-pdid');
                    ClearMapResult();
                    g.MapResult = new RichMarker({
                        pdid: $html.attr('data-pdid'),
                        position: new google.maps.LatLng(lat, lng),
                        map: g.Map,
                        draggable: false,
                        content: $('<div class="map-result card--property card-no-overlay simple-gallery multi-image" data-pdid="' + pdid.htmlEncode() + '">' + $html.html() + '</div>')[0],
                        shadow: ''
                    });
                    google.maps.event.addListener(g.MapResult, 'ready', function () {
                        var $script = $html.find('script');
                        eval($script.html());
                        $script.remove();
                    });
                    google.maps.event.addListener(g.MapResult, 'click', KillEvent);
                });
                var $splitWrap = $('.js-splitwrap');
                if ($splitWrap.length === 1) {
                    $splitWrap.scrollTo('.js-searchresult[data-pdid="' + this.pdid + '"]', {
                        offsetTop: ($('#content').outerHeight() + 15)
                    });
                }
            });

            persistResult = (persistResult || (g.MapResult !== null && g.MapResult.pdid === result.pdid));

            g.MapMarkers.push(marker);

        });
        if (!persistResult) {
            ClearMapResult();
        }

        if (g.FirstSearch && results.mapBounds && results.mapBounds.maxLat && results.mapBounds.maxLng && results.mapBounds.minLng && results.mapBounds.minLng) {
            g.IgnoreIdle = 1;
            var bounds = new google.maps.LatLngBounds();
            bounds.extend(new google.maps.LatLng(results.mapBounds.minLat, results.mapBounds.minLng));
            bounds.extend(new google.maps.LatLng(results.mapBounds.maxLat, results.mapBounds.maxLng));
            g.Map.fitBounds(bounds);
        }

    };

    var BindSearchBox = g.BindSearchBox = function () {
        $(CINC.Search.css.KeywordSearchField).searchBox({
            hiddenInput: $('.js-kwinputname'),
            topMostParentClassIdentifier:  CINC.Search.css.SearchFiltersForm
        });
    };

    var InitListSearch = function () {
        if (el.ListSearch.length < 1)
            return;
        g.SearchTypes.push('LIST');
    };

    //#region Map Search

    var FinishMapInit = CINC.Search.FinishMapInit = function () {
        InitMapSearch();
    };

    var InitMapSearch = function () {
        if (el.MapSearch.length < 1 || CINC.Core.IsBot()) {
            return;
        }
        g.SearchTypes.push('MAP');
        var lat = CINC.Site.StartLat;
        var lng = CINC.Site.StartLong;
        var zoom = 5;
        var initStrCrit = $('.js-filters-form').serializeObject();
        if (initStrCrit.lat && initStrCrit['long']) {
            lat = parseFloat(initStrCrit.lat);
            lng = parseFloat(initStrCrit['long']);
            g.FirstSearch = false;
            zoom = 13;
        }
        else if (initStrCrit.acl_city || initStrCrit.acl_county || initStrCrit.acl_zip5 || initStrCrit.polygonmap) {
            g.FirstSearch = true;
        }

        var mapOptions = {
            'center': new google.maps.LatLng(lat, lng),
            'mapTypeControlOptions': {
                'position': google.maps.ControlPosition.TOP_LEFT
            },
            'mapTypeId': google.maps.MapTypeId.ROADMAP,
            'zoom': zoom,
            'draggable': true,
            'disableDoubleClickZoom': true
        };

        g.Map = new google.maps.Map(el.MapSearch[0], mapOptions);

        setTimeout(function () {
            g.MapOverlay = new google.maps.OverlayView();
            g.MapOverlay.draw = function () { };
            g.MapOverlay.setMap(g.Map);

            if (initStrCrit.polygonmap) {
                CreateMapPolygons(initStrCrit.polygonmap);
            }

            google.maps.event.addListener(g.Map, 'click', function () {
                if (g.IgnoreEvent) {
                    g.IgnoreEvent = false;
                }
                else {
                    ClearMapResult();
                }
            });

            google.maps.event.addListener(g.Map, 'idle', function () {
                if (g.IgnoreIdle === 2 || (g.IgnoreIdle === 1 && g.SearchTypes.length > 1)) {
                    g.IgnoreIdle = 0;
                }
                else if (g.IgnoreIdle === 1) {
                    g.IgnoreIdle = 2;
                    g.Map.setZoom(g.Map.getZoom() + 1);
                }
                else if (g.MapPolygons.length === 0) {
                    RefreshSearch();
                }
            });

            el.ClearControl = $('<span class="mapsearch-control mapsearch-draw mapsearch-clear">Clear</span>');
            google.maps.event.addDomListener(el.ClearControl[0], 'click', function (e) {
                if (g.MapPolygons.length > 0) {
                    ClearMapPolygons();
                    ShowDrawButton();
                    RefreshSearch();
                }
            });
            g.Map.controls[google.maps.ControlPosition.TOP_RIGHT].push(el.ClearControl[0]);

            el.DrawControl = $('<span class="mapsearch-control mapsearch-draw">Draw Custom Search</span>');
            google.maps.event.addDomListener(el.DrawControl[0], 'click', function (e) {
                if (g.MapDrawMode) {
                    el.MapSearch.off('mousedown', HandleDrawMousedown);
                    el.MapSearch.off('mousemove', HandleDrawMousemove);
                    el.MapSearch.off('mouseup', HandleDrawMouseup);
                    g.MapDrawMode = false;
                    g.Map.setOptions({
                        'draggable': true
                    });
                    g.MapPolyline = null;
                    ShowDrawButton();
                }
                else {
                    g.Map.setOptions({
                        'draggable': false
                    });
                    el.MapSearch.on('mousedown', HandleDrawMousedown);
                    g.MapDrawMode = true;
                    ShowDrawingButton();
                }
            });
            g.Map.controls[google.maps.ControlPosition.TOP_RIGHT].push(el.DrawControl[0]);

            el.SplitLink = $('<a class="mapsearch-icon js-mapsearch-link-split" href="/search/split"><i class="fa fa-columns"></i></a>');
            el.SearchLink = $('<a class="mapsearch-icon js-mapsearch-link" href="/search"><i class="fa fa-th-large"></i></a>');
            if (g.SearchTypes.length < 2) {
                g.Map.controls[google.maps.ControlPosition.TOP_RIGHT].push(el.SplitLink[0]);
                g.Map.controls[google.maps.ControlPosition.TOP_RIGHT].push(el.SearchLink[0]);
            }

            if (CINC.DefaultMapData) {
                HandleMapResponse(CINC.DefaultMapData);
                FinalizeSearchResponse(CINC.DefaultMapData.searchQs, CINC.DefaultMapData.searchTitle, CINC.DefaultMapData.searchUrl);
            }
            else {
                RefreshSearch();
            }

        }, 1000);
    }

    var KillEvent = function () {
        g.IgnoreEvent = true;
    };

    var ClearMapResult = function () {
        if (g.MapResult !== null) {
            g.MapResult.setMap(null);
            g.MapResult = null;
        }
    };

    var ShowDrawButton = function () {
        el.DrawControl.text('Draw Custom Search').removeClass('mapsearch-drawing mapsearch-clear');
    };

    var ShowDrawingButton = function () {
        el.DrawControl.text('Drawing...').removeClass('mapsearch-clear').addClass('mapsearch-drawing');
    };

    var HandleDrawMousedown = function (e) {
        g.MapPolyline = new google.maps.Polyline({
            'map': g.Map
        });
        el.MapSearch.on('mousemove', HandleDrawMousemove);
        el.MapSearch.on('mouseup', HandleDrawMouseup);
        el.MapSearch.off('mousedown', HandleDrawMousedown);
    };

    var HandleDrawMousemove = function (e) {
        var offset = el.MapSearch.offset();
        var pageX = e.pageX - offset.left;
        var pageY = e.pageY - offset.top;
        var point = new google.maps.Point(parseInt(pageX), parseInt(pageY));
        var latLng = g.MapOverlay.getProjection().fromContainerPixelToLatLng(point);
        g.MapPolyline.getPath().push(latLng);
    };

    var HandleDrawMouseup = function (e) {
        if (g.MapPolyline && g.MapPolyline !== null) {
            if (g.MapPolyline.getPath().getArray().length > 2) {

                g.Map.setOptions({
                    'draggable': true
                });

                g.MapDrawMode = false;

                //don't oversimplify polygons
                var precision = 0.0009; //default
                var maxIterations = 10;
                var polyLength = g.MapPolyline.simplifyLine(precision).length;
                while ((polyLength < 4 || polyLength >= 100) && maxIterations-- > 0) {
                    if (polyLength < 4) {
                        precision = precision / 10.0;
                    }

                    if (polyLength >= 100) {
                        precision = precision * 10.0;
                    }

                    polyLength = g.MapPolyline.simplifyLine(precision).length;
                }

                var polygon = new google.maps.Polygon({
                    'paths': g.MapPolyline.simplifyLine(precision),
                    'strokeColor': "#227B87",
                    'strokeOpacity': 0.8,
                    'strokeWeight': 3,
                    'fillColor': "#7DCFB6",
                    'fillOpacity': 0.1,
                    'editable': false,
                    'geodesic': false
                });
                polygon.setMap(g.Map);

                g.MapPolygons.push(polygon);
                $(CINC.Search.css.KeywordSearchField).val('');
                ShowDrawButton();

                el.MapSearch.off('mousedown', HandleDrawMousedown);
                el.MapSearch.off('mousemove', HandleDrawMousemove);
                el.MapSearch.off('mouseup', HandleDrawMouseup);

                g.MapPolyline.setMap(null);
                g.MapPolyline = null;

                RefreshSearch();
            }
        }
    };

    var CreateMapPolygons = function (polygonMapStr) {
        if (polygonMapStr.length < 1)
            return;

        var polygonMapArr = polygonMapStr.split(':');
        var minLat = null, minLong = null, maxLat = null, maxLong = null;

        for (var j = 0; j < polygonMapArr.length; j++) {
            var coordsArr = polygonMapArr[j].split(',');
            var coord;
            var latLngArr = [];
            for (var i = 0; i < coordsArr.length; i++) {
                coord = $.trim(coordsArr[i]).split(' ');
                latLngArr.push(new google.maps.LatLng(parseFloat(coord[0]), parseFloat(coord[1])));
                if (minLat === null || parseFloat(coord[0]) < minLat) {
                    minLat = parseFloat(coord[0]);
                }
                else if (maxLat === null || parseFloat(coord[0]) > maxLat) {
                    maxLat = parseFloat(coord[0]);
                }
                if (minLong === null || parseFloat(coord[1]) < minLong) {
                    minLong = parseFloat(coord[1]);
                }
                else if (maxLong === null || parseFloat(coord[1]) > maxLong) {
                    maxLong = parseFloat(coord[1]);
                }
            }
            var polygon = new google.maps.Polygon({
                'paths': latLngArr,
                'strokeColor': "#005063",
                'strokeOpacity': 0.8,
                'strokeWeight': 3,
                'fillColor': "#CCECF4",
                'fillOpacity': 0.3,
                'editable': false,
                'geodesic': false
            });
            polygon.setMap(g.Map);
            g.MapPolygons.push(polygon);
        }

        g.Map.panTo(new google.maps.LatLng(((maxLat + minLat) / 2.0), ((maxLong + minLong) / 2.0)));

    };

    var ClearMapPolygons = function () {
        if (g.MapPolygons.length > 0) {
            for (var i = 0; i < g.MapPolygons.length; i++) {
                g.MapPolygons[i].setMap(null);
            }
            g.MapPolygons = [];
        }
        $('.js-filters-form').find('[name="polygonmap"]').remove();
    };

    //#endregion

    var pdqModalFormSubmit = function() {
        var $form = $(this);
        var data = $form.serializeObject();
        data.filtersAsString = JSON.stringify(StrCrit());

        CINC.Api.Search.SavePdq(data)
            .post(data)
            .success(function (data, textStatus, jqXHR) {
                window.location.pathname = data;
            })
            .error(function(jqXHR, textStatus, errorThrown) {
                alert("Unable to persist the PDQ. See error: "  + errorThrown);
            });

        return false;
    };

    var pdqManagerModalWireup = function () {
        el.PdqAnchor.on('click', function (e) {
            e.preventDefault();
            Modals.PdqManagerModal().Open();
        });

        el.PdqModalForm.on('submit', pdqModalFormSubmit);
    };

    $(document).ready(function () {
        if (el.SearchHandoffModal.length > 0) {
            el.SearchHandoffModal.prop('checked', false);
        }

        if (CINC.Site.IsBrandedSlaveSite) {
            $('body').on('click', '.js-handofflink', function (e) {
                e.preventDefault();
                var trigger = $(this);
                var url = trigger.attr('href') || trigger.data('handoffurl');
                if (url) {
                    GracefulHandoff(url);
                }
            });
        }

        SetUrlStack();
        if (!ApplyUrlStack()) {
            // TODO: fill via API call
        }

        if (CINC.QS.forceopen > 0) {
            // if we can't force traversal through the urlstack, just display the page without the forced open
            if (!CINC.Core.LocalStorage.IsAvailable) {
                window.location = window.location.replace("forceopen=" + CINC.QS.forceopen, "");
                return;
            }

            var urlStack = GetUrlStack();
            var url = urlStack[CINC.QS.forceopen];
            if (url) {
                window.location = url;
                Modals.Loading("Finding your requested listing").Open();
                return;
            }
        }

        BindFiltersForm();
        BindSearchBox();
        BindResults();
        InitListSearch();
        pdqManagerModalWireup();

        $('.brokenImage').each(function (index, element) {
            CINC.Api.Photo('broken').post({
                pdid: $(element).data('pdid'),
                url: $(element).find('.initial-image').attr('src'),
                mlsid: $(element).data('mlsid')
            }).done(function (r) {
                //console.log("success");
            }).fail(function (r) {
                //console.warn("fail");
            });
        });

        // Map search initialized in HousesDotNet.Core.js, after Google Maps
        if (CINC.QS && CINC.QS.advanced === '1') {
            OpenFilters();
        }

        $('.js-lender-search-banner').on('click', function (e) {
        });

        CINC.Core.OptInImport();
    });

})(typeof ga === 'undefined' || ga === null ? function () { } : ga);

(function () {
    var getInstances = function () {
        var instances = [];
        $('.searchboxed').each(function () {
            var $searchBox = $(this);
            if ($searchBox.data('searchBox'))
                instances.push($searchBox.data('searchBox'));
        });
        return instances;
    };

    var removeDropdowns = function (exceptInstance) {
        $.each(getInstances(), function (i, instance) {
            if (!exceptInstance || !exceptInstance.is(instance))
                instance.func.dropdown.remove();
        });
    };

    var preventDefaultBehavior = function(event, prevent) {
        if (prevent) {
            event.stopPropagation();
            event.preventDefault();
        }

        return !prevent;
    }

    $.fn.searchBox = function (parms) {
        this.each(function () {
            var me = $(this);
            if (me.data('searchBox')) {
                return true;
            }

                var g = {
                    keywords: [],
                    el: {
                        dropdown: null,
                        searchBox: null,
                        tagsWrap: null,
                        wrap: null
                    },
                    func: {
                        dropdown: {
                            bind: function() {
                                if (g.el.dropdown === null || g.el.dropdown.length === 0)
                                    return;

                                g.el.dropdown.off('click', g.func.dropdown.handleDropdownClick)
                                    .on('click', g.func.dropdown.handleDropdownClick);
                                g.el.dropdown.find('.js-keyword')
                                    .off('click', g.func.dropdown.handleClick)
                                    .on('click', g.func.dropdown.handleClick)
                                    .off('mouseenter', g.func.dropdown.handleMouseEnter)
                                    .on('mouseenter', g.func.dropdown.handleMouseEnter);
                            },
                            handleClick: function(e) {
                                g.func.dropdown.select($(this), e);
                            },
                            handleDropdownClick: function(e) {
                                e.stopPropagation();
                            },
                            handleMouseEnter: function() {
                                g.func.dropdown.preselect($(this), false);
                            },
                            moveSelected: function(up) {
                                if (g.el.dropdown === null || g.el.dropdown.length === 0)
                                    return;

                                var $keywords = g.el.dropdown.find('.js-keyword');
                                var $selected = $keywords.filter('.preselected');
                                var index = $keywords.index($selected[0]);

                                if (up && $selected.length === 1 && index > 0) {
                                    g.func.dropdown.preselect($($keywords[index - 1]), true);
                                } else if ($selected.length === 0) {
                                    g.func.dropdown.preselect($keywords.first(), true);
                                } else if ($selected.length === 1 && index < $keywords.length - 1) {
                                    g.func.dropdown.preselect($($keywords[index + 1]), true);
                                }
                            },
                            preselect: function($keyword, autoScroll) {
                                if (g.el.dropdown === null || g.el.dropdown.length === 0)
                                    return;

                                g.el.dropdown.find('.js-keyword').removeClass('preselected');
                                $keyword.addClass('preselected');

                                if (autoScroll) {
                                    var $scrollWrap = g.el.dropdown.find('.js-keywords-scroll');
                                    var height = $keyword.outerHeight();
                                    var top = $keyword.position().top;
                                    var minVisible = 0;
                                    var maxVisible = $scrollWrap.height();
                                    if (top < minVisible) {
                                        $scrollWrap.animate({ scrollTop: '-=' + (minVisible - top + height) }, 0);
                                    } else if (top + height > maxVisible) {
                                        $scrollWrap.animate({ scrollTop: '+=' + (top + height - maxVisible) }, 0);
                                    }
                                }

                            },
                            preselectFirst: function() {
                                if (g.el.dropdown === null || g.el.dropdown.length === 0)
                                    return false;

                                var $firstKeyword = g.el.dropdown.find('.js-keyword:first');
                                if ($firstKeyword.length === 1) {
                                    g.func.dropdown.preselect($firstKeyword, false);
                                    return true;
                                }
                                return false;
                            },
                            select: function(oKeyword, e) {
                                if (oKeyword instanceof jQuery) {
                                    oKeyword = {
                                        friendlyInputName: oKeyword.attr('data-friendlyinputname'),
                                        inputName: oKeyword.attr('data-inputname'),
                                        value: oKeyword.attr('data-value'),
                                        detailsUrl: oKeyword.attr('data-detailsurl')
                                    };
                                }

                                if (oKeyword.detailsUrl) {
                                    g.func.dropdown.remove();
                                    window.location.href = oKeyword.detailsUrl;
                                    return;
                                }

                                var refreshSearch = true;
                                var inputName = oKeyword.inputName.toLowerCase();
                                var friendlyInputName = oKeyword.friendlyInputName.toLowerCase();
                                var keyword = oKeyword.value;
                                var id = (inputName + '_' + keyword).replace(/ /g, '_').replace(/,/g, '').replace(/\(|\)/g, '').toLowerCase();

                                if (g.parms.tags && g.el.tagsWrap !== null && g.el.tagsWrap.length === 1) {
                                    id = id.split("/").join("_"); // essentially a .replaceAll() substitute, since it doesn't exist in JS :(
                                    if ($('#' + id).length === 0) {
                                        g.el.tagsWrap.append('<input class="js-searchbox-tag" type="checkbox" name="' + inputName + '" id="' + id.htmlEncode() + '" value="' + keyword.htmlEncode() + '" checked="checked" />');
                                        g.el.tagsWrap.append('<label for="' + id + '"><span class="filtertag">' + keyword.htmlEncode() + ' (' + friendlyInputName.htmlEncode() + ')</span></label>');
                                    } else {
                                        refreshSearch = false;
                                    }
                                    g.el.searchBox.attr('name', g.parms.defaultInputName).val('');
                                } else {
                                    g.el.searchBox.attr('name', inputName).val(keyword);
                                }

                                g.parms.lastWord = keyword;
                                g.parms.lastInputName = inputName;
                                g.func.dropdown.remove();

                                var $altForm = $('.js-filters-altform');
                                if ($altForm.length === 1 && $altForm.is(':visible') && typeof e !== 'undefined') {
                                    e.stopPropagation();
                                    e.preventDefault();
                                } else if (refreshSearch && CINC.Search && CINC.Search.RefreshSearch) {
                                    CINC.Search.RefreshSearch();
                                }
                            },
                            remove: function() {
                                if (g.el.dropdown === null || g.el.dropdown.length === 0)
                                    return;

                                g.el.dropdown.remove();
                                g.el.dropdown = null;
                            },
                            removeAll: removeDropdowns,
                        trySelectFirst: function () {
                            if (g.keywords.length === 0)
                                return;

                            var match = $.trim(g.el.searchBox.val());
                            var oKeyword = g.keywords[0];
                            var keyword = oKeyword.value;
                            var perms = [keyword, keyword.replace(',', '').replace('  ', ' ')];

                            $.each(perms, function (i, v) {
                                if (v.toLowerCase().indexOf(match.toLowerCase()) === 0) {
                                    g.func.dropdown.select(oKeyword);
                                    return false;
                                }
                            });
                        }
                    },
                    init: function () {
                        g.el.searchBox = me;
                        g.el.wrap = me.closest('.js-searchbox-wrap');
                        if (g.parms.tags) {
                            g.el.tagsWrap = g.el.wrap.next('.js-searchbox-tagswrap');
                            if (g.el.tagsWrap.length === 0) {
                                g.el.tagsWrap = g.el.wrap.find('.js-searchbox-tagswrap');
                            }
                            if (g.el.tagsWrap.length === 0) {
                                g.el.tagsWrap = null;
                                g.parms.tags = false;
                            }
                            else {
                                g.func.tags.bind();
                            }
                        }

                        g.func.searchBox.bind();
                        return me.addClass('searchboxed');
                    },
                    searchBox: {
                        bind: function () {
                            if (g.el.searchBox === null || g.el.searchBox.length === 0)
                                return;

                            g.el.searchBox
                                .off('click', g.func.searchBox.handleClick).on('click', g.func.searchBox.handleClick)
                                .off('keydown', g.func.searchBox.handleKeydown).on('keydown', g.func.searchBox.handleKeydown)
                                .off('keypress', g.func.searchBox.handleKeypress).on('keypress', g.func.searchBox.handleKeypress)
                                .off('keyup', g.func.searchBox.handleKeyup).on('keyup', g.func.searchBox.handleKeyup)
                                .off('change', g.func.searchBox.handleEvent).on('change', g.func.searchBox.handleEvent)
                                .off('focus', g.func.searchBox.handleEvent).on('focus', function (e) { g.func.searchBox.handleEvent(e, true); });
                        },
                        clear: function () {
                            g.el.searchBox.attr('name', g.parms.defaultInputName);
                            g.el.searchBox.val('');
                        },
                        handleClick: function (e) {
                            e.stopPropagation();
                            removeDropdowns(g);
                        },
                        handleEvent: function (e, immediate) {
                            if (CINC.Search && CINC.Search.g) {
                                CINC.Search.g.FirstSearch = true;
                                CINC.Search.g.NextZoom = 12;
                            }

                            var autocompleteEvent = function () {
                                var word = $.trim(g.el.searchBox.val());

                                if (word.length < 2) {
                                    g.func.dropdown.remove();
                                }
                                else if (word !== g.parms.lastWord || e.type === 'focus') {
                                    CINC.Api.Search.AutocompleteHtml(g.parms.autocompleteName, word, true).get({
                                        IncludeSearches: (g.parms.includeSearches ? '1' : '0')
                                    }).success(function (response) {

                                        g.func.dropdown.remove();
                                        var $dropdown = $(response);

                                        if (parseInt($dropdown.attr('data-groupcount')) > 0) {

                                            g.el.dropdown = $(response).appendTo(g.el.wrap.addClass('open'));

                                            g.keywords = [];
                                            $dropdown.find('.js-keyword').each(function () {
                                                var $keyword = $(this);
                                                g.keywords.push({
                                                    friendlyInputName: $keyword.attr('data-friendlyinputname'),
                                                    inputName: $keyword.attr('data-inputname'),
                                                    value: $keyword.attr('data-value'),
                                                    detailsUrl: $keyword.attr('data-detailsurl')
                                                });
                                            });

                                            g.func.dropdown.bind();
                                            g.func.dropdown.preselectFirst();

                                        }
                                        else {
                                            g.el.searchBox.attr('name', g.parms.defaultInputName);
                                        }

                                    });
                                }
                                g.parms.lastWord = word;

                                if (e.type === 'change') {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    return false;
                                }
                                return true;
                            };

                            if (immediate) {
                                autocompleteEvent();
                            }
                            else {
                                if (g.AutocompleteTimer)
                                    clearTimeout(g.AutocompleteTimer);

                                g.AutocompleteTimer = setTimeout(autocompleteEvent, 800);
                            }
                        },
                        handleKeydown: function (e) {

                            var preventDefault = false;
                            switch (e.which) {
                                case 27: //escape
                                    if (g.el.dropdown !== null) {
                                        g.func.dropdown.remove();
                                        preventDefault = true;
                                    }
                                    break;
                                case 38: case 40: //up arrow, down arrow
                                    if (g.el.dropdown !== null) {
                                        preventDefault = true;
                                    }
                                    break;
                            }

                            // stops propagation if true
                            return preventDefaultBehavior(e, preventDefault);
                        },
                        handleKeypress: function (e) {

                            var preventDefault = false;
                            switch (e.which) {
                                case 13: //enter
                                    if (g.el.dropdown !== null) {
                                        var $selected = g.el.dropdown.find('.js-keyword.preselected');
                                        if ($selected.length === 1) {
                                            g.func.dropdown.select($selected, e);
                                            preventDefault = true;
                                        }
                                        else {
                                            g.el.searchBox.attr('name', g.parms.defaultInputName);
                                        }
                                    }
                                    break;
                            }

                            // stops propagation if true
                            return preventDefaultBehavior(e, preventDefault);
                        },
                        handleKeyup: function (e) {

                            var preventDefault = false;
                            switch (e.which) {
                                case 38: //up arrow
                                    preventDefault = true;
                                    g.func.dropdown.moveSelected(true);
                                    break;
                                case 40: //down arrow
                                    preventDefault = true;
                                    g.func.dropdown.moveSelected(false);
                                    break;
                                default:
                                    preventDefault = g.func.searchBox.handleEvent.apply(this, [e]);
                                    break;
                            }

                            // stops propagation if true
                            return preventDefaultBehavior(e, preventDefault);
                        }
                    },
                    tags: {
                        bind: function () {
                            g.el.tagsWrap.off('change', '.js-searchbox-tag', g.func.tags.handleChange).on('change', '.js-searchbox-tag', g.func.tags.handleChange);
                        },
                        handleChange: function (e) {
                            var $tag = $(this);
                            if (!$tag.prop('checked')) {
                                var name = $tag.attr('name');
                                var value = $tag.attr('value');
                                $.each(getInstances(), function (i, instance) {
                                    console.log(instance.el.searchBox.attr('name'));
                                    console.log(instance.el.searchBox.val());
                                    if (instance.el.searchBox.attr('name') === name && instance.el.searchBox.val() === value) {
                                        instance.func.searchBox.clear();
                                    }
                                });
                            }
                        },
                        removeAll: function () {
                            var parent = me.data('searchBox').el.searchBox.parents(g.parms.topMostParentClassIdentifier);
                            parent.find('.js-searchbox-tagswrap').empty();
                        }
                    }
                },
                is: function (other) {
                    return (other.el.wrap[0] === g.el.wrap[0]);
                },
                parms: $.extend({
                    autocompleteName: (me.attr('data-autocompletename') ? me.attr('data-autocompletename') : 'acl_kw'),
                    defaultInputName: (me.attr('data-defaultinputname') ? me.attr('data-defaultinputname') : 'kw'),
                    tags: false,
                    lastWord: null,
                    includeSearches: !!me.attr('data-includesearches') && me.attr('data-includesearches') !== '0'
                }, parms)
            };

            g.func.init();
            me.data('searchBox', g);
            return true;
        });

        $('body').on('click', function () {
            removeDropdowns();
        });
        return this;
    };

    $.fn.searchBox.tags = false;
})();
CINC = (typeof CINC === 'undefined' ? {} : CINC);

CINC.PDQ = (function(ga){
    var isPdqPage = window.location.pathname.indexOf('/search/quick') === 0;
    var logPdqGaEvent = function(event) {
        if (isPdqPage && event) {
            if (typeof gtag !== 'undefined' && gtag !== null) {
                gtag("event", event, { feature: 'old_PDQ' });
            }
            else {
                console.log('Tried to fire Google Analytics event' + event + ' on feature old_PDQ, but gtag is unavailable');
            }
        }
    };

    var recordAbTestEvent = function (event) {
        CINC.Api.ConsumerProperty.RecordABTestEvent(event).post()
    }
    let searchTagAnchors = document.getElementsByClassName('searchtag');
    for (let i = 0; i < searchTagAnchors.length; i++) {
        searchTagAnchors[i].onclick = function() { recordAbTestEvent('pdq_remove_search_options_from_searchview'); };
    }

    let paginationAnchors = document.getElementsByClassName('pagination');
    for (let i = 0; i < paginationAnchors.length; i++) {
        paginationAnchors[i].onclick = function() { recordAbTestEvent('pdq_navigate_by_pagination'); };
    }

    let quickSearchAnchors = document.getElementsByClassName('js-quick-search-link');
    for (let i = 0; i < quickSearchAnchors.length; i++) {
        quickSearchAnchors[i].onclick = function() { logPdqGaEvent('quicksearch_link'); recordAbTestEvent('pdq_open_quick_search_pdqlink');};
    }

    let marketReportElements = document.getElementsByClassName('js-market-report-link'); 
    if (marketReportElements && marketReportElements[0]){
        marketReportElements[0].onclick = function() { logPdqGaEvent('goto_market_report'); recordAbTestEvent('pdq_see_market_stats');};
    }

    let openHouseElements = document.getElementsByClassName('js-open-house');
    if (openHouseElements && openHouseElements[0]){
        openHouseElements[0].onclick = function() { recordAbTestEvent('pdq_open_open_house_listing');};
    }

    let mobileMenuElements = document.getElementsByClassName('icon-more');
    if (mobileMenuElements && mobileMenuElements[0]){
        mobileMenuElements[0].onclick = function() { recordAbTestEvent('pdq_open_mobile_menu');};
    }
    
    return {
        events: {
            clearFilters: function() { logPdqGaEvent('clear_current_search_criteria'); recordAbTestEvent('pdq_clear_all_search_parameters_desktop');},
            submitClick: function(label) { logPdqGaEvent('search_initiated'); recordAbTestEvent('pdq_execute_search_desktop');},
            mapViewClick: function() { logPdqGaEvent('open_mapview'); recordAbTestEvent('pdq_map_view_desktop');},
            splitViewClick: function() { logPdqGaEvent('open_splitview'); recordAbTestEvent('pdq_split_view_desktop');},
            gridViewClick: function() { logPdqGaEvent('open_gridview'); recordAbTestEvent('pdq_grid_view_desktop');},
            advancedFiltersClick: function() { logPdqGaEvent('open_advanced_filters'); recordAbTestEvent('pdq_more_options_desktop');},
            applyAdvancedClick: function() { logPdqGaEvent('apply_advanced_filters') },
            listingClick: function () { logPdqGaEvent('listing_open'); recordAbTestEvent('pdq_open_listing'); },
            sortByClick: function(element) {
                switch (element.options[element.selectedIndex].value) {
                    case 'highestprice': logPdqGaEvent('sortby_sortby_highest_price'); recordAbTestEvent('pdq_sortby_highest_price'); break;
                    case 'lowestprice': logPdqGaEvent('sortby_sortby_lowest_price'); recordAbTestEvent('pdq_sortby_lowest_price'); break;
                    case 'latest': logPdqGaEvent('sortby_latest_listing'); recordAbTestEvent('pdq_sortby_latest_listings'); break;
                    case 'baths': logPdqGaEvent('sortby_baths'); recordAbTestEvent('pdq_sortby_baths'); break;
                    case 'beds': logPdqGaEvent('sortby_beds'); recordAbTestEvent('pdq_sortby_beds'); break;
                    case 'newest': logPdqGaEvent('sortby_year_built'); recordAbTestEvent('pdq_sortby_yearbuilt'); break;
                    case 'nearest': logPdqGaEvent('sortby_nearest'); recordAbTestEvent('pdq_sortby_nearest'); break;
                }
            },
        }
    }
})(typeof ga === 'undefined' ? function(){} : ga);



CINC.Forms = {};
CINC.Forms.Validate = function (val, type) {

    var isValid = true;
    val = val.trim();

    switch (type.toLowerCase()) {
        case 'address':
            if (val.length < 5 || val.toUpperCase() === 'STREET ADDRESS (LINE 1)') {
                isValid = false;
            }
            else {
                var parts = val.split(' ');
                if (parts.length <= 1) {
                    isValid = false;
                }
                else {
                    if (parts[0].length < 1 || parts[1].length < 1) {
                        isValid = false;
                    }
                    if (!$.isNumeric(parts[0])) {
                        isValid = false;
                    }
                }
            }
            break;
        case 'email':
            var rEmailVal = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            val = val.toLowerCase();
            if ((val.length < 1) || (!rEmailVal.test(val))) {
                isValid = false;
            }
            break;
        case 'name':
            if (!CINC.Site.NameValidationDisabled) {
                // proceed as normal
                if ((val.length < 1) || (val.indexOf(' ') === -1) || val.toLowerCase() === 'full name') {
                    isValid = false;
                }
            }
            else {
                if (val.length < 1 || val.toLowerCase() === 'full name') {
                    isValid = false;
                }
            }
            break;
        case 'message':
            break;
        case 'password':
            if (val.length < 5) {
                isValid = false;
            }
            break;
        case 'phone':
            val = val.replace(/\D/g, '');
            var rPhoneVal;
            var SAPhoneVal = /^((?:\+27|27)|0)(\d{2})-?(\d{3})-?(\d{4})$/;
            if (val.length <= 10) {
                rPhoneVal = /^[2-9][0-9][0-9][2-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
            }
            else {
                rPhoneVal = /^(999|998|997|996|995|994|993|992|991|990|979|978|977|976|975|974|973|972|971|970|969|968|967|966|965|964|963|962|961|960|899|898|897|896|895|894|893|892|891|890|889|888|887|886|885|884|883|882|881|880|879|878|877|876|875|874|873|872|871|870|859|858|857|856|855|854|853|852|851|850|839|838|837|836|835|834|833|832|831|830|809|808|807|806|805|804|803|802|801|800|699|698|697|696|695|694|693|692|691|690|689|688|687|686|685|684|683|682|681|680|679|678|677|676|675|674|673|672|671|670|599|598|597|596|595|594|593|592|591|590|509|508|507|506|505|504|503|502|501|500|429|428|427|426|425|424|423|422|421|420|389|388|387|386|385|384|383|382|381|380|379|378|377|376|375|374|373|372|371|370|359|358|357|356|355|354|353|352|351|350|299|298|297|296|295|294|293|292|291|290|289|288|287|286|285|284|283|282|281|280|269|268|267|266|265|264|263|262|261|260|259|258|257|256|255|254|253|252|251|250|249|248|247|246|245|244|243|242|241|240|239|238|237|236|235|234|233|232|231|230|229|228|227|226|225|224|223|222|221|220|219|218|217|216|215|214|213|212|211|210|98|95|94|93|92|91|90|86|84|82|81|66|65|64|63|62|61|60|58|57|56|55|54|53|52|51|49|48|47|46|45|44|43|41|40|39|36|34|33|32|31|30|27|20|7|1)[0-9]{0,14}$/;
            }
            if (val.length < 10 || !(rPhoneVal.test(val) || SAPhoneVal.test(val))) {
                isValid = false;
            }

            try {
                if (isValid) {
                    // if the phone number is the same number repeated, bail out
                    if (val[0].repeat(val.length) == val)
                        isValid = false;
                }
            } catch (e) {
                // just making sure this doesn't break registration
            }
            break;
        case 'price':
            val = val.replace(/\D/g, '');
            if (val.length === 0) {
                isValid = false;
            }
            break;
        case 'state':
            if (val.length !== 2) {
                isValid = false;
            }
            break;
        case 'zip':
            var matches = val.match(/^(\d{5}|[A-Za-z]\d[A-Z] ?\d[A-Za-z]\d)$/g);
            if (typeof matches === 'undefined' || matches === null || matches.length < 1) {
                isValid = false;
            } else {
                val = matches[0];
            }
            break;
    }
    return isValid;
};

CINC.Forms.Serialize = function ($selector) {
    var formData = {};;
    $selector.serializeArray().map(function (x) {
        if (formData[x.name] === undefined || formData[x.name] === null) {
            formData[x.name] = x.value;
        } else {
            if (Array.isArray(formData[x.name]))
                formData[x.name].push(x.value);
            else
                formData[x.name] = [formData[x.name], x.value]
        }
    });
    return formData;
};
CINC.Forms.Arrayify = function (property) {
    if (property !== undefined && property !== null && !Array.isArray(property)) {
        return [property];
    }
    return property;
};

$(document).ready(function () {
    $('body').delegate('form.cinc-form-validation input[type="submit"]', 'click', function (e) {
        e.preventDefault();
        var $form = $(this).closest('form.cinc-form-validation'),
            $inputs = $form.find(':input'),
            $validationInputs = $form.find('*[data-val="true"]:input'),
            isValid = true,
            i = 0;
        while (isValid && i < $validationInputs.length) {
            var $element = $($validationInputs[i]);
            $element.valueIsNullOrEmpty = CINC.IsNullOrEmpty($element.val());
            $element.isRequired = false;
            $element.hasRegex = false;
            if ($element.data('val-required')) {
                $element.isRequired = true;
                $element.requiredMessage = $element.data('val-required');
            }
            if ($element.data('val-regex')) {
                $element.hasRegex = true;
                $element.regexMessage = $element.data('val-regex');
                $element.regexPattern = $element.data('val-regex-pattern');
            }
            if ($element.data('val-type'))
            {
                $element.hasType = true;
                $element.type = $element.data('val-type');
                $element.typeMessage = $element.data('val-type-message');
            }
            if ($element.valueIsNullOrEmpty && $element.isRequired) {
                isValid = false;
                Notification.Tooltip.Show($element.requiredMessage, $element);
                return;
            }
            if (!$element.valueIsNullOrEmpty && $element.hasRegex) {
                var regex = new RegExp($element.regexPattern);
                var passedText = regex.test($element.val());
                if (!passedText) {
                    isValid = false;
                    Notification.Tooltip.Show($element.regexMessage, $element);
                    return;
                }
            }
            if (!$element.valueIsNullOrEmpty && $element.hasType) {
                if(!CINC.Forms.Validate($element.val(), $element.type)) {
                    isValid = false;
                    Notification.Tooltip.Show($element.typeMessage, $element);
                    return;
                }                
            }
            i += 1;
        }

        if (isValid)
        {
            var options = {};

            if ($form.data('ajax')) {
                var options = {};
                fnBegin = CINC.GetFunctionFromString($form.data('ajax-begin')),
                fnError = CINC.GetFunctionFromString($form.data('ajax-failure')),
                fnSuccess = CINC.GetFunctionFromString($form.data('ajax-success')),
                fnCompleted = CINC.GetFunctionFromString($form.data('ajax-complete'));
                if (fnBegin) {
                    options.beforeSubmit = function (arr, $form, options) {
                        var args = {
                            arr: arr,
                            $form: $form,
                            options: options
                        };
                        fnBegin(args);
                    }
                }
                if (fnError) {
                    options.error = function (xhr, status, errorMessage, $form) {
                        var args = {
                            xhr: xhr,
                            status: status,
                            error: true,
                            success: false,
                            response: errorMessage,
                            $form: $form
                        };
                        fnError(args);
                        if (fnCompleted)
                            fnCompleted(args);
                    }
                }
                if (fnSuccess) {
                    options.success = function (response, status, xhr, $form) {
                        var args = {
                            xhr: xhr,
                            status: status,
                            error: false,
                            success: true,
                            response: response,
                            $form: $form
                        };
                        fnSuccess(args);
                        if (fnCompleted)
                            fnCompleted(args);
                    }
                }
                $form.ajaxSubmit(options);
            }
        }
    });    
});

$(document).bind('ready ajaxComplete', function () {
    $('.simple-file-uploader').each(function () {
        var $this = $(this);
        $this.fineUploader({
            'request': {
                'endpoint': '/upload'
            },
            button: $($this.data('upload-button'))[0],
            multiple: false,
        }).on('submit', function (event, id, name) {
            var $this = $(this),
                fineUploaderOptions = {},
                eventSourceId = $this.attr('id'),
                fnBegin = CINC.GetFunctionFromString($this.data('ajax-begin'));

            if (!eventSourceId) {
                eventSourceId = 'id{0}'.format(Math.floor((1 + Math.random()) * 10000));
                $(this).attr('id', eventSourceId);
            }

            //antiforgerytoken
            fineUploaderOptions.__RequestVerificationToken =
                $this.closest('form')
                    .find('input[name="__RequestVerificationToken"]').val();

            if (fnBegin) {
                var args = {};
                args.event = event;
                args.id = id;
                args.name = name;
                args.options = fineUploaderOptions;
                args.$source = $this;
                fnBegin(args);
            }

            $this.fineUploader('setParams', fineUploaderOptions);

        }).on('error', function (event, id, name, errorReason, xhr) {
            var responseObj = JSON.parse(xhr.responseText),
                $source = $(event.target),
                fnError = CINC.GetFunctionFromString($source.data('ajax-failure'));

            if (fnError) {
                var args = {};
                args.event = event;
                args.id = id;
                args.name = name;
                args.errorReason = errorReason;
                args.xhr = xhr;
                args.xhr.responseText = undefined;
                args.xhr.responseJSON = responseObj;
                args.$source = $source;
                fnError(args);
            }

        }).on('complete', function (event, id, name, response) {
            var responseObj = '',
                $source = $(event.target),
                fnSuccess = CINC.GetFunctionFromString($source.data('ajax-success')),
                fnCompleted = CINC.GetFunctionFromString($source.data('ajax-complete'));

            if (fnCompleted || fnSuccess) {
                var args = {};
                args.event = event;
                args.id = id;
                args.name = name;
                args.response = response;
                args.$source = $source;
                if (response.success && fnSuccess)
                    fnSuccess(args);
                if (fnCompleted)
                    fnCompleted(args);
            }

        });
    });
})


CINC.ResumeFormSubmitError = function (args) {
    Notification.Banner.Error("Error", "Resume Form Error");
};
CINC.ResumeFormSubmitSuccess = function (args) {
    if (!IsLoggedIn) {
        $('body').append(CINC.Site.ConversionTrackingScripts);

        if (typeof ga !== 'undefined' && ga !== null) {
        }

        if ($('.js-inquiry-noreload').length == 0) {
            window.location.reload(true);
        }
    } else {
        $('#resume-form').addClass('success');
    }
};
CINC.BeginningResumeFormSubmit = function (args) {
    Modals.Loading('').Open();
};
CINC.FinalizingResumeFormSubmit = function (args) {
    Modals.Loading('').Close();
};

$(document).ready(function () {
    $('#resume-form .upload').fineUploader({
        'request': {
            'endpoint': '/upload'
        },
        multiple: false,
    }).on('submit', function (event, id, name) {
        loadingModal = Modals.Loading("Uploading file").Open();
        $(this).fineUploader('setParams', {
            'action': 'uploadfiles',
            //antiforgerytoken
            '__RequestVerificationToken': $('#resume-form input[name="__RequestVerificationToken"]').val()
        });
    }).on('error', function (event, id, name, errorReason, xhrOrXdr) {
        Notification.Banner.Error(errorReason || '', "Failed to upload file");
    }).on('complete', function (event, id, name, response) {
        if (response.success) {
            var uploadDid = response.data[0].fileDID;
            $('#resume-form .upload').addClass('completed');
            $('#resume-form input[name="UploadDID"]').val(uploadDid);
        }

        if (loadingModal) loadingModal.Close();
    });
});

$(document).ready(function () {
    initToggleNavItemsVisibility();
    closeNavSidebarWhenModalOpenMobile();
});
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

var debounceToggleNavItemVisibility = debounce(toggleNavItemsVisibility, 50);
function initToggleNavItemsVisibility() {
    debounceToggleNavItemVisibility();
    $(window).off('resize', debounceToggleNavItemVisibility).on('resize', debounceToggleNavItemVisibility);
}

function toggleNavItemsVisibility() {
    var nav = $('nav');
    if (nav.length === 0 || !nav.is(':visible')) {
        return;
    }

    var menu = nav.find('.header-menu-left');
    if (menu.length === 0 || !menu.is(':visible')) {
        return;
    }

    var navItems = menu.find('.header-item').not('.js-nav-more');
    var moreItems = $('.js-nav-more').find('.menu .item');
    toggleMoreDropdownVisbility(navItems, moreItems);
}

function toggleMoreDropdownVisbility(navItems, moreItems) {
    var showMoreDropdown = false;

    navItems.each(function () {
        var navItem = $(this);
        var navItemText = $(this).find('a').text();

        moreItems.each(function () {
            var moreItem = $(this);
            var moreItemText = $(this).find('a').text();

            if (navItemText === moreItemText) {
                if (navItem.is(':hidden')) {
                    moreItem.show();
                    showMoreDropdown = true;    // if any item is shown, show the dropdown
                } else {
                    moreItem.hide();
                }
                return;
            }
        });

        var windowWidth = $(window).innerWidth();

        if (windowWidth <= 768) {
            navItem.removeClass('hidden-xs hidden-s');
            showMoreDropdown = false;
        }

    });

    if (showMoreDropdown) {
        $('.js-nav-more').css('display', 'inline-block');
    } else {
        $('.js-nav-more').hide();
    }
}

function closeNavSidebarWhenModalOpenMobile() {
    var windowWidth = $(window).innerWidth();

    if ( windowWidth <= 768 ) {
        $('.js-promptforlogin, .js-promptforsignup').on('click', function() {
            $('body').removeClass('with-sidebar');
        });
    }
}

